// Este arquivo foi gerado automaticamente por um script. Não edite manualmente.
// Total de aeroportos: 4132
export const airports = [
  {
    "iata": "5A8",
    "name": "Aleknagik / New Airport",
    "city": "Aleknagik"
  },
   {
    "iata": "JJG",
    "name": "Humberto Ghizzo Bortoluzzi Regional Airport",
    "city": "Jaguaruna"
  },
  {
    "iata": "HIR",
    "name": "Honiara International Airport",
    "city": "Honiara"
  },
  {
    "iata": "MUA",
    "name": "Munda Airport",
    "city": "Munda"
  },
  {
    "iata": "INU",
    "name": "Nauru International Airport",
    "city": "Yaren District"
  },
  {
    "iata": "VMU",
    "name": "Baimuru Airport",
    "city": "Baimuru"
  },
  {
    "iata": "BUA",
    "name": "Buka Airport",
    "city": "Buka Island"
  },
  {
    "iata": "OPU",
    "name": "Balimo Airport",
    "city": "Balimo"
  },
  {
    "iata": "CMU",
    "name": "Chimbu Airport",
    "city": "Kundiawa"
  },
  {
    "iata": "DAU",
    "name": "Daru Airport",
    "city": "Daru"
  },
  {
    "iata": "GKA",
    "name": "Goroka Airport",
    "city": "Goronka"
  },
  {
    "iata": "GUR",
    "name": "Gurney Airport",
    "city": "Gurney"
  },
  {
    "iata": "PNP",
    "name": "Girua Airport",
    "city": "Popondetta"
  },
  {
    "iata": "HKN",
    "name": "Hoskins Airport",
    "city": "Kimbe"
  },
  {
    "iata": "KMA",
    "name": "Kerema Airport",
    "city": "Kerema"
  },
  {
    "iata": "KVG",
    "name": "Kavieng Airport",
    "city": "Kavieng"
  },
  {
    "iata": "MAG",
    "name": "Madang Airport",
    "city": "Madang"
  },
  {
    "iata": "HGU",
    "name": "Mount Hagen Kagamuga Airport",
    "city": "Mount Hagen"
  },
  {
    "iata": "MDU",
    "name": "Mendi Airport",
    "city": "Mendi"
  },
  {
    "iata": "MAS",
    "name": "Momote Airport",
    "city": "Manus Island"
  },
  {
    "iata": "LAE",
    "name": "Nadzab Airport",
    "city": "Lae"
  },
  {
    "iata": "POM",
    "name": "Port Moresby Jacksons International Airport",
    "city": "Port Moresby"
  },
  {
    "iata": "RAB",
    "name": "Tokua Airport",
    "city": "Kokopo"
  },
  {
    "iata": "VAI",
    "name": "Vanimo Airport",
    "city": "Vanimo"
  },
  {
    "iata": "WBM",
    "name": "Wapenamanda Airport",
    "city": "Wapenamanda"
  },
  {
    "iata": "WWK",
    "name": "Wewak International Airport",
    "city": "Wewak"
  },
  {
    "iata": "JEG",
    "name": "Aasiaat Airport",
    "city": "Aasiaat"
  },
  {
    "iata": "UAK",
    "name": "Narsarsuaq Airport",
    "city": "Narsarsuaq"
  },
  {
    "iata": "GOH",
    "name": "Nuuk Airport",
    "city": "Nuuk"
  },
  {
    "iata": "JAV",
    "name": "Ilulissat Airport",
    "city": "Ilulissat"
  },
  {
    "iata": "KUS",
    "name": "Kulusuk Airport",
    "city": "Kulusuk"
  },
  {
    "iata": "SFJ",
    "name": "Kangerlussuaq Airport",
    "city": "Kangerlussuaq"
  },
  {
    "iata": "JHS",
    "name": "Sisimiut Airport",
    "city": "Sisimiut"
  },
  {
    "iata": "THU",
    "name": "Pituffik Space Base",
    "city": "Pituffik"
  },
  {
    "iata": "AEY",
    "name": "Akureyri Airport",
    "city": "Akureyri"
  },
  {
    "iata": "EGS",
    "name": "Egilsstaðir Airport",
    "city": "Egilsstaðir"
  },
  {
    "iata": "HFN",
    "name": "Hornafjörður Airport",
    "city": "Höfn"
  },
  {
    "iata": "HZK",
    "name": "Húsavík Airport",
    "city": "Húsavík"
  },
  {
    "iata": "IFJ",
    "name": "Ísafjörður Airport",
    "city": "Ísafjörður"
  },
  {
    "iata": "KEF",
    "name": "Keflavik International Airport",
    "city": "Reykjavík"
  },
  {
    "iata": "RKV",
    "name": "Reykjavík Domestic Airport",
    "city": "Reykjavík"
  },
  {
    "iata": "SIJ",
    "name": "Siglufjörður Airport",
    "city": "Siglufjörður"
  },
  {
    "iata": "VEY",
    "name": "Vestmannaeyjar Airport",
    "city": "Vestmannaeyjar"
  },
  {
    "iata": "PRN",
    "name": "Priština Adem Jashari International Airport",
    "city": "Prishtina"
  },
  {
    "iata": "ZEL",
    "name": "Bella Bella (Campbell Island) Airport",
    "city": "Bella Bella"
  },
  {
    "iata": "HSC",
    "name": "Shaoguan Danxia Airport",
    "city": "Shaoguan"
  },
  {
    "iata": "YAG",
    "name": "Fort Frances Municipal Airport",
    "city": "Fort Frances"
  },
  {
    "iata": "YAH",
    "name": "La Grande-4 Airport",
    "city": "La Grande-4"
  },
  {
    "iata": "YAM",
    "name": "Sault Ste Marie Airport",
    "city": "Sault Ste Marie"
  },
  {
    "iata": "XKS",
    "name": "Kasabonika Airport",
    "city": "Kasabonika"
  },
  {
    "iata": "YAY",
    "name": "St. Anthony Airport",
    "city": "St. Anthony"
  },
  {
    "iata": "YAZ",
    "name": "Tofino / Long Beach Airport",
    "city": "Tofino"
  },
  {
    "iata": "YBC",
    "name": "Baie-Comeau Airport",
    "city": "Baie-Comeau"
  },
  {
    "iata": "QBC",
    "name": "Bella Coola Airport",
    "city": "Bella Coola"
  },
  {
    "iata": "YBY",
    "name": "Bonnyville Airport",
    "city": "Bonnyville"
  },
  {
    "iata": "YBG",
    "name": "CFB Bagotville / Saguenay-Bagotville Airport",
    "city": "La Baie"
  },
  {
    "iata": "YBK",
    "name": "Baker Lake Airport",
    "city": "Baker Lake"
  },
  {
    "iata": "YBL",
    "name": "Campbell River Airport",
    "city": "Campbell River"
  },
  {
    "iata": "YBR",
    "name": "Brandon Municipal Airport",
    "city": "Brandon"
  },
  {
    "iata": "YBX",
    "name": "Lourdes-de-Blanc-Sablon Airport",
    "city": "Blanc-Sablon"
  },
  {
    "iata": "YCB",
    "name": "Cambridge Bay Airport",
    "city": "Cambridge Bay"
  },
  {
    "iata": "YCC",
    "name": "Cornwall Regional Airport",
    "city": "Cornwall"
  },
  {
    "iata": "YCD",
    "name": "Nanaimo Airport",
    "city": "Nanaimo"
  },
  {
    "iata": "YCE",
    "name": "Centralia / James T. Field Memorial Aerodrome",
    "city": "Huron Park"
  },
  {
    "iata": "YCG",
    "name": "Castlegar/West Kootenay Regional Airport",
    "city": "Castlegar"
  },
  {
    "iata": "YCH",
    "name": "Miramichi Airport",
    "city": "Miramichi"
  },
  {
    "iata": "YCL",
    "name": "Charlo Airport",
    "city": "Charlo"
  },
  {
    "iata": "YCN",
    "name": "Cochrane Airport",
    "city": "Cochrane"
  },
  {
    "iata": "YCQ",
    "name": "Chetwynd Airport",
    "city": "Chetwynd"
  },
  {
    "iata": "YDA",
    "name": "Dawson City Airport",
    "city": "Dawson City"
  },
  {
    "iata": "YDB",
    "name": "Burwash Airport",
    "city": "Burwash Landing"
  },
  {
    "iata": "YDF",
    "name": "Deer Lake Airport",
    "city": "Deer Lake"
  },
  {
    "iata": "XRR",
    "name": "Ross River Airport",
    "city": "Ross River"
  },
  {
    "iata": "YDN",
    "name": "Dauphin Barker Airport",
    "city": "Dauphin"
  },
  {
    "iata": "YDO",
    "name": "Dolbeau-Saint-Felicien Airport",
    "city": "Dolbeau-Saint-Felicien"
  },
  {
    "iata": "YDQ",
    "name": "Dawson Creek Airport",
    "city": "Dawson Creek"
  },
  {
    "iata": "YEG",
    "name": "Edmonton International Airport",
    "city": "Edmonton"
  },
  {
    "iata": "YEL",
    "name": "Elliot Lake Municipal Airport",
    "city": "Elliot Lake"
  },
  {
    "iata": "YEM",
    "name": "Manitoulin East Municipal Airport",
    "city": "Sheguiandah"
  },
  {
    "iata": "YEN",
    "name": "Estevan Airport",
    "city": "Estevan"
  },
  {
    "iata": "YET",
    "name": "Edson Airport",
    "city": "Edson"
  },
  {
    "iata": "YEV",
    "name": "Inuvik Mike Zubko Airport",
    "city": "Inuvik"
  },
  {
    "iata": "YEY",
    "name": "Amos/Magny Airport",
    "city": "Amos"
  },
  {
    "iata": "YFB",
    "name": "Iqaluit Airport",
    "city": "Iqaluit"
  },
  {
    "iata": "YFC",
    "name": "Fredericton Airport",
    "city": "Fredericton"
  },
  {
    "iata": "YFE",
    "name": "Forestville Airport",
    "city": "Forestville"
  },
  {
    "iata": "YTM",
    "name": "Mont-Tremblant International Airport",
    "city": "La Macaza"
  },
  {
    "iata": "YFR",
    "name": "Fort Resolution Airport",
    "city": "Fort Resolution"
  },
  {
    "iata": "YFS",
    "name": "Fort Simpson Airport",
    "city": "Fort Simpson"
  },
  {
    "iata": "YGK",
    "name": "Kingston Norman Rogers Airport",
    "city": "Kingston"
  },
  {
    "iata": "YGL",
    "name": "La Grande Rivière Airport",
    "city": "La Grande Rivière"
  },
  {
    "iata": "YGM",
    "name": "Gimli Industrial Park Airport",
    "city": "Gimli"
  },
  {
    "iata": "YGP",
    "name": "Michel-Pouliot Gaspé Airport",
    "city": "Gaspé"
  },
  {
    "iata": "YGQ",
    "name": "Geraldton Greenstone Regional Airport",
    "city": "Geraldton"
  },
  {
    "iata": "YGR",
    "name": "Îles-de-la-Madeleine Airport",
    "city": "Les Îles-de-la-Madeleine"
  },
  {
    "iata": "YGV",
    "name": "Havre-Saint-Pierre Airport",
    "city": "Havre-Saint-Pierre"
  },
  {
    "iata": "YGW",
    "name": "Kuujjuarapik Airport",
    "city": "Kuujjuarapik"
  },
  {
    "iata": "YHD",
    "name": "Dryden Regional Airport",
    "city": "Dryden"
  },
  {
    "iata": "YHF",
    "name": "Hearst René Fontaine Municipal Airport",
    "city": "Hearst"
  },
  {
    "iata": "YHM",
    "name": "John C. Munro Hamilton International Airport",
    "city": "Hamilton"
  },
  {
    "iata": "YHN",
    "name": "Hornepayne Municipal Airport",
    "city": "Hornepayne"
  },
  {
    "iata": "YHT",
    "name": "Haines Junction Airport",
    "city": "Haines Junction"
  },
  {
    "iata": "YHU",
    "name": "Montréal / Saint-Hubert Metropolitan Airport",
    "city": "Montréal"
  },
  {
    "iata": "YHY",
    "name": "Hay River / Merlyn Carter Airport",
    "city": "Hay River"
  },
  {
    "iata": "YHZ",
    "name": "Halifax / Stanfield International Airport",
    "city": "Halifax"
  },
  {
    "iata": "YIB",
    "name": "Atikokan Municipal Airport",
    "city": "Atikokan"
  },
  {
    "iata": "YDG",
    "name": "Digby / Annapolis Regional Airport",
    "city": "Digby"
  },
  {
    "iata": "YIF",
    "name": "St Augustin Airport",
    "city": "St-Augustin"
  },
  {
    "iata": "YIV",
    "name": "Island Lake Airport",
    "city": "Island Lake"
  },
  {
    "iata": "YJF",
    "name": "Fort Liard Airport",
    "city": "Fort Liard"
  },
  {
    "iata": "YJN",
    "name": "St Jean Airport",
    "city": "St Jean"
  },
  {
    "iata": "YJT",
    "name": "Dymond Airport",
    "city": "Stephenville"
  },
  {
    "iata": "YKA",
    "name": "Kamloops John Moose Fulton Field Regional Airport",
    "city": "Kamloops"
  },
  {
    "iata": "YKF",
    "name": "Region of Waterloo International Airport",
    "city": "Breslau"
  },
  {
    "iata": "YKJ",
    "name": "Key Lake Airport",
    "city": "Key Lake"
  },
  {
    "iata": "YKL",
    "name": "Schefferville Airport",
    "city": "Schefferville"
  },
  {
    "iata": "YKD",
    "name": "Kincardine Municipal Airport",
    "city": "Kincardine"
  },
  {
    "iata": "YKX",
    "name": "Kirkland Lake Airport",
    "city": "Kirkland Lake"
  },
  {
    "iata": "YKY",
    "name": "Kindersley Airport",
    "city": "Kindersley"
  },
  {
    "iata": "YLD",
    "name": "Chapleau Airport",
    "city": "Chapleau"
  },
  {
    "iata": "YLJ",
    "name": "Meadow Lake Airport",
    "city": "Meadow Lake"
  },
  {
    "iata": "YLL",
    "name": "Lloydminster Airport",
    "city": "Lloydminster"
  },
  {
    "iata": "YLR",
    "name": "Leaf Rapids Airport",
    "city": "Leaf Rapids"
  },
  {
    "iata": "YLK",
    "name": "Barrie-Lake Simcoe Regional Airport",
    "city": "Barrie"
  },
  {
    "iata": "YLT",
    "name": "Alert Airport",
    "city": "Alert"
  },
  {
    "iata": "YLW",
    "name": "Kelowna International Airport",
    "city": "Kelowna"
  },
  {
    "iata": "YMA",
    "name": "Mayo Airport",
    "city": "Mayo"
  },
  {
    "iata": "YME",
    "name": "Matane Airport",
    "city": "Matane"
  },
  {
    "iata": "YMG",
    "name": "Manitouwadge Airport",
    "city": "Manitouwadge"
  },
  {
    "iata": "YMJ",
    "name": "Moose Jaw Air Vice Marshal C. M. McEwen Airport",
    "city": "Moose Jaw"
  },
  {
    "iata": "YML",
    "name": "Charlevoix Airport",
    "city": "Charlevoix"
  },
  {
    "iata": "YMM",
    "name": "Fort McMurray Airport",
    "city": "Fort McMurray"
  },
  {
    "iata": "YMO",
    "name": "Moosonee Airport",
    "city": "Moosonee"
  },
  {
    "iata": "YMT",
    "name": "Chapais Airport",
    "city": "Chibougamau"
  },
  {
    "iata": "YMX",
    "name": "Montreal International (Mirabel) Airport",
    "city": "Montréal"
  },
  {
    "iata": "YNA",
    "name": "Natashquan Airport",
    "city": "Natashquan"
  },
  {
    "iata": "YND",
    "name": "Ottawa / Gatineau Airport",
    "city": "Gatineau"
  },
  {
    "iata": "YLY",
    "name": "Langley Airport",
    "city": "Langley"
  },
  {
    "iata": "YNL",
    "name": "Points North Landing Airport",
    "city": "Points North Landing"
  },
  {
    "iata": "YNM",
    "name": "Matagami Airport",
    "city": "Matagami"
  },
  {
    "iata": "YOA",
    "name": "Ekati Airport",
    "city": "Ekati"
  },
  {
    "iata": "YOD",
    "name": "CFB Cold Lake",
    "city": "Cold Lake"
  },
  {
    "iata": "YOJ",
    "name": "High Level Airport",
    "city": "High Level"
  },
  {
    "iata": "YOO",
    "name": "Oshawa Executive Airport",
    "city": "Oshawa"
  },
  {
    "iata": "YOP",
    "name": "Rainbow Lake Airport",
    "city": "Rainbow Lake"
  },
  {
    "iata": "YOS",
    "name": "Owen Sound / Billy Bishop Regional Airport",
    "city": "Owen Sound"
  },
  {
    "iata": "YOW",
    "name": "Ottawa Macdonald-Cartier International Airport",
    "city": "Ottawa"
  },
  {
    "iata": "YPA",
    "name": "Prince Albert Glass Field",
    "city": "Prince Albert"
  },
  {
    "iata": "YPS",
    "name": "Port Hawkesbury Airport",
    "city": "Port Hawkesbury"
  },
  {
    "iata": "YPE",
    "name": "Peace River Airport",
    "city": "Peace River"
  },
  {
    "iata": "YPG",
    "name": "Portage-la-Prairie / Southport Airport",
    "city": "Portage la Prairie"
  },
  {
    "iata": "YPL",
    "name": "Pickle Lake Airport",
    "city": "Pickle Lake"
  },
  {
    "iata": "YPN",
    "name": "Port-Menier Airport",
    "city": "Port-Menier"
  },
  {
    "iata": "YPQ",
    "name": "Peterborough Municipal Airport",
    "city": "Peterborough"
  },
  {
    "iata": "YPR",
    "name": "Prince Rupert Airport",
    "city": "Prince Rupert"
  },
  {
    "iata": "YPW",
    "name": "Powell River Airport",
    "city": "Powell River"
  },
  {
    "iata": "YPX",
    "name": "Puvirnituq Airport",
    "city": "Puvirnituq"
  },
  {
    "iata": "YPY",
    "name": "Fort Chipewyan Airport",
    "city": "Fort Chipewyan"
  },
  {
    "iata": "YPZ",
    "name": "Burns Lake Airport",
    "city": "Burns Lake"
  },
  {
    "iata": "YQA",
    "name": "Muskoka Airport",
    "city": "Gravenhurst"
  },
  {
    "iata": "YQB",
    "name": "Quebec Jean Lesage International Airport",
    "city": "Quebec"
  },
  {
    "iata": "YQD",
    "name": "The Pas Airport",
    "city": "The Pas"
  },
  {
    "iata": "YQF",
    "name": "Red Deer Regional Airport",
    "city": "Springbrook"
  },
  {
    "iata": "YQG",
    "name": "Windsor Airport",
    "city": "Windsor"
  },
  {
    "iata": "YQH",
    "name": "Watson Lake Airport",
    "city": "Watson Lake"
  },
  {
    "iata": "YQI",
    "name": "Yarmouth Airport",
    "city": "Yarmouth"
  },
  {
    "iata": "YQK",
    "name": "Kenora Airport",
    "city": "Kenora"
  },
  {
    "iata": "YQL",
    "name": "Lethbridge County Airport",
    "city": "Lethbridge"
  },
  {
    "iata": "YQM",
    "name": "Greater Moncton Roméo LeBlanc International Airport",
    "city": "Moncton"
  },
  {
    "iata": "YQN",
    "name": "Nakina Airport",
    "city": "Nakina"
  },
  {
    "iata": "YQQ",
    "name": "Comox Valley Airport / CFB Comox",
    "city": "Comox"
  },
  {
    "iata": "YQR",
    "name": "Regina International Airport",
    "city": "Regina"
  },
  {
    "iata": "YQS",
    "name": "St Thomas Municipal Airport",
    "city": "St Thomas"
  },
  {
    "iata": "YQT",
    "name": "Thunder Bay Airport",
    "city": "Thunder Bay"
  },
  {
    "iata": "YQU",
    "name": "Grande Prairie Airport",
    "city": "Grande Prairie"
  },
  {
    "iata": "YQV",
    "name": "Yorkton Municipal Airport",
    "city": "Yorkton"
  },
  {
    "iata": "YQW",
    "name": "North Battleford Airport",
    "city": "North Battleford"
  },
  {
    "iata": "YQX",
    "name": "Gander International Airport / CFB Gander",
    "city": "Gander"
  },
  {
    "iata": "YQY",
    "name": "Sydney / J.A. Douglas McCurdy Airport",
    "city": "Sydney"
  },
  {
    "iata": "YQZ",
    "name": "Quesnel Airport",
    "city": "Quesnel"
  },
  {
    "iata": "YRB",
    "name": "Resolute Bay Airport",
    "city": "Resolute Bay"
  },
  {
    "iata": "YRI",
    "name": "Rivière-du-Loup Airport",
    "city": "Rivière-du-Loup"
  },
  {
    "iata": "YRJ",
    "name": "Roberval Airport",
    "city": "Roberval"
  },
  {
    "iata": "YRL",
    "name": "Red Lake Airport",
    "city": "Red Lake"
  },
  {
    "iata": "YRO",
    "name": "Ottawa / Rockcliffe Airport",
    "city": "Ottawa"
  },
  {
    "iata": "YRQ",
    "name": "Trois-Rivières Airport",
    "city": "Trois-Rivières"
  },
  {
    "iata": "YRT",
    "name": "Rankin Inlet Airport",
    "city": "Rankin Inlet"
  },
  {
    "iata": "YRV",
    "name": "Revelstoke Airport",
    "city": "Revelstoke"
  },
  {
    "iata": "YSB",
    "name": "Sudbury Airport",
    "city": "Sudbury"
  },
  {
    "iata": "YSC",
    "name": "Sherbrooke Airport",
    "city": "Sherbrooke"
  },
  {
    "iata": "YSF",
    "name": "Stony Rapids Airport",
    "city": "Stony Rapids"
  },
  {
    "iata": "YSH",
    "name": "Smiths Falls-Montague (Russ Beach) Airport",
    "city": "Smiths Falls"
  },
  {
    "iata": "YSJ",
    "name": "Saint John Airport",
    "city": "Saint John"
  },
  {
    "iata": "YSL",
    "name": "Saint-Léonard Airport",
    "city": "Saint-Léonard"
  },
  {
    "iata": "YSM",
    "name": "Fort Smith Airport",
    "city": "Fort Smith"
  },
  {
    "iata": "YCM",
    "name": "Niagara District Airport",
    "city": "Niagara-on-the-Lake"
  },
  {
    "iata": "YSP",
    "name": "Marathon Airport",
    "city": "Marathon"
  },
  {
    "iata": "YSU",
    "name": "Summerside Airport",
    "city": "Slemon Park"
  },
  {
    "iata": "YTA",
    "name": "Pembroke Airport",
    "city": "Pembroke"
  },
  {
    "iata": "YTF",
    "name": "Alma Airport",
    "city": "Alma"
  },
  {
    "iata": "YTH",
    "name": "Thompson Airport",
    "city": "Thompson"
  },
  {
    "iata": "YTR",
    "name": "CFB Trenton",
    "city": "Trenton"
  },
  {
    "iata": "YTS",
    "name": "Timmins/Victor M. Power",
    "city": "Timmins"
  },
  {
    "iata": "YTZ",
    "name": "Billy Bishop Toronto City Centre Airport",
    "city": "Toronto"
  },
  {
    "iata": "YUL",
    "name": "Montreal / Pierre Elliott Trudeau International Airport",
    "city": "Montréal"
  },
  {
    "iata": "YUX",
    "name": "Hall Beach Airport",
    "city": "Sanirajak"
  },
  {
    "iata": "YUY",
    "name": "Rouyn Noranda Airport",
    "city": "Rouyn-Noranda"
  },
  {
    "iata": "YVB",
    "name": "Bonaventure Airport",
    "city": "Bonaventure"
  },
  {
    "iata": "YVC",
    "name": "La Ronge Airport",
    "city": "La Ronge"
  },
  {
    "iata": "YVE",
    "name": "Vernon Regional Airport",
    "city": "Vernon"
  },
  {
    "iata": "YVO",
    "name": "Val-d'Or Airport",
    "city": "Val-d'Or"
  },
  {
    "iata": "YVP",
    "name": "Kuujjuaq Airport",
    "city": "Kuujjuaq"
  },
  {
    "iata": "YVQ",
    "name": "Norman Wells Airport",
    "city": "Norman Wells"
  },
  {
    "iata": "YVR",
    "name": "Vancouver International Airport",
    "city": "Vancouver"
  },
  {
    "iata": "YVV",
    "name": "Wiarton Airport",
    "city": "Wiarton"
  },
  {
    "iata": "YWA",
    "name": "Petawawa Airport",
    "city": "Petawawa"
  },
  {
    "iata": "YWG",
    "name": "Winnipeg / James Armstrong Richardson International Airport",
    "city": "Winnipeg"
  },
  {
    "iata": "YWK",
    "name": "Wabush Airport",
    "city": "Wabush"
  },
  {
    "iata": "YWL",
    "name": "Williams Lake Airport",
    "city": "Williams Lake"
  },
  {
    "iata": "YWY",
    "name": "Wrigley Airport",
    "city": "Wrigley"
  },
  {
    "iata": "YXC",
    "name": "Cranbrook/Canadian Rockies International Airport",
    "city": "Cranbrook"
  },
  {
    "iata": "YXE",
    "name": "Saskatoon John G. Diefenbaker International Airport",
    "city": "Saskatoon"
  },
  {
    "iata": "YXH",
    "name": "Medicine Hat Regional Airport",
    "city": "Medicine Hat"
  },
  {
    "iata": "YXJ",
    "name": "Fort St John / North Peace Regional Airport",
    "city": "Fort Saint John"
  },
  {
    "iata": "YXK",
    "name": "Rimouski Airport",
    "city": "Rimouski"
  },
  {
    "iata": "YXL",
    "name": "Sioux Lookout Airport",
    "city": "Sioux Lookout"
  },
  {
    "iata": "YXQ",
    "name": "Beaver Creek Airport",
    "city": "Beaver Creek"
  },
  {
    "iata": "YXR",
    "name": "Earlton (Timiskaming Regional) Airport",
    "city": "Earlton"
  },
  {
    "iata": "YXS",
    "name": "Prince George Airport",
    "city": "Prince George"
  },
  {
    "iata": "YXT",
    "name": "Northwest Regional Airport Terrace-Kitimat",
    "city": "Terrace"
  },
  {
    "iata": "YXU",
    "name": "London Airport",
    "city": "London"
  },
  {
    "iata": "YXX",
    "name": "Abbotsford International Airport",
    "city": "Abbotsford"
  },
  {
    "iata": "YXY",
    "name": "Whitehorse / Erik Nielsen International Airport",
    "city": "Whitehorse"
  },
  {
    "iata": "YXZ",
    "name": "Wawa Airport",
    "city": "Wawa"
  },
  {
    "iata": "YYB",
    "name": "North Bay Jack Garland Airport",
    "city": "North Bay"
  },
  {
    "iata": "YYC",
    "name": "Calgary International Airport",
    "city": "Calgary"
  },
  {
    "iata": "YYD",
    "name": "Smithers Airport",
    "city": "Smithers"
  },
  {
    "iata": "YYE",
    "name": "Fort Nelson Airport",
    "city": "Fort Nelson"
  },
  {
    "iata": "YYF",
    "name": "Penticton Airport",
    "city": "Penticton"
  },
  {
    "iata": "YYG",
    "name": "Charlottetown Airport",
    "city": "Charlottetown"
  },
  {
    "iata": "YYJ",
    "name": "Victoria International Airport",
    "city": "Victoria"
  },
  {
    "iata": "YYL",
    "name": "Lynn Lake Airport",
    "city": "Lynn Lake"
  },
  {
    "iata": "YYN",
    "name": "Swift Current Airport",
    "city": "Swift Current"
  },
  {
    "iata": "YYQ",
    "name": "Churchill Airport",
    "city": "Churchill"
  },
  {
    "iata": "YYR",
    "name": "Goose Bay Airport",
    "city": "Goose Bay"
  },
  {
    "iata": "YYT",
    "name": "St. John's International Airport",
    "city": "St. John's"
  },
  {
    "iata": "YYU",
    "name": "Kapuskasing Airport",
    "city": "Kapuskasing"
  },
  {
    "iata": "YYW",
    "name": "Armstrong Airport",
    "city": "Armstrong"
  },
  {
    "iata": "YYY",
    "name": "Mont Joli Airport",
    "city": "Mont-Joli"
  },
  {
    "iata": "YYZ",
    "name": "Toronto Lester B. Pearson International Airport",
    "city": "Toronto"
  },
  {
    "iata": "YZE",
    "name": "Gore Bay Manitoulin Airport",
    "city": "Gore Bay"
  },
  {
    "iata": "YZF",
    "name": "Yellowknife International Airport",
    "city": "Yellowknife"
  },
  {
    "iata": "YZH",
    "name": "Slave Lake Airport",
    "city": "Slave Lake"
  },
  {
    "iata": "YZP",
    "name": "Sandspit Airport",
    "city": "Sandspit"
  },
  {
    "iata": "YZR",
    "name": "Chris Hadfield Airport",
    "city": "Sarnia"
  },
  {
    "iata": "YZS",
    "name": "Coral Harbour Airport",
    "city": "Coral Harbour"
  },
  {
    "iata": "YZT",
    "name": "Port Hardy Airport",
    "city": "Port Hardy"
  },
  {
    "iata": "YZU",
    "name": "Whitecourt Airport",
    "city": "Whitecourt"
  },
  {
    "iata": "YZV",
    "name": "Sept-Îles Airport",
    "city": "Sept-Îles"
  },
  {
    "iata": "YZW",
    "name": "Teslin Airport",
    "city": "Teslin"
  },
  {
    "iata": "YZX",
    "name": "CFB Greenwood",
    "city": "Greenwood"
  },
  {
    "iata": "YSN",
    "name": "Shuswap Regional Airport",
    "city": "Salmon Arm"
  },
  {
    "iata": "YDT",
    "name": "Boundary Bay Airport",
    "city": "Delta"
  },
  {
    "iata": "ZBF",
    "name": "Bathurst Airport",
    "city": "South Tetagouche"
  },
  {
    "iata": "ZBM",
    "name": "Bromont (Roland Désourdy) Airport",
    "city": "Bromont"
  },
  {
    "iata": "KES",
    "name": "Kelsey Airport",
    "city": "Kelsey"
  },
  {
    "iata": "ZFA",
    "name": "Faro Airport",
    "city": "Faro"
  },
  {
    "iata": "ZGF",
    "name": "Grand Forks Airport",
    "city": "Grand Forks"
  },
  {
    "iata": "ZJG",
    "name": "Jenpeg Airport",
    "city": "Jenpeg"
  },
  {
    "iata": "ZJN",
    "name": "Swan River Airport",
    "city": "Swan River"
  },
  {
    "iata": "YTD",
    "name": "Thicket Portage Airport",
    "city": "Thicket Portage"
  },
  {
    "iata": "PIW",
    "name": "Pikwitonei Airport",
    "city": "Pikwitonei"
  },
  {
    "iata": "ZMT",
    "name": "Masset Airport",
    "city": "Masset"
  },
  {
    "iata": "WPC",
    "name": "Pincher Creek Airport",
    "city": "Pincher Creek"
  },
  {
    "iata": "ZSJ",
    "name": "Sandy Lake Airport",
    "city": "Sandy Lake"
  },
  {
    "iata": "ZST",
    "name": "Stewart Airport",
    "city": "Stewart"
  },
  {
    "iata": "ZUC",
    "name": "Ignace Municipal Airport",
    "city": "Ignace"
  },
  {
    "iata": "BUJ",
    "name": "Bou Saada Airport",
    "city": "Ouled Sidi Brahim"
  },
  {
    "iata": "BJA",
    "name": "Soummam–Abane Ramdane Airport",
    "city": "Béjaïa"
  },
  {
    "iata": "ALG",
    "name": "Houari Boumediene Airport",
    "city": "Algiers"
  },
  {
    "iata": "DJG",
    "name": "Djanet Inedbirene Airport",
    "city": "Djanet"
  },
  {
    "iata": "VVZ",
    "name": "Illizi Takhamalt Airport",
    "city": "Illizi"
  },
  {
    "iata": "QSF",
    "name": "Ain Arnat Airport",
    "city": "Sétif"
  },
  {
    "iata": "TMR",
    "name": "Aguenar – Hadj Bey Akhamok Airport",
    "city": "Tamanrasset"
  },
  {
    "iata": "GJL",
    "name": "Jijel Ferhat Abbas Airport",
    "city": "Tahir"
  },
  {
    "iata": "MZW",
    "name": "Mecheria Airport",
    "city": "Mecheria"
  },
  {
    "iata": "AAE",
    "name": "Annaba Rabah Bitat Airport",
    "city": "Annaba"
  },
  {
    "iata": "CZL",
    "name": "Mohamed Boudiaf International Airport",
    "city": "Constantine"
  },
  {
    "iata": "TEE",
    "name": "Cheikh Larbi Tébessi Airport",
    "city": "Tébessi"
  },
  {
    "iata": "BLJ",
    "name": "Batna Mostefa Ben Boulaid Airport",
    "city": "Batna"
  },
  {
    "iata": "HRM",
    "name": "Hassi R'Mel Airport",
    "city": "Hassi R'Mel"
  },
  {
    "iata": "TID",
    "name": "Abdelhafid Boussouf Bou Chekif Airport",
    "city": "Tiaret"
  },
  {
    "iata": "TIN",
    "name": "Tindouf Airport",
    "city": "Tindouf"
  },
  {
    "iata": "CFK",
    "name": "Chlef Aboubakr Belkaid International Airport",
    "city": "Chlef"
  },
  {
    "iata": "TAF",
    "name": "Oran Tafraoui Airport",
    "city": "Tafraoui"
  },
  {
    "iata": "TLM",
    "name": "Zenata – Messali El Hadj Airport",
    "city": "Zenata"
  },
  {
    "iata": "ORN",
    "name": "Oran Es-Sénia (Ahmed Ben Bella) International Airport",
    "city": "Es-Sénia"
  },
  {
    "iata": "CBH",
    "name": "Béchar Boudghene Ben Ali Lotfi Airport",
    "city": "Béchar"
  },
  {
    "iata": "MUW",
    "name": "Ghriss Airport",
    "city": "Ghriss"
  },
  {
    "iata": "AZR",
    "name": "Touat Cheikh Sidi Mohamed Belkebir Airport",
    "city": "Adrar"
  },
  {
    "iata": "BSK",
    "name": "Biskra - Mohamed Khider Airport",
    "city": "Biskra"
  },
  {
    "iata": "ELG",
    "name": "El Golea Airport",
    "city": "El Menia"
  },
  {
    "iata": "GHA",
    "name": "Noumérat - Moufdi Zakaria Airport",
    "city": "El Atteuf"
  },
  {
    "iata": "HME",
    "name": "Hassi Messaoud-Oued Irara Krim Belkacem Airport",
    "city": "Hassi Messaoud"
  },
  {
    "iata": "INZ",
    "name": "In Salah Airport",
    "city": "In Salah"
  },
  {
    "iata": "TGR",
    "name": "Touggourt Sidi Madhi Airport",
    "city": "Touggourt"
  },
  {
    "iata": "LOO",
    "name": "Laghouat - Molay Ahmed Medeghri Airport",
    "city": "Laghouat"
  },
  {
    "iata": "ELU",
    "name": "Guemar Airport - مطار قمار بالوادي",
    "city": "Guemar"
  },
  {
    "iata": "TMX",
    "name": "Timimoun Airport",
    "city": "Timimoun"
  },
  {
    "iata": "OGX",
    "name": "Ain Beida Airport",
    "city": "Ouargla"
  },
  {
    "iata": "IAM",
    "name": "Zarzaitine - In Aménas Airport",
    "city": "In Aménas"
  },
  {
    "iata": "COO",
    "name": "Cadjehoun Airport",
    "city": "Cotonou"
  },
  {
    "iata": "OUA",
    "name": "Ouagadougou Airport",
    "city": "Ouagadougou"
  },
  {
    "iata": "BOY",
    "name": "Bobo Dioulasso Airport",
    "city": "Bobo Dioulasso"
  },
  {
    "iata": "ACC",
    "name": "Kotoka International Airport",
    "city": "Accra"
  },
  {
    "iata": "TML",
    "name": "Tamale Airport",
    "city": "Tamale"
  },
  {
    "iata": "KMS",
    "name": "Kumasi Airport",
    "city": "Kumasi"
  },
  {
    "iata": "NYI",
    "name": "Sunyani Airport",
    "city": "Sunyani"
  },
  {
    "iata": "TKD",
    "name": "Takoradi Airport",
    "city": "Sekondi-Takoradi"
  },
  {
    "iata": "ABJ",
    "name": "Félix-Houphouët-Boigny International Airport",
    "city": "Abidjan"
  },
  {
    "iata": "BYK",
    "name": "Bouaké Airport",
    "city": "Bouaké"
  },
  {
    "iata": "HGO",
    "name": "Korhogo Airport",
    "city": "Korhogo"
  },
  {
    "iata": "ASK",
    "name": "Yamoussoukro Airport",
    "city": "Yamoussoukro"
  },
  {
    "iata": "ABV",
    "name": "Nnamdi Azikiwe International Airport",
    "city": "Abuja"
  },
  {
    "iata": "QUO",
    "name": "Akwa Ibom International Airport",
    "city": "Uyo"
  },
  {
    "iata": "AKR",
    "name": "Akure Airport",
    "city": "Akure"
  },
  {
    "iata": "ABB",
    "name": "Asaba International Airport",
    "city": "Asaba"
  },
  {
    "iata": "BNI",
    "name": "Benin Airport",
    "city": "Benin"
  },
  {
    "iata": "CBQ",
    "name": "Margaret Ekpo International Airport",
    "city": "Calabar"
  },
  {
    "iata": "ENU",
    "name": "Akanu Ibiam International Airport",
    "city": "Enegu"
  },
  {
    "iata": "GMO",
    "name": "Gombe Lawanti International Airport",
    "city": "Gombe"
  },
  {
    "iata": "IBA",
    "name": "Ibadan Airport",
    "city": "Ibadan"
  },
  {
    "iata": "ILR",
    "name": "Ilorin International Airport",
    "city": "Ilorin"
  },
  {
    "iata": "QOW",
    "name": "Sam Mbakwe International Airport",
    "city": "Owerri"
  },
  {
    "iata": "JOS",
    "name": "Yakubu Gowon Airport",
    "city": "Jos"
  },
  {
    "iata": "KAD",
    "name": "Kaduna Airport",
    "city": "Kaduna"
  },
  {
    "iata": "KAN",
    "name": "Mallam Aminu International Airport",
    "city": "Kano"
  },
  {
    "iata": "MIU",
    "name": "Maiduguri International Airport",
    "city": "Maiduguri"
  },
  {
    "iata": "MDI",
    "name": "Makurdi Airport",
    "city": "Makurdi"
  },
  {
    "iata": "LOS",
    "name": "Murtala Muhammed International Airport",
    "city": "Lagos"
  },
  {
    "iata": "MXJ",
    "name": "Minna Airport",
    "city": "Minna"
  },
  {
    "iata": "PHC",
    "name": "Port Harcourt International Airport",
    "city": "Port Harcourt"
  },
  {
    "iata": "SKO",
    "name": "Sadiq Abubakar III International Airport",
    "city": "Sokoto"
  },
  {
    "iata": "QRW",
    "name": "Warri Airport",
    "city": "Okpe"
  },
  {
    "iata": "YOL",
    "name": "Yola Airport",
    "city": "Yola"
  },
  {
    "iata": "ZAR",
    "name": "Zaria Airport",
    "city": "Zaria"
  },
  {
    "iata": "MFQ",
    "name": "Maradi Airport",
    "city": "Maradi"
  },
  {
    "iata": "NIM",
    "name": "Diori Hamani International Airport",
    "city": "Niamey"
  },
  {
    "iata": "THZ",
    "name": "Tahoua Airport",
    "city": "Tahoua"
  },
  {
    "iata": "AJY",
    "name": "Mano Dayak International Airport",
    "city": "Agadez"
  },
  {
    "iata": "ZND",
    "name": "Zinder Airport",
    "city": "Zinder"
  },
  {
    "iata": "TBJ",
    "name": "Tabarka-Aïn Draham International Airport",
    "city": "Tabarka"
  },
  {
    "iata": "MIR",
    "name": "Monastir Habib Bourguiba International Airport",
    "city": "Monastir"
  },
  {
    "iata": "NBE",
    "name": "Enfidha - Hammamet International Airport",
    "city": "Enfidha"
  },
  {
    "iata": "TUN",
    "name": "Tunis Carthage International Airport",
    "city": "Tunis"
  },
  {
    "iata": "GAF",
    "name": "Gafsa Ksar International Airport",
    "city": "Gafsa"
  },
  {
    "iata": "GAE",
    "name": "Gabès Matmata International Airport",
    "city": "Gabès"
  },
  {
    "iata": "DJE",
    "name": "Djerba Zarzis International Airport",
    "city": "Mellita"
  },
  {
    "iata": "EBM",
    "name": "El Borma Airport",
    "city": "El Borma"
  },
  {
    "iata": "SFA",
    "name": "Sfax Thyna International Airport",
    "city": "Sfax"
  },
  {
    "iata": "TOE",
    "name": "Tozeur Nefta International Airport",
    "city": "Tozeur"
  },
  {
    "iata": "LRL",
    "name": "Niamtougou International Airport",
    "city": "Niamtougou"
  },
  {
    "iata": "LFW",
    "name": "Lomé–Tokoin International Airport",
    "city": "Lomé"
  },
  {
    "iata": "ANR",
    "name": "Antwerp International Airport (Deurne)",
    "city": "Antwerp"
  },
  {
    "iata": "BRU",
    "name": "Brussels Airport",
    "city": "Zaventem"
  },
  {
    "iata": "CRL",
    "name": "Brussels South Charleroi Airport",
    "city": "Charleroi"
  },
  {
    "iata": "KJK",
    "name": "Flanders International Airport Kortrijk-Wevelgem",
    "city": "Wevelgem"
  },
  {
    "iata": "LGG",
    "name": "Liège Airport",
    "city": "Grâce-Hollogne"
  },
  {
    "iata": "OST",
    "name": "Oostende-Brugge International Airport",
    "city": "Oostende"
  },
  {
    "iata": "AOC",
    "name": "Leipzig–Altenburg Airport",
    "city": "Nobitz"
  },
  {
    "iata": "HDF",
    "name": "Heringsdorf Airport",
    "city": "Zirchow"
  },
  {
    "iata": "FNB",
    "name": "Neubrandenburg Trollenhagen Airport",
    "city": "Trollenhagen"
  },
  {
    "iata": "BER",
    "name": "Berlin Brandenburg Airport",
    "city": "Berlin"
  },
  {
    "iata": "DRS",
    "name": "Dresden Airport",
    "city": "Dresden"
  },
  {
    "iata": "ERF",
    "name": "Erfurt-Weimar Airport",
    "city": "Erfurt"
  },
  {
    "iata": "FRA",
    "name": "Frankfurt Airport",
    "city": "Frankfurt am Main"
  },
  {
    "iata": "FMO",
    "name": "Münster Osnabrück Airport",
    "city": "Greven"
  },
  {
    "iata": "HAM",
    "name": "Hamburg Helmut Schmidt Airport",
    "city": "Hamburg"
  },
  {
    "iata": "CGN",
    "name": "Cologne Bonn Airport",
    "city": "Köln (Cologne)"
  },
  {
    "iata": "DUS",
    "name": "Düsseldorf Airport",
    "city": "Düsseldorf"
  },
  {
    "iata": "MUC",
    "name": "Munich Airport",
    "city": "Munich"
  },
  {
    "iata": "NUE",
    "name": "Nuremberg Airport",
    "city": "Nuremberg"
  },
  {
    "iata": "LEJ",
    "name": "Leipzig/Halle Airport",
    "city": "Schkeuditz"
  },
  {
    "iata": "SCN",
    "name": "Saarbrücken Airport",
    "city": "Saarbrücken"
  },
  {
    "iata": "STR",
    "name": "Stuttgart Airport",
    "city": "Stuttgart"
  },
  {
    "iata": "HAJ",
    "name": "Hannover Airport",
    "city": "Hannover"
  },
  {
    "iata": "BRE",
    "name": "Bremen Airport",
    "city": "Bremen"
  },
  {
    "iata": "HHN",
    "name": "Frankfurt-Hahn Airport",
    "city": "Frankfurt am Main (Lautzenhausen)"
  },
  {
    "iata": "MHG",
    "name": "Mannheim-City Airport",
    "city": "Mannheim"
  },
  {
    "iata": "EIB",
    "name": "Eisenach-Kindel Airport",
    "city": "Hörselberg-Hainich"
  },
  {
    "iata": "SGE",
    "name": "Siegerland Airport",
    "city": "Burbach"
  },
  {
    "iata": "XFW",
    "name": "Hamburg-Finkenwerder Airport",
    "city": "Hamburg"
  },
  {
    "iata": "KEL",
    "name": "Kiel-Holtenau Airport",
    "city": "Kiel"
  },
  {
    "iata": "LBC",
    "name": "Lübeck Blankensee Airport",
    "city": "Lübeck"
  },
  {
    "iata": "FMM",
    "name": "Memmingen Allgau Airport",
    "city": "Memmingen"
  },
  {
    "iata": "MGL",
    "name": "Mönchengladbach Airport",
    "city": "Mönchengladbach"
  },
  {
    "iata": "PAD",
    "name": "Paderborn Lippstadt Airport",
    "city": "Büren"
  },
  {
    "iata": "NRN",
    "name": "Weeze Airport",
    "city": "Weeze"
  },
  {
    "iata": "DTM",
    "name": "Dortmund Airport",
    "city": "Dortmund"
  },
  {
    "iata": "AGB",
    "name": "Augsburg Airport",
    "city": "Augsburg"
  },
  {
    "iata": "OBF",
    "name": "Oberpfaffenhofen Airport",
    "city": "Weßling"
  },
  {
    "iata": "FDH",
    "name": "Friedrichshafen Airport",
    "city": "Friedrichshafen"
  },
  {
    "iata": "BYU",
    "name": "Bayreuth Airport",
    "city": "Bindlach"
  },
  {
    "iata": "HOQ",
    "name": "Hof-Plauen Airport",
    "city": "Hof"
  },
  {
    "iata": "FKB",
    "name": "Karlsruhe Baden-Baden Airport",
    "city": "Rheinmünster"
  },
  {
    "iata": "LHA",
    "name": "Lahr Airport",
    "city": "Lahr/Schwarzwald"
  },
  {
    "iata": "BWE",
    "name": "Braunschweig-Wolfsburg Airport",
    "city": "Braunschweig"
  },
  {
    "iata": "KSF",
    "name": "Kassel Airport",
    "city": "Calden"
  },
  {
    "iata": "GWT",
    "name": "Westerland Sylt Airport",
    "city": "Sylt"
  },
  {
    "iata": "KDL",
    "name": "Kärdla Airport",
    "city": "Kärdla"
  },
  {
    "iata": "URE",
    "name": "Kuressaare Airport",
    "city": "Kuressaare"
  },
  {
    "iata": "EPU",
    "name": "Pärnu Airport",
    "city": "Pärnu"
  },
  {
    "iata": "TLL",
    "name": "Lennart Meri Tallinn Airport",
    "city": "Tallinn"
  },
  {
    "iata": "TAY",
    "name": "Tartu Airport",
    "city": "Reola"
  },
  {
    "iata": "ENF",
    "name": "Enontekio Airport",
    "city": "Enontekio"
  },
  {
    "iata": "KEV",
    "name": "Halli Airport",
    "city": "Jämsä"
  },
  {
    "iata": "HEL",
    "name": "Helsinki Vantaa Airport",
    "city": "Helsinki (Vantaa)"
  },
  {
    "iata": "KTQ",
    "name": "Kitee Airport",
    "city": "Kitee"
  },
  {
    "iata": "IVL",
    "name": "Ivalo Airport",
    "city": "Ivalo"
  },
  {
    "iata": "JOE",
    "name": "Joensuu Airport",
    "city": "Joensuu"
  },
  {
    "iata": "JYV",
    "name": "Jyväskylä Airport",
    "city": "Jyväskylän Maalaiskunta"
  },
  {
    "iata": "KAU",
    "name": "Kauhava Airfield",
    "city": "Kauhava"
  },
  {
    "iata": "KEM",
    "name": "Kemi-Tornio Airport",
    "city": "Kemi / Tornio"
  },
  {
    "iata": "KAJ",
    "name": "Kajaani Airport",
    "city": "Kajaani"
  },
  {
    "iata": "KHJ",
    "name": "Kauhajoki Airfield",
    "city": "Kauhajoki"
  },
  {
    "iata": "KOK",
    "name": "Kokkola-Pietarsaari Airport",
    "city": "Kokkola / Kruunupyy"
  },
  {
    "iata": "KAO",
    "name": "Kuusamo Airport",
    "city": "Kuusamo"
  },
  {
    "iata": "KTT",
    "name": "Kittilä Airport",
    "city": "Kittilä"
  },
  {
    "iata": "KUO",
    "name": "Kuopio Airport",
    "city": "Kuopio / Siilinjärvi"
  },
  {
    "iata": "LPP",
    "name": "Lappeenranta Airport",
    "city": "Lappeenranta"
  },
  {
    "iata": "MHQ",
    "name": "Mariehamn Airport",
    "city": "Mariehamn"
  },
  {
    "iata": "MIK",
    "name": "Mikkeli Airport",
    "city": "Mikkeli"
  },
  {
    "iata": "OUL",
    "name": "Oulu Airport",
    "city": "Oulu / Oulunsalo"
  },
  {
    "iata": "POR",
    "name": "Pori Airport",
    "city": "Pori"
  },
  {
    "iata": "RVN",
    "name": "Rovaniemi Airport",
    "city": "Rovaniemi"
  },
  {
    "iata": "SVL",
    "name": "Savonlinna Airport",
    "city": "Savonlinna"
  },
  {
    "iata": "SJY",
    "name": "Seinäjoki Airport",
    "city": "Seinäjoki / Ilmajoki"
  },
  {
    "iata": "SOT",
    "name": "Sodankyla Airport",
    "city": "Sodankyla"
  },
  {
    "iata": "TMP",
    "name": "Tampere-Pirkkala Airport",
    "city": "Tampere / Pirkkala"
  },
  {
    "iata": "TKU",
    "name": "Turku Airport",
    "city": "Turku"
  },
  {
    "iata": "UTI",
    "name": "Utti Air Base",
    "city": "Utti / Valkeala"
  },
  {
    "iata": "VAA",
    "name": "Vaasa Airport",
    "city": "Vaasa"
  },
  {
    "iata": "VRK",
    "name": "Varkaus Airport",
    "city": "Varkaus / Joroinen"
  },
  {
    "iata": "YLI",
    "name": "Ylivieska Airfield",
    "city": "Ylivieska"
  },
  {
    "iata": "BFS",
    "name": "Belfast International Airport",
    "city": "Belfast"
  },
  {
    "iata": "ENK",
    "name": "Enniskillen/St Angelo Airport",
    "city": "Enniskillen"
  },
  {
    "iata": "BHD",
    "name": "George Best Belfast City Airport",
    "city": "Belfast"
  },
  {
    "iata": "LDY",
    "name": "City of Derry Airport",
    "city": "Derry"
  },
  {
    "iata": "BHX",
    "name": "Birmingham Airport",
    "city": "Birmingham, West Midlands"
  },
  {
    "iata": "CVT",
    "name": "Coventry Airport",
    "city": "Coventry, West Midlands"
  },
  {
    "iata": "GLO",
    "name": "Gloucestershire Airport",
    "city": "Staverton"
  },
  {
    "iata": "NQT",
    "name": "Nottingham Airport",
    "city": "Nottingham"
  },
  {
    "iata": "MAN",
    "name": "Manchester Airport",
    "city": "Manchester, Greater Manchester"
  },
  {
    "iata": "YEO",
    "name": "RNAS Yeovilton",
    "city": "Yeovil, Somerset"
  },
  {
    "iata": "CAL",
    "name": "Campbeltown Airport",
    "city": "Campbeltown"
  },
  {
    "iata": "EOI",
    "name": "Eday Airport",
    "city": "Eday"
  },
  {
    "iata": "HAW",
    "name": "Haverfordwest Airport",
    "city": "Haverfordwest"
  },
  {
    "iata": "CWL",
    "name": "Cardiff International Airport",
    "city": "Rhoose, Vale of Glamorgan"
  },
  {
    "iata": "SWS",
    "name": "Swansea Airport",
    "city": "Swansea"
  },
  {
    "iata": "BRS",
    "name": "Bristol Airport",
    "city": "Bristol"
  },
  {
    "iata": "LPL",
    "name": "Liverpool John Lennon Airport",
    "city": "Liverpool"
  },
  {
    "iata": "LTN",
    "name": "London Luton Airport",
    "city": "Luton, Bedfordshire"
  },
  {
    "iata": "BOH",
    "name": "Bournemouth Airport",
    "city": "Christchurch, Dorset"
  },
  {
    "iata": "SOU",
    "name": "Southampton Airport",
    "city": "Southampton"
  },
  {
    "iata": "NQY",
    "name": "Cornwall Airport Newquay",
    "city": "Newquay"
  },
  {
    "iata": "ACI",
    "name": "Alderney Airport",
    "city": "Saint Anne"
  },
  {
    "iata": "GCI",
    "name": "Guernsey Airport",
    "city": "Saint Peter Port"
  },
  {
    "iata": "JER",
    "name": "Jersey Airport",
    "city": "Saint Helier"
  },
  {
    "iata": "ESH",
    "name": "Brighton City Airport",
    "city": "Brighton, East Sussex"
  },
  {
    "iata": "BQH",
    "name": "London Biggin Hill Airport",
    "city": "London"
  },
  {
    "iata": "LGW",
    "name": "London Gatwick Airport",
    "city": "London"
  },
  {
    "iata": "LCY",
    "name": "London City Airport",
    "city": "London"
  },
  {
    "iata": "FAB",
    "name": "Farnborough Airport",
    "city": "Farnborough, Hampshire"
  },
  {
    "iata": "BBS",
    "name": "Blackbushe Airport",
    "city": "Camberley, Surrey"
  },
  {
    "iata": "LHR",
    "name": "London Heathrow Airport",
    "city": "London"
  },
  {
    "iata": "SEN",
    "name": "London Southend Airport",
    "city": "Southend-on-Sea, Essex"
  },
  {
    "iata": "LYX",
    "name": "Lydd London Ashford Airport",
    "city": "Romney Marsh, Kent"
  },
  {
    "iata": "CAX",
    "name": "Carlisle Lake District Airport",
    "city": "Carlisle"
  },
  {
    "iata": "BLK",
    "name": "Blackpool International Airport",
    "city": "Blackpool"
  },
  {
    "iata": "HUY",
    "name": "Humberside Airport",
    "city": "Grimsby, Lincolnshire"
  },
  {
    "iata": "BWF",
    "name": "Barrow Walney Island Airport",
    "city": "Barrow-in-Furness"
  },
  {
    "iata": "LBA",
    "name": "Leeds Bradford Airport",
    "city": "Leeds, West Yorkshire"
  },
  {
    "iata": "WRT",
    "name": "Warton Aerodrome",
    "city": "Warton"
  },
  {
    "iata": "CEG",
    "name": "Hawarden Airport",
    "city": "Broughton"
  },
  {
    "iata": "IOM",
    "name": "Isle of Man Airport",
    "city": "Castletown"
  },
  {
    "iata": "NCL",
    "name": "Newcastle International Airport",
    "city": "Newcastle upon Tyne, Tyne and Wear"
  },
  {
    "iata": "MME",
    "name": "Teesside International Airport",
    "city": "Darlington, Durham"
  },
  {
    "iata": "EMA",
    "name": "East Midlands Airport",
    "city": "Nottingham"
  },
  {
    "iata": "VLY",
    "name": "Anglesey Airport",
    "city": "Angelsey"
  },
  {
    "iata": "KOI",
    "name": "Kirkwall Airport",
    "city": "Orkney Islands"
  },
  {
    "iata": "LSI",
    "name": "Sumburgh Airport",
    "city": "Lerwick"
  },
  {
    "iata": "WIC",
    "name": "Wick Airport",
    "city": "Wick"
  },
  {
    "iata": "ABZ",
    "name": "Aberdeen Dyce Airport",
    "city": "Aberdeen"
  },
  {
    "iata": "INV",
    "name": "Inverness Airport",
    "city": "Inverness"
  },
  {
    "iata": "GLA",
    "name": "Glasgow International Airport",
    "city": "Paisley, Renfrewshire"
  },
  {
    "iata": "EDI",
    "name": "Edinburgh Airport",
    "city": "Edinburgh"
  },
  {
    "iata": "ILY",
    "name": "Islay Airport",
    "city": "Isle of Islay, Argyll and Bute"
  },
  {
    "iata": "PIK",
    "name": "Glasgow Prestwick Airport",
    "city": "Prestwick, South Ayrshire"
  },
  {
    "iata": "BEB",
    "name": "Benbecula Airport",
    "city": "Balivanich"
  },
  {
    "iata": "DND",
    "name": "Dundee Airport",
    "city": "Dundee"
  },
  {
    "iata": "SYY",
    "name": "Stornoway Airport",
    "city": "Stornoway, Western Isles"
  },
  {
    "iata": "BRR",
    "name": "Barra Airport",
    "city": "Eoligarry"
  },
  {
    "iata": "TRE",
    "name": "Tiree Airport",
    "city": "Balemartine"
  },
  {
    "iata": "ADX",
    "name": "Leuchars Station Airfield",
    "city": "Leuchars, Fife"
  },
  {
    "iata": "LMO",
    "name": "RAF Lossiemouth",
    "city": "Lossiemouth"
  },
  {
    "iata": "CBG",
    "name": "Cambridge City Airport",
    "city": "Cambridge, Cambridgeshire"
  },
  {
    "iata": "NWI",
    "name": "Norwich Airport",
    "city": "Norwich, Norfolk"
  },
  {
    "iata": "STN",
    "name": "London Stansted Airport",
    "city": "London"
  },
  {
    "iata": "EXT",
    "name": "Exeter International Airport",
    "city": "Exeter, Devon"
  },
  {
    "iata": "OXF",
    "name": "Oxford (Kidlington) Airport",
    "city": "Kidlington, Oxfordshire"
  },
  {
    "iata": "BEX",
    "name": "RAF Benson",
    "city": "Wallingford, Oxfordshire"
  },
  {
    "iata": "LKZ",
    "name": "RAF Lakenheath",
    "city": "Brandon, Suffolk"
  },
  {
    "iata": "MHZ",
    "name": "RAF Mildenhall",
    "city": "Bury Saint Edmunds, Suffolk"
  },
  {
    "iata": "FFD",
    "name": "RAF Fairford",
    "city": "Fairford, Gloucestershire"
  },
  {
    "iata": "BZZ",
    "name": "RAF Brize Norton",
    "city": "Carterton, Oxfordshire"
  },
  {
    "iata": "ODH",
    "name": "RAF Odiham",
    "city": "Hook, Hampshire"
  },
  {
    "iata": "NHT",
    "name": "RAF Northolt",
    "city": "London"
  },
  {
    "iata": "QCY",
    "name": "RAF Coningsby",
    "city": "Lincoln, Lincolnshire"
  },
  {
    "iata": "BEQ",
    "name": "RAF Honington",
    "city": "Bury Saint Edmunds, Suffolk"
  },
  {
    "iata": "WTN",
    "name": "RAF Waddington",
    "city": "Lincoln, Lincolnshire"
  },
  {
    "iata": "KNF",
    "name": "RAF Marham",
    "city": "King's Lynn, Norfolk"
  },
  {
    "iata": "MPN",
    "name": "Mount Pleasant Airport",
    "city": "Mount Pleasant"
  },
  {
    "iata": "AMS",
    "name": "Amsterdam Airport Schiphol",
    "city": "Amsterdam"
  },
  {
    "iata": "MST",
    "name": "Maastricht Aachen Airport",
    "city": "Maastricht"
  },
  {
    "iata": "EIN",
    "name": "Eindhoven Airport",
    "city": "Eindhoven"
  },
  {
    "iata": "GRQ",
    "name": "Groningen Airport Eelde",
    "city": "Groningen"
  },
  {
    "iata": "GLZ",
    "name": "Gilze Rijen Air Base",
    "city": "Rijen"
  },
  {
    "iata": "DHR",
    "name": "De Kooy Airfield / Den Helder Naval Air Station",
    "city": "Den Helder"
  },
  {
    "iata": "LEY",
    "name": "Lelystad Airport",
    "city": "Lelystad"
  },
  {
    "iata": "LWR",
    "name": "Leeuwarden Air Base",
    "city": "Leeuwarden"
  },
  {
    "iata": "RTM",
    "name": "Rotterdam The Hague Airport",
    "city": "Rotterdam"
  },
  {
    "iata": "ENS",
    "name": "Twente Airport",
    "city": "Enschede"
  },
  {
    "iata": "UDE",
    "name": "Volkel Air Base",
    "city": "Uden"
  },
  {
    "iata": "WOE",
    "name": "Woensdrecht Air Base",
    "city": "Hoogerheide"
  },
  {
    "iata": "ORK",
    "name": "Cork Airport",
    "city": "Cork"
  },
  {
    "iata": "GWY",
    "name": "Galway Airport",
    "city": "Galway"
  },
  {
    "iata": "CFN",
    "name": "Donegal Airport",
    "city": "Donegal"
  },
  {
    "iata": "DUB",
    "name": "Dublin Airport",
    "city": "Dublin"
  },
  {
    "iata": "NOC",
    "name": "Ireland West Knock Airport",
    "city": "Charlestown"
  },
  {
    "iata": "KIR",
    "name": "Kerry Airport",
    "city": "Killarney"
  },
  {
    "iata": "SNN",
    "name": "Shannon Airport",
    "city": "Shannon"
  },
  {
    "iata": "SXL",
    "name": "Sligo Airport",
    "city": "Sligo"
  },
  {
    "iata": "WAT",
    "name": "Waterford Airport",
    "city": "Waterford"
  },
  {
    "iata": "AAR",
    "name": "Aarhus Airport",
    "city": "Aarhus"
  },
  {
    "iata": "BLL",
    "name": "Billund Airport",
    "city": "Billund"
  },
  {
    "iata": "CPH",
    "name": "Copenhagen Kastrup Airport",
    "city": "Copenhagen"
  },
  {
    "iata": "EBJ",
    "name": "Esbjerg Airport",
    "city": "Esbjerg"
  },
  {
    "iata": "KRP",
    "name": "Midtjyllands Airport / Air Base Karup",
    "city": "Karup"
  },
  {
    "iata": "MRW",
    "name": "Lolland Falster Maribo Airport",
    "city": "Rødby"
  },
  {
    "iata": "ODE",
    "name": "Odense Hans Christian Andersen Airport",
    "city": "Odense"
  },
  {
    "iata": "RKE",
    "name": "Copenhagen Roskilde Airport",
    "city": "Roskilde"
  },
  {
    "iata": "RNN",
    "name": "Bornholm Airport",
    "city": "Rønne"
  },
  {
    "iata": "SGD",
    "name": "Sønderborg Airport",
    "city": "Sønderborg"
  },
  {
    "iata": "CNL",
    "name": "Sindal Airport",
    "city": "Sindal"
  },
  {
    "iata": "SKS",
    "name": "Skrydstrup Air Base",
    "city": "Vojens"
  },
  {
    "iata": "SQW",
    "name": "Skive Airport",
    "city": "Skive"
  },
  {
    "iata": "TED",
    "name": "Thisted Airport",
    "city": "Thisted"
  },
  {
    "iata": "FAE",
    "name": "Vágar Airport",
    "city": "Vágar"
  },
  {
    "iata": "STA",
    "name": "Stauning Vestjylland  Airport",
    "city": "Skjern"
  },
  {
    "iata": "AAL",
    "name": "Aalborg Airport",
    "city": "Aalborg"
  },
  {
    "iata": "LUX",
    "name": "Luxembourg-Findel International Airport",
    "city": "Luxembourg"
  },
  {
    "iata": "AES",
    "name": "Ålesund Airport, Vigra",
    "city": "Ålesund"
  },
  {
    "iata": "ANX",
    "name": "Andøya Airport, Andenes",
    "city": "Andenes"
  },
  {
    "iata": "ALF",
    "name": "Alta Airport",
    "city": "Alta"
  },
  {
    "iata": "BNN",
    "name": "Brønnøysund Airport, Brønnøy",
    "city": "Brønnøy"
  },
  {
    "iata": "BOO",
    "name": "Bodø Airport",
    "city": "Bodø"
  },
  {
    "iata": "BGO",
    "name": "Bergen Airport, Flesland",
    "city": "Bergen"
  },
  {
    "iata": "BJF",
    "name": "Båtsfjord Airport",
    "city": "Båtsfjord"
  },
  {
    "iata": "BVG",
    "name": "Berlevåg Airport",
    "city": "Berlevåg"
  },
  {
    "iata": "KRS",
    "name": "Kristiansand Airport, Kjevik",
    "city": "Kjevik"
  },
  {
    "iata": "BDU",
    "name": "Bardufoss Airport",
    "city": "Målselv"
  },
  {
    "iata": "EVE",
    "name": "Harstad/Narvik Airport, Evenes",
    "city": "Evenes"
  },
  {
    "iata": "VDB",
    "name": "Fagernes Airport, Leirin",
    "city": "Fagernes"
  },
  {
    "iata": "FRO",
    "name": "Florø Airport",
    "city": "Florø"
  },
  {
    "iata": "OSL",
    "name": "Oslo Airport, Gardermoen",
    "city": "Oslo (Gardermoen)"
  },
  {
    "iata": "HAU",
    "name": "Haugesund Airport, Karmøy",
    "city": "Karmøy"
  },
  {
    "iata": "HFT",
    "name": "Hammerfest Airport",
    "city": "Hammerfest"
  },
  {
    "iata": "HVG",
    "name": "Honningsvåg Airport, Valan",
    "city": "Honningsvåg"
  },
  {
    "iata": "KSU",
    "name": "Kristiansund Airport, Kvernberget",
    "city": "Kvernberget"
  },
  {
    "iata": "KKN",
    "name": "Kirkenes Airport, Høybuktmoen",
    "city": "Kirkenes"
  },
  {
    "iata": "LKN",
    "name": "Leknes Airport",
    "city": "Leknes"
  },
  {
    "iata": "MEH",
    "name": "Mehamn Airport",
    "city": "Mehamn"
  },
  {
    "iata": "MOL",
    "name": "Molde Airport, Årø",
    "city": "Årø"
  },
  {
    "iata": "MJF",
    "name": "Mosjøen Airport, Kjærstad",
    "city": "Mosjøen"
  },
  {
    "iata": "LKL",
    "name": "Lakselv Airport, Banak",
    "city": "Lakselv"
  },
  {
    "iata": "NTB",
    "name": "Notodden Airport",
    "city": "Notodden"
  },
  {
    "iata": "OLA",
    "name": "Ørland Airport",
    "city": "Ørland"
  },
  {
    "iata": "HOV",
    "name": "Ørsta-Volda Airport, Hovden",
    "city": "Ørsta"
  },
  {
    "iata": "MQN",
    "name": "Mo i Rana Airport, Røssvoll",
    "city": "Mo i Rana"
  },
  {
    "iata": "RVK",
    "name": "Rørvik Airport, Ryum",
    "city": "Rørvik"
  },
  {
    "iata": "RRS",
    "name": "Røros Airport",
    "city": "Røros"
  },
  {
    "iata": "RYG",
    "name": "Moss Airport, Rygge",
    "city": "Oslo"
  },
  {
    "iata": "LYR",
    "name": "Svalbard Airport, Longyear",
    "city": "Longyearbyen"
  },
  {
    "iata": "SVJ",
    "name": "Svolvær Airport, Helle",
    "city": "Svolvær"
  },
  {
    "iata": "SKN",
    "name": "Stokmarknes Airport, Skagen",
    "city": "Hadsel"
  },
  {
    "iata": "SKE",
    "name": "Skien Airport",
    "city": "Geiteryggen"
  },
  {
    "iata": "SRP",
    "name": "Stord Airport, Sørstokken",
    "city": "Leirvik"
  },
  {
    "iata": "SOJ",
    "name": "Sørkjosen Airport",
    "city": "Sørkjosen"
  },
  {
    "iata": "VAW",
    "name": "Vardø Airport, Svartnes",
    "city": "Vardø"
  },
  {
    "iata": "SSJ",
    "name": "Sandnessjøen Airport, Stokka",
    "city": "Alstahaug"
  },
  {
    "iata": "TOS",
    "name": "Tromsø Airport, Langnes",
    "city": "Tromsø"
  },
  {
    "iata": "TRF",
    "name": "Sandefjord Airport, Torp",
    "city": "Torp"
  },
  {
    "iata": "TRD",
    "name": "Trondheim Airport, Værnes",
    "city": "Trondheim"
  },
  {
    "iata": "VDS",
    "name": "Vadsø Airport",
    "city": "Vadsø"
  },
  {
    "iata": "SVG",
    "name": "Stavanger Airport, Sola",
    "city": "Stavanger"
  },
  {
    "iata": "BZG",
    "name": "Bydgoszcz Ignacy Jan Paderewski Airport",
    "city": "Bydgoszcz"
  },
  {
    "iata": "GDN",
    "name": "Gdańsk Lech Wałęsa Airport",
    "city": "Gdańsk"
  },
  {
    "iata": "KRK",
    "name": "Kraków John Paul II International Airport",
    "city": "Balice"
  },
  {
    "iata": "KTW",
    "name": "Katowice Wojciech Korfanty International Airport",
    "city": "Katowice"
  },
  {
    "iata": "LUZ",
    "name": "Lublin Airport",
    "city": "Lublin"
  },
  {
    "iata": "LCJ",
    "name": "Łódź Władysław Reymont Airport",
    "city": "Łódź"
  },
  {
    "iata": "WMI",
    "name": "Modlin Airport",
    "city": "Nowy Dwór Mazowiecki"
  },
  {
    "iata": "POZ",
    "name": "Poznań-Ławica Airport",
    "city": "Poznań"
  },
  {
    "iata": "RDO",
    "name": "Warsaw Radom Airport",
    "city": "Radom"
  },
  {
    "iata": "RZE",
    "name": "Rzeszów-Jasionka Airport",
    "city": "Jasionka"
  },
  {
    "iata": "SZZ",
    "name": "Solidarity Szczecin–Goleniów Airport",
    "city": "Glewice"
  },
  {
    "iata": "SZY",
    "name": "Olsztyn-Mazury Airport",
    "city": "Szymany"
  },
  {
    "iata": "WAW",
    "name": "Warsaw Chopin Airport",
    "city": "Warsaw"
  },
  {
    "iata": "WRO",
    "name": "Copernicus Wrocław Airport",
    "city": "Wrocław"
  },
  {
    "iata": "IEG",
    "name": "Zielona Góra-Babimost Airport",
    "city": "Nowe Kramsko"
  },
  {
    "iata": "RNB",
    "name": "Ronneby Airport",
    "city": "Ronneby"
  },
  {
    "iata": "GOT",
    "name": "Göteborg Landvetter Airport",
    "city": "Göteborg"
  },
  {
    "iata": "JKG",
    "name": "Jönköping Airport",
    "city": "Jönköping"
  },
  {
    "iata": "GSE",
    "name": "Säve Airport",
    "city": "Göteborg"
  },
  {
    "iata": "KVB",
    "name": "Skövde Airport",
    "city": "Skövde"
  },
  {
    "iata": "THN",
    "name": "Trollhättan-Vänersborg Airport",
    "city": "Trollhättan"
  },
  {
    "iata": "KSK",
    "name": "Karlskoga Airport",
    "city": "Karlskoga"
  },
  {
    "iata": "MXX",
    "name": "Mora Airport",
    "city": "Mora"
  },
  {
    "iata": "NYO",
    "name": "Stockholm Skavsta Airport",
    "city": "Nyköping"
  },
  {
    "iata": "KID",
    "name": "Kristianstad Airport",
    "city": "Kristianstad"
  },
  {
    "iata": "KLR",
    "name": "Kalmar Airport",
    "city": "Kalmar"
  },
  {
    "iata": "MMX",
    "name": "Malmö Sturup Airport",
    "city": "Malmö"
  },
  {
    "iata": "HAD",
    "name": "Halmstad Airport",
    "city": "Halmstad"
  },
  {
    "iata": "VXO",
    "name": "Växjö Kronoberg Airport",
    "city": "Växjö"
  },
  {
    "iata": "GEV",
    "name": "Gällivare Airport",
    "city": "Gällivare"
  },
  {
    "iata": "KRF",
    "name": "Kramfors-Sollefteå Höga Kusten Airport",
    "city": "Nyland"
  },
  {
    "iata": "LYC",
    "name": "Lycksele Airport",
    "city": "Lycksele"
  },
  {
    "iata": "SDL",
    "name": "Sundsvall-Härnösand Airport",
    "city": "Sundsvall/ Härnösand"
  },
  {
    "iata": "OER",
    "name": "Örnsköldsvik Airport",
    "city": "Örnsköldsvik"
  },
  {
    "iata": "KRN",
    "name": "Kiruna Airport",
    "city": "Kiruna"
  },
  {
    "iata": "SFT",
    "name": "Skellefteå Airport",
    "city": "Skellefteå"
  },
  {
    "iata": "UME",
    "name": "Umeå Airport",
    "city": "Umeå"
  },
  {
    "iata": "VHM",
    "name": "Vilhelmina South Lapland Airport",
    "city": "Vilhelmina"
  },
  {
    "iata": "AJR",
    "name": "Arvidsjaur Airport",
    "city": "Arvidsjaur"
  },
  {
    "iata": "SOO",
    "name": "Söderhamn Airport",
    "city": "Söderhamn"
  },
  {
    "iata": "OSD",
    "name": "Åre Östersund Airport",
    "city": "Östersund"
  },
  {
    "iata": "ORB",
    "name": "Örebro Airport",
    "city": "Örebro"
  },
  {
    "iata": "KSD",
    "name": "Karlstad Airport",
    "city": "Karlstad"
  },
  {
    "iata": "VST",
    "name": "Stockholm Västerås Airport",
    "city": "Stockholm / Västerås"
  },
  {
    "iata": "LLA",
    "name": "Luleå Airport",
    "city": "Luleå"
  },
  {
    "iata": "ARN",
    "name": "Stockholm-Arlanda Airport",
    "city": "Stockholm"
  },
  {
    "iata": "BMA",
    "name": "Stockholm-Bromma Airport",
    "city": "Stockholm"
  },
  {
    "iata": "BLE",
    "name": "Dala Airport",
    "city": "Borlange"
  },
  {
    "iata": "GVX",
    "name": "Gävle Sandviken Airport",
    "city": "Gävle / Sandviken"
  },
  {
    "iata": "LPI",
    "name": "Linköping City Airport",
    "city": "Linköping"
  },
  {
    "iata": "NRK",
    "name": "Norrköping Airport",
    "city": "Norrköping"
  },
  {
    "iata": "TYF",
    "name": "Torsby Airport",
    "city": "Torsby"
  },
  {
    "iata": "EKT",
    "name": "Eskilstuna Airport",
    "city": "Eskilstuna"
  },
  {
    "iata": "VBY",
    "name": "Visby Airport",
    "city": "Visby"
  },
  {
    "iata": "AGH",
    "name": "Ängelholm-Helsingborg Airport",
    "city": "Ängelholm"
  },
  {
    "iata": "SQO",
    "name": "Storuman Airport",
    "city": "Storuman"
  },
  {
    "iata": "SPM",
    "name": "Spangdahlem Air Base",
    "city": "Trier"
  },
  {
    "iata": "RMS",
    "name": "Ramstein Air Base",
    "city": "Ramstein-Miesenbach"
  },
  {
    "iata": "FRZ",
    "name": "Fritzlar Army Airfield",
    "city": "Fritzlar"
  },
  {
    "iata": "FCN",
    "name": "Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase",
    "city": "Wurster Nordseeküste"
  },
  {
    "iata": "GKE",
    "name": "Geilenkirchen Air Base",
    "city": "Geilenkirchen"
  },
  {
    "iata": "RLG",
    "name": "Rostock-Laage Airport",
    "city": "Laage"
  },
  {
    "iata": "WBG",
    "name": "Schleswig Air Base",
    "city": "Jagel"
  },
  {
    "iata": "WIE",
    "name": "Wiesbaden Army Airfield",
    "city": "Wiesbaden"
  },
  {
    "iata": "IGS",
    "name": "Ingolstadt Manching Airport",
    "city": "Manching"
  },
  {
    "iata": "LPX",
    "name": "Liepāja International Airport",
    "city": "Liepāja"
  },
  {
    "iata": "RIX",
    "name": "Riga International Airport",
    "city": "Riga"
  },
  {
    "iata": "KUN",
    "name": "Kaunas International Airport",
    "city": "Kaunas"
  },
  {
    "iata": "PLQ",
    "name": "Palanga International Airport",
    "city": "Palanga"
  },
  {
    "iata": "PNV",
    "name": "Panevėžys Air Base",
    "city": "Panevėžys"
  },
  {
    "iata": "SQQ",
    "name": "Šiauliai International Airport",
    "city": "Šiauliai"
  },
  {
    "iata": "VNO",
    "name": "Vilnius International Airport",
    "city": "Vilnius"
  },
  {
    "iata": "ALJ",
    "name": "Alexander Bay Airport",
    "city": "Alexander Bay"
  },
  {
    "iata": "AGZ",
    "name": "Aggeneys Airport",
    "city": "Aggeneys"
  },
  {
    "iata": "BIY",
    "name": "Bisho Airport",
    "city": "Bisho"
  },
  {
    "iata": "BFN",
    "name": "Bram Fischer International Airport",
    "city": "Bloemfontain"
  },
  {
    "iata": "CPT",
    "name": "Cape Town International Airport",
    "city": "Cape Town"
  },
  {
    "iata": "ELS",
    "name": "King Phalo Airport",
    "city": "East London"
  },
  {
    "iata": "FCB",
    "name": "Ficksburg Sentraoes Airport",
    "city": "Ficksburg"
  },
  {
    "iata": "GCJ",
    "name": "Grand Central Airport",
    "city": "Midrand"
  },
  {
    "iata": "GRJ",
    "name": "George Airport",
    "city": "George"
  },
  {
    "iata": "QRA",
    "name": "Rand Airport",
    "city": "Johannesburg"
  },
  {
    "iata": "HRS",
    "name": "Harrismith Airport",
    "city": "Harrismith"
  },
  {
    "iata": "KXE",
    "name": "P C Pelser Airport",
    "city": "Klerksdorp"
  },
  {
    "iata": "KIM",
    "name": "Kimberley Airport",
    "city": "Kimberley"
  },
  {
    "iata": "MQP",
    "name": "Kruger Mpumalanga International Airport",
    "city": "Mpumalanga"
  },
  {
    "iata": "KMH",
    "name": "Johan Pienaar Airport",
    "city": "Kuruman"
  },
  {
    "iata": "KLZ",
    "name": "Kleinsee Airport",
    "city": "Kleinsee"
  },
  {
    "iata": "HLA",
    "name": "Lanseria International Airport",
    "city": "Johannesburg"
  },
  {
    "iata": "LMR",
    "name": "Lime Acres Finsch Mine Airport",
    "city": "Lime Acres"
  },
  {
    "iata": "DUR",
    "name": "King Shaka International Airport",
    "city": "Durban"
  },
  {
    "iata": "SDB",
    "name": "Langebaanweg Airport",
    "city": "Langebaanweg"
  },
  {
    "iata": "LAY",
    "name": "Ladysmith Airport",
    "city": "Ladysmith"
  },
  {
    "iata": "AAM",
    "name": "Malamala Airport",
    "city": "Malamala"
  },
  {
    "iata": "MGH",
    "name": "Margate Airport",
    "city": "Margate"
  },
  {
    "iata": "MBD",
    "name": "Mmabatho International Airport",
    "city": "Mafeking"
  },
  {
    "iata": "MZQ",
    "name": "Mkuze Airport",
    "city": "Mkuze"
  },
  {
    "iata": "NCS",
    "name": "Newcastle Airport",
    "city": "Newcastle"
  },
  {
    "iata": "OUH",
    "name": "Oudtshoorn Airport",
    "city": "Oudtshoorn"
  },
  {
    "iata": "JNB",
    "name": "O.R. Tambo International Airport",
    "city": "Johannesburg"
  },
  {
    "iata": "PLZ",
    "name": "Chief Dawid Stuurman International Airport",
    "city": "Gqeberha (Port Elizabeth)"
  },
  {
    "iata": "PBZ",
    "name": "Plettenberg Bay Airport",
    "city": "Plettenberg Bay"
  },
  {
    "iata": "PHW",
    "name": "Hendrik Van Eck Airport",
    "city": "Phalaborwa"
  },
  {
    "iata": "JOH",
    "name": "Port St Johns Airport",
    "city": "Port St Johns"
  },
  {
    "iata": "PZB",
    "name": "Pietermaritzburg Airport",
    "city": "Pietermaritzburg"
  },
  {
    "iata": "PTG",
    "name": "Polokwane International Airport",
    "city": "Polokwane"
  },
  {
    "iata": "PCF",
    "name": "Potchefstroom Airport",
    "city": "Potchefstroom"
  },
  {
    "iata": "UTW",
    "name": "Queenstown Airport",
    "city": "Queenstown"
  },
  {
    "iata": "RCB",
    "name": "Richards Bay Airport",
    "city": "Richards Bay"
  },
  {
    "iata": "ROD",
    "name": "Robertson Airport",
    "city": "Robertson"
  },
  {
    "iata": "SBU",
    "name": "Springbok Airport",
    "city": "Springbok"
  },
  {
    "iata": "ZEC",
    "name": "Secunda Airport",
    "city": "Secunda"
  },
  {
    "iata": "SIS",
    "name": "Sishen Airport",
    "city": "Sishen"
  },
  {
    "iata": "SZK",
    "name": "Skukuza Airport",
    "city": "Skukuza"
  },
  {
    "iata": "LTA",
    "name": "Tzaneen Airport",
    "city": "Tzaneen"
  },
  {
    "iata": "ULD",
    "name": "Prince Mangosuthu Buthelezi Airport",
    "city": "Ulundi"
  },
  {
    "iata": "UTN",
    "name": "Pierre Van Ryneveld Airport",
    "city": "Upington"
  },
  {
    "iata": "UTT",
    "name": "K. D. Matanzima Airport",
    "city": "Mthatha"
  },
  {
    "iata": "VRU",
    "name": "Vryburg Airport",
    "city": "Vyrburg"
  },
  {
    "iata": "VIR",
    "name": "Virginia Airport",
    "city": "Durban"
  },
  {
    "iata": "VRE",
    "name": "Vredendal Airport",
    "city": "Vredendal"
  },
  {
    "iata": "PRY",
    "name": "Wonderboom Airport",
    "city": "Pretoria"
  },
  {
    "iata": "WKF",
    "name": "Waterkloof Air Force Base",
    "city": "Pretoria"
  },
  {
    "iata": "JWA",
    "name": "Jwaneng Airport",
    "city": "Jwaneng"
  },
  {
    "iata": "BBK",
    "name": "Kasane Airport",
    "city": "Kasane"
  },
  {
    "iata": "MUB",
    "name": "Maun Airport",
    "city": "Maun"
  },
  {
    "iata": "GBE",
    "name": "Sir Seretse Khama International Airport",
    "city": "Gaborone"
  },
  {
    "iata": "SXN",
    "name": "Sua Pan Airport",
    "city": "Sowa"
  },
  {
    "iata": "PKW",
    "name": "Selebi Phikwe Airport",
    "city": "Selebi Phikwe"
  },
  {
    "iata": "BZV",
    "name": "Maya-Maya Airport",
    "city": "Brazzaville"
  },
  {
    "iata": "FTX",
    "name": "Owando Airport",
    "city": "Owando"
  },
  {
    "iata": "DIS",
    "name": "Ngot Nzoungou Airport",
    "city": "Dolisie"
  },
  {
    "iata": "PNR",
    "name": "Antonio Agostinho-Neto International Airport",
    "city": "Pointe Noire"
  },
  {
    "iata": "MTS",
    "name": "Matsapha Airport",
    "city": "Manzini"
  },
  {
    "iata": "SHO",
    "name": "King Mswati III International Airport",
    "city": "Mpaka"
  },
  {
    "iata": "BGF",
    "name": "Bangui M'Poko International Airport",
    "city": "Bangui"
  },
  {
    "iata": "BBT",
    "name": "Berbérati Airport",
    "city": "Berbérati"
  },
  {
    "iata": "BSG",
    "name": "Bata Airport",
    "city": "Bata"
  },
  {
    "iata": "SSG",
    "name": "Malabo Airport",
    "city": "Malabo"
  },
  {
    "iata": "ASI",
    "name": "RAF Ascension Island",
    "city": "Cat Hill"
  },
  {
    "iata": "MRU",
    "name": "Sir Seewoosagur Ramgoolam International Airport",
    "city": "Plaine Magnien"
  },
  {
    "iata": "RRG",
    "name": "Sir Charles Gaetan Duval Airport",
    "city": "Port Mathurin"
  },
  {
    "iata": "TKC",
    "name": "Tiko Airport",
    "city": "Tiko"
  },
  {
    "iata": "DLA",
    "name": "Douala International Airport",
    "city": "Douala"
  },
  {
    "iata": "MVR",
    "name": "Salak Airport",
    "city": "Maroua"
  },
  {
    "iata": "FOM",
    "name": "Foumban Nkounja Airport",
    "city": "Foumban"
  },
  {
    "iata": "NGE",
    "name": "N'Gaoundéré Airport",
    "city": "N'Gaoundéré"
  },
  {
    "iata": "GOU",
    "name": "Garoua International Airport",
    "city": "Garoua"
  },
  {
    "iata": "BFX",
    "name": "Bafoussam Airport",
    "city": "Bafoussam"
  },
  {
    "iata": "BPC",
    "name": "Bamenda Airport",
    "city": "Bamenda"
  },
  {
    "iata": "YAO",
    "name": "Yaoundé Airport",
    "city": "Yaoundé"
  },
  {
    "iata": "NSI",
    "name": "Yaoundé Nsimalen International Airport",
    "city": "Yaoundé"
  },
  {
    "iata": "MFU",
    "name": "Mfuwe Airport",
    "city": "Mfuwe"
  },
  {
    "iata": "MNR",
    "name": "Mongu Airport",
    "city": "Mongu"
  },
  {
    "iata": "KIW",
    "name": "Southdowns Airport",
    "city": "Kitwe"
  },
  {
    "iata": "HAH",
    "name": "Prince Said Ibrahim International Airport",
    "city": "Moroni"
  },
  {
    "iata": "NWA",
    "name": "Mohéli Bandar Es Eslam Airport",
    "city": "Fomboni"
  },
  {
    "iata": "AJN",
    "name": "Ouani Airport",
    "city": "Ouani"
  },
  {
    "iata": "DZA",
    "name": "Dzaoudzi Pamandzi International Airport",
    "city": "Dzaoudzi"
  },
  {
    "iata": "RUN",
    "name": "Roland Garros Airport",
    "city": "Sainte-Marie"
  },
  {
    "iata": "ZSE",
    "name": "Pierrefonds Airport",
    "city": "Saint-Pierre"
  },
  {
    "iata": "TNR",
    "name": "Ivato Airport",
    "city": "Antananarivo"
  },
  {
    "iata": "ZVA",
    "name": "Miandrivazo Airport",
    "city": "Miandrivazo"
  },
  {
    "iata": "SMS",
    "name": "Sainte Marie Airport",
    "city": "Vohilava"
  },
  {
    "iata": "TMM",
    "name": "Toamasina Ambalamanasy Airport",
    "city": "Toamasina"
  },
  {
    "iata": "MOQ",
    "name": "Morondava Airport",
    "city": "Morondava"
  },
  {
    "iata": "DIE",
    "name": "Arrachart Airport",
    "city": "Antisiranana"
  },
  {
    "iata": "WMR",
    "name": "Mananara Nord Airport",
    "city": "Mananara Nord"
  },
  {
    "iata": "ANM",
    "name": "Antsirabe Airport",
    "city": "Antsirabe"
  },
  {
    "iata": "HVA",
    "name": "Analalava Airport",
    "city": "Analalava"
  },
  {
    "iata": "MJN",
    "name": "Amborovy Airport",
    "city": "Mahajanga"
  },
  {
    "iata": "NOS",
    "name": "Fascene Airport",
    "city": "Nosy Be"
  },
  {
    "iata": "BPY",
    "name": "Besalampy Airport",
    "city": "Besalampy"
  },
  {
    "iata": "WMN",
    "name": "Maroantsetra Airport",
    "city": "Maroantsetra"
  },
  {
    "iata": "SVB",
    "name": "Sambava Airport",
    "city": "Sambava"
  },
  {
    "iata": "VOH",
    "name": "Vohemar Airport",
    "city": "Vohemar"
  },
  {
    "iata": "WAI",
    "name": "Ambalabe Airport",
    "city": "Antsohihy"
  },
  {
    "iata": "FTU",
    "name": "Tôlanaro Airport",
    "city": "Tôlanaro"
  },
  {
    "iata": "WFI",
    "name": "Fianarantsoa Airport",
    "city": "Fianarantsoa"
  },
  {
    "iata": "WVK",
    "name": "Manakara Airport",
    "city": "Manakara"
  },
  {
    "iata": "MNJ",
    "name": "Mananjary Airport",
    "city": "Mananjary"
  },
  {
    "iata": "MXM",
    "name": "Morombe Airport",
    "city": "Morombe"
  },
  {
    "iata": "TLE",
    "name": "Toliara Airport",
    "city": "Toliara"
  },
  {
    "iata": "SSY",
    "name": "Mbanza Congo Airport",
    "city": "Mbanza Congo"
  },
  {
    "iata": "BUG",
    "name": "Benguela 17th of September Airport",
    "city": "Benguela"
  },
  {
    "iata": "NBJ",
    "name": "Dr. Antonio Agostinho Neto International Airport",
    "city": "Luanda (Ícolo e Bengo)"
  },
  {
    "iata": "CAB",
    "name": "Cabinda Airport",
    "city": "Cabinda"
  },
  {
    "iata": "CBT",
    "name": "Catumbela Airport",
    "city": "Catumbela"
  },
  {
    "iata": "DUE",
    "name": "Dundo Airport",
    "city": "Chitato"
  },
  {
    "iata": "VPE",
    "name": "Ngjiva Pereira Airport",
    "city": "Ngiva"
  },
  {
    "iata": "NOV",
    "name": "Nova Lisboa Airport",
    "city": "Huambo"
  },
  {
    "iata": "SVP",
    "name": "Kuito Airport",
    "city": "Kuito"
  },
  {
    "iata": "LAD",
    "name": "Quatro de Fevereiro International Airport",
    "city": "Luanda"
  },
  {
    "iata": "MEG",
    "name": "Malanje Airport",
    "city": "Malanje"
  },
  {
    "iata": "SPP",
    "name": "Menongue Airport",
    "city": "Menongue"
  },
  {
    "iata": "MSZ",
    "name": "Welwitschia Mirabilis International Airport",
    "city": "Moçâmedes"
  },
  {
    "iata": "GXG",
    "name": "Negage Airport",
    "city": "Negage"
  },
  {
    "iata": "PBN",
    "name": "Porto Amboim Airport",
    "city": "Port Amboim"
  },
  {
    "iata": "VHC",
    "name": "Saurimo Airport",
    "city": "Saurimo"
  },
  {
    "iata": "SZA",
    "name": "Soyo Airport",
    "city": "Soyo"
  },
  {
    "iata": "NDD",
    "name": "Sumbe Airport",
    "city": "Sumbe"
  },
  {
    "iata": "SDD",
    "name": "Lubango Airport",
    "city": "Lubango"
  },
  {
    "iata": "LUO",
    "name": "Luena Airport",
    "city": "Luena"
  },
  {
    "iata": "UGO",
    "name": "Uige Airport",
    "city": "Uige"
  },
  {
    "iata": "XGN",
    "name": "Xangongo Airport",
    "city": "Xangongo"
  },
  {
    "iata": "KOU",
    "name": "Koulamoutou Mabimbi Airport",
    "city": "Koulamoutou"
  },
  {
    "iata": "MJL",
    "name": "Mouilla Ville Airport",
    "city": "Mouila"
  },
  {
    "iata": "OYE",
    "name": "Oyem Airport",
    "city": "Oyem"
  },
  {
    "iata": "OKN",
    "name": "Okondja Airport",
    "city": "Okondja"
  },
  {
    "iata": "LBQ",
    "name": "Lambarene Airport",
    "city": "Lambarene"
  },
  {
    "iata": "BMM",
    "name": "Bitam Airport",
    "city": "Bitam"
  },
  {
    "iata": "POG",
    "name": "Port Gentil Airport",
    "city": "Port Gentil"
  },
  {
    "iata": "OMB",
    "name": "Omboue Hospital Airport",
    "city": "Omboue"
  },
  {
    "iata": "MKU",
    "name": "Makokou Airport",
    "city": "Makokou"
  },
  {
    "iata": "LBV",
    "name": "Libreville Leon M'ba International Airport",
    "city": "Libreville"
  },
  {
    "iata": "MVB",
    "name": "M'Vengue El Hadj Omar Bongo Ondimba International Airport",
    "city": "Franceville"
  },
  {
    "iata": "PCP",
    "name": "Principe Airport",
    "city": "São Tomé & Príncipe"
  },
  {
    "iata": "TMS",
    "name": "São Tomé International Airport",
    "city": "São Tomé"
  },
  {
    "iata": "BEW",
    "name": "Beira Airport",
    "city": "Beira"
  },
  {
    "iata": "VPY",
    "name": "Chimoio Airport",
    "city": "Chimoio"
  },
  {
    "iata": "INH",
    "name": "Inhambane Airport",
    "city": "Inhambane"
  },
  {
    "iata": "VXC",
    "name": "Lichinga Airport",
    "city": "Lichinga"
  },
  {
    "iata": "MPM",
    "name": "Maputo Airport",
    "city": "Maputo"
  },
  {
    "iata": "MUD",
    "name": "Mueda Airport",
    "city": "Mueda"
  },
  {
    "iata": "MZB",
    "name": "Mocímboa da Praia Airport",
    "city": "Mocímboa da Praia"
  },
  {
    "iata": "APL",
    "name": "Nampula Airport",
    "city": "Nampula"
  },
  {
    "iata": "POL",
    "name": "Pemba Airport",
    "city": "Pemba"
  },
  {
    "iata": "UEL",
    "name": "Quelimane Airport",
    "city": "Quelimane"
  },
  {
    "iata": "TET",
    "name": "Chingozi Airport",
    "city": "Tete"
  },
  {
    "iata": "VNX",
    "name": "Vilankulo Airport",
    "city": "Vilanculo"
  },
  {
    "iata": "SEZ",
    "name": "Seychelles International Airport",
    "city": "Mahe Island"
  },
  {
    "iata": "PRI",
    "name": "Praslin Island Airport",
    "city": "Praslin Island"
  },
  {
    "iata": "AEH",
    "name": "Abeche Airport",
    "city": "Abeche"
  },
  {
    "iata": "MQQ",
    "name": "Moundou Airport",
    "city": "Moundou"
  },
  {
    "iata": "NDJ",
    "name": "N'Djamena International Airport",
    "city": "N'Djamena"
  },
  {
    "iata": "FYT",
    "name": "Faya-Largeau Airport",
    "city": "Faya-Largeau"
  },
  {
    "iata": "BFO",
    "name": "Buffalo Range Airport",
    "city": "Chiredzi"
  },
  {
    "iata": "VFA",
    "name": "Victoria Falls International Airport",
    "city": "Victoria Falls"
  },
  {
    "iata": "KAB",
    "name": "Kariba International Airport",
    "city": "Kariba"
  },
  {
    "iata": "MVZ",
    "name": "Masvingo International Airport",
    "city": "Masvingo"
  },
  {
    "iata": "GWE",
    "name": "Gweru - Thornhill Air Base",
    "city": "Gweru"
  },
  {
    "iata": "HWN",
    "name": "Hwange National Park Airport",
    "city": "Gwayi River Farms"
  },
  {
    "iata": "BLZ",
    "name": "Chileka International Airport",
    "city": "Blantyre"
  },
  {
    "iata": "DWA",
    "name": "Dwangwa Airport",
    "city": "Dwangwa"
  },
  {
    "iata": "KGJ",
    "name": "Karonga Airport",
    "city": "Karonga"
  },
  {
    "iata": "LLW",
    "name": "Kamuzu International Airport",
    "city": "Lumbadzi"
  },
  {
    "iata": "ZZU",
    "name": "Mzuzu Airport",
    "city": "Mzuzu"
  },
  {
    "iata": "MSU",
    "name": "Moshoeshoe I International Airport",
    "city": "Mazenod"
  },
  {
    "iata": "ADI",
    "name": "Arandis Airport",
    "city": "Arandis"
  },
  {
    "iata": "GFY",
    "name": "Grootfontein Airport",
    "city": "Grootfontein"
  },
  {
    "iata": "MPA",
    "name": "Katima Mulilo Airport",
    "city": "Mpacha"
  },
  {
    "iata": "KMP",
    "name": "Keetmanshoop Airport",
    "city": "Keetmanshoop"
  },
  {
    "iata": "LUD",
    "name": "Luderitz Airport",
    "city": "Luderitz"
  },
  {
    "iata": "OND",
    "name": "Ondangwa Airport",
    "city": "Ondangwa"
  },
  {
    "iata": "OMD",
    "name": "Oranjemund Airport",
    "city": "Oranjemund"
  },
  {
    "iata": "NDU",
    "name": "Rundu Airport",
    "city": "Rundu"
  },
  {
    "iata": "TSB",
    "name": "Tsumeb Airport",
    "city": "Tsumeb"
  },
  {
    "iata": "WVB",
    "name": "Walvis Bay Airport",
    "city": "Rooikop"
  },
  {
    "iata": "ERS",
    "name": "Eros Airport",
    "city": "Windhoek"
  },
  {
    "iata": "WDH",
    "name": "Hosea Kutako International Airport",
    "city": "Windhoek"
  },
  {
    "iata": "FIH",
    "name": "Ndjili International Airport",
    "city": "Kinshasa"
  },
  {
    "iata": "NLO",
    "name": "Ndolo Airport",
    "city": "N'dolo"
  },
  {
    "iata": "FDU",
    "name": "Bandundu Airport",
    "city": "Bandundu"
  },
  {
    "iata": "KKW",
    "name": "Kikwit Airport",
    "city": "Kikwit"
  },
  {
    "iata": "MDK",
    "name": "Mbandaka Airport",
    "city": "Mbandaka"
  },
  {
    "iata": "BDT",
    "name": "Gbadolite Airport",
    "city": "Gbadolite"
  },
  {
    "iata": "GMA",
    "name": "Gemena Airport",
    "city": "Gemena"
  },
  {
    "iata": "LIQ",
    "name": "Lisala Airport",
    "city": "Lisala"
  },
  {
    "iata": "FKI",
    "name": "Bangoka International Airport",
    "city": "Kisangani"
  },
  {
    "iata": "IRP",
    "name": "Matari Airport",
    "city": "Isiro"
  },
  {
    "iata": "BUX",
    "name": "Bunia Airport",
    "city": "Bunia"
  },
  {
    "iata": "BZU",
    "name": "Buta Zega Airport",
    "city": "Buta"
  },
  {
    "iata": "BKY",
    "name": "Bukavu Kavumu Airport",
    "city": "Kamakombe"
  },
  {
    "iata": "GOM",
    "name": "Goma International Airport",
    "city": "Goma"
  },
  {
    "iata": "KND",
    "name": "Kindu Airport",
    "city": "Kindu"
  },
  {
    "iata": "FBM",
    "name": "Lubumbashi International Airport",
    "city": "Lubumbashi"
  },
  {
    "iata": "KWZ",
    "name": "Kolwezi Airport",
    "city": "Kolwezi"
  },
  {
    "iata": "FMI",
    "name": "Kalemie Airport",
    "city": "Kalemie"
  },
  {
    "iata": "KGA",
    "name": "Kananga Airport",
    "city": "Kananga"
  },
  {
    "iata": "MJM",
    "name": "Mbuji Mayi Airport",
    "city": "Mbuji Mayi"
  },
  {
    "iata": "BKO",
    "name": "Modibo Keita International Airport",
    "city": "Bamako"
  },
  {
    "iata": "MZI",
    "name": "Mopti Ambodédjo International Airport",
    "city": "Sévaré"
  },
  {
    "iata": "TOM",
    "name": "Timbuktu Airport",
    "city": "Timbuktu"
  },
  {
    "iata": "BJL",
    "name": "Banjul International Airport",
    "city": "Yundum"
  },
  {
    "iata": "FUE",
    "name": "Fuerteventura Airport",
    "city": "El Matorral"
  },
  {
    "iata": "VDE",
    "name": "El Hierro Airport",
    "city": "El Hierro Island"
  },
  {
    "iata": "SPC",
    "name": "La Palma Airport",
    "city": "Sta Cruz de la Palma, La Palma Island"
  },
  {
    "iata": "LPA",
    "name": "Gran Canaria Airport",
    "city": "Gran Canaria Island"
  },
  {
    "iata": "ACE",
    "name": "César Manrique-Lanzarote Airport",
    "city": "San Bartolomé"
  },
  {
    "iata": "TFS",
    "name": "Tenerife Sur Airport",
    "city": "Tenerife"
  },
  {
    "iata": "TFN",
    "name": "Tenerife Norte-Ciudad de La Laguna Airport",
    "city": "Tenerife"
  },
  {
    "iata": "MLN",
    "name": "Melilla Airport",
    "city": "Melilla"
  },
  {
    "iata": "KBS",
    "name": "Bo Airport",
    "city": "Bo"
  },
  {
    "iata": "KEN",
    "name": "Kenema Airport",
    "city": "Kenema"
  },
  {
    "iata": "FNA",
    "name": "Lungi International Airport",
    "city": "Freetown (Lungi-Town)"
  },
  {
    "iata": "WYE",
    "name": "Yengema Airport",
    "city": "Yengema"
  },
  {
    "iata": "OXB",
    "name": "Osvaldo Vieira International Airport",
    "city": "Bissau"
  },
  {
    "iata": "MLW",
    "name": "Spriggs Payne Airport",
    "city": "Monrovia"
  },
  {
    "iata": "ROB",
    "name": "Roberts International Airport",
    "city": "Monrovia"
  },
  {
    "iata": "AGA",
    "name": "Al Massira Airport",
    "city": "Agadir (Temsia)"
  },
  {
    "iata": "TTA",
    "name": "Tan Tan Airport",
    "city": "Tan Tan"
  },
  {
    "iata": "OZG",
    "name": "Zagora Airport",
    "city": "Zagora"
  },
  {
    "iata": "UAR",
    "name": "Bouarfa Airport",
    "city": "Bouarfa"
  },
  {
    "iata": "FEZ",
    "name": "Fes Saïss International Airport",
    "city": "Saïss"
  },
  {
    "iata": "ERH",
    "name": "Moulay Ali Cherif Airport",
    "city": "Errachidia"
  },
  {
    "iata": "MEK",
    "name": "Bassatine Airport",
    "city": "Meknes"
  },
  {
    "iata": "OUD",
    "name": "Oujda Angads Airport",
    "city": "Ahl Angad"
  },
  {
    "iata": "SMW",
    "name": "Smara Airport",
    "city": "Smara"
  },
  {
    "iata": "RBA",
    "name": "Rabat-Salé Airport",
    "city": "Rabat"
  },
  {
    "iata": "VIL",
    "name": "Dakhla Airport",
    "city": "Dakhla"
  },
  {
    "iata": "ESU",
    "name": "Essaouira-Mogador Airport",
    "city": "Essaouira"
  },
  {
    "iata": "EUN",
    "name": "Hassan I Airport",
    "city": "El Aaiún"
  },
  {
    "iata": "CMN",
    "name": "Mohammed V International Airport",
    "city": "Casablanca"
  },
  {
    "iata": "NDR",
    "name": "Nador Al Aaroui International Airport",
    "city": "Al Aaroui"
  },
  {
    "iata": "RAK",
    "name": "Menara Airport",
    "city": "Marrakech"
  },
  {
    "iata": "OZZ",
    "name": "Ouarzazate Airport",
    "city": "Ouarzazate"
  },
  {
    "iata": "AHU",
    "name": "Cherif Al Idrissi Airport",
    "city": "Al Hoceima"
  },
  {
    "iata": "TNG",
    "name": "Tangier Ibn Battuta Airport",
    "city": "Tangier"
  },
  {
    "iata": "DSS",
    "name": "Blaise Diagne International Airport",
    "city": "Dakar"
  },
  {
    "iata": "ZIG",
    "name": "Ziguinchor Airport",
    "city": "Ziguinchor"
  },
  {
    "iata": "CSK",
    "name": "Cap Skirring Airport",
    "city": "Cap Skirring"
  },
  {
    "iata": "KLC",
    "name": "Kaolack Airport",
    "city": "Kaolack"
  },
  {
    "iata": "DKR",
    "name": "Léopold Sédar Senghor International Airport",
    "city": "Dakar"
  },
  {
    "iata": "MAX",
    "name": "Ouro Sogui Airport",
    "city": "Ouro Sogui"
  },
  {
    "iata": "XLS",
    "name": "Saint Louis Airport",
    "city": "Saint Louis"
  },
  {
    "iata": "BXE",
    "name": "Bakel Airport",
    "city": "Bakel"
  },
  {
    "iata": "KGG",
    "name": "Kédougou Airport",
    "city": "Kédougou"
  },
  {
    "iata": "TUD",
    "name": "Tambacounda Airport",
    "city": "Tambacounda"
  },
  {
    "iata": "NKC",
    "name": "Nouakchott–Oumtounsy International Airport",
    "city": "Nouakchott"
  },
  {
    "iata": "ATR",
    "name": "Atar International Airport",
    "city": "Atar"
  },
  {
    "iata": "NDB",
    "name": "Nouadhibou International Airport",
    "city": "Nouadhibou"
  },
  {
    "iata": "CKY",
    "name": "Conakry International Airport",
    "city": "Conakry"
  },
  {
    "iata": "SID",
    "name": "Amílcar Cabral International Airport",
    "city": "Espargos"
  },
  {
    "iata": "BVC",
    "name": "Rabil Airport",
    "city": "Rabil"
  },
  {
    "iata": "MMO",
    "name": "Maio Airport",
    "city": "Vila do Maio"
  },
  {
    "iata": "RAI",
    "name": "Nelson Mandela International Airport",
    "city": "Praia"
  },
  {
    "iata": "SNE",
    "name": "Preguiça Airport",
    "city": "Preguiça"
  },
  {
    "iata": "VXE",
    "name": "São Pedro Airport",
    "city": "São Pedro"
  },
  {
    "iata": "ADD",
    "name": "Addis Ababa Bole International Airport",
    "city": "Addis Ababa"
  },
  {
    "iata": "AMH",
    "name": "Arba Minch Airport",
    "city": "Arba Minch"
  },
  {
    "iata": "AXU",
    "name": "Axum Airport",
    "city": "Axum"
  },
  {
    "iata": "BJR",
    "name": "Bahir Dar Airport",
    "city": "Bahir Dar"
  },
  {
    "iata": "DIR",
    "name": "Aba Tenna Dejazmach Yilma International Airport",
    "city": "Dire Dawa"
  },
  {
    "iata": "GMB",
    "name": "Gambela Airport",
    "city": "Gambela"
  },
  {
    "iata": "GDQ",
    "name": "Gondar Airport",
    "city": "Azezo"
  },
  {
    "iata": "GDE",
    "name": "Gode Airport",
    "city": "Gode"
  },
  {
    "iata": "JIJ",
    "name": "Wilwal International Airport",
    "city": "Jijiga"
  },
  {
    "iata": "JIM",
    "name": "Jimma Airport",
    "city": "Jimma"
  },
  {
    "iata": "ABK",
    "name": "Kebri Dahar Airport",
    "city": "Kebri Dahar"
  },
  {
    "iata": "AWA",
    "name": "Hawassa International Airport",
    "city": "Hawassa"
  },
  {
    "iata": "MQX",
    "name": "Alula Aba Nega Airport",
    "city": "Mekele"
  },
  {
    "iata": "ASO",
    "name": "Asosa Airport",
    "city": "Asosa"
  },
  {
    "iata": "BJM",
    "name": "Bujumbura Melchior Ndadaye International Airport",
    "city": "Bujumbura"
  },
  {
    "iata": "HGA",
    "name": "Egal International Airport",
    "city": "Hargeisa"
  },
  {
    "iata": "BBO",
    "name": "Berbera Airport",
    "city": "Berbera"
  },
  {
    "iata": "KMU",
    "name": "Kismayo Airport",
    "city": "Kismayo"
  },
  {
    "iata": "MGQ",
    "name": "Aden Adde International Airport",
    "city": "Mogadishu"
  },
  {
    "iata": "JIB",
    "name": "Djibouti-Ambouli Airport",
    "city": "Djibouti City"
  },
  {
    "iata": "DBB",
    "name": "El Alamein International Airport",
    "city": "El Alamein"
  },
  {
    "iata": "AAC",
    "name": "El Arish International Airport",
    "city": "El Arish"
  },
  {
    "iata": "ATZ",
    "name": "Asyut International Airport",
    "city": "Asyut"
  },
  {
    "iata": "HBE",
    "name": "Borj El Arab International Airport",
    "city": "Alexandria"
  },
  {
    "iata": "ABS",
    "name": "Abu Simbel Airport",
    "city": "Abu Simbel"
  },
  {
    "iata": "CAI",
    "name": "Cairo International Airport",
    "city": "Cairo"
  },
  {
    "iata": "HRG",
    "name": "Hurghada International Airport",
    "city": "Hurghada"
  },
  {
    "iata": "LXR",
    "name": "Luxor International Airport",
    "city": "Luxor"
  },
  {
    "iata": "RMF",
    "name": "Marsa Alam International Airport",
    "city": "Marsa Alam"
  },
  {
    "iata": "MUH",
    "name": "Marsa Matruh International Airport",
    "city": "Marsa Matruh"
  },
  {
    "iata": "PSD",
    "name": "Port Said International Airport",
    "city": "Port Said"
  },
  {
    "iata": "SKV",
    "name": "Saint Catherine International Airport",
    "city": "Saint Catherine"
  },
  {
    "iata": "HMB",
    "name": "Suhaj Mubarak International Airport",
    "city": "Suhaj"
  },
  {
    "iata": "SSH",
    "name": "Sharm El Sheikh International Airport",
    "city": "Sharm El Sheikh"
  },
  {
    "iata": "ASW",
    "name": "Aswan International Airport",
    "city": "Aswan"
  },
  {
    "iata": "TCP",
    "name": "Taba International Airport",
    "city": "Taba"
  },
  {
    "iata": "ASM",
    "name": "Asmara International Airport",
    "city": "Asmara"
  },
  {
    "iata": "MSW",
    "name": "Massawa International Airport",
    "city": "Massawa"
  },
  {
    "iata": "ASA",
    "name": "Assab International Airport",
    "city": "Assab"
  },
  {
    "iata": "JUB",
    "name": "Juba International Airport",
    "city": "Juba"
  },
  {
    "iata": "ASV",
    "name": "Amboseli Airport",
    "city": "Amboseli National Park"
  },
  {
    "iata": "EDL",
    "name": "Eldoret International Airport",
    "city": "Eldoret"
  },
  {
    "iata": "NBO",
    "name": "Jomo Kenyatta International Airport",
    "city": "Nairobi"
  },
  {
    "iata": "KIS",
    "name": "Kisumu Airport",
    "city": "Kisumu"
  },
  {
    "iata": "KTL",
    "name": "Kitale Airport",
    "city": "Kitale"
  },
  {
    "iata": "LKG",
    "name": "Lokichogio Airport",
    "city": "Lokichogio"
  },
  {
    "iata": "LOK",
    "name": "Lodwar Airport",
    "city": "Lodwar"
  },
  {
    "iata": "LAU",
    "name": "Manda Airport",
    "city": "Lamu"
  },
  {
    "iata": "MYD",
    "name": "Malindi Airport",
    "city": "Malindi"
  },
  {
    "iata": "MBA",
    "name": "Moi International Airport",
    "city": "Mombasa"
  },
  {
    "iata": "WIL",
    "name": "Nairobi Wilson Airport",
    "city": "Nairobi"
  },
  {
    "iata": "WJR",
    "name": "Wajir Airport",
    "city": "Wajir"
  },
  {
    "iata": "SRX",
    "name": "Sirt International Airport / Ghardabiya Airbase",
    "city": "Sirt"
  },
  {
    "iata": "GHT",
    "name": "Ghat Airport",
    "city": "Ghat"
  },
  {
    "iata": "AKF",
    "name": "Kufra Airport",
    "city": "Kufra"
  },
  {
    "iata": "BEN",
    "name": "Benina International Airport",
    "city": "Benina"
  },
  {
    "iata": "MJI",
    "name": "Mitiga International Airport",
    "city": "Tripoli"
  },
  {
    "iata": "LAQ",
    "name": "Al Abraq International Airport",
    "city": "Al Albraq"
  },
  {
    "iata": "SEB",
    "name": "Sabha Airport",
    "city": "Sabha"
  },
  {
    "iata": "LMQ",
    "name": "Marsa al Brega Airport",
    "city": "Marsa al Brega"
  },
  {
    "iata": "LTD",
    "name": "Ghadames East Airport",
    "city": "Ghadames"
  },
  {
    "iata": "GYI",
    "name": "Gisenyi Airport",
    "city": "Gisenyi"
  },
  {
    "iata": "KGL",
    "name": "Kigali International Airport",
    "city": "Kigali"
  },
  {
    "iata": "KME",
    "name": "Kamembe Airport",
    "city": "Kamembe"
  },
  {
    "iata": "DOG",
    "name": "Dongola Airport",
    "city": "Dongola"
  },
  {
    "iata": "ELF",
    "name": "El Fasher Airport",
    "city": "El Fasher"
  },
  {
    "iata": "KSL",
    "name": "Kassala Airport",
    "city": "Kassala"
  },
  {
    "iata": "MWE",
    "name": "Merowe Airport",
    "city": "Merowe"
  },
  {
    "iata": "UYL",
    "name": "Nyala Airport",
    "city": "Nyala"
  },
  {
    "iata": "EBD",
    "name": "El-Obeid Airport",
    "city": "El-Obeid"
  },
  {
    "iata": "PZU",
    "name": "Port Sudan New International Airport",
    "city": "Port Sudan"
  },
  {
    "iata": "KRT",
    "name": "Khartoum International Airport",
    "city": "Khartoum"
  },
  {
    "iata": "ARK",
    "name": "Arusha Airport",
    "city": "Arusha"
  },
  {
    "iata": "DAR",
    "name": "Julius Nyerere International Airport",
    "city": "Dar es Salaam"
  },
  {
    "iata": "DOD",
    "name": "Dodoma Airport",
    "city": "Dodoma"
  },
  {
    "iata": "IRI",
    "name": "Iringa Airport",
    "city": "Nduli"
  },
  {
    "iata": "JRO",
    "name": "Kilimanjaro International Airport",
    "city": "Arusha"
  },
  {
    "iata": "LKY",
    "name": "Lake Manyara Airport",
    "city": "Lake Manyara National Park"
  },
  {
    "iata": "MYW",
    "name": "Mtwara Airport",
    "city": "Mtwara"
  },
  {
    "iata": "MWZ",
    "name": "Mwanza Airport",
    "city": "Mwanza"
  },
  {
    "iata": "PMA",
    "name": "Pemba Airport",
    "city": "Chake Chake"
  },
  {
    "iata": "TGT",
    "name": "Tanga Airport",
    "city": "Tanga"
  },
  {
    "iata": "ZNZ",
    "name": "Abeid Amani Karume International Airport",
    "city": "Zanzibar"
  },
  {
    "iata": "RUA",
    "name": "Arua Airport",
    "city": "Arua"
  },
  {
    "iata": "EBB",
    "name": "Entebbe International Airport",
    "city": "Kampala"
  },
  {
    "iata": "ULU",
    "name": "Gulu Airport",
    "city": "Gulu"
  },
  {
    "iata": "SRT",
    "name": "Soroti Airport",
    "city": "Soroti"
  },
  {
    "iata": "67L",
    "name": "Mesquite International Airport",
    "city": "Mesquite"
  },
  {
    "iata": "ABE",
    "name": "Lehigh Valley International Airport",
    "city": "Allentown"
  },
  {
    "iata": "ABI",
    "name": "Abilene Regional Airport",
    "city": "Abilene"
  },
  {
    "iata": "ABQ",
    "name": "Albuquerque International Sunport",
    "city": "Albuquerque"
  },
  {
    "iata": "ABR",
    "name": "Aberdeen Regional Airport",
    "city": "Aberdeen"
  },
  {
    "iata": "ABY",
    "name": "Southwest Georgia Regional Airport",
    "city": "Albany"
  },
  {
    "iata": "ACK",
    "name": "Nantucket Memorial Airport",
    "city": "Nantucket"
  },
  {
    "iata": "ACT",
    "name": "Waco Regional Airport",
    "city": "Waco"
  },
  {
    "iata": "ACV",
    "name": "California Redwood Coast-Humboldt County Airport",
    "city": "Arcata/Eureka"
  },
  {
    "iata": "ACY",
    "name": "Atlantic City International Airport",
    "city": "Atlantic City"
  },
  {
    "iata": "ADT",
    "name": "Ada Regional Airport",
    "city": "Ada"
  },
  {
    "iata": "ADW",
    "name": "Joint Base Andrews",
    "city": "Camp Springs"
  },
  {
    "iata": "AEX",
    "name": "Alexandria International Airport",
    "city": "Alexandria"
  },
  {
    "iata": "AFW",
    "name": "Perot Field/Fort Worth Alliance Airport",
    "city": "Fort Worth"
  },
  {
    "iata": "AGC",
    "name": "Allegheny County Airport",
    "city": "Pittsburgh"
  },
  {
    "iata": "AGS",
    "name": "Augusta Regional At Bush Field",
    "city": "Augusta"
  },
  {
    "iata": "AHN",
    "name": "Athens Ben Epps Airport",
    "city": "Athens"
  },
  {
    "iata": "AIA",
    "name": "Alliance Municipal Airport",
    "city": "Alliance"
  },
  {
    "iata": "AKC",
    "name": "Akron Fulton International Airport",
    "city": "Akron"
  },
  {
    "iata": "ALB",
    "name": "Albany International Airport",
    "city": "Albany"
  },
  {
    "iata": "ALI",
    "name": "Alice International Airport",
    "city": "Alice"
  },
  {
    "iata": "ALM",
    "name": "Alamogordo White Sands Regional Airport",
    "city": "Alamogordo"
  },
  {
    "iata": "ALN",
    "name": "St Louis Regional Airport",
    "city": "Alton/St Louis"
  },
  {
    "iata": "ALO",
    "name": "Waterloo Regional Airport",
    "city": "Waterloo"
  },
  {
    "iata": "ALS",
    "name": "San Luis Valley Regional Airport/Bergman Field",
    "city": "Alamosa"
  },
  {
    "iata": "ALW",
    "name": "Walla Walla Regional Airport",
    "city": "Walla Walla"
  },
  {
    "iata": "AMA",
    "name": "Rick Husband Amarillo International Airport",
    "city": "Amarillo"
  },
  {
    "iata": "ANB",
    "name": "Anniston Regional Airport",
    "city": "Anniston"
  },
  {
    "iata": "AND",
    "name": "Anderson Regional Airport",
    "city": "Anderson"
  },
  {
    "iata": "AOO",
    "name": "Altoona Blair County Airport",
    "city": "Altoona"
  },
  {
    "iata": "APA",
    "name": "Centennial Airport",
    "city": "Denver"
  },
  {
    "iata": "APF",
    "name": "Naples Municipal Airport",
    "city": "Naples"
  },
  {
    "iata": "APG",
    "name": "Phillips Army Air Field",
    "city": "Aberdeen"
  },
  {
    "iata": "APN",
    "name": "Alpena County Regional Airport",
    "city": "Alpena"
  },
  {
    "iata": "ARA",
    "name": "Acadiana Regional Airport",
    "city": "New Iberia"
  },
  {
    "iata": "ART",
    "name": "Watertown International Airport",
    "city": "Watertown"
  },
  {
    "iata": "ASE",
    "name": "Aspen-Pitkin County Airport (Sardy Field)",
    "city": "Aspen"
  },
  {
    "iata": "AST",
    "name": "Astoria Regional Airport",
    "city": "Astoria"
  },
  {
    "iata": "ATL",
    "name": "Hartsfield Jackson Atlanta International Airport",
    "city": "Atlanta"
  },
  {
    "iata": "ATW",
    "name": "Appleton International Airport",
    "city": "Appleton"
  },
  {
    "iata": "ATY",
    "name": "Watertown Regional Airport",
    "city": "Watertown"
  },
  {
    "iata": "AUG",
    "name": "Augusta State Airport",
    "city": "Augusta"
  },
  {
    "iata": "AUS",
    "name": "Austin Bergstrom International Airport",
    "city": "Austin"
  },
  {
    "iata": "AUW",
    "name": "Wausau Downtown Airport",
    "city": "Wausau"
  },
  {
    "iata": "AVL",
    "name": "Asheville Regional Airport",
    "city": "Asheville"
  },
  {
    "iata": "AVP",
    "name": "Wilkes Barre Scranton International Airport",
    "city": "Wilkes-Barre/Scranton"
  },
  {
    "iata": "AXN",
    "name": "Chandler Field",
    "city": "Alexandria"
  },
  {
    "iata": "AZO",
    "name": "Kalamazoo Battle Creek International Airport",
    "city": "Kalamazoo"
  },
  {
    "iata": "BAB",
    "name": "Beale Air Force Base",
    "city": "Beale Air Force Base"
  },
  {
    "iata": "BAD",
    "name": "Barksdale Air Force Base",
    "city": "Bossier City"
  },
  {
    "iata": "BAF",
    "name": "Westfield-Barnes Regional Airport",
    "city": "Westfield"
  },
  {
    "iata": "CLU",
    "name": "Columbus Municipal Airport",
    "city": "Columbus"
  },
  {
    "iata": "BBD",
    "name": "Curtis Field",
    "city": "Brady"
  },
  {
    "iata": "BKG",
    "name": "Branson Airport",
    "city": "Branson"
  },
  {
    "iata": "BCE",
    "name": "Bryce Canyon Airport",
    "city": "Bryce Canyon"
  },
  {
    "iata": "BCT",
    "name": "Boca Raton Airport",
    "city": "Boca Raton"
  },
  {
    "iata": "BDE",
    "name": "Baudette International Airport",
    "city": "Baudette"
  },
  {
    "iata": "BDL",
    "name": "Bradley International Airport",
    "city": "Hartford"
  },
  {
    "iata": "BDR",
    "name": "Igor I Sikorsky Memorial Airport",
    "city": "Bridgeport"
  },
  {
    "iata": "BED",
    "name": "Laurence G Hanscom Field",
    "city": "Bedford"
  },
  {
    "iata": "BFD",
    "name": "Bradford Regional Airport",
    "city": "Bradford"
  },
  {
    "iata": "BFF",
    "name": "Western Neb. Rgnl/William B. Heilig Airport",
    "city": "Scottsbluff"
  },
  {
    "iata": "BFI",
    "name": "Boeing Field King County International Airport",
    "city": "Seattle"
  },
  {
    "iata": "BFL",
    "name": "Meadows Field",
    "city": "Bakersfield"
  },
  {
    "iata": "BFM",
    "name": "Mobile Downtown Airport",
    "city": "Mobile"
  },
  {
    "iata": "BGM",
    "name": "Greater Binghamton/Edwin A Link field",
    "city": "Binghamton"
  },
  {
    "iata": "BGR",
    "name": "Bangor International Airport",
    "city": "Bangor"
  },
  {
    "iata": "BHB",
    "name": "Hancock County-Bar Harbor Airport",
    "city": "Bar Harbor"
  },
  {
    "iata": "BHM",
    "name": "Birmingham-Shuttlesworth International Airport",
    "city": "Birmingham"
  },
  {
    "iata": "BIF",
    "name": "Biggs Army Air Field (Fort Bliss)",
    "city": "Fort Bliss/El Paso"
  },
  {
    "iata": "BIH",
    "name": "Eastern Sierra Regional Airport",
    "city": "Bishop"
  },
  {
    "iata": "BIL",
    "name": "Billings Logan International Airport",
    "city": "Billings"
  },
  {
    "iata": "BIS",
    "name": "Bismarck Municipal Airport",
    "city": "Bismarck"
  },
  {
    "iata": "BIX",
    "name": "Keesler Air Force Base",
    "city": "Biloxi"
  },
  {
    "iata": "BJC",
    "name": "Rocky Mountain Metropolitan Airport",
    "city": "Denver"
  },
  {
    "iata": "BJI",
    "name": "Bemidji Regional Airport",
    "city": "Bemidji"
  },
  {
    "iata": "BKE",
    "name": "Baker City Municipal Airport",
    "city": "Baker City"
  },
  {
    "iata": "BFK",
    "name": "Buckley Space Force Base",
    "city": "Aurora"
  },
  {
    "iata": "BKL",
    "name": "Burke Lakefront Airport",
    "city": "Cleveland"
  },
  {
    "iata": "BKW",
    "name": "Raleigh County Memorial Airport",
    "city": "Beaver"
  },
  {
    "iata": "BLF",
    "name": "Mercer County Airport",
    "city": "Bluefield"
  },
  {
    "iata": "BLH",
    "name": "Blythe Airport",
    "city": "Blythe"
  },
  {
    "iata": "BLI",
    "name": "Bellingham International Airport",
    "city": "Bellingham"
  },
  {
    "iata": "BLV",
    "name": "Scott AFB/Midamerica Airport",
    "city": "Belleville"
  },
  {
    "iata": "BMG",
    "name": "Monroe County Airport",
    "city": "Bloomington"
  },
  {
    "iata": "BMI",
    "name": "Central Illinois Regional Airport at Bloomington-Normal",
    "city": "Bloomington/Normal"
  },
  {
    "iata": "BNA",
    "name": "Nashville International Airport",
    "city": "Nashville"
  },
  {
    "iata": "BNO",
    "name": "Burns Municipal Airport",
    "city": "Burns"
  },
  {
    "iata": "BOI",
    "name": "Boise Air Terminal/Gowen Field",
    "city": "Boise"
  },
  {
    "iata": "BOS",
    "name": "Logan International Airport",
    "city": "Boston"
  },
  {
    "iata": "BPI",
    "name": "Miley Memorial Field",
    "city": "Big Piney"
  },
  {
    "iata": "WMH",
    "name": "Ozark Regional Airport",
    "city": "Mountain Home"
  },
  {
    "iata": "BPT",
    "name": "Jack Brooks Regional Airport",
    "city": "Beaumont/Port Arthur"
  },
  {
    "iata": "BQK",
    "name": "Brunswick Golden Isles Airport",
    "city": "Brunswick"
  },
  {
    "iata": "BRD",
    "name": "Brainerd Lakes Regional Airport",
    "city": "Brainerd"
  },
  {
    "iata": "BRL",
    "name": "Southeast Iowa Regional Airport",
    "city": "Burlington"
  },
  {
    "iata": "BRO",
    "name": "Brownsville South Padre Island International Airport",
    "city": "Brownsville"
  },
  {
    "iata": "BTL",
    "name": "Battle Creek Executive Airport at Kellogg Field",
    "city": "Battle Creek"
  },
  {
    "iata": "BTM",
    "name": "Bert Mooney Airport",
    "city": "Butte"
  },
  {
    "iata": "BTR",
    "name": "Baton Rouge Metropolitan Airport",
    "city": "Baton Rouge"
  },
  {
    "iata": "BTV",
    "name": "Burlington International Airport",
    "city": "South Burlington"
  },
  {
    "iata": "BUF",
    "name": "Buffalo Niagara International Airport",
    "city": "Buffalo"
  },
  {
    "iata": "BUR",
    "name": "Hollywood Burbank Airport",
    "city": "Burbank"
  },
  {
    "iata": "BFP",
    "name": "Beaver County Airport",
    "city": "Beaver Falls"
  },
  {
    "iata": "BVY",
    "name": "Beverly Regional Airport",
    "city": "Beverly / Danvers"
  },
  {
    "iata": "BWG",
    "name": "Bowling Green Warren County Regional Airport",
    "city": "Bowling Green"
  },
  {
    "iata": "BWI",
    "name": "Baltimore/Washington International Thurgood Marshall Airport",
    "city": "Baltimore"
  },
  {
    "iata": "NHZ",
    "name": "Brunswick Executive Airport",
    "city": "Brunswick"
  },
  {
    "iata": "BYH",
    "name": "Arkansas International Airport",
    "city": "Blytheville"
  },
  {
    "iata": "BYI",
    "name": "Burley Municipal Airport",
    "city": "Burley"
  },
  {
    "iata": "BYS",
    "name": "Bicycle Lake Army Air Field",
    "city": "Fort Irwin/Barstow"
  },
  {
    "iata": "BZN",
    "name": "Bozeman Yellowstone International Airport",
    "city": "Bozeman"
  },
  {
    "iata": "CAE",
    "name": "Columbia Metropolitan Airport",
    "city": "Columbia"
  },
  {
    "iata": "CAK",
    "name": "Akron Canton Regional Airport",
    "city": "Akron"
  },
  {
    "iata": "CAR",
    "name": "Caribou Municipal Airport",
    "city": "Caribou"
  },
  {
    "iata": "CBM",
    "name": "Columbus Air Force Base",
    "city": "Columbus"
  },
  {
    "iata": "CCR",
    "name": "Buchanan Field",
    "city": "Concord"
  },
  {
    "iata": "CCY",
    "name": "Northeast Iowa Regional Airport",
    "city": "Charles City"
  },
  {
    "iata": "CDC",
    "name": "Cedar City Regional Airport",
    "city": "Cedar City"
  },
  {
    "iata": "CDR",
    "name": "Chadron Municipal Airport",
    "city": "Chadron"
  },
  {
    "iata": "CDS",
    "name": "Childress Municipal Airport",
    "city": "Childress"
  },
  {
    "iata": "CEC",
    "name": "Jack Mc Namara Field Airport",
    "city": "Crescent City"
  },
  {
    "iata": "CEW",
    "name": "Bob Sikes Airport",
    "city": "Crestview"
  },
  {
    "iata": "CEZ",
    "name": "Cortez Municipal Airport",
    "city": "Cortez"
  },
  {
    "iata": "CGF",
    "name": "Cuyahoga County Airport",
    "city": "Cleveland"
  },
  {
    "iata": "CGI",
    "name": "Cape Girardeau Regional Airport",
    "city": "Cape Girardeau"
  },
  {
    "iata": "CHA",
    "name": "Chattanooga Metropolitan Airport (Lovell Field)",
    "city": "Chattanooga"
  },
  {
    "iata": "CHO",
    "name": "Charlottesville Albemarle Airport",
    "city": "Charlottesville"
  },
  {
    "iata": "CHS",
    "name": "Charleston International Airport",
    "city": "Charleston"
  },
  {
    "iata": "CID",
    "name": "The Eastern Iowa Airport",
    "city": "Cedar Rapids"
  },
  {
    "iata": "CIU",
    "name": "Chippewa County International Airport",
    "city": "Kincheloe"
  },
  {
    "iata": "CKB",
    "name": "North Central West Virginia Airport",
    "city": "Bridgeport"
  },
  {
    "iata": "CLE",
    "name": "Cleveland Hopkins International Airport",
    "city": "Cleveland"
  },
  {
    "iata": "CLL",
    "name": "Easterwood Field",
    "city": "College Station"
  },
  {
    "iata": "CLM",
    "name": "William R Fairchild International Airport",
    "city": "Port Angeles"
  },
  {
    "iata": "CLT",
    "name": "Charlotte Douglas International Airport",
    "city": "Charlotte"
  },
  {
    "iata": "CMH",
    "name": "John Glenn Columbus International Airport",
    "city": "Columbus"
  },
  {
    "iata": "CMI",
    "name": "University of Illinois Willard Airport",
    "city": "Savoy"
  },
  {
    "iata": "CMX",
    "name": "Houghton County Memorial Airport",
    "city": "Hancock"
  },
  {
    "iata": "CNM",
    "name": "Cavern City Air Terminal",
    "city": "Carlsbad"
  },
  {
    "iata": "CNU",
    "name": "Chanute Martin Johnson Airport",
    "city": "Chanute"
  },
  {
    "iata": "CNY",
    "name": "Canyonlands Regional Airport",
    "city": "Moab"
  },
  {
    "iata": "COD",
    "name": "Yellowstone Regional Airport",
    "city": "Cody"
  },
  {
    "iata": "COE",
    "name": "Coeur D'Alene Airport - Pappy Boyington Field",
    "city": "Coeur d'Alene"
  },
  {
    "iata": "COF",
    "name": "Patrick Space Force Base",
    "city": "Cocoa Beach"
  },
  {
    "iata": "CON",
    "name": "Concord Municipal Airport",
    "city": "Concord"
  },
  {
    "iata": "COS",
    "name": "City of Colorado Springs Municipal Airport",
    "city": "Colorado Springs"
  },
  {
    "iata": "COU",
    "name": "Columbia Regional Airport",
    "city": "Columbia"
  },
  {
    "iata": "CPR",
    "name": "Casper-Natrona County International Airport",
    "city": "Casper"
  },
  {
    "iata": "CRE",
    "name": "Grand Strand Airport",
    "city": "North Myrtle Beach"
  },
  {
    "iata": "CRG",
    "name": "Jacksonville Executive at Craig Airport",
    "city": "Jacksonville"
  },
  {
    "iata": "CRP",
    "name": "Corpus Christi International Airport",
    "city": "Corpus Christi"
  },
  {
    "iata": "CLD",
    "name": "McClellan-Palomar Airport",
    "city": "Carlsbad"
  },
  {
    "iata": "CRW",
    "name": "Yeager Airport",
    "city": "Charleston"
  },
  {
    "iata": "CSG",
    "name": "Columbus Metropolitan Airport",
    "city": "Columbus"
  },
  {
    "iata": "CSV",
    "name": "Crossville Memorial Airport Whitson Field",
    "city": "Crossville"
  },
  {
    "iata": "CTB",
    "name": "Cut Bank International Airport",
    "city": "Cut Bank"
  },
  {
    "iata": "CUB",
    "name": "Jim Hamilton L.B. Owens Airport",
    "city": "Columbia"
  },
  {
    "iata": "CVG",
    "name": "Cincinnati Northern Kentucky International Airport",
    "city": "Cincinnati / Covington"
  },
  {
    "iata": "CVN",
    "name": "Clovis Municipal Airport",
    "city": "Clovis"
  },
  {
    "iata": "CVO",
    "name": "Corvallis Municipal Airport",
    "city": "Corvallis"
  },
  {
    "iata": "CVS",
    "name": "Cannon Air Force Base",
    "city": "Clovis"
  },
  {
    "iata": "CWA",
    "name": "Central Wisconsin Airport",
    "city": "Mosinee"
  },
  {
    "iata": "CXO",
    "name": "Conroe-North Houston Regional Airport",
    "city": "Houston"
  },
  {
    "iata": "CYS",
    "name": "Cheyenne Regional Jerry Olson Field",
    "city": "Cheyenne"
  },
  {
    "iata": "DAA",
    "name": "Davison Army Air Field",
    "city": "Fort Belvoir"
  },
  {
    "iata": "DAB",
    "name": "Daytona Beach International Airport",
    "city": "Daytona Beach"
  },
  {
    "iata": "DAG",
    "name": "Barstow Daggett Airport",
    "city": "Daggett"
  },
  {
    "iata": "DAL",
    "name": "Dallas Love Field",
    "city": "Dallas"
  },
  {
    "iata": "DAN",
    "name": "Danville Regional Airport",
    "city": "Danville"
  },
  {
    "iata": "DAY",
    "name": "James M Cox Dayton International Airport",
    "city": "Dayton"
  },
  {
    "iata": "DBQ",
    "name": "Dubuque Regional Airport",
    "city": "Dubuque"
  },
  {
    "iata": "DCA",
    "name": "Ronald Reagan Washington National Airport",
    "city": "Washington"
  },
  {
    "iata": "DDC",
    "name": "Dodge City Regional Airport",
    "city": "Dodge City"
  },
  {
    "iata": "DEC",
    "name": "Decatur Airport",
    "city": "Decatur"
  },
  {
    "iata": "DEN",
    "name": "Denver International Airport",
    "city": "Denver"
  },
  {
    "iata": "DFW",
    "name": "Dallas Fort Worth International Airport",
    "city": "Dallas-Fort Worth"
  },
  {
    "iata": "DHN",
    "name": "Dothan Regional Airport",
    "city": "Dothan"
  },
  {
    "iata": "DHT",
    "name": "Dalhart Municipal Airport",
    "city": "Dalhart"
  },
  {
    "iata": "DIK",
    "name": "Dickinson Theodore Roosevelt Regional Airport",
    "city": "Dickinson"
  },
  {
    "iata": "DLF",
    "name": "Laughlin Air Force Base",
    "city": "Del Rio"
  },
  {
    "iata": "DLH",
    "name": "Duluth International Airport",
    "city": "Duluth"
  },
  {
    "iata": "DLS",
    "name": "Columbia Gorge Regional Airport",
    "city": "Dallesport / The Dalles"
  },
  {
    "iata": "DMA",
    "name": "Davis Monthan Air Force Base",
    "city": "Tucson"
  },
  {
    "iata": "DMN",
    "name": "Deming Municipal Airport",
    "city": "Deming"
  },
  {
    "iata": "DNL",
    "name": "Daniel Field",
    "city": "Augusta"
  },
  {
    "iata": "DOV",
    "name": "Dover Air Force Base",
    "city": "Dover"
  },
  {
    "iata": "DPA",
    "name": "Dupage Airport",
    "city": "Chicago/West Chicago"
  },
  {
    "iata": "DRA",
    "name": "Desert Rock Airport",
    "city": "Mercury"
  },
  {
    "iata": "DRI",
    "name": "Beauregard Regional Airport",
    "city": "DeRidder"
  },
  {
    "iata": "DRO",
    "name": "Durango La Plata County Airport",
    "city": "Durango"
  },
  {
    "iata": "DRT",
    "name": "Del Rio International Airport",
    "city": "Del Rio"
  },
  {
    "iata": "DSM",
    "name": "Des Moines International Airport",
    "city": "Des Moines"
  },
  {
    "iata": "DSI",
    "name": "Destin Executive Airport",
    "city": "Destin"
  },
  {
    "iata": "DTW",
    "name": "Detroit Metropolitan Wayne County Airport",
    "city": "Detroit"
  },
  {
    "iata": "DUA",
    "name": "Durant Regional Airport - Eaker Field",
    "city": "Durant"
  },
  {
    "iata": "DUG",
    "name": "Bisbee Douglas International Airport",
    "city": "Douglas Bisbee"
  },
  {
    "iata": "DUJ",
    "name": "DuBois Regional Airport",
    "city": "Dubois"
  },
  {
    "iata": "DVL",
    "name": "Devils Lake Regional Airport",
    "city": "Devils Lake"
  },
  {
    "iata": "DXR",
    "name": "Danbury Municipal Airport",
    "city": "Danbury"
  },
  {
    "iata": "DYS",
    "name": "Dyess Air Force Base",
    "city": "Abilene"
  },
  {
    "iata": "EAR",
    "name": "Kearney Regional Airport",
    "city": "Kearney"
  },
  {
    "iata": "EAT",
    "name": "Pangborn Memorial Airport",
    "city": "Wenatchee"
  },
  {
    "iata": "EAU",
    "name": "Chippewa Valley Regional Airport",
    "city": "Eau Claire"
  },
  {
    "iata": "ECG",
    "name": "Elizabeth City Regional Airport & Coast Guard Air Station",
    "city": "Elizabeth City"
  },
  {
    "iata": "ECP",
    "name": "Northwest Florida Beaches International Airport",
    "city": "Panama City Beach"
  },
  {
    "iata": "EDW",
    "name": "Edwards Air Force Base",
    "city": "Edwards"
  },
  {
    "iata": "EED",
    "name": "Needles Airport",
    "city": "Needles"
  },
  {
    "iata": "EEN",
    "name": "Dillant Hopkins Airport",
    "city": "Keene"
  },
  {
    "iata": "EFD",
    "name": "Ellington Airport",
    "city": "Houston"
  },
  {
    "iata": "EGE",
    "name": "Eagle County Regional Airport",
    "city": "Eagle"
  },
  {
    "iata": "EGI",
    "name": "Duke Field",
    "city": "Crestview"
  },
  {
    "iata": "EKA",
    "name": "Murray Field",
    "city": "Eureka"
  },
  {
    "iata": "EKN",
    "name": "Elkins-Randolph County Regional Airport",
    "city": "Elkins"
  },
  {
    "iata": "EKO",
    "name": "Elko Regional Airport",
    "city": "Elko"
  },
  {
    "iata": "ELD",
    "name": "South Arkansas Regional Airport at Goodwin Field",
    "city": "El Dorado"
  },
  {
    "iata": "ELM",
    "name": "Elmira Corning Regional Airport",
    "city": "Elmira/Corning"
  },
  {
    "iata": "LYU",
    "name": "Ely Municipal Airport",
    "city": "Ely"
  },
  {
    "iata": "ELP",
    "name": "El Paso International Airport",
    "city": "El Paso"
  },
  {
    "iata": "ELY",
    "name": "Ely Airport Yelland Field",
    "city": "Ely"
  },
  {
    "iata": "END",
    "name": "Vance Air Force Base",
    "city": "Enid"
  },
  {
    "iata": "ENV",
    "name": "Wendover Airport",
    "city": "Wendover"
  },
  {
    "iata": "ENW",
    "name": "Kenosha Regional Airport",
    "city": "Kenosha"
  },
  {
    "iata": "ERI",
    "name": "Erie International Tom Ridge Field",
    "city": "Erie"
  },
  {
    "iata": "ESC",
    "name": "Delta County Airport",
    "city": "Escanaba"
  },
  {
    "iata": "ESF",
    "name": "Esler Army Airfield / Esler Regional Airport",
    "city": "Alexandria"
  },
  {
    "iata": "EUG",
    "name": "Mahlon Sweet Field",
    "city": "Eugene"
  },
  {
    "iata": "EVV",
    "name": "Evansville Regional Airport",
    "city": "Evansville"
  },
  {
    "iata": "EVW",
    "name": "Evanston-Uinta County Airport-Burns Field",
    "city": "Evanston"
  },
  {
    "iata": "EWB",
    "name": "New Bedford Regional Airport",
    "city": "New Bedford"
  },
  {
    "iata": "EWN",
    "name": "Coastal Carolina Regional Airport",
    "city": "New Bern"
  },
  {
    "iata": "EWR",
    "name": "Newark Liberty International Airport",
    "city": "Newark"
  },
  {
    "iata": "EYW",
    "name": "Key West International Airport",
    "city": "Key West"
  },
  {
    "iata": "FAF",
    "name": "Felker Army Air Field",
    "city": "Newport News (Fort Eustis)"
  },
  {
    "iata": "FAR",
    "name": "Hector International Airport",
    "city": "Fargo"
  },
  {
    "iata": "FAT",
    "name": "Fresno Yosemite International Airport",
    "city": "Fresno"
  },
  {
    "iata": "FAY",
    "name": "Fayetteville Regional Airport - Grannis Field",
    "city": "Fayetteville"
  },
  {
    "iata": "FBG",
    "name": "Simmons Army Air Field",
    "city": "Fort Bragg"
  },
  {
    "iata": "FCS",
    "name": "Butts AAF (Fort Carson) Air Field",
    "city": "Fort Carson"
  },
  {
    "iata": "FDY",
    "name": "Findlay Airport",
    "city": "Findlay"
  },
  {
    "iata": "FFO",
    "name": "Wright-Patterson Air Force Base",
    "city": "Dayton"
  },
  {
    "iata": "FRD",
    "name": "Friday Harbor Airport",
    "city": "Friday Harbor"
  },
  {
    "iata": "FHU",
    "name": "Sierra Vista Municipal Airport / Libby Army Air Field",
    "city": "Fort Huachuca / Sierra Vista"
  },
  {
    "iata": "FKL",
    "name": "Venango Regional Airport",
    "city": "Franklin"
  },
  {
    "iata": "FLG",
    "name": "Flagstaff Pulliam International Airport",
    "city": "Flagstaff"
  },
  {
    "iata": "FLL",
    "name": "Fort Lauderdale Hollywood International Airport",
    "city": "Fort Lauderdale"
  },
  {
    "iata": "FLO",
    "name": "Florence Regional Airport",
    "city": "Florence"
  },
  {
    "iata": "FME",
    "name": "Tipton Airport",
    "city": "Fort Meade(Odenton)"
  },
  {
    "iata": "FMN",
    "name": "Four Corners Regional Airport",
    "city": "Farmington"
  },
  {
    "iata": "FMY",
    "name": "Page Field",
    "city": "Fort Myers"
  },
  {
    "iata": "FNL",
    "name": "Northern Colorado Regional Airport",
    "city": "Loveland"
  },
  {
    "iata": "FNT",
    "name": "Bishop International Airport",
    "city": "Flint"
  },
  {
    "iata": "FOD",
    "name": "Fort Dodge Regional Airport",
    "city": "Fort Dodge"
  },
  {
    "iata": "FOE",
    "name": "Topeka Regional Airport",
    "city": "Topeka"
  },
  {
    "iata": "FPR",
    "name": "St Lucie County International Airport",
    "city": "Fort Pierce"
  },
  {
    "iata": "FRG",
    "name": "Republic Airport",
    "city": "Farmingdale"
  },
  {
    "iata": "FRI",
    "name": "Marshall Army Air Field",
    "city": "Fort Riley (Junction City)"
  },
  {
    "iata": "FSD",
    "name": "Sioux Falls Regional Airport / Joe Foss Field",
    "city": "Sioux Falls"
  },
  {
    "iata": "FSI",
    "name": "Henry Post Army Air Field",
    "city": "Fort Sill"
  },
  {
    "iata": "FSM",
    "name": "Fort Smith Regional Airport",
    "city": "Fort Smith"
  },
  {
    "iata": "FST",
    "name": "Fort Stockton Pecos County Airport",
    "city": "Fort Stockton"
  },
  {
    "iata": "FTK",
    "name": "Godman Army Air Field",
    "city": "Fort Knox"
  },
  {
    "iata": "FTW",
    "name": "Fort Worth Meacham International Airport",
    "city": "Fort Worth"
  },
  {
    "iata": "FTY",
    "name": "Fulton County Airport Brown Field",
    "city": "Atlanta"
  },
  {
    "iata": "FWA",
    "name": "Fort Wayne International Airport",
    "city": "Fort Wayne"
  },
  {
    "iata": "FXE",
    "name": "Fort Lauderdale Executive Airport",
    "city": "Fort Lauderdale"
  },
  {
    "iata": "FYV",
    "name": "Drake Field",
    "city": "Fayetteville"
  },
  {
    "iata": "GCC",
    "name": "Northeast Wyoming Regional Airport",
    "city": "Gillette"
  },
  {
    "iata": "GCK",
    "name": "Garden City Regional Airport",
    "city": "Garden City"
  },
  {
    "iata": "GCN",
    "name": "Grand Canyon National Park Airport",
    "city": "Grand Canyon - Tusayan"
  },
  {
    "iata": "GDV",
    "name": "Dawson Community Airport",
    "city": "Glendive"
  },
  {
    "iata": "GEG",
    "name": "Spokane International Airport",
    "city": "Spokane"
  },
  {
    "iata": "GFK",
    "name": "Grand Forks International Airport",
    "city": "Grand Forks"
  },
  {
    "iata": "GFL",
    "name": "Floyd Bennett Memorial Airport",
    "city": "Glens Falls"
  },
  {
    "iata": "GGG",
    "name": "East Texas Regional Airport",
    "city": "Longview"
  },
  {
    "iata": "GGW",
    "name": "Glasgow Valley County Airport Wokal Field",
    "city": "Glasgow"
  },
  {
    "iata": "GJT",
    "name": "Grand Junction Regional Airport",
    "city": "Grand Junction"
  },
  {
    "iata": "GLD",
    "name": "Goodland Municipal Airport",
    "city": "Goodland"
  },
  {
    "iata": "GLH",
    "name": "Mid Delta Regional Airport",
    "city": "Greenville"
  },
  {
    "iata": "GLS",
    "name": "Scholes International At Galveston Airport",
    "city": "Galveston"
  },
  {
    "iata": "GMU",
    "name": "Greenville Downtown Airport",
    "city": "Greenville"
  },
  {
    "iata": "GNV",
    "name": "Gainesville Regional Airport",
    "city": "Gainesville"
  },
  {
    "iata": "GON",
    "name": "Groton New London Airport",
    "city": "Groton"
  },
  {
    "iata": "FCA",
    "name": "Glacier Park International Airport",
    "city": "Kalispell"
  },
  {
    "iata": "GPT",
    "name": "Gulfport Biloxi International Airport",
    "city": "Gulfport"
  },
  {
    "iata": "GRB",
    "name": "Austin Straubel International Airport",
    "city": "Green Bay"
  },
  {
    "iata": "GRF",
    "name": "Gray Army Air Field",
    "city": "Fort Lewis/Tacoma"
  },
  {
    "iata": "GRI",
    "name": "Central Nebraska Regional Airport",
    "city": "Grand Island"
  },
  {
    "iata": "GRK",
    "name": "Killeen Regional Airport / Robert Gray Army Airfield",
    "city": "Fort Cavazos"
  },
  {
    "iata": "GRR",
    "name": "Gerald R. Ford International Airport",
    "city": "Grand Rapids"
  },
  {
    "iata": "GSB",
    "name": "Seymour Johnson Air Force Base",
    "city": "Goldsboro"
  },
  {
    "iata": "GSO",
    "name": "Piedmont Triad International Airport",
    "city": "Greensboro"
  },
  {
    "iata": "GSP",
    "name": "Greenville Spartanburg International Airport",
    "city": "Greer"
  },
  {
    "iata": "GTF",
    "name": "Great Falls International Airport",
    "city": "Great Falls"
  },
  {
    "iata": "GTR",
    "name": "Golden Triangle Regional Airport",
    "city": "Columbus/W Point/Starkville"
  },
  {
    "iata": "GUC",
    "name": "Gunnison Crested Butte Regional Airport",
    "city": "Gunnison"
  },
  {
    "iata": "GUP",
    "name": "Gallup Municipal Airport",
    "city": "Gallup"
  },
  {
    "iata": "GUS",
    "name": "Grissom Air Reserve Base",
    "city": "Peru"
  },
  {
    "iata": "GUY",
    "name": "Guymon Municipal Airport",
    "city": "Guymon"
  },
  {
    "iata": "GWO",
    "name": "Greenwood–Leflore Airport",
    "city": "Greenwood"
  },
  {
    "iata": "PNX",
    "name": "North Texas Regional Airport Perrin Field",
    "city": "Denison"
  },
  {
    "iata": "HBG",
    "name": "Hattiesburg Bobby L Chain Municipal Airport",
    "city": "Hattiesburg"
  },
  {
    "iata": "HBR",
    "name": "Hobart Regional Airport",
    "city": "Hobart"
  },
  {
    "iata": "HDN",
    "name": "Yampa Valley Airport",
    "city": "Hayden"
  },
  {
    "iata": "MNZ",
    "name": "Manassas Regional Airport/Harry P. Davis Field",
    "city": "Manassas"
  },
  {
    "iata": "HFD",
    "name": "Hartford Brainard Airport",
    "city": "Hartford"
  },
  {
    "iata": "HGR",
    "name": "Hagerstown Regional Richard A Henson Field",
    "city": "Hagerstown"
  },
  {
    "iata": "HHR",
    "name": "Jack Northrop Field Hawthorne Municipal Airport",
    "city": "Hawthorne"
  },
  {
    "iata": "HIB",
    "name": "Range Regional Airport",
    "city": "Hibbing"
  },
  {
    "iata": "HIF",
    "name": "Hill Air Force Base",
    "city": "Ogden"
  },
  {
    "iata": "HII",
    "name": "Lake Havasu City International Airport",
    "city": "Lake Havasu City"
  },
  {
    "iata": "HIO",
    "name": "Portland Hillsboro Airport",
    "city": "Portland"
  },
  {
    "iata": "HKY",
    "name": "Hickory Regional Airport",
    "city": "Hickory"
  },
  {
    "iata": "HLG",
    "name": "Wheeling Ohio County Airport",
    "city": "Wheeling"
  },
  {
    "iata": "HLN",
    "name": "Helena Regional Airport",
    "city": "Helena"
  },
  {
    "iata": "HMN",
    "name": "Holloman Air Force Base",
    "city": "Alamogordo"
  },
  {
    "iata": "HOB",
    "name": "Lea County Regional Airport",
    "city": "Hobbs"
  },
  {
    "iata": "HON",
    "name": "Huron Regional Airport",
    "city": "Huron"
  },
  {
    "iata": "HOP",
    "name": "Campbell Army Airfield (Fort Campbell)",
    "city": "Fort Campbell"
  },
  {
    "iata": "HOT",
    "name": "Memorial Field Airport",
    "city": "Hot Springs"
  },
  {
    "iata": "HOU",
    "name": "William P Hobby Airport",
    "city": "Houston"
  },
  {
    "iata": "HPN",
    "name": "Westchester County Airport",
    "city": "White Plains"
  },
  {
    "iata": "HQM",
    "name": "Bowerman Airport",
    "city": "Hoquiam"
  },
  {
    "iata": "HRL",
    "name": "Valley International Airport",
    "city": "Harlingen"
  },
  {
    "iata": "HRO",
    "name": "Boone County Airport",
    "city": "Harrison"
  },
  {
    "iata": "HST",
    "name": "Homestead ARB Airport",
    "city": "Homestead"
  },
  {
    "iata": "HSV",
    "name": "Huntsville International Carl T Jones Field",
    "city": "Huntsville"
  },
  {
    "iata": "HTS",
    "name": "Tri-State Airport / Milton J. Ferguson Field",
    "city": "Huntington"
  },
  {
    "iata": "HUA",
    "name": "Redstone Army Air Field",
    "city": "Redstone Arsnl Huntsville"
  },
  {
    "iata": "HUL",
    "name": "Houlton International Airport",
    "city": "Houlton"
  },
  {
    "iata": "HUT",
    "name": "Hutchinson Municipal Airport",
    "city": "Hutchinson"
  },
  {
    "iata": "HVN",
    "name": "Tweed New Haven Airport",
    "city": "New Haven"
  },
  {
    "iata": "HVR",
    "name": "Havre City County Airport",
    "city": "Havre"
  },
  {
    "iata": "HHH",
    "name": "Hilton Head Airport",
    "city": "Hilton Head Island"
  },
  {
    "iata": "HYA",
    "name": "Cape Cod Gateway Airport",
    "city": "Hyannis"
  },
  {
    "iata": "HYR",
    "name": "Sawyer County Airport",
    "city": "Hayward"
  },
  {
    "iata": "HYS",
    "name": "Hays Regional Airport",
    "city": "Hays"
  },
  {
    "iata": "JFN",
    "name": "Northeast Ohio Regional Airport",
    "city": "Ashtabula"
  },
  {
    "iata": "IAB",
    "name": "McConnell Air Force Base",
    "city": "Wichita"
  },
  {
    "iata": "IAD",
    "name": "Washington Dulles International Airport",
    "city": "Dulles"
  },
  {
    "iata": "IAG",
    "name": "Niagara Falls International Airport",
    "city": "Niagara Falls"
  },
  {
    "iata": "IAH",
    "name": "George Bush Intercontinental Houston Airport",
    "city": "Houston"
  },
  {
    "iata": "ICT",
    "name": "Wichita Eisenhower National Airport",
    "city": "Wichita"
  },
  {
    "iata": "IDA",
    "name": "Idaho Falls Regional Airport",
    "city": "Idaho Falls"
  },
  {
    "iata": "IFP",
    "name": "Laughlin Bullhead International Airport",
    "city": "Bullhead City"
  },
  {
    "iata": "IGM",
    "name": "Kingman Airport",
    "city": "Kingman"
  },
  {
    "iata": "IKK",
    "name": "Greater Kankakee Airport",
    "city": "Kankakee"
  },
  {
    "iata": "ILG",
    "name": "Wilmington Airport",
    "city": "Wilmington"
  },
  {
    "iata": "ILM",
    "name": "Wilmington International Airport",
    "city": "Wilmington"
  },
  {
    "iata": "ILN",
    "name": "Wilmington Airpark",
    "city": "Wilmington"
  },
  {
    "iata": "IMT",
    "name": "Ford Airport",
    "city": "Kingsford"
  },
  {
    "iata": "IND",
    "name": "Indianapolis International Airport",
    "city": "Indianapolis"
  },
  {
    "iata": "INK",
    "name": "Winkler County Airport",
    "city": "Wink"
  },
  {
    "iata": "INL",
    "name": "Falls International Airport",
    "city": "International Falls"
  },
  {
    "iata": "INT",
    "name": "Smith Reynolds Airport",
    "city": "Winston Salem"
  },
  {
    "iata": "INW",
    "name": "Winslow Lindbergh Regional Airport",
    "city": "Winslow"
  },
  {
    "iata": "IPL",
    "name": "Imperial County Airport",
    "city": "Imperial"
  },
  {
    "iata": "IPT",
    "name": "Williamsport Regional Airport",
    "city": "Williamsport"
  },
  {
    "iata": "IRK",
    "name": "Kirksville Regional Airport",
    "city": "Kirksville"
  },
  {
    "iata": "ISM",
    "name": "Kissimmee Gateway Airport",
    "city": "Orlando"
  },
  {
    "iata": "ISO",
    "name": "Kinston Regional Jetport At Stallings Field",
    "city": "Kinston"
  },
  {
    "iata": "ISP",
    "name": "Long Island Mac Arthur Airport",
    "city": "Islip"
  },
  {
    "iata": "ITH",
    "name": "Ithaca Tompkins Regional Airport",
    "city": "Ithaca"
  },
  {
    "iata": "AZA",
    "name": "Mesa Gateway Airport",
    "city": "Mesa"
  },
  {
    "iata": "JAC",
    "name": "Jackson Hole Airport",
    "city": "Jackson"
  },
  {
    "iata": "JAN",
    "name": "Jackson-Medgar Wiley Evers International Airport",
    "city": "Jackson"
  },
  {
    "iata": "JAX",
    "name": "Jacksonville International Airport",
    "city": "Jacksonville"
  },
  {
    "iata": "JBR",
    "name": "Jonesboro Municipal Airport",
    "city": "Jonesboro"
  },
  {
    "iata": "JCT",
    "name": "Kimble County Airport",
    "city": "Junction"
  },
  {
    "iata": "JFK",
    "name": "John F Kennedy International Airport",
    "city": "New York"
  },
  {
    "iata": "JHW",
    "name": "Chautauqua County-Jamestown Airport",
    "city": "Jamestown"
  },
  {
    "iata": "JLN",
    "name": "Joplin Regional Airport",
    "city": "Joplin"
  },
  {
    "iata": "JMS",
    "name": "Jamestown Regional Airport",
    "city": "Jamestown"
  },
  {
    "iata": "USA",
    "name": "Concord-Padgett Regional Airport",
    "city": "Concord"
  },
  {
    "iata": "JST",
    "name": "John Murtha Johnstown Cambria County Airport",
    "city": "Johnstown"
  },
  {
    "iata": "JXN",
    "name": "Jackson County Airport/Reynolds Field",
    "city": "Jackson"
  },
  {
    "iata": "KLS",
    "name": "Southwest Washington Regional Airport",
    "city": "Kelso"
  },
  {
    "iata": "LAA",
    "name": "Southeast Colorado Regional Airport",
    "city": "Lamar"
  },
  {
    "iata": "LAF",
    "name": "Purdue University Airport",
    "city": "West Lafayette"
  },
  {
    "iata": "LAL",
    "name": "Lakeland Linder International Airport",
    "city": "Lakeland"
  },
  {
    "iata": "LAN",
    "name": "Capital City Airport",
    "city": "Lansing"
  },
  {
    "iata": "LAR",
    "name": "Laramie Regional Airport",
    "city": "Laramie"
  },
  {
    "iata": "LAS",
    "name": "Harry Reid International Airport",
    "city": "Las Vegas"
  },
  {
    "iata": "LAW",
    "name": "Lawton Fort Sill Regional Airport",
    "city": "Lawton"
  },
  {
    "iata": "LAX",
    "name": "Los Angeles International Airport",
    "city": "Los Angeles"
  },
  {
    "iata": "LBB",
    "name": "Lubbock Preston Smith International Airport",
    "city": "Lubbock"
  },
  {
    "iata": "LBE",
    "name": "Arnold Palmer Regional Airport",
    "city": "Latrobe"
  },
  {
    "iata": "LBF",
    "name": "North Platte Regional Airport Lee Bird Field",
    "city": "North Platte"
  },
  {
    "iata": "LBL",
    "name": "Liberal Mid-America Regional Airport",
    "city": "Liberal"
  },
  {
    "iata": "LBT",
    "name": "Lumberton Regional Airport",
    "city": "Lumberton"
  },
  {
    "iata": "LJN",
    "name": "Texas Gulf Coast Regional Airport",
    "city": "Angleton"
  },
  {
    "iata": "LCH",
    "name": "Lake Charles Regional Airport",
    "city": "Lake Charles"
  },
  {
    "iata": "LCK",
    "name": "Rickenbacker International Airport",
    "city": "Columbus"
  },
  {
    "iata": "LEB",
    "name": "Lebanon Municipal Airport",
    "city": "Lebanon"
  },
  {
    "iata": "LEE",
    "name": "Leesburg International Airport",
    "city": "Leesburg"
  },
  {
    "iata": "LEX",
    "name": "Blue Grass Airport",
    "city": "Lexington"
  },
  {
    "iata": "LFI",
    "name": "Langley Air Force Base",
    "city": "Hampton"
  },
  {
    "iata": "LFK",
    "name": "Angelina County Airport",
    "city": "Lufkin"
  },
  {
    "iata": "LFT",
    "name": "Lafayette Regional Airport",
    "city": "Lafayette"
  },
  {
    "iata": "LGA",
    "name": "LaGuardia Airport",
    "city": "New York"
  },
  {
    "iata": "LGB",
    "name": "Long Beach Airport (Daugherty Field)",
    "city": "Long Beach"
  },
  {
    "iata": "LGU",
    "name": "Logan-Cache Airport",
    "city": "Logan"
  },
  {
    "iata": "LIT",
    "name": "Bill & Hillary Clinton National Airport/Adams Field",
    "city": "Little Rock"
  },
  {
    "iata": "LMT",
    "name": "Crater Lake-Klamath Regional Airport",
    "city": "Klamath Falls"
  },
  {
    "iata": "LND",
    "name": "Hunt Field",
    "city": "Lander"
  },
  {
    "iata": "LNK",
    "name": "Lincoln Airport",
    "city": "Lincoln"
  },
  {
    "iata": "LNS",
    "name": "Lancaster Airport",
    "city": "Lancaster"
  },
  {
    "iata": "LOL",
    "name": "Derby Field",
    "city": "Lovelock"
  },
  {
    "iata": "LOU",
    "name": "Bowman Field",
    "city": "Louisville"
  },
  {
    "iata": "LOZ",
    "name": "London-Corbin Airport/Magee Field",
    "city": "London"
  },
  {
    "iata": "LRD",
    "name": "Laredo International Airport",
    "city": "Laredo"
  },
  {
    "iata": "LRF",
    "name": "Little Rock Air Force Base",
    "city": "Jacksonville"
  },
  {
    "iata": "LRU",
    "name": "Las Cruces International Airport",
    "city": "Las Cruces"
  },
  {
    "iata": "LSE",
    "name": "La Crosse Regional Airport",
    "city": "La Crosse"
  },
  {
    "iata": "LSF",
    "name": "Lawson Army Air Field",
    "city": "Fort Benning"
  },
  {
    "iata": "LSV",
    "name": "Nellis Air Force Base",
    "city": "Las Vegas"
  },
  {
    "iata": "LTS",
    "name": "Altus Air Force Base",
    "city": "Altus"
  },
  {
    "iata": "LUF",
    "name": "Luke Air Force Base",
    "city": "Glendale"
  },
  {
    "iata": "LUK",
    "name": "Cincinnati Municipal Airport Lunken Field",
    "city": "Cincinnati"
  },
  {
    "iata": "LVM",
    "name": "Mission Field",
    "city": "Livingston"
  },
  {
    "iata": "LVS",
    "name": "Las Vegas Municipal Airport",
    "city": "Las Vegas"
  },
  {
    "iata": "LWB",
    "name": "Greenbrier Valley Airport",
    "city": "Lewisburg"
  },
  {
    "iata": "LWM",
    "name": "Lawrence Municipal Airport",
    "city": "Lawrence"
  },
  {
    "iata": "LWS",
    "name": "Lewiston Nez Perce County Airport",
    "city": "Lewiston"
  },
  {
    "iata": "LWT",
    "name": "Lewistown Municipal Airport",
    "city": "Lewistown"
  },
  {
    "iata": "LYH",
    "name": "Lynchburg Regional Airport - Preston Glenn Field",
    "city": "Lynchburg"
  },
  {
    "iata": "MAF",
    "name": "Midland International Air and Space Port",
    "city": "Midland"
  },
  {
    "iata": "MBG",
    "name": "Mobridge Municipal Airport",
    "city": "Mobridge"
  },
  {
    "iata": "MBS",
    "name": "MBS International Airport",
    "city": "Freeland"
  },
  {
    "iata": "MCB",
    "name": "McComb-Pike County Airport / John E Lewis Field",
    "city": "McComb"
  },
  {
    "iata": "MCC",
    "name": "McClellan Airfield",
    "city": "Sacramento"
  },
  {
    "iata": "MCE",
    "name": "Merced Regional Macready Field",
    "city": "Merced"
  },
  {
    "iata": "MCF",
    "name": "MacDill Air Force Base",
    "city": "Tampa"
  },
  {
    "iata": "MCI",
    "name": "Kansas City International Airport",
    "city": "Kansas City"
  },
  {
    "iata": "MCK",
    "name": "McCook Ben Nelson Regional Airport",
    "city": "McCook"
  },
  {
    "iata": "MCN",
    "name": "Middle Georgia Regional Airport",
    "city": "Macon"
  },
  {
    "iata": "MCO",
    "name": "Orlando International Airport",
    "city": "Orlando"
  },
  {
    "iata": "MCW",
    "name": "Mason City Municipal Airport",
    "city": "Mason City"
  },
  {
    "iata": "MDH",
    "name": "Southern Illinois Airport",
    "city": "Murphysboro"
  },
  {
    "iata": "MDT",
    "name": "Harrisburg International Airport",
    "city": "Harrisburg"
  },
  {
    "iata": "MDW",
    "name": "Chicago Midway International Airport",
    "city": "Chicago"
  },
  {
    "iata": "MEI",
    "name": "Key Field / Meridian Regional Airport",
    "city": "Meridian"
  },
  {
    "iata": "MEM",
    "name": "Memphis International Airport",
    "city": "Memphis"
  },
  {
    "iata": "MER",
    "name": "Castle Airport",
    "city": "Merced"
  },
  {
    "iata": "MFD",
    "name": "Mansfield Lahm Regional Airport",
    "city": "Mansfield"
  },
  {
    "iata": "MFE",
    "name": "McAllen Miller International Airport",
    "city": "McAllen"
  },
  {
    "iata": "MFR",
    "name": "Rogue Valley International Medford Airport",
    "city": "Medford"
  },
  {
    "iata": "MGE",
    "name": "Dobbins Air Reserve Base",
    "city": "Marietta"
  },
  {
    "iata": "MGM",
    "name": "Montgomery Regional (Dannelly Field) Airport",
    "city": "Montgomery"
  },
  {
    "iata": "MGW",
    "name": "Morgantown Municipal Airport Walter L. (Bill) Hart Field",
    "city": "Morgantown"
  },
  {
    "iata": "MHK",
    "name": "Manhattan Regional Airport",
    "city": "Manhattan"
  },
  {
    "iata": "MHR",
    "name": "Sacramento Mather Airport",
    "city": "Sacramento"
  },
  {
    "iata": "MHT",
    "name": "Manchester-Boston Regional Airport",
    "city": "Manchester"
  },
  {
    "iata": "MIA",
    "name": "Miami International Airport",
    "city": "Miami"
  },
  {
    "iata": "MIB",
    "name": "Minot Air Force Base",
    "city": "Minot"
  },
  {
    "iata": "MIE",
    "name": "Delaware County Johnson Field",
    "city": "Muncie"
  },
  {
    "iata": "MIV",
    "name": "Millville Municipal Airport",
    "city": "Millville"
  },
  {
    "iata": "MKC",
    "name": "Charles B. Wheeler Downtown Airport",
    "city": "Kansas City"
  },
  {
    "iata": "MKE",
    "name": "General Mitchell International Airport",
    "city": "Milwaukee"
  },
  {
    "iata": "MKG",
    "name": "Muskegon County Airport",
    "city": "Muskegon"
  },
  {
    "iata": "MKL",
    "name": "McKellar-Sipes Regional Airport",
    "city": "Jackson"
  },
  {
    "iata": "MLB",
    "name": "Melbourne Orlando International Airport",
    "city": "Melbourne"
  },
  {
    "iata": "MLC",
    "name": "Mc Alester Regional Airport",
    "city": "Mc Alester"
  },
  {
    "iata": "MLI",
    "name": "Quad City International Airport",
    "city": "Moline"
  },
  {
    "iata": "MLS",
    "name": "Miles City Airport - Frank Wiley Field",
    "city": "Miles City"
  },
  {
    "iata": "MLU",
    "name": "Monroe Regional Airport",
    "city": "Monroe"
  },
  {
    "iata": "MMT",
    "name": "Mc Entire Joint National Guard Base",
    "city": "Eastover"
  },
  {
    "iata": "MMU",
    "name": "Morristown Municipal Airport",
    "city": "Morristown"
  },
  {
    "iata": "MOB",
    "name": "Mobile Regional Airport",
    "city": "Mobile"
  },
  {
    "iata": "MOD",
    "name": "Modesto City Co-Harry Sham Field",
    "city": "Modesto"
  },
  {
    "iata": "MOT",
    "name": "Minot International Airport",
    "city": "Minot"
  },
  {
    "iata": "MPV",
    "name": "Edward F Knapp State Airport",
    "city": "Barre/Montpelier"
  },
  {
    "iata": "MQY",
    "name": "Smyrna Airport",
    "city": "Smyrna"
  },
  {
    "iata": "MRB",
    "name": "Eastern WV Regional Airport/Shepherd Field",
    "city": "Martinsburg"
  },
  {
    "iata": "MRY",
    "name": "Monterey Peninsula Airport",
    "city": "Monterey"
  },
  {
    "iata": "MSL",
    "name": "Northwest Alabama Regional Airport",
    "city": "Muscle Shoals"
  },
  {
    "iata": "MSN",
    "name": "Dane County Regional Truax Field",
    "city": "Madison"
  },
  {
    "iata": "MSO",
    "name": "Missoula International Airport",
    "city": "Missoula"
  },
  {
    "iata": "MSP",
    "name": "Minneapolis–Saint Paul International Airport / Wold–Chamberlain Field",
    "city": "Minneapolis"
  },
  {
    "iata": "MSS",
    "name": "Massena International Airport Richards Field",
    "city": "Massena"
  },
  {
    "iata": "MSY",
    "name": "Louis Armstrong New Orleans International Airport",
    "city": "New Orleans"
  },
  {
    "iata": "MTC",
    "name": "Selfridge Air National Guard Base Airport",
    "city": "Mount Clemens"
  },
  {
    "iata": "MTH",
    "name": "The Florida Keys Marathon Airport",
    "city": "Marathon"
  },
  {
    "iata": "MTJ",
    "name": "Montrose Regional Airport",
    "city": "Montrose"
  },
  {
    "iata": "MTN",
    "name": "Martin State Airport",
    "city": "Baltimore"
  },
  {
    "iata": "MUI",
    "name": "Muir Army Air Field (Fort Indiantown Gap) Airport",
    "city": "Fort Indiantown Gap(Annville)"
  },
  {
    "iata": "MUO",
    "name": "Mountain Home Air Force Base",
    "city": "Mountain Home"
  },
  {
    "iata": "MWA",
    "name": "Veterans Airport of Southern Illinois",
    "city": "Marion"
  },
  {
    "iata": "MWH",
    "name": "Grant County International Airport",
    "city": "Moses Lake"
  },
  {
    "iata": "MXF",
    "name": "Maxwell Air Force Base",
    "city": "Montgomery"
  },
  {
    "iata": "MYL",
    "name": "McCall Municipal Airport",
    "city": "McCall"
  },
  {
    "iata": "MYR",
    "name": "Myrtle Beach International Airport",
    "city": "Myrtle Beach"
  },
  {
    "iata": "MYV",
    "name": "Yuba County Airport",
    "city": "Marysville"
  },
  {
    "iata": "NBG",
    "name": "New Orleans NAS JRB/Alvin Callender Field",
    "city": "New Orleans"
  },
  {
    "iata": "NEL",
    "name": "Lakehurst Maxfield Field Airport",
    "city": "Lakehurst"
  },
  {
    "iata": "NEW",
    "name": "Lakefront Airport",
    "city": "New Orleans"
  },
  {
    "iata": "NFL",
    "name": "Fallon Naval Air Station",
    "city": "Fallon"
  },
  {
    "iata": "FWH",
    "name": "NAS Fort Worth JRB / Carswell Field",
    "city": "Fort Worth"
  },
  {
    "iata": "NGP",
    "name": "Naval Air Station Corpus Christi Truax Field",
    "city": "Corpus Christi"
  },
  {
    "iata": "NGU",
    "name": "Norfolk Naval Station (Chambers Field)",
    "city": "Norfolk"
  },
  {
    "iata": "NHK",
    "name": "Patuxent River Naval Air Station (Trapnell Field)",
    "city": "Patuxent River"
  },
  {
    "iata": "NIP",
    "name": "Jacksonville Naval Air Station (Towers Field)",
    "city": "Jacksonville"
  },
  {
    "iata": "NJK",
    "name": "El Centro NAF Airport (Vraciu Field)",
    "city": "El Centro"
  },
  {
    "iata": "NKX",
    "name": "Miramar Marine Corps Air Station - Mitscher Field",
    "city": "San Diego"
  },
  {
    "iata": "NLC",
    "name": "Lemoore Naval Air Station (Reeves Field) Airport",
    "city": "Lemoore"
  },
  {
    "iata": "NPA",
    "name": "Naval Air Station Pensacola Forrest Sherman Field",
    "city": "Pensacola"
  },
  {
    "iata": "NQA",
    "name": "Millington-Memphis Airport",
    "city": "Millington"
  },
  {
    "iata": "NQI",
    "name": "Kingsville Naval Air Station",
    "city": "Kingsville"
  },
  {
    "iata": "NQX",
    "name": "Naval Air Station Key West/Boca Chica Field",
    "city": "Key West"
  },
  {
    "iata": "NRB",
    "name": "Naval Station Mayport / Admiral David L McDonald Field",
    "city": "Jacksonville"
  },
  {
    "iata": "NSE",
    "name": "Whiting Field Naval Air Station - North",
    "city": "Milton"
  },
  {
    "iata": "NTD",
    "name": "Point Mugu Naval Air Station (Naval Base Ventura Co)",
    "city": "Point Mugu"
  },
  {
    "iata": "NTU",
    "name": "Oceana Naval Air Station",
    "city": "Virginia Beach"
  },
  {
    "iata": "NUQ",
    "name": "Moffett Federal Airfield",
    "city": "Mountain View"
  },
  {
    "iata": "NUW",
    "name": "Whidbey Island Naval Air Station (Ault Field)",
    "city": "Oak Harbor"
  },
  {
    "iata": "NYG",
    "name": "Quantico Marine Corps Airfield / Turner Field",
    "city": "Quantico"
  },
  {
    "iata": "YUM",
    "name": "Yuma International Airport / Marine Corps Air Station Yuma",
    "city": "Yuma"
  },
  {
    "iata": "NZY",
    "name": "North Island Naval Air Station-Halsey Field",
    "city": "San Diego"
  },
  {
    "iata": "OAJ",
    "name": "Albert J Ellis Airport",
    "city": "Richlands"
  },
  {
    "iata": "OAK",
    "name": "San Francisco Bay Oakland International Airport",
    "city": "Oakland"
  },
  {
    "iata": "OFF",
    "name": "Offutt Air Force Base",
    "city": "Omaha"
  },
  {
    "iata": "OFK",
    "name": "Karl Stefan Memorial Airport",
    "city": "Norfolk"
  },
  {
    "iata": "OGB",
    "name": "Orangeburg Municipal Airport",
    "city": "Orangeburg"
  },
  {
    "iata": "OGD",
    "name": "Ogden Hinckley Airport",
    "city": "Ogden"
  },
  {
    "iata": "OGS",
    "name": "Ogdensburg International Airport",
    "city": "Ogdensburg"
  },
  {
    "iata": "OKC",
    "name": "Will Rogers World Airport",
    "city": "Oklahoma City"
  },
  {
    "iata": "OLF",
    "name": "L M Clayton Airport",
    "city": "Wolf Point"
  },
  {
    "iata": "OLM",
    "name": "Olympia Regional Airport",
    "city": "Olympia"
  },
  {
    "iata": "OLS",
    "name": "Nogales International Airport",
    "city": "Nogales"
  },
  {
    "iata": "OLU",
    "name": "Columbus Municipal Airport",
    "city": "Columbus"
  },
  {
    "iata": "OMA",
    "name": "Eppley Airfield",
    "city": "Omaha"
  },
  {
    "iata": "ONO",
    "name": "Ontario Municipal Airport",
    "city": "Oregon"
  },
  {
    "iata": "ONP",
    "name": "Newport Municipal Airport",
    "city": "Newport"
  },
  {
    "iata": "ONT",
    "name": "Ontario International Airport",
    "city": "Ontario"
  },
  {
    "iata": "OPF",
    "name": "Miami-Opa Locka Executive Airport",
    "city": "Miami"
  },
  {
    "iata": "NCO",
    "name": "Quonset State Airport",
    "city": "North Kingstown"
  },
  {
    "iata": "ORD",
    "name": "Chicago O'Hare International Airport",
    "city": "Chicago"
  },
  {
    "iata": "ORF",
    "name": "Norfolk International Airport",
    "city": "Norfolk"
  },
  {
    "iata": "ORH",
    "name": "Worcester Regional Airport",
    "city": "Worcester"
  },
  {
    "iata": "ESD",
    "name": "Orcas Island Airport",
    "city": "Eastsound"
  },
  {
    "iata": "OSH",
    "name": "Wittman Regional Airport",
    "city": "Oshkosh"
  },
  {
    "iata": "OSU",
    "name": "The Ohio State University Airport - Don Scott Field",
    "city": "Columbus"
  },
  {
    "iata": "OTH",
    "name": "Southwest Oregon Regional Airport",
    "city": "North Bend"
  },
  {
    "iata": "OTM",
    "name": "Ottumwa Regional Airport",
    "city": "Ottumwa"
  },
  {
    "iata": "OWB",
    "name": "Owensboro Daviess County Airport",
    "city": "Owensboro"
  },
  {
    "iata": "OWD",
    "name": "Norwood Memorial Airport",
    "city": "Norwood"
  },
  {
    "iata": "OXR",
    "name": "Oxnard Airport",
    "city": "Oxnard"
  },
  {
    "iata": "OZR",
    "name": "Cairns AAF (Fort Rucker) Air Field",
    "city": "Fort Rucker/Ozark"
  },
  {
    "iata": "PAE",
    "name": "Seattle Paine Field International Airport",
    "city": "Everett"
  },
  {
    "iata": "PAH",
    "name": "Barkley Regional Airport",
    "city": "Paducah"
  },
  {
    "iata": "PAM",
    "name": "Tyndall Air Force Base",
    "city": "Panama City"
  },
  {
    "iata": "PAO",
    "name": "Palo Alto Airport",
    "city": "Palo Alto"
  },
  {
    "iata": "PBF",
    "name": "Pine Bluff Regional Airport, Grider Field",
    "city": "Pine Bluff"
  },
  {
    "iata": "PBG",
    "name": "Plattsburgh International Airport",
    "city": "Plattsburgh"
  },
  {
    "iata": "PBI",
    "name": "Palm Beach International Airport",
    "city": "West Palm Beach"
  },
  {
    "iata": "PDK",
    "name": "DeKalb Peachtree Airport",
    "city": "Atlanta"
  },
  {
    "iata": "PDT",
    "name": "Eastern Oregon Regional Airport at Pendleton",
    "city": "Pendleton"
  },
  {
    "iata": "PDX",
    "name": "Portland International Airport",
    "city": "Portland"
  },
  {
    "iata": "PGA",
    "name": "Page Municipal Airport",
    "city": "Page"
  },
  {
    "iata": "PGD",
    "name": "Punta Gorda Airport",
    "city": "Punta Gorda"
  },
  {
    "iata": "PGV",
    "name": "Pitt-Greenville Airport",
    "city": "Greenville"
  },
  {
    "iata": "PHF",
    "name": "Newport News Williamsburg International Airport",
    "city": "Newport News"
  },
  {
    "iata": "PHL",
    "name": "Philadelphia International Airport",
    "city": "Philadelphia"
  },
  {
    "iata": "PHX",
    "name": "Phoenix Sky Harbor International Airport",
    "city": "Phoenix"
  },
  {
    "iata": "PIA",
    "name": "General Wayne A. Downing Peoria International Airport",
    "city": "Peoria"
  },
  {
    "iata": "PIB",
    "name": "Hattiesburg Laurel Regional Airport",
    "city": "Moselle"
  },
  {
    "iata": "PIE",
    "name": "St. Petersburg Clearwater International Airport",
    "city": "Pinellas Park"
  },
  {
    "iata": "PIH",
    "name": "Pocatello Regional Airport",
    "city": "Pocatello"
  },
  {
    "iata": "PIR",
    "name": "Pierre Regional Airport",
    "city": "Pierre"
  },
  {
    "iata": "PIT",
    "name": "Pittsburgh International Airport",
    "city": "Pittsburgh"
  },
  {
    "iata": "PKB",
    "name": "Mid Ohio Valley Regional Airport",
    "city": "Parkersburg (Williamstown)"
  },
  {
    "iata": "PLN",
    "name": "Pellston Regional Airport of Emmet County Airport",
    "city": "Pellston"
  },
  {
    "iata": "PMD",
    "name": "Palmdale Regional Airport / USAF Plant 42 Airport",
    "city": "Palmdale"
  },
  {
    "iata": "PWY",
    "name": "Ralph Wenz Field",
    "city": "Pinedale"
  },
  {
    "iata": "PNC",
    "name": "Ponca City Regional Airport",
    "city": "Ponca City"
  },
  {
    "iata": "PNE",
    "name": "Northeast Philadelphia Airport",
    "city": "Philadelphia"
  },
  {
    "iata": "PNS",
    "name": "Pensacola International Airport",
    "city": "Pensacola"
  },
  {
    "iata": "POB",
    "name": "Pope Field",
    "city": "Fort Bragg"
  },
  {
    "iata": "POE",
    "name": "Polk Army Air Field",
    "city": "Fort Polk"
  },
  {
    "iata": "POU",
    "name": "Dutchess County Airport",
    "city": "Poughkeepsie"
  },
  {
    "iata": "PQI",
    "name": "Presque Isle International Airport",
    "city": "Presque Isle"
  },
  {
    "iata": "PRB",
    "name": "Paso Robles Municipal Airport",
    "city": "Paso Robles"
  },
  {
    "iata": "PRC",
    "name": "Prescott International Airport - Ernest A. Love Field",
    "city": "Prescott"
  },
  {
    "iata": "PRX",
    "name": "Cox Field",
    "city": "Paris"
  },
  {
    "iata": "PSC",
    "name": "Tri Cities Airport",
    "city": "Pasco"
  },
  {
    "iata": "PSM",
    "name": "Portsmouth International at Pease Airport",
    "city": "Portsmouth"
  },
  {
    "iata": "PSP",
    "name": "Palm Springs International Airport",
    "city": "Palm Springs"
  },
  {
    "iata": "PTK",
    "name": "Oakland County International Airport",
    "city": "Pontiac"
  },
  {
    "iata": "PUB",
    "name": "Pueblo Memorial Airport",
    "city": "Pueblo"
  },
  {
    "iata": "PUW",
    "name": "Pullman-Moscow Regional Airport",
    "city": "Pullman"
  },
  {
    "iata": "PVD",
    "name": "Theodore Francis Green State Airport",
    "city": "Warwick"
  },
  {
    "iata": "PVU",
    "name": "Provo-Utah Lake International Airport",
    "city": "Provo"
  },
  {
    "iata": "PWM",
    "name": "Portland International Jetport",
    "city": "Portland"
  },
  {
    "iata": "PWT",
    "name": "Bremerton National Airport",
    "city": "Bremerton"
  },
  {
    "iata": "RAL",
    "name": "Riverside Municipal Airport",
    "city": "Riverside"
  },
  {
    "iata": "RAP",
    "name": "Rapid City Regional Airport",
    "city": "Rapid City"
  },
  {
    "iata": "RBL",
    "name": "Red Bluff Municipal Airport",
    "city": "Red Bluff"
  },
  {
    "iata": "RCA",
    "name": "Ellsworth Air Force Base",
    "city": "Rapid City"
  },
  {
    "iata": "RDD",
    "name": "Redding Municipal Airport",
    "city": "Redding"
  },
  {
    "iata": "RDG",
    "name": "Reading Regional Airport (Carl A Spaatz Field)",
    "city": "Reading"
  },
  {
    "iata": "RDM",
    "name": "Roberts Field",
    "city": "Redmond"
  },
  {
    "iata": "RDR",
    "name": "Grand Forks Air Force Base",
    "city": "Grand Forks"
  },
  {
    "iata": "RDU",
    "name": "Raleigh Durham International Airport",
    "city": "Raleigh/Durham"
  },
  {
    "iata": "RFD",
    "name": "Chicago Rockford International Airport",
    "city": "Chicago/Rockford"
  },
  {
    "iata": "RHI",
    "name": "Rhinelander Oneida County Airport",
    "city": "Rhinelander"
  },
  {
    "iata": "RIC",
    "name": "Richmond International Airport",
    "city": "Richmond"
  },
  {
    "iata": "RIL",
    "name": "Garfield County Regional Airport",
    "city": "Rifle"
  },
  {
    "iata": "RIV",
    "name": "March Air Reserve Base",
    "city": "Riverside"
  },
  {
    "iata": "RIW",
    "name": "Central Wyoming Regional Airport",
    "city": "Riverton"
  },
  {
    "iata": "RKD",
    "name": "Knox County Regional Airport",
    "city": "Rockland"
  },
  {
    "iata": "RKS",
    "name": "Southwest Wyoming Regional Airport",
    "city": "Rock Springs"
  },
  {
    "iata": "RME",
    "name": "Griffiss International Airport",
    "city": "Rome"
  },
  {
    "iata": "RMG",
    "name": "Richard B Russell Airport",
    "city": "Rome"
  },
  {
    "iata": "RND",
    "name": "Randolph Air Force Base",
    "city": "Universal City"
  },
  {
    "iata": "RNH",
    "name": "New Richmond Regional Airport",
    "city": "New Richmond"
  },
  {
    "iata": "RNO",
    "name": "Reno Tahoe International Airport",
    "city": "Reno"
  },
  {
    "iata": "ROA",
    "name": "Roanoke–Blacksburg Regional Airport",
    "city": "Roanoke"
  },
  {
    "iata": "ROC",
    "name": "Frederick Douglass Greater Rochester International Airport",
    "city": "Rochester"
  },
  {
    "iata": "ROW",
    "name": "Roswell Air Center Airport",
    "city": "Roswell"
  },
  {
    "iata": "RSL",
    "name": "Russell Municipal Airport",
    "city": "Russell"
  },
  {
    "iata": "RST",
    "name": "Rochester International Airport",
    "city": "Rochester"
  },
  {
    "iata": "RSW",
    "name": "Southwest Florida International Airport",
    "city": "Fort Myers"
  },
  {
    "iata": "RUT",
    "name": "Rutland - Southern Vermont Regional Airport",
    "city": "Rutland"
  },
  {
    "iata": "RVS",
    "name": "Tulsa Riverside Airport",
    "city": "Tulsa"
  },
  {
    "iata": "RWF",
    "name": "Redwood Falls Municipal Airport",
    "city": "Redwood Falls"
  },
  {
    "iata": "RWI",
    "name": "Rocky Mount Wilson Regional Airport",
    "city": "Rocky Mount"
  },
  {
    "iata": "RWL",
    "name": "Rawlins Municipal Airport/Harvey Field",
    "city": "Rawlins"
  },
  {
    "iata": "SAC",
    "name": "Sacramento Executive Airport",
    "city": "Sacramento"
  },
  {
    "iata": "SAF",
    "name": "Santa Fe Municipal Airport",
    "city": "Santa Fe"
  },
  {
    "iata": "SAN",
    "name": "San Diego International Airport",
    "city": "San Diego"
  },
  {
    "iata": "SAT",
    "name": "San Antonio International Airport",
    "city": "San Antonio"
  },
  {
    "iata": "SAV",
    "name": "Savannah Hilton Head International Airport",
    "city": "Savannah"
  },
  {
    "iata": "MQT",
    "name": "Marquette/Sawyer International Airport",
    "city": "Gwinn"
  },
  {
    "iata": "SBA",
    "name": "Santa Barbara Municipal Airport",
    "city": "Santa Barbara"
  },
  {
    "iata": "SBD",
    "name": "San Bernardino International Airport",
    "city": "San Bernardino"
  },
  {
    "iata": "SBN",
    "name": "South Bend Regional Airport",
    "city": "South Bend"
  },
  {
    "iata": "SBP",
    "name": "San Luis County Regional Airport",
    "city": "San Luis Obispo"
  },
  {
    "iata": "SBY",
    "name": "Salisbury Ocean City Wicomico Regional Airport",
    "city": "Salisbury"
  },
  {
    "iata": "SCH",
    "name": "Schenectady County Airport",
    "city": "Schenectady"
  },
  {
    "iata": "SCK",
    "name": "Stockton Metropolitan Airport",
    "city": "Stockton"
  },
  {
    "iata": "SDF",
    "name": "Louisville Muhammad Ali International Airport",
    "city": "Louisville"
  },
  {
    "iata": "SDM",
    "name": "Brown Field Municipal Airport",
    "city": "San Diego"
  },
  {
    "iata": "SDY",
    "name": "Sidney - Richland Regional Airport",
    "city": "Sidney"
  },
  {
    "iata": "SEA",
    "name": "Seattle–Tacoma International Airport",
    "city": "Seattle"
  },
  {
    "iata": "SFB",
    "name": "Orlando Sanford International Airport",
    "city": "Orlando"
  },
  {
    "iata": "SFF",
    "name": "Felts Field",
    "city": "Spokane"
  },
  {
    "iata": "SFO",
    "name": "San Francisco International Airport",
    "city": "San Francisco"
  },
  {
    "iata": "SGF",
    "name": "Springfield Branson National Airport",
    "city": "Springfield"
  },
  {
    "iata": "SGH",
    "name": "Springfield-Beckley Municipal Airport",
    "city": "Springfield"
  },
  {
    "iata": "UST",
    "name": "Northeast Florida Regional Airport",
    "city": "St Augustine"
  },
  {
    "iata": "SGR",
    "name": "Sugar Land Regional Airport",
    "city": "Houston"
  },
  {
    "iata": "SGU",
    "name": "St George Regional Airport",
    "city": "St George"
  },
  {
    "iata": "SHD",
    "name": "Shenandoah Valley Regional Airport",
    "city": "Weyers Cave"
  },
  {
    "iata": "SHR",
    "name": "Sheridan County Airport",
    "city": "Sheridan"
  },
  {
    "iata": "SHV",
    "name": "Shreveport Regional Airport",
    "city": "Shreveport"
  },
  {
    "iata": "SJC",
    "name": "Norman Y. Mineta San Jose International Airport",
    "city": "San Jose"
  },
  {
    "iata": "SJT",
    "name": "San Angelo Regional Mathis Field",
    "city": "San Angelo"
  },
  {
    "iata": "SKA",
    "name": "Fairchild Air Force Base",
    "city": "Spokane"
  },
  {
    "iata": "SKF",
    "name": "Lackland Air Force Base",
    "city": "San Antonio"
  },
  {
    "iata": "TSM",
    "name": "Taos Regional Airport",
    "city": "Taos"
  },
  {
    "iata": "SLC",
    "name": "Salt Lake City International Airport",
    "city": "Salt Lake City"
  },
  {
    "iata": "SLE",
    "name": "Salem-Willamette Valley Airport/McNary Field",
    "city": "Salem"
  },
  {
    "iata": "SLK",
    "name": "Adirondack Regional Airport",
    "city": "Saranac Lake"
  },
  {
    "iata": "SLN",
    "name": "Salina Municipal Airport",
    "city": "Salina"
  },
  {
    "iata": "SME",
    "name": "Lake Cumberland Regional Airport",
    "city": "Somerset"
  },
  {
    "iata": "SMF",
    "name": "Sacramento International Airport",
    "city": "Sacramento"
  },
  {
    "iata": "SMN",
    "name": "Lemhi County Airport",
    "city": "Salmon"
  },
  {
    "iata": "SMO",
    "name": "Santa Monica Municipal Airport",
    "city": "Santa Monica"
  },
  {
    "iata": "SMX",
    "name": "Santa Maria Public Airport Captain G Allan Hancock Field",
    "city": "Santa Maria"
  },
  {
    "iata": "SNA",
    "name": "John Wayne Orange County International Airport",
    "city": "Santa Ana"
  },
  {
    "iata": "SNS",
    "name": "Salinas Municipal Airport",
    "city": "Salinas"
  },
  {
    "iata": "SNY",
    "name": "Sidney Municipal Airport Lloyd W Carr Field",
    "city": "Sidney"
  },
  {
    "iata": "SOW",
    "name": "Show Low Regional Airport",
    "city": "Show Low"
  },
  {
    "iata": "SPI",
    "name": "Abraham Lincoln Capital Airport",
    "city": "Springfield"
  },
  {
    "iata": "SPS",
    "name": "Wichita Falls Municipal Airport / Sheppard Air Force Base",
    "city": "Wichita Falls"
  },
  {
    "iata": "SQL",
    "name": "San Carlos Airport",
    "city": "San Carlos"
  },
  {
    "iata": "SRQ",
    "name": "Sarasota Bradenton International Airport",
    "city": "Sarasota/Bradenton"
  },
  {
    "iata": "RUI",
    "name": "Sierra Blanca Regional Airport",
    "city": "Alto"
  },
  {
    "iata": "SSC",
    "name": "Shaw Air Force Base",
    "city": "Sumter"
  },
  {
    "iata": "SSF",
    "name": "Stinson Municipal Airport",
    "city": "San Antonio"
  },
  {
    "iata": "SSI",
    "name": "St Simons Island Airport",
    "city": "St Simons Island"
  },
  {
    "iata": "STC",
    "name": "Saint Cloud Regional Airport",
    "city": "Saint Cloud"
  },
  {
    "iata": "STJ",
    "name": "Rosecrans Memorial Airport",
    "city": "St Joseph"
  },
  {
    "iata": "STL",
    "name": "St. Louis Lambert International Airport",
    "city": "St Louis"
  },
  {
    "iata": "STP",
    "name": "Saint Paul Downtown Holman Field",
    "city": "Saint Paul"
  },
  {
    "iata": "STS",
    "name": "Charles M. Schulz Sonoma County Airport",
    "city": "Santa Rosa"
  },
  {
    "iata": "SUN",
    "name": "Friedman Memorial Airport",
    "city": "Hailey"
  },
  {
    "iata": "SUS",
    "name": "Spirit of St Louis Airport",
    "city": "St Louis"
  },
  {
    "iata": "SUU",
    "name": "Travis Air Force Base",
    "city": "Fairfield"
  },
  {
    "iata": "SUX",
    "name": "Sioux Gateway Airport / Brigadier General Bud Day Field",
    "city": "Sioux City"
  },
  {
    "iata": "SVC",
    "name": "Grant County Airport",
    "city": "Silver City"
  },
  {
    "iata": "SVN",
    "name": "Hunter Army Air Field",
    "city": "Savannah"
  },
  {
    "iata": "SWF",
    "name": "New York Stewart International Airport",
    "city": "Newburgh"
  },
  {
    "iata": "SWO",
    "name": "Stillwater Regional Airport",
    "city": "Stillwater"
  },
  {
    "iata": "SYR",
    "name": "Syracuse Hancock International Airport",
    "city": "Syracuse"
  },
  {
    "iata": "SZL",
    "name": "Whiteman Air Force Base",
    "city": "Knob Noster"
  },
  {
    "iata": "TBN",
    "name": "Waynesville-St. Robert Regional Airport-Forney Field",
    "city": "Fort Leonard Wood"
  },
  {
    "iata": "TCC",
    "name": "Tucumcari Municipal Airport",
    "city": "Tucumcari"
  },
  {
    "iata": "TCL",
    "name": "Tuscaloosa National Airport",
    "city": "Tuscaloosa"
  },
  {
    "iata": "TCM",
    "name": "McChord Air Force Base",
    "city": "Tacoma"
  },
  {
    "iata": "TCS",
    "name": "Truth or Consequences Municipal Airport",
    "city": "Truth or Consequences"
  },
  {
    "iata": "TEB",
    "name": "Teterboro Airport",
    "city": "Teterboro"
  },
  {
    "iata": "TEX",
    "name": "Telluride Regional Airport",
    "city": "Telluride"
  },
  {
    "iata": "TIK",
    "name": "Tinker Air Force Base",
    "city": "Oklahoma City"
  },
  {
    "iata": "TIW",
    "name": "Tacoma Narrows Airport",
    "city": "Tacoma"
  },
  {
    "iata": "TIX",
    "name": "Space Coast Regional Airport",
    "city": "Titusville"
  },
  {
    "iata": "TLH",
    "name": "Tallahassee Regional Airport",
    "city": "Tallahassee"
  },
  {
    "iata": "TMB",
    "name": "Miami Executive Airport",
    "city": "Miami"
  },
  {
    "iata": "TOI",
    "name": "Troy Municipal Airport at N Kenneth Campbell Field",
    "city": "Troy"
  },
  {
    "iata": "TOL",
    "name": "Eugene F. Kranz Toledo Express Airport",
    "city": "Toledo"
  },
  {
    "iata": "TOP",
    "name": "Philip Billard Municipal Airport",
    "city": "Topeka"
  },
  {
    "iata": "TPA",
    "name": "Tampa International Airport",
    "city": "Tampa"
  },
  {
    "iata": "TPH",
    "name": "Tonopah Airport",
    "city": "Tonopah"
  },
  {
    "iata": "TPL",
    "name": "Draughon Miller Central Texas Regional Airport",
    "city": "Temple"
  },
  {
    "iata": "TRI",
    "name": "Tri-Cities Regional TN/VA Airport",
    "city": "Blountville"
  },
  {
    "iata": "TKF",
    "name": "Truckee Tahoe Airport",
    "city": "Truckee"
  },
  {
    "iata": "TRM",
    "name": "Jacqueline Cochran Regional Airport",
    "city": "Palm Springs"
  },
  {
    "iata": "TTD",
    "name": "Portland Troutdale Airport",
    "city": "Portland"
  },
  {
    "iata": "TTN",
    "name": "Trenton Mercer Airport",
    "city": "Ewing Township"
  },
  {
    "iata": "TUL",
    "name": "Tulsa International Airport",
    "city": "Tulsa"
  },
  {
    "iata": "TUP",
    "name": "Tupelo Regional Airport",
    "city": "Tupelo"
  },
  {
    "iata": "TUS",
    "name": "Tucson International Airport / Morris Air National Guard Base",
    "city": "Tucson"
  },
  {
    "iata": "TVC",
    "name": "Cherry Capital Airport",
    "city": "Traverse City"
  },
  {
    "iata": "TVF",
    "name": "Thief River Falls Regional Airport",
    "city": "Thief River Falls"
  },
  {
    "iata": "TVL",
    "name": "Lake Tahoe Airport",
    "city": "South Lake Tahoe"
  },
  {
    "iata": "TWF",
    "name": "Joslin Field Magic Valley Regional Airport",
    "city": "Twin Falls"
  },
  {
    "iata": "TXK",
    "name": "Texarkana Regional Airport (Webb Field)",
    "city": "Texarkana"
  },
  {
    "iata": "TYR",
    "name": "Tyler Pounds Regional Airport",
    "city": "Tyler"
  },
  {
    "iata": "TYS",
    "name": "McGhee Tyson Airport",
    "city": "Alcoa"
  },
  {
    "iata": "UIN",
    "name": "Quincy Regional Airport Baldwin Field",
    "city": "Quincy"
  },
  {
    "iata": "UKI",
    "name": "Ukiah Municipal Airport",
    "city": "Ukiah"
  },
  {
    "iata": "SCE",
    "name": "State College Regional Airport",
    "city": "State College"
  },
  {
    "iata": "UOX",
    "name": "University Oxford Airport",
    "city": "Oxford"
  },
  {
    "iata": "HTV",
    "name": "Huntsville Regional Airport",
    "city": "Huntsville"
  },
  {
    "iata": "VAD",
    "name": "Moody Air Force Base",
    "city": "Valdosta"
  },
  {
    "iata": "VBG",
    "name": "Vandenberg Space Force Base",
    "city": "Lompoc"
  },
  {
    "iata": "VCT",
    "name": "Victoria Regional Airport",
    "city": "Victoria"
  },
  {
    "iata": "VEL",
    "name": "Vernal Regional Airport",
    "city": "Vernal"
  },
  {
    "iata": "VGT",
    "name": "North Las Vegas Metropolitan International Airport",
    "city": "Las Vegas"
  },
  {
    "iata": "VIS",
    "name": "Visalia Municipal Airport",
    "city": "Visalia"
  },
  {
    "iata": "VLD",
    "name": "Valdosta Regional Airport",
    "city": "Valdosta"
  },
  {
    "iata": "VNY",
    "name": "Van Nuys Airport",
    "city": "Van Nuys"
  },
  {
    "iata": "VOK",
    "name": "Volk Field",
    "city": "Camp Douglas"
  },
  {
    "iata": "VPS",
    "name": "Destin-Fort Walton Beach Airport",
    "city": "Valparaiso"
  },
  {
    "iata": "VPZ",
    "name": "Porter County Municipal Airport",
    "city": "Valparaiso"
  },
  {
    "iata": "VQQ",
    "name": "Cecil Airport",
    "city": "Jacksonville"
  },
  {
    "iata": "VRB",
    "name": "Vero Beach Regional Airport",
    "city": "Vero Beach"
  },
  {
    "iata": "VTN",
    "name": "Miller Field",
    "city": "Valentine"
  },
  {
    "iata": "WJF",
    "name": "General William J Fox Airfield",
    "city": "Lancaster"
  },
  {
    "iata": "WMC",
    "name": "Winnemucca Municipal Airport",
    "city": "Winnemucca"
  },
  {
    "iata": "WRB",
    "name": "Robins Air Force Base",
    "city": "Warner Robins"
  },
  {
    "iata": "WRI",
    "name": "Mc Guire Air Force Base",
    "city": "Wrightstown"
  },
  {
    "iata": "WRL",
    "name": "Worland Municipal Airport",
    "city": "Worland"
  },
  {
    "iata": "WST",
    "name": "Westerly State Airport",
    "city": "Westerly"
  },
  {
    "iata": "WWD",
    "name": "Cape May County Airport",
    "city": "Wildwood"
  },
  {
    "iata": "WWR",
    "name": "West Woodward Airport",
    "city": "Woodward"
  },
  {
    "iata": "WYS",
    "name": "Yellowstone Airport",
    "city": "West Yellowstone"
  },
  {
    "iata": "XNA",
    "name": "Northwest Arkansas National Airport",
    "city": "Fayetteville/Springdale/Rogers"
  },
  {
    "iata": "XWA",
    "name": "Williston Basin International Airport",
    "city": "Williston"
  },
  {
    "iata": "YKM",
    "name": "Yakima Air Terminal McAllister Field",
    "city": "Yakima"
  },
  {
    "iata": "YKN",
    "name": "Chan Gurney Municipal Airport",
    "city": "Yankton"
  },
  {
    "iata": "YNG",
    "name": "Youngstown Warren Regional Airport",
    "city": "Youngstown/Warren"
  },
  {
    "iata": "ZZV",
    "name": "Zanesville Municipal Airport",
    "city": "Zanesville"
  },
  {
    "iata": "TIA",
    "name": "Tirana International Airport Mother Teresa",
    "city": "Rinas"
  },
  {
    "iata": "BOJ",
    "name": "Burgas Airport",
    "city": "Burgas"
  },
  {
    "iata": "GOZ",
    "name": "Gorna Oryahovitsa Airport",
    "city": "Gorna Oryahovitsa"
  },
  {
    "iata": "PDV",
    "name": "Plovdiv International Airport",
    "city": "Plovdiv"
  },
  {
    "iata": "SOF",
    "name": "Sofia Airport",
    "city": "Sofia"
  },
  {
    "iata": "VAR",
    "name": "Varna Airport",
    "city": "Varna"
  },
  {
    "iata": "ECN",
    "name": "Nicosia (Lefkoşa) Ercan International Airport",
    "city": "Tymbou (Kirklar)"
  },
  {
    "iata": "GEC",
    "name": "Lefkoniko Airport / Geçitkale Air Base",
    "city": "Lefkoniko (Geçitkale)"
  },
  {
    "iata": "LCA",
    "name": "Larnaca International Airport",
    "city": "Larnaca"
  },
  {
    "iata": "PFO",
    "name": "Paphos International Airport",
    "city": "Paphos"
  },
  {
    "iata": "AKT",
    "name": "RAF Akrotiri",
    "city": "Akrotiri"
  },
  {
    "iata": "DBV",
    "name": "Dubrovnik Ruđer Bošković Airport",
    "city": "Čilipi"
  },
  {
    "iata": "OSI",
    "name": "Osijek Airport",
    "city": "Klisa"
  },
  {
    "iata": "PUY",
    "name": "Pula Airport",
    "city": "Pula"
  },
  {
    "iata": "RJK",
    "name": "Rijeka Airport",
    "city": "Omišalj"
  },
  {
    "iata": "BWK",
    "name": "Brač Airport",
    "city": "Gornji Humac"
  },
  {
    "iata": "SPU",
    "name": "Split Airport",
    "city": "Kaštel Štafilić"
  },
  {
    "iata": "ZAG",
    "name": "Zagreb Franjo Tuđman International Airport",
    "city": "Velika Gorica"
  },
  {
    "iata": "ZAD",
    "name": "Zadar Airport",
    "city": "Zemunik Donji (Zadar)"
  },
  {
    "iata": "ABC",
    "name": "Albacete Airport / Los Llanos Air Base",
    "city": "Albacete"
  },
  {
    "iata": "ALC",
    "name": "Alicante-Elche Miguel Hernández Airport",
    "city": "Alicante"
  },
  {
    "iata": "LEI",
    "name": "Almería Airport",
    "city": "Almería"
  },
  {
    "iata": "OVD",
    "name": "Asturias Airport",
    "city": "Ranón"
  },
  {
    "iata": "ODB",
    "name": "Córdoba Airport",
    "city": "Córdoba"
  },
  {
    "iata": "BIO",
    "name": "Bilbao Airport",
    "city": "Bilbao"
  },
  {
    "iata": "RGS",
    "name": "Burgos Airport",
    "city": "Burgos"
  },
  {
    "iata": "BCN",
    "name": "Josep Tarradellas Barcelona-El Prat Airport",
    "city": "Barcelona"
  },
  {
    "iata": "BJZ",
    "name": "Badajoz Airport",
    "city": "Badajoz"
  },
  {
    "iata": "CDT",
    "name": "Castellón-Costa Azahar Airport",
    "city": "Castellón de la Plana"
  },
  {
    "iata": "LCG",
    "name": "A Coruña Airport",
    "city": "Culleredo"
  },
  {
    "iata": "ILD",
    "name": "Lleida-Alguaire Airport",
    "city": "Lleida"
  },
  {
    "iata": "GRO",
    "name": "Girona-Costa Brava Airport",
    "city": "Girona"
  },
  {
    "iata": "GRX",
    "name": "F.G.L. Airport Granada-Jaén Airport",
    "city": "Granada"
  },
  {
    "iata": "IBZ",
    "name": "Ibiza Airport",
    "city": "Ibiza (Eivissa)"
  },
  {
    "iata": "XRY",
    "name": "Jerez Airport",
    "city": "Jerez de la Frontera"
  },
  {
    "iata": "MJV",
    "name": "San Javier Airport",
    "city": "San Javier"
  },
  {
    "iata": "LEN",
    "name": "León Airport",
    "city": "León"
  },
  {
    "iata": "MAD",
    "name": "Adolfo Suárez Madrid–Barajas Airport",
    "city": "Madrid"
  },
  {
    "iata": "AGP",
    "name": "Málaga-Costa del Sol Airport",
    "city": "Málaga"
  },
  {
    "iata": "MAH",
    "name": "Menorca Airport",
    "city": "Mahón (Maó)"
  },
  {
    "iata": "RMU",
    "name": "Región de Murcia International Airport",
    "city": "Corvera"
  },
  {
    "iata": "OZP",
    "name": "Moron Air Base",
    "city": "Morón"
  },
  {
    "iata": "PMI",
    "name": "Palma de Mallorca Airport",
    "city": "Palma de Mallorca"
  },
  {
    "iata": "PNA",
    "name": "Pamplona Airport",
    "city": "Pamplona"
  },
  {
    "iata": "REU",
    "name": "Reus Airport",
    "city": "Reus"
  },
  {
    "iata": "ROZ",
    "name": "Rota Naval Station Airport",
    "city": "Rota"
  },
  {
    "iata": "SLM",
    "name": "Salamanca Airport",
    "city": "Salamanca"
  },
  {
    "iata": "EAS",
    "name": "San Sebastián Airport",
    "city": "Hondarribia"
  },
  {
    "iata": "SCQ",
    "name": "Santiago-Rosalía de Castro Airport",
    "city": "Santiago de Compostela"
  },
  {
    "iata": "TEV",
    "name": "Teruel Airport",
    "city": "Teruel"
  },
  {
    "iata": "TOJ",
    "name": "Madrid–Torrejón Airport / Torrejón Air Base",
    "city": "Madrid"
  },
  {
    "iata": "VLC",
    "name": "Valencia Airport",
    "city": "Valencia"
  },
  {
    "iata": "VLL",
    "name": "Valladolid Airport",
    "city": "Valladolid"
  },
  {
    "iata": "VIT",
    "name": "Vitoria Airport",
    "city": "Alava"
  },
  {
    "iata": "VGO",
    "name": "Vigo Airport",
    "city": "Vigo"
  },
  {
    "iata": "SDR",
    "name": "Seve Ballesteros-Santander Airport",
    "city": "Santander"
  },
  {
    "iata": "ZAZ",
    "name": "Zaragoza Airport",
    "city": "Zaragoza"
  },
  {
    "iata": "SVQ",
    "name": "Sevilla Airport",
    "city": "Sevilla"
  },
  {
    "iata": "CQF",
    "name": "Calais-Dunkerque Airport",
    "city": "Marck"
  },
  {
    "iata": "LTQ",
    "name": "Le Touquet-Côte d'Opale Airport",
    "city": "Le Touquet-Paris-Plage"
  },
  {
    "iata": "AGF",
    "name": "Agen-La Garenne Airport",
    "city": "Agen/La Garenne"
  },
  {
    "iata": "BOD",
    "name": "Bordeaux-Mérignac Airport",
    "city": "Bordeaux/Mérignac"
  },
  {
    "iata": "EGC",
    "name": "Bergerac Dordogne Périgord Airport",
    "city": "Bergerac/Roumanière"
  },
  {
    "iata": "CNG",
    "name": "Cognac-Châteaubernard (BA 709) Air Base",
    "city": "Cognac/Châteaubernard"
  },
  {
    "iata": "LRH",
    "name": "La Rochelle-Île de Ré Airport",
    "city": "La Rochelle/Île de Ré"
  },
  {
    "iata": "PIS",
    "name": "Poitiers-Biard Airport",
    "city": "Poitiers/Biard"
  },
  {
    "iata": "MCU",
    "name": "Montluçon-Guéret Airport",
    "city": "Lépaud, Creuse"
  },
  {
    "iata": "LIG",
    "name": "Limoges Airport",
    "city": "Limoges/Bellegarde"
  },
  {
    "iata": "NIT",
    "name": "Niort - Marais Poitevin Airport",
    "city": "Niort/Souché"
  },
  {
    "iata": "TLS",
    "name": "Toulouse-Blagnac Airport",
    "city": "Toulouse/Blagnac"
  },
  {
    "iata": "PUF",
    "name": "Pau Pyrénées Airport",
    "city": "Pau/Pyrénées (Uzein)"
  },
  {
    "iata": "LDE",
    "name": "Tarbes-Lourdes-Pyrénées Airport",
    "city": "Tarbes/Lourdes/Pyrénées"
  },
  {
    "iata": "ANG",
    "name": "Angoulême-Brie-Champniers Airport",
    "city": "Angoulême/Brie/Champniers"
  },
  {
    "iata": "PGX",
    "name": "Périgueux-Bassillac Airport",
    "city": "Périgueux/Bassillac"
  },
  {
    "iata": "BIQ",
    "name": "Biarritz-Anglet-Bayonne Airport",
    "city": "Biarritz/Anglet/Bayonne"
  },
  {
    "iata": "ZAO",
    "name": "Aérodrome de Cahors-Lalbenque",
    "city": "Cahors/Lalbenque"
  },
  {
    "iata": "LBI",
    "name": "Albi-Le Séquestre Airport",
    "city": "Albi/Le Séquestre"
  },
  {
    "iata": "DCM",
    "name": "Castres-Mazamet Airport",
    "city": "Castres/Mazamet"
  },
  {
    "iata": "RDZ",
    "name": "Rodez–Aveyron Airport",
    "city": "Rodez/Marcillac"
  },
  {
    "iata": "RYN",
    "name": "Royan-Médis Airport",
    "city": "Royan/Médis"
  },
  {
    "iata": "RCO",
    "name": "Rochefort-Saint-Agnant (BA 721) Airport",
    "city": "Rochefort/Saint-Agnant"
  },
  {
    "iata": "CMR",
    "name": "Colmar-Houssen Airport",
    "city": "Colmar, Haut-Rhin"
  },
  {
    "iata": "DLE",
    "name": "Dole-Jura Airport",
    "city": "Tavaux, Jura"
  },
  {
    "iata": "OBS",
    "name": "Aubenas-South Ardèche Airport",
    "city": "Lanas, Ardèche"
  },
  {
    "iata": "ETZ",
    "name": "Metz-Nancy-Lorraine Airport",
    "city": "Goin"
  },
  {
    "iata": "ANE",
    "name": "Angers-Loire Airport",
    "city": "Marcé, Maine-et-Loire"
  },
  {
    "iata": "BIA",
    "name": "Bastia-Poretta Airport",
    "city": "Bastia/Poretta"
  },
  {
    "iata": "CLY",
    "name": "Calvi-Sainte-Catherine Airport",
    "city": "Calvi/Sainte-Catherine"
  },
  {
    "iata": "FSC",
    "name": "Figari Sud-Corse Airport",
    "city": "Figari Sud-Corse"
  },
  {
    "iata": "AJA",
    "name": "Ajaccio-Napoléon Bonaparte Airport",
    "city": "Ajaccio/Napoléon Bonaparte"
  },
  {
    "iata": "SOZ",
    "name": "Solenzara (BA 126) Air Base",
    "city": "Solenzara"
  },
  {
    "iata": "AUF",
    "name": "Auxerre-Branches Airport",
    "city": "Appoigny, Yonne"
  },
  {
    "iata": "CMF",
    "name": "Chambéry Savoie Mont Blanc Airport",
    "city": "Viviers-du-Lac"
  },
  {
    "iata": "CFE",
    "name": "Clermont-Ferrand Auvergne Airport",
    "city": "Aulnat, Puy-de-Dôme"
  },
  {
    "iata": "BOU",
    "name": "Bourges Airport",
    "city": "Bourges, Cher"
  },
  {
    "iata": "LYS",
    "name": "Lyon Saint-Exupéry Airport",
    "city": "Colombier-Saugnieu, Rhône"
  },
  {
    "iata": "SYT",
    "name": "Saint-Yan Airport",
    "city": "L'Hôpital-le-Mercier, Saône-et-Loire"
  },
  {
    "iata": "RNE",
    "name": "Roanne-Renaison Airport",
    "city": "Saint-Léger-sur-Roanne"
  },
  {
    "iata": "NCY",
    "name": "Annecy Haute-Savoie Mont Blanc Airport",
    "city": "Epagny Metz-Tessy"
  },
  {
    "iata": "GNB",
    "name": "Grenoble Alpes Isère Airport",
    "city": "Saint-Étienne-de-Saint-Geoirs, Isère"
  },
  {
    "iata": "VAF",
    "name": "Valence-Chabeuil Airport",
    "city": "Chabeuil, Drôme"
  },
  {
    "iata": "VHY",
    "name": "Vichy-Charmeil Airport",
    "city": "Charmeil, Allier"
  },
  {
    "iata": "AUR",
    "name": "Aurillac Airport",
    "city": "Aurillac"
  },
  {
    "iata": "CHR",
    "name": "Châteauroux-Déols Marcel Dassault Airport",
    "city": "Déols, Indre"
  },
  {
    "iata": "LYN",
    "name": "Lyon Bron Airport",
    "city": "Chassieu, Lyon"
  },
  {
    "iata": "CEQ",
    "name": "Cannes-Mandelieu Airport",
    "city": "Cannes, Alpes-Maritimes"
  },
  {
    "iata": "EBU",
    "name": "Saint-Étienne-Bouthéon Airport",
    "city": "Andrézieux-Bouthéon, Loire"
  },
  {
    "iata": "CCF",
    "name": "Carcassonne Airport",
    "city": "Carcassonne/Salvaza"
  },
  {
    "iata": "MRS",
    "name": "Marseille Provence Airport",
    "city": "Marignane, Bouches-du-Rhône"
  },
  {
    "iata": "NCE",
    "name": "Nice-Côte d'Azur Airport",
    "city": "Nice, Alpes-Maritimes"
  },
  {
    "iata": "PGF",
    "name": "Perpignan-Rivesaltes (Llabanère) Airport",
    "city": "Perpignan/Rivesaltes"
  },
  {
    "iata": "CTT",
    "name": "Le Castellet Airport",
    "city": "Le Castellet, Var"
  },
  {
    "iata": "MPL",
    "name": "Montpellier-Méditerranée Airport",
    "city": "Montpellier/Méditerranée"
  },
  {
    "iata": "BZR",
    "name": "Béziers-Vias Airport",
    "city": "Béziers/Vias"
  },
  {
    "iata": "AVN",
    "name": "Avignon-Caumont Airport",
    "city": "Avignon, Vaucluse"
  },
  {
    "iata": "MEN",
    "name": "Mende-Brenoux Airfield",
    "city": "Mende/Brénoux"
  },
  {
    "iata": "BVA",
    "name": "Paris-Beauvais Airport",
    "city": "Tillé"
  },
  {
    "iata": "EVX",
    "name": "Évreux-Fauville (BA 105) Air Base",
    "city": "Fauville, Eure"
  },
  {
    "iata": "LEH",
    "name": "Le Havre-Octeville Airport",
    "city": "Le Havre"
  },
  {
    "iata": "XCR",
    "name": "Châlons-Vatry Airport",
    "city": "Bussy-Lettrée"
  },
  {
    "iata": "URO",
    "name": "Rouen Vallée de Seine Airport",
    "city": "Boos"
  },
  {
    "iata": "TUF",
    "name": "Tours Val de Loire Airport",
    "city": "Tours, Indre-et-Loire"
  },
  {
    "iata": "LVA",
    "name": "Laval-Entrammes Airport",
    "city": "Laval, Mayenne"
  },
  {
    "iata": "CSF",
    "name": "Creil Air Base",
    "city": "Creil"
  },
  {
    "iata": "CDG",
    "name": "Charles de Gaulle International Airport",
    "city": "Paris (Roissy-en-France, Val-d'Oise)"
  },
  {
    "iata": "TNF",
    "name": "Toussus-le-Noble Airport",
    "city": "Toussus-le-Noble, Yvelines"
  },
  {
    "iata": "ORY",
    "name": "Paris-Orly Airport",
    "city": "Paris (Orly, Val-de-Marne)"
  },
  {
    "iata": "NVS",
    "name": "Nevers-Fourchambault Airport",
    "city": "Marzy, Nièvre"
  },
  {
    "iata": "LIL",
    "name": "Lille Airport",
    "city": "Lesquin"
  },
  {
    "iata": "HZB",
    "name": "Merville-Calonne Airport",
    "city": "Merville, Nord"
  },
  {
    "iata": "BES",
    "name": "Brest Bretagne Airport",
    "city": "Brest/Guipavas"
  },
  {
    "iata": "CER",
    "name": "Cherbourg-Maupertus Airport",
    "city": "Gonneville-Le Theil, Manche"
  },
  {
    "iata": "DNR",
    "name": "Dinard-Pleurtuit-Saint-Malo Airport",
    "city": "Pleurtuit, Ille-et-Vilaine"
  },
  {
    "iata": "LBY",
    "name": "La Baule-Escoublac Airport",
    "city": "La Baule-Escoublac"
  },
  {
    "iata": "GFR",
    "name": "Granville Airport",
    "city": "Bréville-sur-Mer, Manche"
  },
  {
    "iata": "DOL",
    "name": "Deauville-Normandie Airport",
    "city": "Deauville, Calvados"
  },
  {
    "iata": "LRT",
    "name": "Lorient South Brittany (Bretagne Sud) Airport",
    "city": "Lorient/Lann/Bihoué"
  },
  {
    "iata": "EDM",
    "name": "La Roche-sur-Yon Airport",
    "city": "La Roche-sur-Yon/Les Ajoncs"
  },
  {
    "iata": "LDV",
    "name": "Landivisiau Air Base",
    "city": "Landivisiau"
  },
  {
    "iata": "CFR",
    "name": "Caen-Carpiquet Airport",
    "city": "Carpiquet, Calvados"
  },
  {
    "iata": "LME",
    "name": "Le Mans-Arnage Airport",
    "city": "Le Mans, Sarthe"
  },
  {
    "iata": "RNS",
    "name": "Rennes-Saint-Jacques Airport",
    "city": "Saint-Jacques-de-la-Lande, Ille-et-Vilaine"
  },
  {
    "iata": "LAI",
    "name": "Lannion-Côte de Granit Airport",
    "city": "Lannion"
  },
  {
    "iata": "UIP",
    "name": "Quimper-Cornouaille Airport",
    "city": "Quimper/Pluguffan"
  },
  {
    "iata": "NTE",
    "name": "Nantes Atlantique Airport",
    "city": "Nantes"
  },
  {
    "iata": "SBK",
    "name": "Saint-Brieuc-Armor Airport",
    "city": "Trémuson, Côtes-d'Armor"
  },
  {
    "iata": "MXN",
    "name": "Morlaix-Ploujean Airport",
    "city": "Morlaix/Ploujean"
  },
  {
    "iata": "VNE",
    "name": "Vannes-Meucon Airport",
    "city": "Vannes/Meucon"
  },
  {
    "iata": "SNR",
    "name": "Saint-Nazaire-Montoir Airport",
    "city": "Saint-Nazaire/Montoir"
  },
  {
    "iata": "BSL",
    "name": "EuroAirport Basel-Mulhouse-Freiburg",
    "city": "Saint-Louis"
  },
  {
    "iata": "DIJ",
    "name": "Dijon-Bourgogne Airport",
    "city": "Ouges, Côte-d'Or"
  },
  {
    "iata": "EPL",
    "name": "Épinal-Mirecourt Airport",
    "city": "Juvaincourt, Vosges"
  },
  {
    "iata": "BVE",
    "name": "Brive-Souillac",
    "city": "Brive la Gaillarde"
  },
  {
    "iata": "ENC",
    "name": "Nancy-Essey Airport",
    "city": "Tomblaine, Meurthe-et-Moselle"
  },
  {
    "iata": "SXB",
    "name": "Strasbourg Airport",
    "city": "Strasbourg"
  },
  {
    "iata": "TLN",
    "name": "Toulon-Hyères Airport",
    "city": "Hyères, Var"
  },
  {
    "iata": "FNI",
    "name": "Nîmes-Arles-Camargue Airport",
    "city": "Nîmes/Garons"
  },
  {
    "iata": "FSP",
    "name": "St Pierre Airport",
    "city": "Saint-Pierre"
  },
  {
    "iata": "PYR",
    "name": "Andravida Air Base",
    "city": "Andravida"
  },
  {
    "iata": "AXD",
    "name": "Alexandroupoli Democritus Airport",
    "city": "Alexandroupolis"
  },
  {
    "iata": "ATH",
    "name": "Athens Eleftherios Venizelos International Airport",
    "city": "Spata-Artemida"
  },
  {
    "iata": "VOL",
    "name": "Nea Anchialos National Airport",
    "city": "Nea Anchialos"
  },
  {
    "iata": "JKH",
    "name": "Chios Island National Airport",
    "city": "Chios Island"
  },
  {
    "iata": "IOA",
    "name": "Ioannina King Pyrrhus National Airport",
    "city": "Ioannina"
  },
  {
    "iata": "HER",
    "name": "Heraklion International Nikos Kazantzakis Airport",
    "city": "Heraklion"
  },
  {
    "iata": "EFL",
    "name": "Kefallinia Airport",
    "city": "Kefallinia Island"
  },
  {
    "iata": "KLX",
    "name": "Kalamata Airport",
    "city": "Kalamata"
  },
  {
    "iata": "KGS",
    "name": "Kos Airport",
    "city": "Kos Island"
  },
  {
    "iata": "AOK",
    "name": "Karpathos Airport",
    "city": "Karpathos Island"
  },
  {
    "iata": "CFU",
    "name": "Corfu Ioannis Kapodistrias International Airport",
    "city": "Kerkyra (Corfu)"
  },
  {
    "iata": "KVA",
    "name": "Kavala Alexander the Great International Airport",
    "city": "Kavala"
  },
  {
    "iata": "KZI",
    "name": "Kozani National Airport Filippos",
    "city": "Kozani"
  },
  {
    "iata": "JMK",
    "name": "Mykonos Island National Airport",
    "city": "Mykonos"
  },
  {
    "iata": "MJT",
    "name": "Mytilene International Airport",
    "city": "Mytilene"
  },
  {
    "iata": "PVK",
    "name": "Aktion National Airport",
    "city": "Preveza"
  },
  {
    "iata": "RHO",
    "name": "Diagoras Airport",
    "city": "Rhodes"
  },
  {
    "iata": "GPA",
    "name": "Patras Araxos Agamemnon Airport",
    "city": "Patras"
  },
  {
    "iata": "CHQ",
    "name": "Chania International Airport",
    "city": "Souda"
  },
  {
    "iata": "JSI",
    "name": "Skiathos Island National Airport",
    "city": "Skiathos"
  },
  {
    "iata": "SMI",
    "name": "Samos Airport",
    "city": "Samos Island"
  },
  {
    "iata": "JTR",
    "name": "Santorini Airport",
    "city": "Santorini Island"
  },
  {
    "iata": "JSH",
    "name": "Sitia Airport",
    "city": "Crete Island"
  },
  {
    "iata": "SKG",
    "name": "Thessaloniki Macedonia International Airport",
    "city": "Thessaloniki"
  },
  {
    "iata": "ZTH",
    "name": "Zakynthos International Airport Dionysios Solomos",
    "city": "Zakynthos"
  },
  {
    "iata": "BUD",
    "name": "Budapest Liszt Ferenc International Airport",
    "city": "Budapest"
  },
  {
    "iata": "DEB",
    "name": "Debrecen International Airport",
    "city": "Debrecen"
  },
  {
    "iata": "PEV",
    "name": "Pécs-Pogány Airport",
    "city": "Pécs"
  },
  {
    "iata": "SOB",
    "name": "Hévíz–Balaton Airport",
    "city": "Sármellék"
  },
  {
    "iata": "CRV",
    "name": "Crotone Sant'Anna Pythagoras Airport",
    "city": "Isola di Capo Rizzuto (KR)"
  },
  {
    "iata": "BRI",
    "name": "Bari Karol Wojtyła International Airport",
    "city": "Bari"
  },
  {
    "iata": "FOG",
    "name": "Foggia Gino Lisa Airport",
    "city": "Foggia (FG)"
  },
  {
    "iata": "TAR",
    "name": "Taranto-Grottaglie Marcello Arlotta Airport",
    "city": "Grottaglie"
  },
  {
    "iata": "LCC",
    "name": "Lecce Galatina Air Base / Galatina Fortunato Cesari Airport",
    "city": "Galatina (LE)"
  },
  {
    "iata": "PSR",
    "name": "Abruzzo Airport",
    "city": "Pescara"
  },
  {
    "iata": "BDS",
    "name": "Brindisi Airport",
    "city": "Brindisi"
  },
  {
    "iata": "SUF",
    "name": "Lamezia Terme Sant'Eufemia International Airport",
    "city": "Lamezia Terme (CZ)"
  },
  {
    "iata": "CIY",
    "name": "Comiso Airport",
    "city": "Comiso"
  },
  {
    "iata": "CTA",
    "name": "Catania-Fontanarossa Airport",
    "city": "Catania"
  },
  {
    "iata": "LMP",
    "name": "Lampedusa Airport",
    "city": "Lampedusa"
  },
  {
    "iata": "PNL",
    "name": "Pantelleria Airport",
    "city": "Pantelleria (TP)"
  },
  {
    "iata": "PMO",
    "name": "Falcone–Borsellino Airport",
    "city": "Palermo"
  },
  {
    "iata": "REG",
    "name": "Reggio Calabria Airport",
    "city": "Reggio Calabria"
  },
  {
    "iata": "TPS",
    "name": "Vincenzo Florio Airport Trapani-Birgi",
    "city": "Trapani (TP)"
  },
  {
    "iata": "NSY",
    "name": "Sigonella Navy Air Base",
    "city": "Sigonella (CT)"
  },
  {
    "iata": "AHO",
    "name": "Alghero-Fertilia Airport",
    "city": "Alghero"
  },
  {
    "iata": "DCI",
    "name": "Decimomannu Air Base",
    "city": "Decimomannu"
  },
  {
    "iata": "CAG",
    "name": "Cagliari Elmas Airport",
    "city": "Cagliari"
  },
  {
    "iata": "OLB",
    "name": "Olbia Costa Smeralda Airport",
    "city": "Olbia (SS)"
  },
  {
    "iata": "TTB",
    "name": "Tortolì Airport",
    "city": "Arbatax"
  },
  {
    "iata": "MXP",
    "name": "Milan Malpensa International Airport",
    "city": "Ferno (VA)"
  },
  {
    "iata": "BGY",
    "name": "Milan Bergamo Airport / Antonio Locatelli Air Base",
    "city": "Orio al Serio (BG)"
  },
  {
    "iata": "TRN",
    "name": "Turin Airport",
    "city": "Caselle Torinese (TO)"
  },
  {
    "iata": "ALL",
    "name": "Riviera Villanova d'Albenga International Airport",
    "city": "Villanova d'Albenga (SV)"
  },
  {
    "iata": "GOA",
    "name": "Genoa Cristoforo Colombo Airport",
    "city": "Genova (GE)"
  },
  {
    "iata": "LIN",
    "name": "Milano Linate Airport",
    "city": "Segrate (MI)"
  },
  {
    "iata": "PMF",
    "name": "Parma Airport",
    "city": "Parma (PR)"
  },
  {
    "iata": "AOT",
    "name": "Aosta Corrado Gex Airport",
    "city": "Saint-Christophe (AO)"
  },
  {
    "iata": "CUF",
    "name": "Cuneo International Airport",
    "city": "Levaldigi (CN)"
  },
  {
    "iata": "AVB",
    "name": "Aviano Air Base",
    "city": "Aviano (PN)"
  },
  {
    "iata": "BZO",
    "name": "Bolzano Airport",
    "city": "Bolzano (BZ)"
  },
  {
    "iata": "BLQ",
    "name": "Bologna Guglielmo Marconi Airport",
    "city": "Bologna"
  },
  {
    "iata": "TSF",
    "name": "Treviso Antonio Canova Airport",
    "city": "Treviso (TV)"
  },
  {
    "iata": "FRL",
    "name": "Forlì Luigi Ridolfi Airport",
    "city": "Forlì (FC)"
  },
  {
    "iata": "VBS",
    "name": "Brescia Gabriele d'Annunzio Airport",
    "city": "Montichiari (BS)"
  },
  {
    "iata": "TRS",
    "name": "Trieste–Friuli Venezia Giulia Airport",
    "city": "Ronchi dei Legionari (GO)"
  },
  {
    "iata": "RMI",
    "name": "Federico Fellini International Airport",
    "city": "Rimini (RN)"
  },
  {
    "iata": "VRN",
    "name": "Verona Villafranca Valerio Catullo Airport",
    "city": "Caselle (VR)"
  },
  {
    "iata": "AOI",
    "name": "Marche Airport",
    "city": "Falconara Marittima (AN)"
  },
  {
    "iata": "VCE",
    "name": "Venice Marco Polo Airport",
    "city": "Venezia (VE)"
  },
  {
    "iata": "SAY",
    "name": "Siena-Ampugnano Airport",
    "city": "Ampugnano (SI)"
  },
  {
    "iata": "CIA",
    "name": "Ciampino–G. B. Pastine International Airport",
    "city": "Rome"
  },
  {
    "iata": "FCO",
    "name": "Rome–Fiumicino Leonardo da Vinci International Airport",
    "city": "Rome"
  },
  {
    "iata": "QSR",
    "name": "Salerno Costa d'Amalfi Airport",
    "city": "Salerno"
  },
  {
    "iata": "EBA",
    "name": "Marina di Campo Airport",
    "city": "Campo nell'Elba (LI)"
  },
  {
    "iata": "NAP",
    "name": "Naples International Airport",
    "city": "Napoli"
  },
  {
    "iata": "PSA",
    "name": "Pisa International Airport",
    "city": "Pisa (PI)"
  },
  {
    "iata": "FLR",
    "name": "Florence Airport, Peretola",
    "city": "Firenze (FI)"
  },
  {
    "iata": "GRS",
    "name": "Grosseto Corrado Baccarini Air Base / Grosseto Airport",
    "city": "Grosseto (GR)"
  },
  {
    "iata": "PEG",
    "name": "Perugia San Francesco d'Assisi – Umbria International Airport",
    "city": "Perugia (PG)"
  },
  {
    "iata": "LJU",
    "name": "Ljubljana Jože Pučnik Airport",
    "city": "Zgornji Brnik"
  },
  {
    "iata": "MBX",
    "name": "Maribor Edvard Rusjan Airport",
    "city": "Orehova Vas"
  },
  {
    "iata": "POW",
    "name": "Portorož Airport",
    "city": "Sečovlje"
  },
  {
    "iata": "UHE",
    "name": "Kunovice Airport",
    "city": "Uherské Hradiště"
  },
  {
    "iata": "KLV",
    "name": "Karlovy Vary Airport",
    "city": "Karlovy Vary"
  },
  {
    "iata": "OSR",
    "name": "Ostrava Leos Janáček Airport",
    "city": "Mošnov"
  },
  {
    "iata": "PED",
    "name": "Pardubice Airport",
    "city": "Pardubice"
  },
  {
    "iata": "PRV",
    "name": "Přerov Air Base",
    "city": "Přerov"
  },
  {
    "iata": "PRG",
    "name": "Václav Havel Airport Prague",
    "city": "Prague"
  },
  {
    "iata": "BRQ",
    "name": "Brno-Tuřany Airport",
    "city": "Brno"
  },
  {
    "iata": "VOD",
    "name": "Vodochody Airport",
    "city": "Vodochody"
  },
  {
    "iata": "TLV",
    "name": "Ben Gurion International Airport",
    "city": "Tel Aviv"
  },
  {
    "iata": "ETM",
    "name": "Ramon International Airport",
    "city": "Eilat"
  },
  {
    "iata": "HFA",
    "name": "Haifa International Airport",
    "city": "Haifa"
  },
  {
    "iata": "RPN",
    "name": "Rosh Pina Airport",
    "city": "Rosh Pina"
  },
  {
    "iata": "MTZ",
    "name": "Bar Yehuda Airfield",
    "city": "Masada"
  },
  {
    "iata": "VTM",
    "name": "Nevatim Air Base",
    "city": "Beersheba"
  },
  {
    "iata": "MLA",
    "name": "Malta International Airport",
    "city": "Valletta"
  },
  {
    "iata": "GRZ",
    "name": "Graz Airport",
    "city": "Feldkirchen bei Graz"
  },
  {
    "iata": "INN",
    "name": "Innsbruck Airport",
    "city": "Innsbruck"
  },
  {
    "iata": "KLU",
    "name": "Klagenfurt Airport",
    "city": "Klagenfurt am Wörthersee"
  },
  {
    "iata": "LNZ",
    "name": "Linz-Hörsching Airport / Vogler Air Base",
    "city": "Linz"
  },
  {
    "iata": "SZG",
    "name": "Salzburg Airport",
    "city": "Salzburg"
  },
  {
    "iata": "VIE",
    "name": "Vienna International Airport",
    "city": "Vienna"
  },
  {
    "iata": "SMA",
    "name": "Santa Maria Airport",
    "city": "Vila do Porto"
  },
  {
    "iata": "BGC",
    "name": "Bragança Airport",
    "city": "Bragança"
  },
  {
    "iata": "BYJ",
    "name": "Beja Airport / Airbase",
    "city": "Beja"
  },
  {
    "iata": "BGZ",
    "name": "Braga Municipal Aerodrome",
    "city": "Braga"
  },
  {
    "iata": "CBP",
    "name": "Aerodromo Municipal de Coimbra",
    "city": "Coimbra"
  },
  {
    "iata": "CAT",
    "name": "Cascais Airport",
    "city": "Cascais"
  },
  {
    "iata": "FLW",
    "name": "Flores Airport",
    "city": "Santa Cruz das Flores"
  },
  {
    "iata": "FAO",
    "name": "Faro Airport",
    "city": "Faro"
  },
  {
    "iata": "GRW",
    "name": "Graciosa Airport",
    "city": "Santa Cruz da Graciosa"
  },
  {
    "iata": "HOR",
    "name": "Horta Airport",
    "city": "Horta"
  },
  {
    "iata": "TER",
    "name": "Lajes Airport",
    "city": "Praia da Vitória"
  },
  {
    "iata": "FNC",
    "name": "Madeira International Airport Cristiano Ronaldo",
    "city": "Funchal"
  },
  {
    "iata": "PDL",
    "name": "João Paulo II Airport",
    "city": "Ponta Delgada"
  },
  {
    "iata": "PIX",
    "name": "Pico Airport",
    "city": "Pico Island"
  },
  {
    "iata": "PRM",
    "name": "Portimão Airport",
    "city": "Portimão"
  },
  {
    "iata": "OPO",
    "name": "Francisco de Sá Carneiro Airport",
    "city": "Porto"
  },
  {
    "iata": "PXO",
    "name": "Porto Santo Airport",
    "city": "Vila Baleira"
  },
  {
    "iata": "LIS",
    "name": "Lisbon Humberto Delgado Airport",
    "city": "Lisbon"
  },
  {
    "iata": "SJZ",
    "name": "São Jorge Airport",
    "city": "Velas"
  },
  {
    "iata": "VRL",
    "name": "Vila Real Airport",
    "city": "Vila Real"
  },
  {
    "iata": "VSE",
    "name": "Aerodromo Goncalves Lobato (Viseu Airport)",
    "city": "Viseu"
  },
  {
    "iata": "BNX",
    "name": "Banja Luka International Airport",
    "city": "Mahovljani"
  },
  {
    "iata": "OMO",
    "name": "Mostar International Airport",
    "city": "Mostar"
  },
  {
    "iata": "SJJ",
    "name": "Sarajevo International Airport",
    "city": "Sarajevo"
  },
  {
    "iata": "TZL",
    "name": "Tuzla International Airport",
    "city": "Dubrave Gornje"
  },
  {
    "iata": "ARW",
    "name": "Arad International Airport",
    "city": "Arad"
  },
  {
    "iata": "BCM",
    "name": "Bacău George Enescu International  Airport",
    "city": "Bacău"
  },
  {
    "iata": "BAY",
    "name": "Maramureș International Airport",
    "city": "Tăuții-Măgherăuș"
  },
  {
    "iata": "BBU",
    "name": "Bucharest Băneasa Aurel Vlaicu International Airport",
    "city": "Bucharest"
  },
  {
    "iata": "GHV",
    "name": "Brașov-Ghimbav International Airport",
    "city": "Brașov (Ghimbav)"
  },
  {
    "iata": "CND",
    "name": "Mihail Kogălniceanu International Airport",
    "city": "Mihail Kogălniceanu"
  },
  {
    "iata": "CLJ",
    "name": "Cluj Avram Iancu International Airport",
    "city": "Cluj-Napoca"
  },
  {
    "iata": "CSB",
    "name": "Caransebeş Airport",
    "city": "Caransebeş"
  },
  {
    "iata": "CRA",
    "name": "Craiova International Airport",
    "city": "Craiova"
  },
  {
    "iata": "IAS",
    "name": "Iaşi Airport",
    "city": "Iaşi"
  },
  {
    "iata": "OMR",
    "name": "Oradea International Airport",
    "city": "Oradea"
  },
  {
    "iata": "OTP",
    "name": "Bucharest Henri Coandă International Airport",
    "city": "Otopeni"
  },
  {
    "iata": "SBZ",
    "name": "Sibiu International Airport",
    "city": "Sibiu"
  },
  {
    "iata": "SUJ",
    "name": "Satu Mare International Airport",
    "city": "Satu Mare"
  },
  {
    "iata": "SCV",
    "name": "Suceava Stefan cel Mare Airport",
    "city": "Suceava"
  },
  {
    "iata": "TCE",
    "name": "Tulcea Danube Delta Airport",
    "city": "Mihail Kogălniceanu"
  },
  {
    "iata": "TGM",
    "name": "Târgu Mureş Transilvania International Airport",
    "city": "Recea"
  },
  {
    "iata": "TSR",
    "name": "Timişoara Traian Vuia Airport",
    "city": "Timişoara"
  },
  {
    "iata": "GVA",
    "name": "Geneva Cointrin International Airport",
    "city": "Geneva"
  },
  {
    "iata": "SIR",
    "name": "Sion Airport",
    "city": "Sion"
  },
  {
    "iata": "EML",
    "name": "Emmen Air Base",
    "city": "Emmen"
  },
  {
    "iata": "VIP",
    "name": "Payerne Air Base",
    "city": "Payerne"
  },
  {
    "iata": "LUG",
    "name": "Lugano Airport",
    "city": "Agno"
  },
  {
    "iata": "BRN",
    "name": "Bern Airport",
    "city": "Bern"
  },
  {
    "iata": "ZRH",
    "name": "Zürich Airport",
    "city": "Zurich"
  },
  {
    "iata": "ACH",
    "name": "Sankt Gallen Altenrhein Airport",
    "city": "St. Gallen"
  },
  {
    "iata": "SMV",
    "name": "Samedan Airport",
    "city": "Samedan"
  },
  {
    "iata": "ESB",
    "name": "Esenboğa International Airport",
    "city": "Ankara"
  },
  {
    "iata": "ANK",
    "name": "Etimesgut Air Base",
    "city": "Ankara"
  },
  {
    "iata": "ADA",
    "name": "Adana Şakirpaşa Airport",
    "city": "Seyhan"
  },
  {
    "iata": "UAB",
    "name": "İncirlik Air Base",
    "city": "Sarıçam"
  },
  {
    "iata": "AFY",
    "name": "Afyon Air Base",
    "city": "Afyonkarahisar"
  },
  {
    "iata": "AYT",
    "name": "Antalya International Airport",
    "city": "Antalya"
  },
  {
    "iata": "GZT",
    "name": "Gaziantep International Airport",
    "city": "Gaziantep"
  },
  {
    "iata": "KFS",
    "name": "Kastamonu Airport",
    "city": "Kastamonu"
  },
  {
    "iata": "KYA",
    "name": "Konya Airport",
    "city": "Konya"
  },
  {
    "iata": "ONQ",
    "name": "Zonguldak Çaycuma Airport",
    "city": "Zonguldak"
  },
  {
    "iata": "MLX",
    "name": "Malatya Erhaç Airport",
    "city": "Malatya"
  },
  {
    "iata": "ASR",
    "name": "Kayseri Erkilet Airport",
    "city": "Kayseri"
  },
  {
    "iata": "TJK",
    "name": "Tokat Airport",
    "city": "Tokat"
  },
  {
    "iata": "DNZ",
    "name": "Çardak Airport",
    "city": "Denizli"
  },
  {
    "iata": "ISL",
    "name": "İstanbul Atatürk Airport",
    "city": "Bakırköy, Istanbul"
  },
  {
    "iata": "BZI",
    "name": "Balıkesir Airport",
    "city": "Balıkesir"
  },
  {
    "iata": "BDM",
    "name": "Bandırma Airport",
    "city": "Bandırma"
  },
  {
    "iata": "CKZ",
    "name": "Çanakkale Airport",
    "city": "Çanakkale"
  },
  {
    "iata": "ESK",
    "name": "Eskişehir Air Base",
    "city": "Eskişehir"
  },
  {
    "iata": "ADB",
    "name": "Adnan Menderes International Airport",
    "city": "Gaziemir"
  },
  {
    "iata": "USQ",
    "name": "Uşak Airport",
    "city": "Uşak"
  },
  {
    "iata": "KCO",
    "name": "Cengiz Topel Airport",
    "city": "Kartepe"
  },
  {
    "iata": "YEI",
    "name": "Bursa Yenişehir Airport",
    "city": "Yenişehir"
  },
  {
    "iata": "DLM",
    "name": "Dalaman International Airport",
    "city": "Dalaman"
  },
  {
    "iata": "TEQ",
    "name": "Tekirdağ Çorlu Airport",
    "city": "Çorlu"
  },
  {
    "iata": "AOE",
    "name": "Anadolu Airport",
    "city": "Eskişehir"
  },
  {
    "iata": "EZS",
    "name": "Elazığ Airport",
    "city": "Elazığ"
  },
  {
    "iata": "OGU",
    "name": "Ordu–Giresun Airport",
    "city": "Ordu"
  },
  {
    "iata": "DIY",
    "name": "Diyarbakır Airport",
    "city": "Diyarbakır"
  },
  {
    "iata": "ERC",
    "name": "Erzincan Airport",
    "city": "Erzincan"
  },
  {
    "iata": "ERZ",
    "name": "Erzurum International Airport",
    "city": "Erzurum"
  },
  {
    "iata": "KSY",
    "name": "Kars Airport",
    "city": "Kars"
  },
  {
    "iata": "TZX",
    "name": "Trabzon International Airport",
    "city": "Trabzon"
  },
  {
    "iata": "VAN",
    "name": "Van Ferit Melen Airport",
    "city": "Van"
  },
  {
    "iata": "BAL",
    "name": "Batman Airport",
    "city": "Batman"
  },
  {
    "iata": "MSR",
    "name": "Muş Airport",
    "city": "Muş"
  },
  {
    "iata": "SXZ",
    "name": "Siirt Airport",
    "city": "Siirt"
  },
  {
    "iata": "OPS",
    "name": "Sinop Airport",
    "city": "Sinop"
  },
  {
    "iata": "KCM",
    "name": "Kahramanmaraş Airport",
    "city": "Kahramanmaraş"
  },
  {
    "iata": "AJI",
    "name": "Ağrı Airport",
    "city": "Ağrı"
  },
  {
    "iata": "ADF",
    "name": "Adıyaman Airport",
    "city": "Adıyaman"
  },
  {
    "iata": "MQM",
    "name": "Mardin Airport",
    "city": "Mardin"
  },
  {
    "iata": "GNY",
    "name": "Şanlıurfa GAP Airport",
    "city": "Şanlıurfa"
  },
  {
    "iata": "IGD",
    "name": "Iğdır Airport",
    "city": "Iğdır"
  },
  {
    "iata": "NKT",
    "name": "Şırnak Şerafettin Elçi Airport",
    "city": "Şırnak"
  },
  {
    "iata": "YKO",
    "name": "Hakkari Yüksekova Airport",
    "city": "Hakkari"
  },
  {
    "iata": "HTY",
    "name": "Hatay Airport",
    "city": "Antakya"
  },
  {
    "iata": "COV",
    "name": "Çukurova International Airport",
    "city": "Tarsus"
  },
  {
    "iata": "ISE",
    "name": "Süleyman Demirel International Airport",
    "city": "Isparta"
  },
  {
    "iata": "EDO",
    "name": "Balıkesir Koca Seyit Airport",
    "city": "Edremit"
  },
  {
    "iata": "BJV",
    "name": "Milas Bodrum International Airport",
    "city": "Bodrum"
  },
  {
    "iata": "GZP",
    "name": "Gazipaşa-Alanya Airport",
    "city": "Gazipaşa"
  },
  {
    "iata": "SZF",
    "name": "Samsun-Çarşamba Airport",
    "city": "Samsun"
  },
  {
    "iata": "SAW",
    "name": "Istanbul Sabiha Gökçen International Airport",
    "city": "Pendik, Istanbul"
  },
  {
    "iata": "IST",
    "name": "İstanbul Airport",
    "city": "Arnavutköy, Istanbul"
  },
  {
    "iata": "RZV",
    "name": "Rize–Artvin Airport",
    "city": "Rize"
  },
  {
    "iata": "BZY",
    "name": "Bălți International Airport",
    "city": "Bălți"
  },
  {
    "iata": "RMO",
    "name": "Chişinău International Airport",
    "city": "Chişinău"
  },
  {
    "iata": "OHD",
    "name": "Ohrid St. Paul the Apostle Airport",
    "city": "Ohrid"
  },
  {
    "iata": "SKP",
    "name": "Skopje International Airport",
    "city": "Ilinden"
  },
  {
    "iata": "GIB",
    "name": "Gibraltar Airport",
    "city": "Gibraltar"
  },
  {
    "iata": "BEG",
    "name": "Belgrade Nikola Tesla Airport",
    "city": "Belgrade"
  },
  {
    "iata": "BJY",
    "name": "Batajnica Air Base",
    "city": "Zemun"
  },
  {
    "iata": "KVO",
    "name": "Morava Airport",
    "city": "Kraljevo"
  },
  {
    "iata": "INI",
    "name": "Niš Constantine the Great Airport",
    "city": "Niš"
  },
  {
    "iata": "TGD",
    "name": "Podgorica Airport / Podgorica Golubovci Airbase",
    "city": "Podgorica"
  },
  {
    "iata": "TIV",
    "name": "Tivat Airport",
    "city": "Tivat"
  },
  {
    "iata": "UZC",
    "name": "Ponikve Airport",
    "city": "Stapari"
  },
  {
    "iata": "BTS",
    "name": "M. R. Štefánik Airport",
    "city": "Bratislava"
  },
  {
    "iata": "KSC",
    "name": "Košice International Airport",
    "city": "Košice"
  },
  {
    "iata": "PZY",
    "name": "Piešťany Airport",
    "city": "Piešťany"
  },
  {
    "iata": "SLD",
    "name": "Sliač Airport",
    "city": "Sliač"
  },
  {
    "iata": "TAT",
    "name": "Poprad-Tatry Airport",
    "city": "Poprad"
  },
  {
    "iata": "ILZ",
    "name": "Žilina-Dolný Hričov Airport",
    "city": "Dolný Hričov"
  },
  {
    "iata": "GDT",
    "name": "JAGS McCartney International Airport",
    "city": "Cockburn Town"
  },
  {
    "iata": "NCA",
    "name": "North Caicos Airport",
    "city": "North Caicos"
  },
  {
    "iata": "PLS",
    "name": "Providenciales International Airport",
    "city": "Providenciales"
  },
  {
    "iata": "XSC",
    "name": "South Caicos Airport",
    "city": "South Caicos"
  },
  {
    "iata": "BRX",
    "name": "Maria Montez International Airport",
    "city": "Barahona"
  },
  {
    "iata": "CBJ",
    "name": "Cabo Rojo Airport",
    "city": "Cabo Rojo"
  },
  {
    "iata": "AZS",
    "name": "Samaná El Catey International Airport",
    "city": "Samana"
  },
  {
    "iata": "JBQ",
    "name": "La Isabela International Airport",
    "city": "La Isabela"
  },
  {
    "iata": "LRM",
    "name": "Casa De Campo International Airport",
    "city": "La Romana"
  },
  {
    "iata": "PUJ",
    "name": "Punta Cana International Airport",
    "city": "Punta Cana"
  },
  {
    "iata": "POP",
    "name": "Gregorio Luperon International Airport",
    "city": "Puerto Plata"
  },
  {
    "iata": "SDQ",
    "name": "Las Américas International Airport",
    "city": "Santo Domingo"
  },
  {
    "iata": "STI",
    "name": "Cibao International Airport",
    "city": "Santiago"
  },
  {
    "iata": "CBV",
    "name": "Coban Airport",
    "city": "Coban"
  },
  {
    "iata": "GUA",
    "name": "La Aurora Airport",
    "city": "Guatemala City"
  },
  {
    "iata": "PBR",
    "name": "Puerto Barrios Airport",
    "city": "Puerto Barrios"
  },
  {
    "iata": "RUV",
    "name": "Rubelsanto Airport",
    "city": "Rubelsanto"
  },
  {
    "iata": "RER",
    "name": "Retalhuleu Airport",
    "city": "Retalhuleu"
  },
  {
    "iata": "GSJ",
    "name": "San José Airport",
    "city": "Puerto San José"
  },
  {
    "iata": "LCE",
    "name": "Goloson International Airport",
    "city": "La Ceiba"
  },
  {
    "iata": "SAP",
    "name": "Ramón Villeda Morales International Airport",
    "city": "San Pedro Sula"
  },
  {
    "iata": "GJA",
    "name": "La Laguna Airport",
    "city": "Guanaja"
  },
  {
    "iata": "RTB",
    "name": "Juan Manuel Gálvez International Airport",
    "city": "Coxen Hole"
  },
  {
    "iata": "TEA",
    "name": "Tela Airport",
    "city": "Tela"
  },
  {
    "iata": "TGU",
    "name": "Toncontín International Airport",
    "city": "Tegucigalpa"
  },
  {
    "iata": "TJI",
    "name": "Trujillo Airport",
    "city": "Trujillo"
  },
  {
    "iata": "OCJ",
    "name": "Ian Fleming International Airport",
    "city": "Boscobel"
  },
  {
    "iata": "KIN",
    "name": "Norman Manley International Airport",
    "city": "Kingston"
  },
  {
    "iata": "MBJ",
    "name": "Sangster International Airport",
    "city": "Montego Bay"
  },
  {
    "iata": "POT",
    "name": "Ken Jones Airport",
    "city": "Ken Jones"
  },
  {
    "iata": "KTP",
    "name": "Tinson Pen Airport",
    "city": "Tinson Pen"
  },
  {
    "iata": "ACA",
    "name": "General Juan N. Álvarez International Airport",
    "city": "Acapulco"
  },
  {
    "iata": "NTR",
    "name": "Del Norte International Airport",
    "city": "Monterrey"
  },
  {
    "iata": "AGU",
    "name": "Jesús Terán Peredo International Airport",
    "city": "Aguascalientes"
  },
  {
    "iata": "HUX",
    "name": "Bahías de Huatulco International Airport",
    "city": "Huatulco"
  },
  {
    "iata": "CVJ",
    "name": "General Mariano Matamoros International Airport",
    "city": "Temixco"
  },
  {
    "iata": "CME",
    "name": "Ciudad del Carmen International Airport",
    "city": "Ciudad del Carmen"
  },
  {
    "iata": "CUL",
    "name": "Bachigualato Federal International Airport",
    "city": "Culiacán"
  },
  {
    "iata": "CTM",
    "name": "Chetumal International Airport",
    "city": "Chetumal"
  },
  {
    "iata": "CEN",
    "name": "Ciudad Obregón International Airport",
    "city": "Ciudad Obregón"
  },
  {
    "iata": "CPE",
    "name": "Ingeniero Alberto Acuña Ongay International Airport",
    "city": "Campeche"
  },
  {
    "iata": "CJS",
    "name": "Abraham González International Airport",
    "city": "Ciudad Juárez"
  },
  {
    "iata": "CUU",
    "name": "General Roberto Fierro Villalobos International Airport",
    "city": "Chihuahua"
  },
  {
    "iata": "CVM",
    "name": "General Pedro Jose Mendez International Airport",
    "city": "Ciudad Victoria"
  },
  {
    "iata": "CYW",
    "name": "Captain Rogelio Castillo National Airport",
    "city": "Celaya"
  },
  {
    "iata": "CZM",
    "name": "Cozumel International Airport",
    "city": "Cozumel"
  },
  {
    "iata": "DGO",
    "name": "General Guadalupe Victoria International Airport",
    "city": "Durango"
  },
  {
    "iata": "TPQ",
    "name": "Amado Nervo National Airport",
    "city": "Tepic"
  },
  {
    "iata": "GDL",
    "name": "Guadalajara International Airport",
    "city": "Guadalajara"
  },
  {
    "iata": "GYM",
    "name": "General José María Yáñez International Airport",
    "city": "Guaymas"
  },
  {
    "iata": "HMO",
    "name": "General Ignacio P. Garcia International Airport",
    "city": "Hermosillo"
  },
  {
    "iata": "CLQ",
    "name": "Licenciado Miguel de la Madrid International Airport",
    "city": "Colima"
  },
  {
    "iata": "SLW",
    "name": "Plan De Guadalupe International Airport",
    "city": "Saltillo"
  },
  {
    "iata": "IZT",
    "name": "General Antonio Cárdenas Rodríguez National Airport / Ixtepec Air Base",
    "city": "Ixtepec"
  },
  {
    "iata": "JAL",
    "name": "El Lencero Airport",
    "city": "Emiliano Zapata"
  },
  {
    "iata": "LZC",
    "name": "Lázaro Cárdenas Airport",
    "city": "Lázaro Cárdenas"
  },
  {
    "iata": "LMM",
    "name": "Valle del Fuerte International Airport",
    "city": "Los Mochis"
  },
  {
    "iata": "BJX",
    "name": "Del Bajío International Airport",
    "city": "Silao"
  },
  {
    "iata": "LAP",
    "name": "Manuel Márquez de León International Airport",
    "city": "La Paz"
  },
  {
    "iata": "LTO",
    "name": "Loreto International Airport",
    "city": "Loreto"
  },
  {
    "iata": "MAM",
    "name": "General Servando Canales International Airport",
    "city": "Matamoros"
  },
  {
    "iata": "MID",
    "name": "Manuel Crescencio Rejón International Airport",
    "city": "Mérida"
  },
  {
    "iata": "MXL",
    "name": "General Rodolfo Sánchez Taboada International Airport",
    "city": "Mexicali"
  },
  {
    "iata": "MLM",
    "name": "General Francisco J. Mujica International Airport",
    "city": "Morelia"
  },
  {
    "iata": "MTT",
    "name": "Minatitlán/Coatzacoalcos International Airport",
    "city": "Cosoleacaque"
  },
  {
    "iata": "LOV",
    "name": "Monclova International Airport",
    "city": "Monclova"
  },
  {
    "iata": "MEX",
    "name": "Benito Juárez International Airport",
    "city": "Ciudad de México"
  },
  {
    "iata": "MTY",
    "name": "Monterrey International Airport",
    "city": "Monterrey"
  },
  {
    "iata": "MZT",
    "name": "General Rafael Buelna International Airport",
    "city": "Mazatlàn"
  },
  {
    "iata": "NLD",
    "name": "Quetzalcóatl International Airport",
    "city": "Nuevo Laredo"
  },
  {
    "iata": "OAX",
    "name": "Xoxocotlán International Airport",
    "city": "Oaxaca"
  },
  {
    "iata": "PAZ",
    "name": "El Tajín National Airport",
    "city": "Poza Rica"
  },
  {
    "iata": "PBC",
    "name": "Hermanos Serdán International Airport",
    "city": "Puebla"
  },
  {
    "iata": "PDS",
    "name": "Piedras Negras International Airport",
    "city": "Piedras Negras"
  },
  {
    "iata": "UPN",
    "name": "Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport",
    "city": "Uruapan"
  },
  {
    "iata": "PVR",
    "name": "Puerto Vallarta International Airport",
    "city": "Puerto Vallarta"
  },
  {
    "iata": "PXM",
    "name": "Puerto Escondido International Airport",
    "city": "Puerto Escondido"
  },
  {
    "iata": "QRO",
    "name": "Querétaro Intercontinental Airport",
    "city": "Querétaro"
  },
  {
    "iata": "REX",
    "name": "General Lucio Blanco International Airport",
    "city": "Reynosa"
  },
  {
    "iata": "SJD",
    "name": "Los Cabos International Airport",
    "city": "San José del Cabo"
  },
  {
    "iata": "NLU",
    "name": "General Felipe Ángeles International Airport",
    "city": "Mexico City"
  },
  {
    "iata": "SLP",
    "name": "Ponciano Arriaga International Airport",
    "city": "San Luis Potosí"
  },
  {
    "iata": "TRC",
    "name": "Francisco Sarabia Tinoco International Airport",
    "city": "Torreón"
  },
  {
    "iata": "TGZ",
    "name": "Angel Albino Corzo International Airport",
    "city": "Tuxtla Gutiérrez"
  },
  {
    "iata": "TIJ",
    "name": "General Abelardo L. Rodriguez International Airport",
    "city": "Tijuana"
  },
  {
    "iata": "TQO",
    "name": "Felipe Carrillo Puerto International Airport",
    "city": "Tulum"
  },
  {
    "iata": "TAM",
    "name": "General Francisco Javier Mina International Airport",
    "city": "Tampico"
  },
  {
    "iata": "TLC",
    "name": "Adolfo López Mateos International Airport",
    "city": "Toluca"
  },
  {
    "iata": "TAP",
    "name": "Tapachula International Airport",
    "city": "Tapachula"
  },
  {
    "iata": "CUN",
    "name": "Cancún International Airport",
    "city": "Cancún"
  },
  {
    "iata": "VSA",
    "name": "Carlos Rovirosa Pérez International Airport",
    "city": "Villahermosa"
  },
  {
    "iata": "VER",
    "name": "General Heriberto Jara International Airport",
    "city": "Veracruz"
  },
  {
    "iata": "ZCL",
    "name": "General Leobardo C. Ruiz International Airport",
    "city": "Zacatecas"
  },
  {
    "iata": "ZIH",
    "name": "Ixtapa-Zihuatanejo International Airport",
    "city": "Ixtapa"
  },
  {
    "iata": "ZLO",
    "name": "Playa de Oro International Airport",
    "city": "Manzanillo"
  },
  {
    "iata": "BEF",
    "name": "Bluefields Airport",
    "city": "Bluefileds"
  },
  {
    "iata": "MGA",
    "name": "Augusto C. Sandino (Managua) International Airport",
    "city": "Managua"
  },
  {
    "iata": "PUZ",
    "name": "Puerto Cabezas Airport",
    "city": "Puerto Cabezas"
  },
  {
    "iata": "BOC",
    "name": "Bocas del Toro International Airport",
    "city": "Isla Colón"
  },
  {
    "iata": "CTD",
    "name": "Alonso Valderrama Airport",
    "city": "Chitré"
  },
  {
    "iata": "CHX",
    "name": "Changuinola Captain Manuel Niño International Airport",
    "city": "Changuinola"
  },
  {
    "iata": "DAV",
    "name": "Enrique Malek International Airport",
    "city": "David"
  },
  {
    "iata": "ONX",
    "name": "Enrique Adolfo Jimenez Airport",
    "city": "Colón"
  },
  {
    "iata": "PAC",
    "name": "Marcos A. Gelabert International Airport",
    "city": "Albrook"
  },
  {
    "iata": "SYP",
    "name": "Ruben Cantu Airport",
    "city": "Santiago"
  },
  {
    "iata": "PTY",
    "name": "Tocumen International Airport",
    "city": "Tocumen"
  },
  {
    "iata": "BAI",
    "name": "Buenos Aires Airport",
    "city": "Punta Arenas"
  },
  {
    "iata": "BCL",
    "name": "Barra del Colorado Airport",
    "city": "Pococi"
  },
  {
    "iata": "OTR",
    "name": "Coto 47 Airport",
    "city": "Corredores"
  },
  {
    "iata": "GLF",
    "name": "Golfito Airport",
    "city": "Golfito"
  },
  {
    "iata": "GPL",
    "name": "Guapiles Airport",
    "city": "Pococi"
  },
  {
    "iata": "LIR",
    "name": "Guanacaste Airport",
    "city": "Liberia"
  },
  {
    "iata": "LSL",
    "name": "Los Chiles Airport",
    "city": "Los Chiles"
  },
  {
    "iata": "LIO",
    "name": "Limon International Airport",
    "city": "Puerto Limon"
  },
  {
    "iata": "NOB",
    "name": "Nosara Airport",
    "city": "Nicoya"
  },
  {
    "iata": "SJO",
    "name": "Juan Santamaría International Airport",
    "city": "San José (Alajuela)"
  },
  {
    "iata": "PJM",
    "name": "Puerto Jimenez Airport",
    "city": "Puerto Jimenez"
  },
  {
    "iata": "PMZ",
    "name": "Palmar Sur Airport",
    "city": "Palmar Sur"
  },
  {
    "iata": "SYQ",
    "name": "Tobías Bolaños International Airport",
    "city": "San Jose"
  },
  {
    "iata": "XQP",
    "name": "Quepos Managua Airport",
    "city": "Quepos"
  },
  {
    "iata": "UPL",
    "name": "Upala Airport",
    "city": "Upala"
  },
  {
    "iata": "SAL",
    "name": "Monseñor Óscar Arnulfo Romero International Airport",
    "city": "San Salvador (San Luis Talpa)"
  },
  {
    "iata": "ILS",
    "name": "Ilopango International Airport",
    "city": "San Salvador"
  },
  {
    "iata": "CYA",
    "name": "Antoine-Simon International Airport",
    "city": "Les Cayes"
  },
  {
    "iata": "CAP",
    "name": "Cap Haitien International Airport",
    "city": "Cap Haitien"
  },
  {
    "iata": "JAK",
    "name": "Jacmel Airport",
    "city": "Jacmel"
  },
  {
    "iata": "JEE",
    "name": "Jérémie Airport",
    "city": "Carrefour Sanon"
  },
  {
    "iata": "PAP",
    "name": "Toussaint Louverture International Airport",
    "city": "Port-au-Prince"
  },
  {
    "iata": "PAX",
    "name": "Port-de-Paix Airport",
    "city": "Port-de-Paix"
  },
  {
    "iata": "BCA",
    "name": "Gustavo Rizo Airport",
    "city": "Baracoa"
  },
  {
    "iata": "BYM",
    "name": "Carlos Manuel de Cespedes Airport",
    "city": "Bayamo"
  },
  {
    "iata": "AVI",
    "name": "Máximo Gómez Airport",
    "city": "Ciro Redondo"
  },
  {
    "iata": "CCC",
    "name": "Jardines Del Rey Airport",
    "city": "Cayo Coco"
  },
  {
    "iata": "CFG",
    "name": "Jaime Gonzalez Airport",
    "city": "Cienfuegos"
  },
  {
    "iata": "CYO",
    "name": "Vilo Acuña International Airport",
    "city": "Cayo Largo del Sur"
  },
  {
    "iata": "CMW",
    "name": "Ignacio Agramonte International Airport",
    "city": "Camaguey"
  },
  {
    "iata": "SCU",
    "name": "Antonio Maceo International Airport",
    "city": "Santiago"
  },
  {
    "iata": "NBW",
    "name": "Leeward Point Field",
    "city": "Guantanamo Bay Naval Station"
  },
  {
    "iata": "GAO",
    "name": "Mariana Grajales Airport",
    "city": "Guantánamo"
  },
  {
    "iata": "HAV",
    "name": "José Martí International Airport",
    "city": "Havana"
  },
  {
    "iata": "HOG",
    "name": "Frank Pais International Airport",
    "city": "Holguin"
  },
  {
    "iata": "VRO",
    "name": "Kawama Airport",
    "city": "Santa Marta"
  },
  {
    "iata": "LCL",
    "name": "La Coloma Airport",
    "city": "Pinar del Rio"
  },
  {
    "iata": "MOA",
    "name": "Orestes Acosta Airport",
    "city": "Moa"
  },
  {
    "iata": "MZO",
    "name": "Sierra Maestra International Airport",
    "city": "Manzanillo"
  },
  {
    "iata": "GER",
    "name": "Rafael Cabrera Airport",
    "city": "Nueva Gerona"
  },
  {
    "iata": "UPB",
    "name": "Playa Baracoa Airport",
    "city": "Havana"
  },
  {
    "iata": "SNU",
    "name": "Abel Santamaria Airport",
    "city": "Santa Clara"
  },
  {
    "iata": "SNJ",
    "name": "San Julián Air Base",
    "city": "Sandino"
  },
  {
    "iata": "SZJ",
    "name": "Siguanea Airport",
    "city": "Isla de la Juventud"
  },
  {
    "iata": "TND",
    "name": "Alberto Delgado Airport",
    "city": "Trinidad"
  },
  {
    "iata": "VRA",
    "name": "Juan Gualberto Gomez International Airport",
    "city": "Matanzas"
  },
  {
    "iata": "VTU",
    "name": "Hermanos Ameijeiras Airport",
    "city": "Las Tunas"
  },
  {
    "iata": "CYB",
    "name": "Charles Kirkconnell International Airport",
    "city": "West End"
  },
  {
    "iata": "LYB",
    "name": "Edward Bodden Little Cayman Airfield",
    "city": "Blossom Village"
  },
  {
    "iata": "GCM",
    "name": "Owen Roberts International Airport",
    "city": "George Town"
  },
  {
    "iata": "MAY",
    "name": "Clarence A. Bain Airport",
    "city": "Mangrove Cay"
  },
  {
    "iata": "ASD",
    "name": "Andros Town Airport",
    "city": "Andros Town"
  },
  {
    "iata": "TZN",
    "name": "Congo Town Airport",
    "city": "Andros"
  },
  {
    "iata": "MHH",
    "name": "Leonard M Thompson International Airport",
    "city": "Marsh Harbour"
  },
  {
    "iata": "SAQ",
    "name": "San Andros Airport",
    "city": "Andros Island"
  },
  {
    "iata": "AXP",
    "name": "Spring Point Airport",
    "city": "Spring Point"
  },
  {
    "iata": "TCB",
    "name": "Treasure Cay Airport",
    "city": "Treasure Cay"
  },
  {
    "iata": "CCZ",
    "name": "Chub Cay Airport",
    "city": "Chub Cay"
  },
  {
    "iata": "GHC",
    "name": "Great Harbour Cay Airport",
    "city": "Bullocks Harbour"
  },
  {
    "iata": "BIM",
    "name": "South Bimini Airport",
    "city": "South Bimini"
  },
  {
    "iata": "ATC",
    "name": "Arthur's Town Airport",
    "city": "Arthur's Town"
  },
  {
    "iata": "TBI",
    "name": "New Bight Airport",
    "city": "Cat Island"
  },
  {
    "iata": "CRI",
    "name": "Colonel Hill Airport",
    "city": "Colonel Hill"
  },
  {
    "iata": "GGT",
    "name": "Exuma International Airport",
    "city": "Moss Town"
  },
  {
    "iata": "ELH",
    "name": "North Eleuthera Airport",
    "city": "North Eleuthera"
  },
  {
    "iata": "GHB",
    "name": "Governor's Harbour Airport",
    "city": "Governor's Harbour"
  },
  {
    "iata": "NMC",
    "name": "Normans Cay Airport",
    "city": "Normans Cay"
  },
  {
    "iata": "RSD",
    "name": "Rock Sound Airport",
    "city": "Rock Sound"
  },
  {
    "iata": "TYM",
    "name": "Staniel Cay Airport",
    "city": "Staniel Cay"
  },
  {
    "iata": "FPO",
    "name": "Grand Bahama International Airport",
    "city": "Freeport"
  },
  {
    "iata": "IGA",
    "name": "Inagua Airport",
    "city": "Matthew Town"
  },
  {
    "iata": "LGI",
    "name": "Deadman's Cay Airport",
    "city": "Deadman's Cay"
  },
  {
    "iata": "SML",
    "name": "Stella Maris Airport",
    "city": "Stella Maris"
  },
  {
    "iata": "MYG",
    "name": "Mayaguana Airport",
    "city": "Abraham Bay Settlement"
  },
  {
    "iata": "NAS",
    "name": "Lynden Pindling International Airport",
    "city": "Nassau"
  },
  {
    "iata": "DCT",
    "name": "Duncan Town Airport",
    "city": "Duncan Town"
  },
  {
    "iata": "ZSA",
    "name": "San Salvador Airport",
    "city": "San Salvador"
  },
  {
    "iata": "BZE",
    "name": "Philip S. W. Goldson International Airport",
    "city": "Belize City"
  },
  {
    "iata": "PLJ",
    "name": "Placencia Airport",
    "city": "Placencia"
  },
  {
    "iata": "RAR",
    "name": "Rarotonga International Airport",
    "city": "Avarua"
  },
  {
    "iata": "NAN",
    "name": "Nadi International Airport",
    "city": "Nadi"
  },
  {
    "iata": "SUV",
    "name": "Nausori International Airport",
    "city": "Nausori"
  },
  {
    "iata": "LBS",
    "name": "Labasa Airport",
    "city": "Labasa"
  },
  {
    "iata": "TBU",
    "name": "Fua'amotu International Airport",
    "city": "Nuku'alofa"
  },
  {
    "iata": "HPA",
    "name": "Lifuka Island Airport",
    "city": "Lifuka"
  },
  {
    "iata": "VAV",
    "name": "Vava'u International Airport",
    "city": "Vava'u Island"
  },
  {
    "iata": "FUN",
    "name": "Funafuti International Airport",
    "city": "Funafuti"
  },
  {
    "iata": "TRW",
    "name": "Bonriki International Airport",
    "city": "Tarawa"
  },
  {
    "iata": "IUE",
    "name": "Niue International Airport",
    "city": "Alofi"
  },
  {
    "iata": "WLS",
    "name": "Hihifo Airport",
    "city": "Wallis Island"
  },
  {
    "iata": "APW",
    "name": "Faleolo International Airport",
    "city": "Apia"
  },
  {
    "iata": "PPG",
    "name": "Pago Pago International Airport",
    "city": "Pago Pago"
  },
  {
    "iata": "PPT",
    "name": "Faa'a International Airport",
    "city": "Papeete"
  },
  {
    "iata": "AAA",
    "name": "Anaa Airport",
    "city": "Anaa"
  },
  {
    "iata": "FGU",
    "name": "Fangatau Airport",
    "city": "Fangatau"
  },
  {
    "iata": "REA",
    "name": "Reao Airport",
    "city": "Reao"
  },
  {
    "iata": "KKR",
    "name": "Kaukura Airport",
    "city": "Raitahiti"
  },
  {
    "iata": "MKP",
    "name": "Makemo Airport",
    "city": "Makemo"
  },
  {
    "iata": "AHE",
    "name": "Ahe Airport",
    "city": "Ahe Atoll"
  },
  {
    "iata": "NHV",
    "name": "Nuku Hiva Airport",
    "city": "Nuku Hiva"
  },
  {
    "iata": "AUQ",
    "name": "Hiva Oa-Atuona Airport",
    "city": "Hiva Oa Island"
  },
  {
    "iata": "BOB",
    "name": "Bora Bora Airport",
    "city": "Motu Mute"
  },
  {
    "iata": "HUH",
    "name": "Huahine-Fare Airport",
    "city": "Fare"
  },
  {
    "iata": "MOZ",
    "name": "Moorea Temae Airport",
    "city": "Moorea-Maiao"
  },
  {
    "iata": "HOI",
    "name": "Hao Airport",
    "city": "Otepa"
  },
  {
    "iata": "RFP",
    "name": "Raiatea Airport",
    "city": "Uturoa"
  },
  {
    "iata": "ZGU",
    "name": "Gaua Island Airport",
    "city": "Gaua Island"
  },
  {
    "iata": "SON",
    "name": "Santo Pekoa International Airport",
    "city": "Luganville"
  },
  {
    "iata": "VLI",
    "name": "Bauerfield International Airport",
    "city": "Port Vila"
  },
  {
    "iata": "TGJ",
    "name": "Tiga Airport",
    "city": "Tiga"
  },
  {
    "iata": "KNQ",
    "name": "Koné Airport",
    "city": "Koné"
  },
  {
    "iata": "ILP",
    "name": "Île des Pins Airport",
    "city": "Île des Pins"
  },
  {
    "iata": "LIF",
    "name": "Lifou Airport",
    "city": "Lifou"
  },
  {
    "iata": "GEA",
    "name": "Nouméa Magenta Airport",
    "city": "Nouméa"
  },
  {
    "iata": "MEE",
    "name": "Maré Airport",
    "city": "Maré"
  },
  {
    "iata": "TOU",
    "name": "Touho Airport",
    "city": "Touho"
  },
  {
    "iata": "UVE",
    "name": "Ouvéa Airport",
    "city": "Ouvéa"
  },
  {
    "iata": "NOU",
    "name": "La Tontouta International Airport",
    "city": "Nouméa (La Tontouta)"
  },
  {
    "iata": "AKL",
    "name": "Auckland International Airport",
    "city": "Auckland"
  },
  {
    "iata": "TUO",
    "name": "Taupo Airport",
    "city": "Taupo"
  },
  {
    "iata": "AMZ",
    "name": "Ardmore Airport",
    "city": "Manurewa"
  },
  {
    "iata": "CHC",
    "name": "Christchurch International Airport",
    "city": "Christchurch"
  },
  {
    "iata": "CHT",
    "name": "Chatham Islands / Tuuta Airport",
    "city": "Te One"
  },
  {
    "iata": "DUD",
    "name": "Dunedin International Airport",
    "city": "Dunedin"
  },
  {
    "iata": "GIS",
    "name": "Gisborne Airport",
    "city": "Gisborne"
  },
  {
    "iata": "GTN",
    "name": "Glentanner Airport",
    "city": "Glentanner Station"
  },
  {
    "iata": "HLZ",
    "name": "Hamilton International Airport",
    "city": "Hamilton"
  },
  {
    "iata": "KKE",
    "name": "Kerikeri Airport",
    "city": "Kerikeri"
  },
  {
    "iata": "KAT",
    "name": "Kaitaia Airport",
    "city": "Awanui"
  },
  {
    "iata": "ALR",
    "name": "Alexandra Aerodrome",
    "city": "Alexandra"
  },
  {
    "iata": "MRO",
    "name": "Hood Airport",
    "city": "Masterton"
  },
  {
    "iata": "NPL",
    "name": "New Plymouth Airport",
    "city": "New Plymouth"
  },
  {
    "iata": "NPE",
    "name": "Hawke's Bay Airport",
    "city": "Napier"
  },
  {
    "iata": "NSN",
    "name": "Nelson Airport",
    "city": "Nelson"
  },
  {
    "iata": "IVC",
    "name": "Invercargill Airport",
    "city": "Invercargill"
  },
  {
    "iata": "PMR",
    "name": "Palmerston North Airport",
    "city": "Palmerston North"
  },
  {
    "iata": "ZQN",
    "name": "Queenstown International Airport",
    "city": "Queenstown"
  },
  {
    "iata": "ROT",
    "name": "Rotorua Regional Airport",
    "city": "Rotorua"
  },
  {
    "iata": "TRG",
    "name": "Tauranga Airport",
    "city": "Tauranga"
  },
  {
    "iata": "TWZ",
    "name": "Pukaki Airport",
    "city": "Twitzel"
  },
  {
    "iata": "BHE",
    "name": "Woodbourne Airport",
    "city": "Blenheim"
  },
  {
    "iata": "WKA",
    "name": "Wanaka Airport",
    "city": "Wanaka"
  },
  {
    "iata": "WLG",
    "name": "Wellington International Airport",
    "city": "Wellington"
  },
  {
    "iata": "WIR",
    "name": "Wairoa Airport",
    "city": "Wairoa"
  },
  {
    "iata": "WRE",
    "name": "Whangarei Airport",
    "city": "Whangarei"
  },
  {
    "iata": "WSZ",
    "name": "Westport Airport",
    "city": "Westport"
  },
  {
    "iata": "WAG",
    "name": "Wanganui Airport",
    "city": "Wanganui"
  },
  {
    "iata": "HEA",
    "name": "Herat - Khwaja Abdullah Ansari International Airport",
    "city": "Guzara"
  },
  {
    "iata": "OAI",
    "name": "Bagram Airfield",
    "city": "Bagram"
  },
  {
    "iata": "JAA",
    "name": "Jalalabad Airport",
    "city": "Jalalabad"
  },
  {
    "iata": "KBL",
    "name": "Kabul International Airport",
    "city": "Kabul"
  },
  {
    "iata": "KDH",
    "name": "Ahmad Shah Baba International Airport / Kandahar Airfield",
    "city": "Khvoshab"
  },
  {
    "iata": "KHT",
    "name": "Khost International Airport",
    "city": "Khost"
  },
  {
    "iata": "MMZ",
    "name": "Maymana Zahiraddin Faryabi Airport",
    "city": "Maymana"
  },
  {
    "iata": "MZR",
    "name": "Mazar-i-Sharif International Airport",
    "city": "Mazar-i-Sharif"
  },
  {
    "iata": "UND",
    "name": "Kunduz Airport",
    "city": "Kunduz"
  },
  {
    "iata": "BAH",
    "name": "Bahrain International Airport",
    "city": "Manama"
  },
  {
    "iata": "AHB",
    "name": "Abha International Airport",
    "city": "Abha"
  },
  {
    "iata": "HOF",
    "name": "Al-Ahsa International Airport",
    "city": "Hofuf"
  },
  {
    "iata": "ULH",
    "name": "Majeed Bin Abdulaziz Airport",
    "city": "Al Ula"
  },
  {
    "iata": "ABT",
    "name": "King Saud Bin Abdulaziz (Al Baha) Airport",
    "city": "Al-Baha"
  },
  {
    "iata": "BHH",
    "name": "Bisha Airport",
    "city": "Bisha"
  },
  {
    "iata": "DMM",
    "name": "King Fahd International Airport",
    "city": "Ad Dammam"
  },
  {
    "iata": "DHA",
    "name": "King Abdulaziz Air Base",
    "city": "Dhahran"
  },
  {
    "iata": "GIZ",
    "name": "Jizan Regional Airport / King Abdullah bin Abdulaziz Airport",
    "city": "Jizan"
  },
  {
    "iata": "ELQ",
    "name": "Gassim Airport",
    "city": "Buraidah"
  },
  {
    "iata": "URY",
    "name": "Gurayat Domestic Airport",
    "city": "Gurayat"
  },
  {
    "iata": "HAS",
    "name": "Ha'il Airport",
    "city": "Ha'il"
  },
  {
    "iata": "JED",
    "name": "King Abdulaziz International Airport",
    "city": "Jeddah"
  },
  {
    "iata": "KMC",
    "name": "King Khaled Military City Airport",
    "city": "King Khaled Military City"
  },
  {
    "iata": "KMX",
    "name": "King Khalid Air Base",
    "city": "Khamis Mushait"
  },
  {
    "iata": "MED",
    "name": "Prince Mohammad Bin Abdulaziz Airport",
    "city": "Medina"
  },
  {
    "iata": "EAM",
    "name": "Najran Domestic Airport",
    "city": "Najran"
  },
  {
    "iata": "NUM",
    "name": "Neom Bay Airport",
    "city": "Sharma"
  },
  {
    "iata": "AQI",
    "name": "Al Qaisumah/Hafr Al Batin Airport",
    "city": "Qaisumah"
  },
  {
    "iata": "AKH",
    "name": "Prince Sultan Air Base",
    "city": "Al Kharj"
  },
  {
    "iata": "RAH",
    "name": "Rafha Domestic Airport",
    "city": "Rafha"
  },
  {
    "iata": "RUH",
    "name": "King Khaled International Airport",
    "city": "Riyadh"
  },
  {
    "iata": "RAE",
    "name": "Arar Domestic Airport",
    "city": "Arar"
  },
  {
    "iata": "SHW",
    "name": "Sharurah Domestic Airport",
    "city": "Sharurah"
  },
  {
    "iata": "AJF",
    "name": "Al-Jawf Domestic Airport",
    "city": "Al-Jawf"
  },
  {
    "iata": "TUU",
    "name": "Tabuk Airport",
    "city": "Tabuk"
  },
  {
    "iata": "TIF",
    "name": "Ta’if Regional Airport",
    "city": "Ta’if"
  },
  {
    "iata": "TUI",
    "name": "Turaif Domestic Airport",
    "city": "Turaif"
  },
  {
    "iata": "WAE",
    "name": "Wadi Al Dawasir Domestic Airport",
    "city": "Wadi Al Dawasir"
  },
  {
    "iata": "EJH",
    "name": "Al Wajh Domestic Airport",
    "city": "Al Wajh"
  },
  {
    "iata": "YNB",
    "name": "Prince Abdul Mohsin bin Abdulaziz International Airport / Yanbu Airport",
    "city": "Yanbu"
  },
  {
    "iata": "ABD",
    "name": "Abadan Airport",
    "city": "Abadan"
  },
  {
    "iata": "DEF",
    "name": "Dezful Airport",
    "city": "Dezful"
  },
  {
    "iata": "AKW",
    "name": "Aghajari Airport",
    "city": "Aghajari"
  },
  {
    "iata": "GCH",
    "name": "Gachsaran Airport",
    "city": "Gachsaran"
  },
  {
    "iata": "MRX",
    "name": "Mahshahr Airport",
    "city": "Mahshahr"
  },
  {
    "iata": "AWZ",
    "name": "Lieutenant General Qasem Soleimani International Airport",
    "city": "Ahvaz"
  },
  {
    "iata": "AEU",
    "name": "Abu Musa Island Airport",
    "city": "Abu Musa"
  },
  {
    "iata": "BUZ",
    "name": "Bushehr Airport",
    "city": "Bushehr"
  },
  {
    "iata": "KNR",
    "name": "Jam Airport",
    "city": "Jam"
  },
  {
    "iata": "KIH",
    "name": "Kish International Airport",
    "city": "Kish Island"
  },
  {
    "iata": "BDH",
    "name": "Bandar Lengeh International Airport",
    "city": "Bandar Lengeh"
  },
  {
    "iata": "PGU",
    "name": "Persian Gulf International Airport",
    "city": "Khiyaroo"
  },
  {
    "iata": "KHK",
    "name": "Khark Airport",
    "city": "Khark"
  },
  {
    "iata": "SXI",
    "name": "Siri Airport",
    "city": "Siri"
  },
  {
    "iata": "LVP",
    "name": "Lavan Airport",
    "city": "Lavan Airport"
  },
  {
    "iata": "KSH",
    "name": "Shahid Ashrafi Esfahani Airport",
    "city": "Kermanshah"
  },
  {
    "iata": "IIL",
    "name": "Ilam Airport",
    "city": "Ilam"
  },
  {
    "iata": "KKS",
    "name": "Kashan Airport",
    "city": "Kashan"
  },
  {
    "iata": "IFN",
    "name": "Isfahan Shahid Beheshti International Airport",
    "city": "Isfahan"
  },
  {
    "iata": "CQD",
    "name": "Shahrekord Airport",
    "city": "Shahrekord"
  },
  {
    "iata": "RAS",
    "name": "Sardar-e-Jangal Airport",
    "city": "Rasht"
  },
  {
    "iata": "HDM",
    "name": "Hamadan Airport",
    "city": "Hamadan"
  },
  {
    "iata": "NUJ",
    "name": "Nojeh Air Base",
    "city": "Amirabad"
  },
  {
    "iata": "IKA",
    "name": "Imam Khomeini International Airport",
    "city": "Tehran"
  },
  {
    "iata": "THR",
    "name": "Mehrabad International Airport",
    "city": "Tehran"
  },
  {
    "iata": "GZW",
    "name": "Qazvin Airport",
    "city": "Qazvin"
  },
  {
    "iata": "PYK",
    "name": "Payam Karaj International Airport",
    "city": "Karaj"
  },
  {
    "iata": "BND",
    "name": "Bandar Abbas International Airport",
    "city": "Bandar Abbas"
  },
  {
    "iata": "JYR",
    "name": "Jiroft Airport",
    "city": "Jiroft"
  },
  {
    "iata": "KER",
    "name": "Ayatollah Hashemi Rafsanjani International Airport",
    "city": "Kerman"
  },
  {
    "iata": "BXR",
    "name": "Bam Airport",
    "city": "Bam"
  },
  {
    "iata": "RJN",
    "name": "Rafsanjan Airport",
    "city": "Rafsanjan"
  },
  {
    "iata": "SYJ",
    "name": "Sirjan Airport",
    "city": "Sirjan"
  },
  {
    "iata": "XBJ",
    "name": "Birjand International Airport",
    "city": "Birjand"
  },
  {
    "iata": "CKT",
    "name": "Sarakhs Airport",
    "city": "Sarakhs"
  },
  {
    "iata": "MHD",
    "name": "Mashhad International Airport",
    "city": "Mashhad"
  },
  {
    "iata": "BJB",
    "name": "Bojnord Airport",
    "city": "Bojnord"
  },
  {
    "iata": "AFZ",
    "name": "Sabzevar National Airport",
    "city": "Sabzevar"
  },
  {
    "iata": "TCX",
    "name": "Tabas Airport",
    "city": "Tabas"
  },
  {
    "iata": "GBT",
    "name": "Gorgan Airport",
    "city": "Gorgan"
  },
  {
    "iata": "NSH",
    "name": "Nowshahr Airport",
    "city": "Nowshahr"
  },
  {
    "iata": "RZR",
    "name": "Ramsar Airport",
    "city": "Ramsar"
  },
  {
    "iata": "SRY",
    "name": "Sari Dasht-e Naz International Airport",
    "city": "Sari"
  },
  {
    "iata": "FAZ",
    "name": "Fasa Airport",
    "city": "Fasa"
  },
  {
    "iata": "LRR",
    "name": "Lar Airport",
    "city": "Lar"
  },
  {
    "iata": "LFM",
    "name": "Lamerd Airport",
    "city": "Lamerd"
  },
  {
    "iata": "SYZ",
    "name": "Shiraz Shahid Dastghaib International Airport",
    "city": "Shiraz"
  },
  {
    "iata": "YES",
    "name": "Yasuj Airport",
    "city": "Yasuj"
  },
  {
    "iata": "ADU",
    "name": "Ardabil Airport",
    "city": "Ardabil"
  },
  {
    "iata": "OMH",
    "name": "Urmia Airport",
    "city": "Urmia"
  },
  {
    "iata": "TBZ",
    "name": "Tabriz International Airport",
    "city": "Tabriz"
  },
  {
    "iata": "IMQ",
    "name": "Maku National Airport",
    "city": "Showt"
  },
  {
    "iata": "JWN",
    "name": "Zanjan Airport",
    "city": "Zanjan"
  },
  {
    "iata": "AZD",
    "name": "Shahid Sadooghi Airport",
    "city": "Yazd"
  },
  {
    "iata": "ACZ",
    "name": "Zabol Airport",
    "city": "Zabol"
  },
  {
    "iata": "ZBR",
    "name": "Chabahar Konarak International Airport",
    "city": "Konarak"
  },
  {
    "iata": "ZAH",
    "name": "Zahedan International Airport",
    "city": "Zahedan"
  },
  {
    "iata": "IHR",
    "name": "Iranshahr Airport",
    "city": "Iranshahr"
  },
  {
    "iata": "AMM",
    "name": "Queen Alia International Airport",
    "city": "Amman"
  },
  {
    "iata": "ADJ",
    "name": "Amman Civil (Marka International) Airport",
    "city": "Amman"
  },
  {
    "iata": "AQJ",
    "name": "Aqaba King Hussein International Airport",
    "city": "Aqaba"
  },
  {
    "iata": "XIJ",
    "name": "Ahmed Al Jaber Air Base",
    "city": "Ahmed Al Jaber AB"
  },
  {
    "iata": "KWI",
    "name": "Kuwait International Airport",
    "city": "Kuwait City"
  },
  {
    "iata": "BEY",
    "name": "Beirut Rafic Hariri International Airport",
    "city": "Beirut"
  },
  {
    "iata": "KYE",
    "name": "Rene Mouawad Air Base / Kleyate Airport",
    "city": "Tripoli"
  },
  {
    "iata": "AUH",
    "name": "Zayed International Airport",
    "city": "Abu Dhabi"
  },
  {
    "iata": "AZI",
    "name": "Al Bateen Executive Airport",
    "city": "Abu Dhabi"
  },
  {
    "iata": "AAN",
    "name": "Al Ain International Airport",
    "city": "Al Ain"
  },
  {
    "iata": "XSB",
    "name": "Sir Bani Yas Airport",
    "city": "Sir Bani Yas"
  },
  {
    "iata": "DXB",
    "name": "Dubai International Airport",
    "city": "Dubai"
  },
  {
    "iata": "NHD",
    "name": "Al Minhad Air Base",
    "city": "Dubai"
  },
  {
    "iata": "DWC",
    "name": "Al Maktoum International Airport",
    "city": "Jebel Ali"
  },
  {
    "iata": "FJR",
    "name": "Fujairah International Airport",
    "city": "Fujairah"
  },
  {
    "iata": "RKT",
    "name": "Ras Al Khaimah International Airport",
    "city": "Ras Al Khaimah"
  },
  {
    "iata": "SHJ",
    "name": "Sharjah International Airport",
    "city": "Sharjah"
  },
  {
    "iata": "KHS",
    "name": "Khasab Airport",
    "city": "Khasab"
  },
  {
    "iata": "MSH",
    "name": "RAFO Masirah",
    "city": "Masirah"
  },
  {
    "iata": "MCT",
    "name": "Muscat International Airport",
    "city": "Muscat"
  },
  {
    "iata": "SLL",
    "name": "Salalah Airport",
    "city": "Salalah"
  },
  {
    "iata": "TTH",
    "name": "Thumrait Air Base",
    "city": "Thumrait"
  },
  {
    "iata": "BHV",
    "name": "Bahawalpur Airport",
    "city": "Bahawalpur"
  },
  {
    "iata": "CJL",
    "name": "Chitral Airport",
    "city": "Chitral"
  },
  {
    "iata": "DEA",
    "name": "Dera Ghazi Khan Airport",
    "city": "Dera Ghazi Khan"
  },
  {
    "iata": "DSK",
    "name": "Dera Ismael Khan Airport",
    "city": "Dera Ismael Khan"
  },
  {
    "iata": "LYP",
    "name": "Faisalabad International Airport",
    "city": "Faisalabad"
  },
  {
    "iata": "GWD",
    "name": "New Gwadar International Airport",
    "city": "Gurandani"
  },
  {
    "iata": "GIL",
    "name": "Gilgit Airport",
    "city": "Gilgit"
  },
  {
    "iata": "ISB",
    "name": "Islamabad International Airport",
    "city": "Attock"
  },
  {
    "iata": "JAG",
    "name": "Shahbaz Air Base",
    "city": "Jacobabad"
  },
  {
    "iata": "KHI",
    "name": "Jinnah International Airport",
    "city": "Karachi"
  },
  {
    "iata": "LHE",
    "name": "Allama Iqbal International Airport",
    "city": "Lahore"
  },
  {
    "iata": "XJM",
    "name": "Mangla Airport",
    "city": "Mangla"
  },
  {
    "iata": "MFG",
    "name": "Muzaffarabad Airport",
    "city": "Muzaffarabad"
  },
  {
    "iata": "MWD",
    "name": "Mianwali Air Base",
    "city": "Mianwali"
  },
  {
    "iata": "MJD",
    "name": "Moenjodaro Airport",
    "city": "Moenjodaro"
  },
  {
    "iata": "MUX",
    "name": "Multan International Airport",
    "city": "Multan"
  },
  {
    "iata": "WNS",
    "name": "Shaheed Benazirabad Airport",
    "city": "Nawabashah"
  },
  {
    "iata": "PJG",
    "name": "Panjgur Airport",
    "city": "Panjgur"
  },
  {
    "iata": "PSI",
    "name": "Pasni Airport",
    "city": "Pasni"
  },
  {
    "iata": "PEW",
    "name": "Peshawar International Airport",
    "city": "Peshawar"
  },
  {
    "iata": "UET",
    "name": "Quetta International Airport",
    "city": "Quetta"
  },
  {
    "iata": "RYK",
    "name": "Shaikh Zaid Airport",
    "city": "Rahim Yar Khan"
  },
  {
    "iata": "RAZ",
    "name": "Rawalakot Airport",
    "city": "Rawalakot"
  },
  {
    "iata": "KDU",
    "name": "Skardu Airport",
    "city": "Skardu"
  },
  {
    "iata": "SKZ",
    "name": "Sukkur Airport",
    "city": "Mirpur Khas"
  },
  {
    "iata": "SYW",
    "name": "Sehwan Sharif Airport",
    "city": "Sehwan Sharif"
  },
  {
    "iata": "SGI",
    "name": "Mushaf Air Base",
    "city": "Sargodha"
  },
  {
    "iata": "SDT",
    "name": "Saidu Sharif Airport",
    "city": "Saidu Sharif"
  },
  {
    "iata": "SKT",
    "name": "Sialkot International Airport",
    "city": "Sialkot"
  },
  {
    "iata": "SUL",
    "name": "Sui Airport",
    "city": "Sui"
  },
  {
    "iata": "TUK",
    "name": "Turbat International Airport",
    "city": "Turbat"
  },
  {
    "iata": "PZH",
    "name": "Zhob Airport",
    "city": "Fort Sandeman"
  },
  {
    "iata": "IQA",
    "name": "Al Asad Air Base",
    "city": "Hīt"
  },
  {
    "iata": "TQD",
    "name": "Al Taqaddum Air Base",
    "city": "Al Habbaniyah"
  },
  {
    "iata": "BGW",
    "name": "Baghdad International Airport / New Al Muthana Air Base",
    "city": "Baghdad"
  },
  {
    "iata": "OSM",
    "name": "Mosul International Airport",
    "city": "Mosul"
  },
  {
    "iata": "EBL",
    "name": "Erbil International Airport",
    "city": "Arbil"
  },
  {
    "iata": "KIK",
    "name": "Kirkuk Air Base",
    "city": "Kirkuk"
  },
  {
    "iata": "BSR",
    "name": "Basra International Airport",
    "city": "Basra"
  },
  {
    "iata": "NJF",
    "name": "Al Najaf International Airport",
    "city": "Najaf"
  },
  {
    "iata": "ISU",
    "name": "Sulaymaniyah International Airport",
    "city": "Sulaymaniyah"
  },
  {
    "iata": "ALP",
    "name": "Aleppo International Airport",
    "city": "Aleppo"
  },
  {
    "iata": "DAM",
    "name": "Damascus International Airport",
    "city": "Damascus"
  },
  {
    "iata": "DEZ",
    "name": "Deir ez-Zor Airport",
    "city": "Deir ez-Zor"
  },
  {
    "iata": "KAC",
    "name": "Qamishli Airport",
    "city": "Qamishly"
  },
  {
    "iata": "LTK",
    "name": "Hmeimim Air Base",
    "city": "Latakia"
  },
  {
    "iata": "PMS",
    "name": "Palmyra Airport",
    "city": "Tadmur"
  },
  {
    "iata": "DIA",
    "name": "Doha International Airport",
    "city": "Doha"
  },
  {
    "iata": "XJD",
    "name": "Al Udeid Air Base",
    "city": "Ar Rayyan"
  },
  {
    "iata": "DOH",
    "name": "Hamad International Airport",
    "city": "Doha"
  },
  {
    "iata": "ADE",
    "name": "Aden International Airport",
    "city": "Aden"
  },
  {
    "iata": "AXK",
    "name": "Ataq Airport",
    "city": "Ataq"
  },
  {
    "iata": "AAY",
    "name": "Al Ghaydah International Airport",
    "city": "Al Ghaydah"
  },
  {
    "iata": "RIY",
    "name": "Riyan Mukalla International Airport",
    "city": "Riyan"
  },
  {
    "iata": "SAH",
    "name": "Sanaa International Airport",
    "city": "Sanaa"
  },
  {
    "iata": "SCT",
    "name": "Socotra International Airport",
    "city": "Mori"
  },
  {
    "iata": "GXF",
    "name": "Seiyun Hadhramaut International Airport",
    "city": "Seiyun"
  },
  {
    "iata": "TAI",
    "name": "Ta'izz International Airport",
    "city": "Ta'izz"
  },
  {
    "iata": "PAQ",
    "name": "Warren Bud Woods Palmer Municipal Airport",
    "city": "Palmer"
  },
  {
    "iata": "BTI",
    "name": "Barter Island Long Range Radar Station Airport",
    "city": "Barter Island"
  },
  {
    "iata": "BET",
    "name": "Bethel Airport",
    "city": "Bethel"
  },
  {
    "iata": "BIG",
    "name": "Allen Army Airfield",
    "city": "Delta Junction Ft Greely"
  },
  {
    "iata": "BRW",
    "name": "Wiley Post Will Rogers Memorial Airport",
    "city": "Utqiaġvik"
  },
  {
    "iata": "CDB",
    "name": "Cold Bay Airport",
    "city": "Cold Bay"
  },
  {
    "iata": "CDV",
    "name": "Merle K (Mudhole) Smith Airport",
    "city": "Cordova"
  },
  {
    "iata": "CZF",
    "name": "Cape Romanzof LRRS Airport",
    "city": "Cape Romanzof"
  },
  {
    "iata": "DRG",
    "name": "Deering Airport",
    "city": "Deering"
  },
  {
    "iata": "ADK",
    "name": "Adak Airport",
    "city": "Adak"
  },
  {
    "iata": "DLG",
    "name": "Dillingham Airport",
    "city": "Dillingham"
  },
  {
    "iata": "ADQ",
    "name": "Kodiak Airport",
    "city": "Kodiak"
  },
  {
    "iata": "DUT",
    "name": "Tom Madsen (Dutch Harbor) Airport",
    "city": "Unalaska"
  },
  {
    "iata": "EDF",
    "name": "Elmendorf Air Force Base",
    "city": "Anchorage"
  },
  {
    "iata": "EHM",
    "name": "Cape Newenham LRRS Airport",
    "city": "Cape Newenham"
  },
  {
    "iata": "EIL",
    "name": "Eielson Air Force Base",
    "city": "Fairbanks"
  },
  {
    "iata": "EMK",
    "name": "Emmonak Airport",
    "city": "Emmonak"
  },
  {
    "iata": "ENA",
    "name": "Kenai Municipal Airport",
    "city": "Kenai"
  },
  {
    "iata": "FAI",
    "name": "Fairbanks International Airport",
    "city": "Fairbanks"
  },
  {
    "iata": "FBK",
    "name": "Ladd Army Airfield",
    "city": "Fairbanks"
  },
  {
    "iata": "ABL",
    "name": "Ambler Airport",
    "city": "Ambler"
  },
  {
    "iata": "GAL",
    "name": "Edward G. Pitka Sr Airport",
    "city": "Galena"
  },
  {
    "iata": "GKN",
    "name": "Gulkana Airport",
    "city": "Gulkana"
  },
  {
    "iata": "GAM",
    "name": "Gambell Airport",
    "city": "Gambell"
  },
  {
    "iata": "GST",
    "name": "Gustavus Airport",
    "city": "Gustavus"
  },
  {
    "iata": "HCR",
    "name": "Holy Cross Airport",
    "city": "Holy Cross"
  },
  {
    "iata": "HSL",
    "name": "Huslia Airport",
    "city": "Huslia"
  },
  {
    "iata": "HNS",
    "name": "Haines Airport",
    "city": "Haines"
  },
  {
    "iata": "HOM",
    "name": "Homer Airport",
    "city": "Homer"
  },
  {
    "iata": "EGX",
    "name": "Egegik Airport",
    "city": "Egegik"
  },
  {
    "iata": "IAN",
    "name": "Bob Baker Memorial Airport",
    "city": "Kiana"
  },
  {
    "iata": "ILI",
    "name": "Iliamna Airport",
    "city": "Iliamna"
  },
  {
    "iata": "UTO",
    "name": "Indian Mountain LRRS Airport",
    "city": "Utopia Creek"
  },
  {
    "iata": "JNU",
    "name": "Juneau International Airport",
    "city": "Juneau"
  },
  {
    "iata": "AKN",
    "name": "King Salmon Airport",
    "city": "King Salmon"
  },
  {
    "iata": "AKP",
    "name": "Anaktuvuk Pass Airport",
    "city": "Anaktuvuk Pass"
  },
  {
    "iata": "KTN",
    "name": "Ketchikan International Airport",
    "city": "Ketchikan"
  },
  {
    "iata": "KLW",
    "name": "Klawock Airport",
    "city": "Klawock"
  },
  {
    "iata": "LUR",
    "name": "Cape Lisburne LRRS Airport",
    "city": "Cape Lisburne"
  },
  {
    "iata": "MCG",
    "name": "McGrath Airport",
    "city": "McGrath"
  },
  {
    "iata": "MRI",
    "name": "Merrill Field",
    "city": "Anchorage"
  },
  {
    "iata": "MYU",
    "name": "Mekoryuk Airport",
    "city": "Mekoryuk"
  },
  {
    "iata": "ANC",
    "name": "Ted Stevens Anchorage International Airport",
    "city": "Anchorage"
  },
  {
    "iata": "ANI",
    "name": "Aniak Airport",
    "city": "Aniak"
  },
  {
    "iata": "ENN",
    "name": "Nenana Municipal Airport",
    "city": "Nenana"
  },
  {
    "iata": "ANN",
    "name": "Annette Island Airport",
    "city": "Metlakatla"
  },
  {
    "iata": "ANV",
    "name": "Anvik Airport",
    "city": "Anvik"
  },
  {
    "iata": "OME",
    "name": "Nome Airport",
    "city": "Nome"
  },
  {
    "iata": "ORT",
    "name": "Northway Airport",
    "city": "Northway"
  },
  {
    "iata": "OTZ",
    "name": "Ralph Wien Memorial Airport",
    "city": "Kotzebue"
  },
  {
    "iata": "STG",
    "name": "St George Airport",
    "city": "St George"
  },
  {
    "iata": "KPC",
    "name": "Port Clarence Coast Guard Station",
    "city": "Port Clarence"
  },
  {
    "iata": "PSG",
    "name": "Petersburg James A Johnson Airport",
    "city": "Petersburg"
  },
  {
    "iata": "PTH",
    "name": "Port Heiden Airport",
    "city": "Port Heiden"
  },
  {
    "iata": "PTU",
    "name": "Platinum Airport",
    "city": "Platinum"
  },
  {
    "iata": "NUI",
    "name": "Nuiqsut Airport",
    "city": "Nuiqsut"
  },
  {
    "iata": "ARC",
    "name": "Arctic Village Airport",
    "city": "Arctic Village"
  },
  {
    "iata": "RBY",
    "name": "Ruby Airport",
    "city": "Ruby"
  },
  {
    "iata": "SVA",
    "name": "Savoonga Airport",
    "city": "Savoonga"
  },
  {
    "iata": "SCC",
    "name": "Deadhorse Airport",
    "city": "Deadhorse"
  },
  {
    "iata": "SDP",
    "name": "Sand Point Airport",
    "city": "Sand Point"
  },
  {
    "iata": "SIT",
    "name": "Sitka Rocky Gutierrez Airport",
    "city": "Sitka"
  },
  {
    "iata": "SNP",
    "name": "St Paul Island Airport",
    "city": "St Paul Island"
  },
  {
    "iata": "SVW",
    "name": "Sparrevohn LRRS Airport",
    "city": "Sparrevohn"
  },
  {
    "iata": "SXQ",
    "name": "Soldotna Airport",
    "city": "Soldotna"
  },
  {
    "iata": "SYA",
    "name": "Eareckson Air Station",
    "city": "Shemya"
  },
  {
    "iata": "TKA",
    "name": "Talkeetna Airport",
    "city": "Talkeetna"
  },
  {
    "iata": "TLJ",
    "name": "Tatalina LRRS Airport",
    "city": "Takotna"
  },
  {
    "iata": "ATK",
    "name": "Atqasuk Edward Burnell Sr Memorial Airport",
    "city": "Atqasuk"
  },
  {
    "iata": "UNK",
    "name": "Unalakleet Airport",
    "city": "Unalakleet"
  },
  {
    "iata": "VDZ",
    "name": "Valdez Pioneer Field",
    "city": "Valdez"
  },
  {
    "iata": "SWD",
    "name": "Seward Airport",
    "city": "Seward"
  },
  {
    "iata": "WRG",
    "name": "Wrangell Airport",
    "city": "Wrangell"
  },
  {
    "iata": "AIN",
    "name": "Wainwright Airport",
    "city": "Wainwright"
  },
  {
    "iata": "WWA",
    "name": "Wasilla Airport",
    "city": "Wasilla"
  },
  {
    "iata": "YAK",
    "name": "Yakutat Airport",
    "city": "Yakutat"
  },
  {
    "iata": "CIS",
    "name": "Canton Island Airport",
    "city": "Abariringa"
  },
  {
    "iata": "FYU",
    "name": "Fort Yukon Airport",
    "city": "Fort Yukon"
  },
  {
    "iata": "ROP",
    "name": "Rota International Airport",
    "city": "Rota Island"
  },
  {
    "iata": "SPN",
    "name": "Saipan International Airport",
    "city": "I Fadang, Saipan"
  },
  {
    "iata": "UAM",
    "name": "Andersen Air Force Base",
    "city": "Yigo"
  },
  {
    "iata": "GUM",
    "name": "Antonio B. Won Pat International Airport",
    "city": "Hagåtña"
  },
  {
    "iata": "TIQ",
    "name": "Tinian International Airport",
    "city": "Tinian Island"
  },
  {
    "iata": "BKH",
    "name": "Barking Sands Airport",
    "city": "Kekaha"
  },
  {
    "iata": "HNM",
    "name": "Hana Airport",
    "city": "Hana"
  },
  {
    "iata": "HIK",
    "name": "Hickam Air Force Base",
    "city": "Honolulu"
  },
  {
    "iata": "JHM",
    "name": "Kapalua Airport",
    "city": "Lahaina"
  },
  {
    "iata": "JRF",
    "name": "Kalaeloa Airport",
    "city": "Kapolei"
  },
  {
    "iata": "KOA",
    "name": "Ellison Onizuka Kona International Airport at Keahole",
    "city": "Kailua-Kona"
  },
  {
    "iata": "LIH",
    "name": "Lihue Airport",
    "city": "Lihue"
  },
  {
    "iata": "MKK",
    "name": "Molokai Airport",
    "city": "Kaunakakai"
  },
  {
    "iata": "MUE",
    "name": "Waimea Kohala Airport",
    "city": "Waimea (Kamuela)"
  },
  {
    "iata": "NGF",
    "name": "Kaneohe Bay MCAS (Marion E. Carl Field) Airport",
    "city": "Kaneohe"
  },
  {
    "iata": "HNL",
    "name": "Daniel K Inouye International Airport",
    "city": "Honolulu, Oahu"
  },
  {
    "iata": "LNY",
    "name": "Lanai Airport",
    "city": "Lanai City"
  },
  {
    "iata": "OGG",
    "name": "Kahului International Airport",
    "city": "Kahului"
  },
  {
    "iata": "ITO",
    "name": "Hilo International Airport",
    "city": "Hilo"
  },
  {
    "iata": "MAJ",
    "name": "Marshall Islands International Airport",
    "city": "Majuro Atoll"
  },
  {
    "iata": "KWA",
    "name": "Bucholz Army Air Field",
    "city": "Kwajalein"
  },
  {
    "iata": "CXI",
    "name": "Cassidy International Airport",
    "city": "Kiritimati"
  },
  {
    "iata": "MDY",
    "name": "Henderson Field",
    "city": "Sand Island"
  },
  {
    "iata": "PIZ",
    "name": "Point Lay LRRS Airport",
    "city": "Point Lay"
  },
  {
    "iata": "TKK",
    "name": "Chuuk International Airport",
    "city": "Weno Island"
  },
  {
    "iata": "PNI",
    "name": "Pohnpei International Airport",
    "city": "Pohnpei Island"
  },
  {
    "iata": "ROR",
    "name": "Babelthuap Airport",
    "city": "Babelthuap Island"
  },
  {
    "iata": "KSA",
    "name": "Kosrae International Airport",
    "city": "Okat"
  },
  {
    "iata": "YAP",
    "name": "Yap International Airport",
    "city": "Yap Island"
  },
  {
    "iata": "AWK",
    "name": "Wake Island Airfield",
    "city": "Wake Island"
  },
  {
    "iata": "KNH",
    "name": "Kinmen Airport",
    "city": "Shang-I"
  },
  {
    "iata": "LZN",
    "name": "Matsu Nangan Airport",
    "city": "Matsu (Nangan)"
  },
  {
    "iata": "TTT",
    "name": "Taitung Airport",
    "city": "Taitung City"
  },
  {
    "iata": "KHH",
    "name": "Kaohsiung International Airport",
    "city": "Kaohsiung (Xiaogang)"
  },
  {
    "iata": "CYI",
    "name": "Chiayi Airport",
    "city": "Shuishang"
  },
  {
    "iata": "HCN",
    "name": "Hengchun Airport",
    "city": "Hengchun"
  },
  {
    "iata": "KYD",
    "name": "Lanyu Airport",
    "city": "Orchid Island"
  },
  {
    "iata": "RMQ",
    "name": "Taichung International Airport / Ching Chuang Kang Air Base",
    "city": "Taichung (Qingshui)"
  },
  {
    "iata": "MFK",
    "name": "Matsu Beigan Airport",
    "city": "Matsu (Beigan)"
  },
  {
    "iata": "TNN",
    "name": "Tainan International Airport / Tainan Air Base",
    "city": "Tainan (Rende)"
  },
  {
    "iata": "HSZ",
    "name": "Hsinchu Air Base",
    "city": "Hsinchu City"
  },
  {
    "iata": "MZG",
    "name": "Penghu Magong Airport",
    "city": "Huxi"
  },
  {
    "iata": "TSA",
    "name": "Taipei Songshan Airport",
    "city": "Taipei (Songshan)"
  },
  {
    "iata": "TPE",
    "name": "Taiwan Taoyuan International Airport",
    "city": "Taoyuan"
  },
  {
    "iata": "HUN",
    "name": "Hualien Airport",
    "city": "Hualien City"
  },
  {
    "iata": "NRT",
    "name": "Narita International Airport",
    "city": "Narita"
  },
  {
    "iata": "MMJ",
    "name": "Shinshu-Matsumoto Airport",
    "city": "Matsumoto"
  },
  {
    "iata": "IBR",
    "name": "Ibaraki Airport / JASDF Hyakuri Air Base",
    "city": "Omitama"
  },
  {
    "iata": "IWO",
    "name": "Ioto (Iwo Jima) Airbase",
    "city": "Ogasawara"
  },
  {
    "iata": "KIX",
    "name": "Kansai International Airport",
    "city": "Osaka"
  },
  {
    "iata": "SHM",
    "name": "Nanki Shirahama Airport",
    "city": "Shirahama"
  },
  {
    "iata": "UKB",
    "name": "Kobe Airport",
    "city": "Kobe"
  },
  {
    "iata": "TJH",
    "name": "Konotori Tajima Airport",
    "city": "Toyooka"
  },
  {
    "iata": "OBO",
    "name": "Tokachi-Obihiro Airport",
    "city": "Obihiro"
  },
  {
    "iata": "CTS",
    "name": "New Chitose Airport",
    "city": "Sapporo"
  },
  {
    "iata": "HKD",
    "name": "Hakodate Airport",
    "city": "Hakodate"
  },
  {
    "iata": "KUH",
    "name": "Kushiro Airport",
    "city": "Kushiro"
  },
  {
    "iata": "MMB",
    "name": "Memanbetsu Airport",
    "city": "Ōzora"
  },
  {
    "iata": "SHB",
    "name": "Nakashibetsu Airport",
    "city": "Nakashibetsu"
  },
  {
    "iata": "OKD",
    "name": "Sapporo Okadama Airport",
    "city": "Sapporo"
  },
  {
    "iata": "WKJ",
    "name": "Wakkanai Airport",
    "city": "Wakkanai"
  },
  {
    "iata": "IKI",
    "name": "Iki Airport",
    "city": "Iki"
  },
  {
    "iata": "UBJ",
    "name": "Yamaguchi Ube Airport",
    "city": "Ube"
  },
  {
    "iata": "TSJ",
    "name": "Tsushima Airport",
    "city": "Tsushima"
  },
  {
    "iata": "MBE",
    "name": "Monbetsu Airport",
    "city": "Monbetsu"
  },
  {
    "iata": "AKJ",
    "name": "Asahikawa Airport",
    "city": "Higashikagura"
  },
  {
    "iata": "OIR",
    "name": "Okushiri Airport",
    "city": "Okushiri Island"
  },
  {
    "iata": "RIS",
    "name": "Rishiri Airport",
    "city": "Rishiri"
  },
  {
    "iata": "KUM",
    "name": "Yakushima Airport",
    "city": "Yakushima"
  },
  {
    "iata": "FUJ",
    "name": "Fukue Airport",
    "city": "Goto"
  },
  {
    "iata": "FUK",
    "name": "Fukuoka Airport",
    "city": "Fukuoka"
  },
  {
    "iata": "TNE",
    "name": "New Tanegashima Airport",
    "city": "Tanegashima"
  },
  {
    "iata": "KOJ",
    "name": "Kagoshima Airport",
    "city": "Kagoshima"
  },
  {
    "iata": "KMI",
    "name": "Miyazaki Airport",
    "city": "Miyazaki"
  },
  {
    "iata": "OIT",
    "name": "Oita Airport",
    "city": "Oita"
  },
  {
    "iata": "KKJ",
    "name": "Kitakyushu Airport",
    "city": "Kitakyushu"
  },
  {
    "iata": "HSG",
    "name": "Saga Airport",
    "city": "Saga"
  },
  {
    "iata": "KMJ",
    "name": "Kumamoto Airport",
    "city": "Kumamoto"
  },
  {
    "iata": "NGS",
    "name": "Nagasaki Airport",
    "city": "Nagasaki"
  },
  {
    "iata": "NGO",
    "name": "Chubu Centrair International Airport",
    "city": "Tokoname"
  },
  {
    "iata": "ASJ",
    "name": "Amami Airport",
    "city": "Amami"
  },
  {
    "iata": "OKE",
    "name": "Okinoerabu Airport",
    "city": "Wadomari"
  },
  {
    "iata": "KKX",
    "name": "Kikai Airport",
    "city": "Kikai"
  },
  {
    "iata": "TKN",
    "name": "Tokunoshima Airport",
    "city": "Amagi"
  },
  {
    "iata": "NKM",
    "name": "Nagoya Airport / JASDF Komaki Air Base",
    "city": "Nagoya"
  },
  {
    "iata": "FKJ",
    "name": "Fukui Airport",
    "city": "Fukui"
  },
  {
    "iata": "KMQ",
    "name": "Komatsu Airport / JASDF Komatsu Air Base",
    "city": "Kanazawa"
  },
  {
    "iata": "OKI",
    "name": "Oki Global Geopark Airport",
    "city": "Okinoshima"
  },
  {
    "iata": "FSZ",
    "name": "Mount Fuji Shizuoka Airport",
    "city": "Makinohara / Shimada"
  },
  {
    "iata": "TOY",
    "name": "Toyama Airport",
    "city": "Toyama"
  },
  {
    "iata": "NTQ",
    "name": "Noto Satoyama Airport",
    "city": "Wajima"
  },
  {
    "iata": "HIJ",
    "name": "Hiroshima Airport",
    "city": "Hiroshima"
  },
  {
    "iata": "OKJ",
    "name": "Okayama Momotaro Airport",
    "city": "Okayama"
  },
  {
    "iata": "IZO",
    "name": "Izumo Enmusubi Airport",
    "city": "Izumo"
  },
  {
    "iata": "YGJ",
    "name": "Yonago Kitaro Airport / JASDF Miho Air Base",
    "city": "Yonago"
  },
  {
    "iata": "IWK",
    "name": "Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni",
    "city": "Iwakuni"
  },
  {
    "iata": "KCZ",
    "name": "Kochi Ryoma Airport",
    "city": "Nankoku"
  },
  {
    "iata": "MYJ",
    "name": "Matsuyama Airport",
    "city": "Matsuyama"
  },
  {
    "iata": "ITM",
    "name": "Osaka International Airport",
    "city": "Osaka"
  },
  {
    "iata": "TTJ",
    "name": "Tottori Sand Dunes Conan Airport",
    "city": "Tottori"
  },
  {
    "iata": "TKS",
    "name": "Tokushima Awaodori Airport / JMSDF Tokushima Air Base",
    "city": "Tokushima"
  },
  {
    "iata": "TAK",
    "name": "Takamatsu Airport",
    "city": "Takamatsu"
  },
  {
    "iata": "IWJ",
    "name": "Iwami Airport",
    "city": "Masuda"
  },
  {
    "iata": "AOJ",
    "name": "Aomori Airport",
    "city": "Aomori"
  },
  {
    "iata": "GAJ",
    "name": "Yamagata Airport",
    "city": "Higashine"
  },
  {
    "iata": "SDS",
    "name": "Sado Airport",
    "city": "Sado"
  },
  {
    "iata": "FKS",
    "name": "Fukushima Airport",
    "city": "Sukagawa"
  },
  {
    "iata": "HHE",
    "name": "JMSDF Hachinohe Air Base / Hachinohe Airport",
    "city": "Hachinohe"
  },
  {
    "iata": "HNA",
    "name": "Iwate Hanamaki Airport",
    "city": "Hanamaki"
  },
  {
    "iata": "AXT",
    "name": "Akita Airport",
    "city": "Akita"
  },
  {
    "iata": "MSJ",
    "name": "Misawa Airport / Misawa Air Base",
    "city": "Misawa"
  },
  {
    "iata": "KIJ",
    "name": "Niigata Airport",
    "city": "Niigata"
  },
  {
    "iata": "ONJ",
    "name": "Odate Noshiro Airport",
    "city": "Kitaakita"
  },
  {
    "iata": "SDJ",
    "name": "Sendai Airport",
    "city": "Natori"
  },
  {
    "iata": "SYO",
    "name": "Shonai Airport",
    "city": "Shonai"
  },
  {
    "iata": "NJA",
    "name": "JMSDF Atsugi Air Base / Naval Air Facility Atsugi",
    "city": "Ayase / Yamato"
  },
  {
    "iata": "HAC",
    "name": "Hachijojima Airport",
    "city": "Hachijojima"
  },
  {
    "iata": "OIM",
    "name": "Oshima Airport",
    "city": "Izu Oshima"
  },
  {
    "iata": "MYE",
    "name": "Miyakejima Airport",
    "city": "Miyakejima"
  },
  {
    "iata": "HND",
    "name": "Tokyo Haneda International Airport",
    "city": "Tokyo"
  },
  {
    "iata": "MWX",
    "name": "Muan International Airport",
    "city": "Muan (Piseo-ri)"
  },
  {
    "iata": "KWJ",
    "name": "Gwangju Airport",
    "city": "Gwangju"
  },
  {
    "iata": "KUV",
    "name": "Gunsan Airport / Gunsan Air Base",
    "city": "Gunsan"
  },
  {
    "iata": "RSU",
    "name": "Yeosu Airport",
    "city": "Yeosu"
  },
  {
    "iata": "KAG",
    "name": "Gangneung Airport (K-18)",
    "city": "Gangneung"
  },
  {
    "iata": "WJU",
    "name": "Wonju Airport / Hoengseong Air Base (K-38/K-46)",
    "city": "Wonju"
  },
  {
    "iata": "YNY",
    "name": "Yangyang International Airport",
    "city": "Gonghang-ro"
  },
  {
    "iata": "CJU",
    "name": "Jeju International Airport",
    "city": "Jeju City"
  },
  {
    "iata": "JDG",
    "name": "Jeongseok Airport",
    "city": "Jeju Island"
  },
  {
    "iata": "PUS",
    "name": "Gimhae International Airport",
    "city": "Busan"
  },
  {
    "iata": "HIN",
    "name": "Sacheon Airport / Sacheon Air Base",
    "city": "Sacheon"
  },
  {
    "iata": "USN",
    "name": "Ulsan Airport",
    "city": "Ulsan"
  },
  {
    "iata": "ICN",
    "name": "Incheon International Airport",
    "city": "Seoul"
  },
  {
    "iata": "OSN",
    "name": "Osan Air Base",
    "city": "Pyeongtaek"
  },
  {
    "iata": "GMP",
    "name": "Gimpo International Airport",
    "city": "Seoul"
  },
  {
    "iata": "SWU",
    "name": "Suwon Airport",
    "city": "Suwon"
  },
  {
    "iata": "KPO",
    "name": "Pohang Airport (G-815/K-3)",
    "city": "Pohang"
  },
  {
    "iata": "JWO",
    "name": "Jungwon Air Base/Chungju Airport",
    "city": "Gimseang-ro"
  },
  {
    "iata": "TAE",
    "name": "Daegu Airport",
    "city": "Daegu"
  },
  {
    "iata": "CJJ",
    "name": "Cheongju International Airport/Cheongju Air Base (K-59/G-513)",
    "city": "Cheongju"
  },
  {
    "iata": "YEC",
    "name": "Yecheon Airbase",
    "city": "Yecheon-ri"
  },
  {
    "iata": "OKA",
    "name": "Naha Airport / JASDF Naha Air Base",
    "city": "Naha"
  },
  {
    "iata": "DNA",
    "name": "Kadena Air Base",
    "city": "Okinawa"
  },
  {
    "iata": "ISG",
    "name": "New Ishigaki Airport",
    "city": "Ishigaki"
  },
  {
    "iata": "UEO",
    "name": "Kumejima Airport",
    "city": "Kumejima"
  },
  {
    "iata": "MMD",
    "name": "Minamidaito Airport",
    "city": "Minamidaito"
  },
  {
    "iata": "MMY",
    "name": "Miyako Airport",
    "city": "Miyakojima"
  },
  {
    "iata": "IEJ",
    "name": "Iejima Airport",
    "city": "Ie"
  },
  {
    "iata": "KTD",
    "name": "Kitadaito Airport",
    "city": "Kitadaitōjima"
  },
  {
    "iata": "SHI",
    "name": "Shimojishima Airport",
    "city": "Miyakojima"
  },
  {
    "iata": "TRA",
    "name": "Tarama Airport",
    "city": "Tarama"
  },
  {
    "iata": "RNJ",
    "name": "Yoron Airport",
    "city": "Yoron"
  },
  {
    "iata": "OGN",
    "name": "Yonaguni Airport",
    "city": "Yonaguni"
  },
  {
    "iata": "SFS",
    "name": "Subic Bay International Airport / Naval Air Station Cubi Point",
    "city": "Olongapo"
  },
  {
    "iata": "CRK",
    "name": "Clark International Airport / Clark Air Base",
    "city": "Mabalacat"
  },
  {
    "iata": "LLC",
    "name": "Cagayan North International Airport",
    "city": "Lal-lo"
  },
  {
    "iata": "LAO",
    "name": "Laoag International Airport",
    "city": "Laoag City"
  },
  {
    "iata": "DRP",
    "name": "Bicol International Airport",
    "city": "Legazpi"
  },
  {
    "iata": "MNL",
    "name": "Ninoy Aquino International Airport",
    "city": "Manila (Pasay)"
  },
  {
    "iata": "SGL",
    "name": "Danilo Atienza Air Base",
    "city": "Cavite"
  },
  {
    "iata": "LBX",
    "name": "Lubang Airport",
    "city": "Lubang"
  },
  {
    "iata": "AAV",
    "name": "Allah Valley Airport",
    "city": "Surallah"
  },
  {
    "iata": "CBO",
    "name": "Cotabato (Awang) Airport",
    "city": "Datu Odin Sinsuat"
  },
  {
    "iata": "DVO",
    "name": "Francisco Bangoy International Airport",
    "city": "Davao"
  },
  {
    "iata": "BXU",
    "name": "Bancasi Airport",
    "city": "Butuan"
  },
  {
    "iata": "BPH",
    "name": "Bislig Airport",
    "city": "Bislig"
  },
  {
    "iata": "DPL",
    "name": "Dipolog Airport",
    "city": "Dipolog"
  },
  {
    "iata": "CGM",
    "name": "Camiguin Airport",
    "city": "Mambajao"
  },
  {
    "iata": "JOL",
    "name": "Jolo Airport",
    "city": "Jolo"
  },
  {
    "iata": "TWT",
    "name": "Sanga Sanga Airport",
    "city": "Bongao"
  },
  {
    "iata": "OZC",
    "name": "Labo Airport",
    "city": "Ozamiz"
  },
  {
    "iata": "PAG",
    "name": "Pagadian Airport",
    "city": "Pagadian"
  },
  {
    "iata": "MXI",
    "name": "Mati National Airport",
    "city": "Mati"
  },
  {
    "iata": "GES",
    "name": "General Santos International Airport",
    "city": "General Santos"
  },
  {
    "iata": "SUG",
    "name": "Surigao Airport",
    "city": "Surigao City"
  },
  {
    "iata": "TDG",
    "name": "Tandag Airport",
    "city": "Tandag"
  },
  {
    "iata": "CGY",
    "name": "Laguindingan International Airport",
    "city": "Laguindingan"
  },
  {
    "iata": "ZAM",
    "name": "Zamboanga International Airport",
    "city": "Zamboanga"
  },
  {
    "iata": "BAG",
    "name": "Loakan Airport",
    "city": "Baguio"
  },
  {
    "iata": "DTE",
    "name": "Daet Airport",
    "city": "Daet"
  },
  {
    "iata": "SJI",
    "name": "San Jose Airport",
    "city": "San Jose"
  },
  {
    "iata": "MBO",
    "name": "Mamburao Airport",
    "city": "Mamburao"
  },
  {
    "iata": "WNP",
    "name": "Naga Airport",
    "city": "Naga"
  },
  {
    "iata": "BSO",
    "name": "Basco Airport",
    "city": "Basco"
  },
  {
    "iata": "BQA",
    "name": "Dr Juan C Angara Airport",
    "city": "Baler"
  },
  {
    "iata": "SFE",
    "name": "San Fernando Airport",
    "city": "San Fernando"
  },
  {
    "iata": "TUG",
    "name": "Tuguegarao Airport",
    "city": "Tuguegarao City"
  },
  {
    "iata": "VRC",
    "name": "Virac Airport",
    "city": "Virac"
  },
  {
    "iata": "MRQ",
    "name": "Marinduque Airport",
    "city": "Gasan"
  },
  {
    "iata": "CYZ",
    "name": "Cauayan Airport",
    "city": "Cauayan City"
  },
  {
    "iata": "TAC",
    "name": "Daniel Z. Romualdez Airport",
    "city": "Tacloban City"
  },
  {
    "iata": "BCD",
    "name": "Bacolod-Silay Airport",
    "city": "Bacolod City"
  },
  {
    "iata": "CYP",
    "name": "Calbayog Airport",
    "city": "Calbayog City"
  },
  {
    "iata": "DGT",
    "name": "Sibulan Airport",
    "city": "Dumaguete City"
  },
  {
    "iata": "MPH",
    "name": "Godofredo P. Ramos Airport",
    "city": "Caticlan"
  },
  {
    "iata": "CRM",
    "name": "Catarman National Airport",
    "city": "Catarman"
  },
  {
    "iata": "ILO",
    "name": "Iloilo International Airport",
    "city": "Cabatuan"
  },
  {
    "iata": "MBT",
    "name": "Moises R. Espinosa Airport",
    "city": "Masbate"
  },
  {
    "iata": "KLO",
    "name": "Kalibo International Airport",
    "city": "Kalibo"
  },
  {
    "iata": "CEB",
    "name": "Mactan Cebu International Airport",
    "city": "Lapu-Lapu City"
  },
  {
    "iata": "OMC",
    "name": "Ormoc Airport",
    "city": "Ormoc City"
  },
  {
    "iata": "PPS",
    "name": "Puerto Princesa International Airport / PAF Antonio Bautista Air Base",
    "city": "Puerto Princesa"
  },
  {
    "iata": "RXS",
    "name": "Roxas Airport",
    "city": "Roxas City"
  },
  {
    "iata": "EUQ",
    "name": "Evelio Javier Airport",
    "city": "San Jose"
  },
  {
    "iata": "TBH",
    "name": "Tugdan Airport",
    "city": "Tablas Island"
  },
  {
    "iata": "USU",
    "name": "Francisco B. Reyes (Busuanga) Airport",
    "city": "Coron"
  },
  {
    "iata": "COC",
    "name": "Comodoro Pierrestegui Airport",
    "city": "Concordia"
  },
  {
    "iata": "GHU",
    "name": "Gualeguaychu Airport",
    "city": "Gualeguaychu"
  },
  {
    "iata": "PRA",
    "name": "General Urquiza Airport",
    "city": "Parana"
  },
  {
    "iata": "ROS",
    "name": "Rosario Islas Malvinas International Airport",
    "city": "Rosario"
  },
  {
    "iata": "SFN",
    "name": "Sauce Viejo Airport",
    "city": "Santa Fe"
  },
  {
    "iata": "AEP",
    "name": "Jorge Newbery Airpark",
    "city": "Buenos Aires"
  },
  {
    "iata": "COR",
    "name": "Ingeniero Ambrosio Taravella Airport",
    "city": "Cordoba"
  },
  {
    "iata": "LPG",
    "name": "La Plata Airport",
    "city": "La Plata"
  },
  {
    "iata": "EPA",
    "name": "El Palomar Airport",
    "city": "El Palomar"
  },
  {
    "iata": "EZE",
    "name": "Minister Pistarini International Airport",
    "city": "Buenos Aires (Ezeiza)"
  },
  {
    "iata": "RDS",
    "name": "Rincon De Los Sauces Airport",
    "city": "Rincon de los Sauces"
  },
  {
    "iata": "APZ",
    "name": "Zapala Airport",
    "city": "Zapala"
  },
  {
    "iata": "MDZ",
    "name": "El Plumerillo Airport",
    "city": "Mendoza"
  },
  {
    "iata": "LGS",
    "name": "Comodoro D.R. Salomón Airport",
    "city": "Malargue"
  },
  {
    "iata": "AFA",
    "name": "Suboficial Ay Santiago Germano Airport",
    "city": "San Rafael"
  },
  {
    "iata": "CTC",
    "name": "Coronel Felipe Varela International Airport",
    "city": "Catamarca"
  },
  {
    "iata": "SDE",
    "name": "Vicecomodoro Angel D. La Paz Aragonés Airport",
    "city": "Santiago del Estero"
  },
  {
    "iata": "IRJ",
    "name": "Capitan V A Almonacid Airport",
    "city": "La Rioja"
  },
  {
    "iata": "RHD",
    "name": "Termas de Río Hondo international Airport",
    "city": "Termas de Río Hondo"
  },
  {
    "iata": "TUC",
    "name": "Teniente Benjamin Matienzo Airport",
    "city": "San Miguel de Tucumán"
  },
  {
    "iata": "UAQ",
    "name": "Domingo Faustino Sarmiento Airport",
    "city": "San Juan"
  },
  {
    "iata": "RCU",
    "name": "Area De Material Airport",
    "city": "Rio Cuarto"
  },
  {
    "iata": "VDR",
    "name": "Villa Dolores Airport",
    "city": "Villa Dolores"
  },
  {
    "iata": "VME",
    "name": "Villa Reynolds Airport",
    "city": "Villa Mercedes"
  },
  {
    "iata": "LUQ",
    "name": "Brigadier Mayor D Cesar Raul Ojeda Airport",
    "city": "San Luis"
  },
  {
    "iata": "CNQ",
    "name": "Corrientes Airport",
    "city": "Corrientes"
  },
  {
    "iata": "RES",
    "name": "Resistencia International Airport",
    "city": "Resistencia"
  },
  {
    "iata": "FMA",
    "name": "Formosa National Airport",
    "city": "Formosa"
  },
  {
    "iata": "IGR",
    "name": "Cataratas Del Iguazú International Airport",
    "city": "Puerto Iguazu"
  },
  {
    "iata": "AOL",
    "name": "Paso De Los Libres Airport",
    "city": "Paso de los Libres"
  },
  {
    "iata": "MCS",
    "name": "Monte Caseros Airport",
    "city": "Monte Caseros"
  },
  {
    "iata": "PSS",
    "name": "Libertador Gral D Jose De San Martin Airport",
    "city": "Posadas"
  },
  {
    "iata": "SLA",
    "name": "Martin Miguel De Guemes International Airport",
    "city": "Salta"
  },
  {
    "iata": "JUJ",
    "name": "Gobernador Horacio Guzman International Airport",
    "city": "San Salvador de Jujuy"
  },
  {
    "iata": "ORA",
    "name": "Orán Airport",
    "city": "Orán"
  },
  {
    "iata": "TTG",
    "name": "General Enrique Mosconi Airport",
    "city": "Tartagal"
  },
  {
    "iata": "OYA",
    "name": "Goya Airport",
    "city": "Goya"
  },
  {
    "iata": "RCQ",
    "name": "Reconquista Airport",
    "city": "Reconquista"
  },
  {
    "iata": "UZU",
    "name": "Curuzu Cuatia Airport",
    "city": "Curuzu Cuatia"
  },
  {
    "iata": "EHL",
    "name": "El Bolsón Airfield",
    "city": "El Bolsón"
  },
  {
    "iata": "CRD",
    "name": "General E. Mosconi Airport",
    "city": "Comodoro Rivadavia"
  },
  {
    "iata": "EQS",
    "name": "Esquel Brigadier Antonio Parodi International Airport",
    "city": "Esquel"
  },
  {
    "iata": "LHS",
    "name": "Las Heras Airport",
    "city": "Las Heras"
  },
  {
    "iata": "REL",
    "name": "Almirante Marco Andres Zar Airport",
    "city": "Rawson"
  },
  {
    "iata": "VDM",
    "name": "Gobernador Castello Airport",
    "city": "Viedma / Carmen de Patagones"
  },
  {
    "iata": "PMY",
    "name": "El Tehuelche Airport",
    "city": "Puerto Madryn"
  },
  {
    "iata": "PUD",
    "name": "Puerto Deseado Airport",
    "city": "Puerto Deseado"
  },
  {
    "iata": "RGA",
    "name": "Gobernador Ramón Trejo Noel International Airport",
    "city": "Rio Grande"
  },
  {
    "iata": "RGL",
    "name": "Piloto Civil N. Fernández Airport",
    "city": "Rio Gallegos"
  },
  {
    "iata": "USH",
    "name": "Ushuaia - Malvinas Argentinas International Airport",
    "city": "Ushuaia"
  },
  {
    "iata": "ULA",
    "name": "Capitan D Daniel Vazquez Airport",
    "city": "San Julian"
  },
  {
    "iata": "PMQ",
    "name": "Perito Moreno Jalil Hamer Airport",
    "city": "Perito Moreno"
  },
  {
    "iata": "RZA",
    "name": "Santa Cruz Airport",
    "city": "Puerto Santa Cruz"
  },
  {
    "iata": "BHI",
    "name": "Comandante Espora Airport",
    "city": "Bahía Blanca"
  },
  {
    "iata": "GPO",
    "name": "General Pico Airport",
    "city": "General Pico"
  },
  {
    "iata": "OYO",
    "name": "Tres Arroyos Airport",
    "city": "Tres Arroyos"
  },
  {
    "iata": "SST",
    "name": "Santa Teresita Airport",
    "city": "Santa Teresita"
  },
  {
    "iata": "MDQ",
    "name": "Ástor Piazzola International Airport",
    "city": "Mar del Plata"
  },
  {
    "iata": "NQN",
    "name": "Presidente Peron Airport",
    "city": "Neuquen"
  },
  {
    "iata": "NEC",
    "name": "Necochea Airport",
    "city": "Necochea"
  },
  {
    "iata": "PEH",
    "name": "Comodoro Pedro Zanni Airport",
    "city": "Pehuajó"
  },
  {
    "iata": "RSA",
    "name": "Santa Rosa Airport",
    "city": "Santa Rosa"
  },
  {
    "iata": "BRC",
    "name": "San Carlos de Bariloche Airport",
    "city": "San Carlos de Bariloche"
  },
  {
    "iata": "TDL",
    "name": "Héroes de Malvinas Airport",
    "city": "Tandil"
  },
  {
    "iata": "VLG",
    "name": "Villa Gesell Airport",
    "city": "Villa Gesell"
  },
  {
    "iata": "CUT",
    "name": "Cutral-Co Airport",
    "city": "Cutral-Co"
  },
  {
    "iata": "CPC",
    "name": "Aviador C. Campos Airport",
    "city": "Chapelco/San Martin de los Andes"
  },
  {
    "iata": "CDJ",
    "name": "Conceição do Araguaia Airport",
    "city": "Conceição do Araguaia"
  },
  {
    "iata": "ARX",
    "name": "Aracati Dragão do Mar Regional Airport",
    "city": "Aracati"
  },
  {
    "iata": "JTC",
    "name": "Bauru/Arealva–Moussa Nakhal Tobias State Airport",
    "city": "Bauru"
  },
  {
    "iata": "AQA",
    "name": "Araraquara Airport",
    "city": "Araraquara"
  },
  {
    "iata": "AJU",
    "name": "Aracaju - Santa Maria International Airport",
    "city": "Aracaju"
  },
  {
    "iata": "AFL",
    "name": "Piloto Osvaldo Marques Dias Airport",
    "city": "Alta Floresta"
  },
  {
    "iata": "ARU",
    "name": "Araçatuba Airport",
    "city": "Araçatuba"
  },
  {
    "iata": "AAX",
    "name": "Romeu Zema Airport",
    "city": "Araxá"
  },
  {
    "iata": "BEL",
    "name": "Val de Cans/Júlio Cezar Ribeiro International Airport",
    "city": "Belém"
  },
  {
    "iata": "BGX",
    "name": "Comandante Gustavo Kraemer Airport",
    "city": "Bagé"
  },
  {
    "iata": "PLU",
    "name": "Pampulha - Carlos Drummond de Andrade Airport",
    "city": "Belo Horizonte"
  },
  {
    "iata": "BFH",
    "name": "Bacacheri Airport",
    "city": "Curitiba"
  },
  {
    "iata": "BSB",
    "name": "Presidente Juscelino Kubitschek International Airport",
    "city": "Brasília"
  },
  {
    "iata": "BVB",
    "name": "Atlas Brasil Cantanhede Airport",
    "city": "Boa Vista"
  },
  {
    "iata": "BPG",
    "name": "Barra do Garças Airport",
    "city": "Barra do Garças"
  },
  {
    "iata": "CAC",
    "name": "Coronel Adalberto Mendes da Silva Airport",
    "city": "Cascavel"
  },
  {
    "iata": "CNF",
    "name": "Tancredo Neves International Airport",
    "city": "Belo Horizonte"
  },
  {
    "iata": "CGR",
    "name": "Campo Grande Airport",
    "city": "Campo Grande"
  },
  {
    "iata": "XAP",
    "name": "Serafin Enoss Bertaso Airport",
    "city": "Chapecó"
  },
  {
    "iata": "CLN",
    "name": "Brig. Lysias Augusto Rodrigues Airport",
    "city": "Carolina"
  },
  {
    "iata": "CKS",
    "name": "Carajás Airport",
    "city": "Parauapebas"
  },
  {
    "iata": "CAW",
    "name": "Bartolomeu Lisandro Airport",
    "city": "Campos Dos Goytacazes"
  },
  {
    "iata": "CMG",
    "name": "Corumbá International Airport",
    "city": "Corumbá"
  },
  {
    "iata": "CWB",
    "name": "Afonso Pena Airport",
    "city": "Curitiba"
  },
  {
    "iata": "CXJ",
    "name": "Hugo Cantergiani Regional Airport",
    "city": "Caxias Do Sul"
  },
  {
    "iata": "CGB",
    "name": "Marechal Rondon Airport",
    "city": "Cuiabá"
  },
  {
    "iata": "CZS",
    "name": "Cruzeiro do Sul Airport",
    "city": "Cruzeiro Do Sul"
  },
  {
    "iata": "PPB",
    "name": "Presidente Prudente Airport",
    "city": "Presidente Prudente"
  },
  {
    "iata": "MAO",
    "name": "Eduardo Gomes International Airport",
    "city": "Manaus"
  },
  {
    "iata": "JCR",
    "name": "Jacareacanga Airport",
    "city": "Jacareacanga"
  },
  {
    "iata": "IGU",
    "name": "Cataratas International Airport",
    "city": "Foz do Iguaçu"
  },
  {
    "iata": "FLN",
    "name": "Hercílio Luz International Airport",
    "city": "Florianópolis"
  },
  {
    "iata": "FEN",
    "name": "Fernando de Noronha Airport",
    "city": "Fernando de Noronha"
  },
  {
    "iata": "FOR",
    "name": "Pinto Martins International Airport",
    "city": "Fortaleza"
  },
  {
    "iata": "GIG",
    "name": "Rio Galeão – Tom Jobim International Airport",
    "city": "Rio De Janeiro"
  },
  {
    "iata": "GJM",
    "name": "Guajará-Mirim Airport",
    "city": "Guajará-Mirim"
  },
  {
    "iata": "GYN",
    "name": "Santa Genoveva Airport",
    "city": "Goiânia"
  },
  {
    "iata": "GRU",
    "name": "Guarulhos - Governador André Franco Montoro International Airport",
    "city": "São Paulo"
  },
  {
    "iata": "GVR",
    "name": "Coronel Altino Machado Airport",
    "city": "Governador Valadares"
  },
  {
    "iata": "GUJ",
    "name": "Edu Chaves Field",
    "city": "Guaratinguetá"
  },
  {
    "iata": "ATM",
    "name": "Altamira Interstate Airport",
    "city": "Altamira"
  },
  {
    "iata": "ITA",
    "name": "Itacoatiara Airport",
    "city": "Itacoatiara"
  },
  {
    "iata": "ITB",
    "name": "Itaituba Airport",
    "city": "Itaituba"
  },
  {
    "iata": "IOS",
    "name": "Bahia - Jorge Amado Airport",
    "city": "Ilhéus"
  },
  {
    "iata": "IPN",
    "name": "Usiminas Airport",
    "city": "Ipatinga"
  },
  {
    "iata": "IMP",
    "name": "Prefeito Renato Moreira Airport",
    "city": "Imperatriz"
  },
  {
    "iata": "JJD",
    "name": "Comandante Ariston Pessoa Airport",
    "city": "Cruz"
  },
  {
    "iata": "JDF",
    "name": "Francisco de Assis Airport",
    "city": "Juiz de Fora"
  },
  {
    "iata": "JPA",
    "name": "Presidente Castro Pinto International Airport",
    "city": "João Pessoa"
  },
  {
    "iata": "JOI",
    "name": "Lauro Carneiro de Loyola Airport",
    "city": "Joinville"
  },
  {
    "iata": "CPV",
    "name": "Presidente João Suassuna Airport",
    "city": "Campina Grande"
  },
  {
    "iata": "VCP",
    "name": "Viracopos International Airport",
    "city": "Campinas"
  },
  {
    "iata": "LAJ",
    "name": "Lages Airport",
    "city": "Lages"
  },
  {
    "iata": "LDB",
    "name": "Governor José Richa Airport",
    "city": "Londrina"
  },
  {
    "iata": "LAZ",
    "name": "Bom Jesus da Lapa Airport",
    "city": "Bom Jesus da Lapa"
  },
  {
    "iata": "MAB",
    "name": "João Correa da Rocha Airport",
    "city": "Marabá"
  },
  {
    "iata": "MEU",
    "name": "Monte Dourado - Serra do Areão Airport",
    "city": "Almeirim"
  },
  {
    "iata": "MEA",
    "name": "Macaé Benedito Lacerda Airport",
    "city": "Macaé"
  },
  {
    "iata": "MGF",
    "name": "Regional de Maringá - Sílvio Name Júnior Airport",
    "city": "Maringá"
  },
  {
    "iata": "MOC",
    "name": "Mário Ribeiro Airport",
    "city": "Montes Claros"
  },
  {
    "iata": "MII",
    "name": "Frank Miloye Milenkowichi–Marília State Airport",
    "city": "Marília"
  },
  {
    "iata": "PLL",
    "name": "Ponta Pelada Airport / Manaus Air Base",
    "city": "Manaus"
  },
  {
    "iata": "MCZ",
    "name": "Zumbi dos Palmares Airport",
    "city": "Maceió"
  },
  {
    "iata": "MCP",
    "name": "Macapá - Alberto Alcolumbre International Airport",
    "city": "Macapá"
  },
  {
    "iata": "MVF",
    "name": "Dix-Sept Rosado Airport",
    "city": "Mossoró"
  },
  {
    "iata": "MNX",
    "name": "Manicoré Airport",
    "city": "Manicoré"
  },
  {
    "iata": "NVT",
    "name": "Ministro Victor Konder International Airport",
    "city": "Navegantes"
  },
  {
    "iata": "GEL",
    "name": "Santo Ângelo Airport",
    "city": "Santo Ângelo"
  },
  {
    "iata": "OYK",
    "name": "Oiapoque Airport",
    "city": "Oiapoque"
  },
  {
    "iata": "POA",
    "name": "Salgado Filho International Airport",
    "city": "Porto Alegre"
  },
  {
    "iata": "PHB",
    "name": "Parnaíba - Prefeito Doutor João Silva Filho International Airport",
    "city": "Parnaíba"
  },
  {
    "iata": "POO",
    "name": "Poços de Caldas - Embaixador Walther Moreira Salles Airport",
    "city": "Poços De Caldas"
  },
  {
    "iata": "PFB",
    "name": "Lauro Kurtz Airport",
    "city": "Passo Fundo"
  },
  {
    "iata": "PGZ",
    "name": "Ponta Grossa Airport - Comandante Antonio Amilton Beraldo",
    "city": "Ponta Grossa"
  },
  {
    "iata": "PMW",
    "name": "Brigadeiro Lysias Rodrigues Airport",
    "city": "Palmas"
  },
  {
    "iata": "PET",
    "name": "João Simões Lopes Neto International Airport",
    "city": "Pelotas"
  },
  {
    "iata": "PNZ",
    "name": "Senador Nilo Coelho Airport",
    "city": "Petrolina"
  },
  {
    "iata": "PMG",
    "name": "Ponta Porã Airport",
    "city": "Ponta Porã"
  },
  {
    "iata": "BPS",
    "name": "Porto Seguro Airport",
    "city": "Porto Seguro"
  },
  {
    "iata": "PVH",
    "name": "Governador Jorge Teixeira de Oliveira Airport",
    "city": "Porto Velho"
  },
  {
    "iata": "RBR",
    "name": "Rio Branco-Plácido de Castro International Airport",
    "city": "Rio Branco"
  },
  {
    "iata": "REC",
    "name": "Recife/Guararapes - Gilberto Freyre International Airport",
    "city": "Recife"
  },
  {
    "iata": "SDU",
    "name": "Santos Dumont Airport",
    "city": "Rio de Janeiro"
  },
  {
    "iata": "RAO",
    "name": "Leite Lopes Airport",
    "city": "Ribeirão Preto"
  },
  {
    "iata": "SJK",
    "name": "Professor Urbano Ernesto Stumpf Airport",
    "city": "São José Dos Campos"
  },
  {
    "iata": "SLZ",
    "name": "Marechal Cunha Machado International Airport",
    "city": "São Luís"
  },
  {
    "iata": "RIA",
    "name": "Santa Maria Airport",
    "city": "Santa Maria"
  },
  {
    "iata": "STM",
    "name": "Santarém - Maestro Wilson Fonseca International Airport",
    "city": "Santarém"
  },
  {
    "iata": "CGH",
    "name": "Congonhas Airport",
    "city": "São Paulo"
  },
  {
    "iata": "SJP",
    "name": "Prof. Eribelto Manoel Reino State Airport",
    "city": "São José do Rio Preto"
  },
  {
    "iata": "SSZ",
    "name": "Santos Nero Moura Air Base / Guarujá Airport",
    "city": "Guarujá"
  },
  {
    "iata": "SSA",
    "name": "Deputado Luiz Eduardo Magalhães International Airport",
    "city": "Salvador"
  },
  {
    "iata": "TMT",
    "name": "Trombetas Airport",
    "city": "Oriximiná"
  },
  {
    "iata": "THE",
    "name": "Senador Petrônio Portela Airport",
    "city": "Teresina"
  },
  {
    "iata": "TFF",
    "name": "Tefé Airport",
    "city": "Tefé"
  },
  {
    "iata": "TRQ",
    "name": "Tarauacá Airport",
    "city": "Tarauacá"
  },
  {
    "iata": "TBT",
    "name": "Tabatinga Airport",
    "city": "Tabatinga"
  },
  {
    "iata": "TUR",
    "name": "Tucuruí Airport",
    "city": "Tucuruí"
  },
  {
    "iata": "SJL",
    "name": "São Gabriel da Cachoeira Airport",
    "city": "São Gabriel da Cachoeira"
  },
  {
    "iata": "PAV",
    "name": "Paulo Afonso Airport",
    "city": "Paulo Afonso"
  },
  {
    "iata": "URG",
    "name": "Rubem Berta Airport",
    "city": "Uruguaiana"
  },
  {
    "iata": "UDI",
    "name": "Ten. Cel. Aviador César Bombonato Airport",
    "city": "Uberlândia"
  },
  {
    "iata": "UBA",
    "name": "Mário de Almeida Franco Airport",
    "city": "Uberaba"
  },
  {
    "iata": "VAG",
    "name": "Major Brigadeiro Trompowsky Airport",
    "city": "Varginha"
  },
  {
    "iata": "BVH",
    "name": "Brigadeiro Camarão Airport",
    "city": "Vilhena"
  },
  {
    "iata": "VIX",
    "name": "Eurico de Aguiar Salles Airport",
    "city": "Vitória"
  },
  {
    "iata": "IZA",
    "name": "Presidente Itamar Franco Airport",
    "city": "Juiz de Fora"
  },
  {
    "iata": "ARI",
    "name": "Chacalluta Airport",
    "city": "Arica"
  },
  {
    "iata": "CPO",
    "name": "Desierto de Atacama Airport",
    "city": "Copiapo"
  },
  {
    "iata": "BBA",
    "name": "Balmaceda Airport",
    "city": "Balmaceda"
  },
  {
    "iata": "TOQ",
    "name": "Barriles Airport",
    "city": "Tocopilla"
  },
  {
    "iata": "CCH",
    "name": "Chile Chico Airport",
    "city": "Chile Chico"
  },
  {
    "iata": "CJC",
    "name": "El Loa Airport",
    "city": "Calama"
  },
  {
    "iata": "YAI",
    "name": "Gral. Bernardo O´Higgins Airport",
    "city": "Chillan"
  },
  {
    "iata": "PUQ",
    "name": "President Carlos Ibañez del Campo International Airport",
    "city": "Punta Arenas"
  },
  {
    "iata": "GXQ",
    "name": "Teniente Vidal Airport",
    "city": "Coyhaique"
  },
  {
    "iata": "IQQ",
    "name": "Diego Aracena Airport",
    "city": "Iquique"
  },
  {
    "iata": "SCL",
    "name": "Comodoro Arturo Merino Benítez International Airport",
    "city": "Santiago"
  },
  {
    "iata": "ESR",
    "name": "Ricardo García Posada Airport",
    "city": "El Salvador"
  },
  {
    "iata": "ANF",
    "name": "Andrés Sabella Gálvez International Airport",
    "city": "Antofagasta"
  },
  {
    "iata": "WPR",
    "name": "Captain Fuentes Martinez Airport",
    "city": "Porvenir"
  },
  {
    "iata": "WPU",
    "name": "Guardia Marina Zañartu Airport",
    "city": "Puerto Williams"
  },
  {
    "iata": "LGR",
    "name": "Cochrane Airport",
    "city": "Cochrane"
  },
  {
    "iata": "CCP",
    "name": "Carriel Sur Airport",
    "city": "Concepcion"
  },
  {
    "iata": "IPC",
    "name": "Mataveri Airport",
    "city": "Isla De Pascua"
  },
  {
    "iata": "ZOS",
    "name": "Cañal Bajo Carlos Hott Siebert Airport",
    "city": "Osorno"
  },
  {
    "iata": "VLR",
    "name": "Vallenar Airport",
    "city": "Vallenar"
  },
  {
    "iata": "PNT",
    "name": "Lieutenant Julio Gallardo Airport",
    "city": "Puerto Natales"
  },
  {
    "iata": "ZCO",
    "name": "La Araucanía Airport",
    "city": "Temuco"
  },
  {
    "iata": "CNR",
    "name": "Chañaral Airport",
    "city": "Chañaral"
  },
  {
    "iata": "LSC",
    "name": "La Florida Airport",
    "city": "La Serena-Coquimbo"
  },
  {
    "iata": "PZS",
    "name": "Maquehue Airport",
    "city": "Temuco"
  },
  {
    "iata": "PMC",
    "name": "El Tepual Airport",
    "city": "Puerto Montt"
  },
  {
    "iata": "TLX",
    "name": "Panguilemo Airport",
    "city": "Talca"
  },
  {
    "iata": "WCH",
    "name": "Nuevo Chaitén Airport",
    "city": "Chaitén"
  },
  {
    "iata": "ZIC",
    "name": "Victoria Airport",
    "city": "Victoria"
  },
  {
    "iata": "TTC",
    "name": "Las Breas Airport",
    "city": "Taltal"
  },
  {
    "iata": "ZAL",
    "name": "Pichoy Airport",
    "city": "Valdivia"
  },
  {
    "iata": "KNA",
    "name": "Viña del Mar Airport",
    "city": "Viña del Mar"
  },
  {
    "iata": "ATF",
    "name": "Chachoán Regional Airport",
    "city": "Ambato"
  },
  {
    "iata": "OCC",
    "name": "Francisco De Orellana Airport",
    "city": "Coca"
  },
  {
    "iata": "CUE",
    "name": "Mariscal Lamar Airport",
    "city": "Cuenca"
  },
  {
    "iata": "GYE",
    "name": "José Joaquín de Olmedo International Airport",
    "city": "Guayaquil"
  },
  {
    "iata": "TNW",
    "name": "Jumandy Airport",
    "city": "Ahuano"
  },
  {
    "iata": "MRR",
    "name": "Jose Maria Velasco Ibarra Airport",
    "city": "Macará"
  },
  {
    "iata": "XMS",
    "name": "Coronel E Carvajal Airport",
    "city": "Macas"
  },
  {
    "iata": "MEC",
    "name": "Eloy Alfaro International Airport",
    "city": "Manta"
  },
  {
    "iata": "PVO",
    "name": "Reales Tamarindos Airport",
    "city": "Portoviejo"
  },
  {
    "iata": "UIO",
    "name": "Mariscal Sucre International Airport",
    "city": "Quito"
  },
  {
    "iata": "ETR",
    "name": "Santa Rosa - Artillery Colonel Victor Larrea International Airport",
    "city": "Santa Rosa"
  },
  {
    "iata": "SNC",
    "name": "General Ulpiano Paez Airport",
    "city": "Salinas"
  },
  {
    "iata": "ESM",
    "name": "Carlos Concha Torres International Airport",
    "city": "Tachina"
  },
  {
    "iata": "TPC",
    "name": "Tarapoa Airport",
    "city": "Tarapoa"
  },
  {
    "iata": "TUA",
    "name": "Lieutenant Colonel Luis A. Mantilla International Airport",
    "city": "Tulcán"
  },
  {
    "iata": "PSY",
    "name": "Port Stanley Airport",
    "city": "Stanley"
  },
  {
    "iata": "ASU",
    "name": "Silvio Pettirossi International Airport",
    "city": "Asunción"
  },
  {
    "iata": "AYO",
    "name": "Juan de Ayolas National Airport",
    "city": "Ayolas"
  },
  {
    "iata": "CIO",
    "name": "Lieutenant Colonel Carmelo Peralta National Airport",
    "city": "Concepción"
  },
  {
    "iata": "ENO",
    "name": "Lieutenant Amin Ayub González International Airport",
    "city": "Encarnación"
  },
  {
    "iata": "AGT",
    "name": "Guaraní International Airport",
    "city": "Ciudad del Este"
  },
  {
    "iata": "ESG",
    "name": "Doctor Luis Maria Argaña International Airport",
    "city": "Mariscal Estigarribia"
  },
  {
    "iata": "PIL",
    "name": "Aeródromo Don Carlos Miguel Gimenez",
    "city": "Pilar"
  },
  {
    "iata": "PJC",
    "name": "Dr. Augusto Roberto Fuster Airport",
    "city": "Pedro Juan Caballero"
  },
  {
    "iata": "API",
    "name": "Gomez Nino Apiay Air Base",
    "city": "Apiay"
  },
  {
    "iata": "AXM",
    "name": "El Eden Airport",
    "city": "Armenia"
  },
  {
    "iata": "PUU",
    "name": "Tres De Mayo Airport",
    "city": "Puerto Asís"
  },
  {
    "iata": "ELB",
    "name": "Las Flores Airport",
    "city": "El Banco"
  },
  {
    "iata": "BGA",
    "name": "Palonegro Airport",
    "city": "Bucaramanga"
  },
  {
    "iata": "BOG",
    "name": "El Dorado International Airport",
    "city": "Bogota"
  },
  {
    "iata": "BAQ",
    "name": "Ernesto Cortissoz International Airport",
    "city": "Barranquilla"
  },
  {
    "iata": "BSC",
    "name": "José Celestino Mutis Airport",
    "city": "Bahía Solano"
  },
  {
    "iata": "BUN",
    "name": "Gerardo Tobar López Airport",
    "city": "Buenaventura"
  },
  {
    "iata": "CUC",
    "name": "Camilo Daza International Airport",
    "city": "Cúcuta"
  },
  {
    "iata": "CTG",
    "name": "Rafael Nuñez International Airport",
    "city": "Cartagena"
  },
  {
    "iata": "CLO",
    "name": "Alfonso Bonilla Aragon International Airport",
    "city": "Cali"
  },
  {
    "iata": "TCO",
    "name": "La Florida Airport",
    "city": "Tumaco"
  },
  {
    "iata": "CAQ",
    "name": "Juan H White Airport",
    "city": "Caucasia"
  },
  {
    "iata": "CVE",
    "name": "Coveñas Airport",
    "city": "Coveñas"
  },
  {
    "iata": "CZU",
    "name": "Las Brujas Airport",
    "city": "Corozal"
  },
  {
    "iata": "EBG",
    "name": "El Bagre Airport",
    "city": "El Bagre"
  },
  {
    "iata": "EJA",
    "name": "Yariguíes Airport",
    "city": "Barrancabermeja"
  },
  {
    "iata": "FLA",
    "name": "Gustavo Artunduaga Paredes Airport",
    "city": "Florencia"
  },
  {
    "iata": "GIR",
    "name": "Santiago Vila Airport",
    "city": "Girardot"
  },
  {
    "iata": "CRC",
    "name": "Santa Ana Airport",
    "city": "Cartago"
  },
  {
    "iata": "GPI",
    "name": "Juan Casiano Airport",
    "city": "Guapi"
  },
  {
    "iata": "IBE",
    "name": "Perales Airport",
    "city": "Ibagué"
  },
  {
    "iata": "IPI",
    "name": "San Luis Airport",
    "city": "Ipiales"
  },
  {
    "iata": "APO",
    "name": "Antonio Roldán Betancur Airport",
    "city": "Carepa"
  },
  {
    "iata": "MCJ",
    "name": "Jorge Isaac Airport",
    "city": "La Mina-Maicao"
  },
  {
    "iata": "LET",
    "name": "Alfredo Vásquez Cobo International Airport",
    "city": "Leticia"
  },
  {
    "iata": "EOH",
    "name": "Enrique Olaya Herrera Airport",
    "city": "Medellín"
  },
  {
    "iata": "MGN",
    "name": "Baracoa Airport",
    "city": "Magangué"
  },
  {
    "iata": "MTR",
    "name": "Los Garzones Airport",
    "city": "Montería"
  },
  {
    "iata": "MVP",
    "name": "Fabio Alberto Leon Bentley Airport",
    "city": "Mitú"
  },
  {
    "iata": "MZL",
    "name": "La Nubia Airport",
    "city": "Manizales"
  },
  {
    "iata": "NVA",
    "name": "Benito Salas Airport",
    "city": "Neiva"
  },
  {
    "iata": "OCV",
    "name": "Aguas Claras Airport",
    "city": "Ocaña"
  },
  {
    "iata": "PCR",
    "name": "German Olano Airport",
    "city": "Puerto Carreño"
  },
  {
    "iata": "PDA",
    "name": "Obando Cesar Gaviria Trujillo Airport",
    "city": "Puerto Inírida"
  },
  {
    "iata": "PEI",
    "name": "Matecaña International Airport",
    "city": "Pereira"
  },
  {
    "iata": "PTX",
    "name": "Pitalito Airport",
    "city": "Pitalito"
  },
  {
    "iata": "PPN",
    "name": "Guillermo León Valencia Airport",
    "city": "Popayán"
  },
  {
    "iata": "PAL",
    "name": "German Olano Air Base",
    "city": "La Dorada"
  },
  {
    "iata": "PSO",
    "name": "Antonio Nariño Airport",
    "city": "Chachagüí"
  },
  {
    "iata": "PVA",
    "name": "El Embrujo Airport",
    "city": "Providencia"
  },
  {
    "iata": "PZA",
    "name": "Paz De Ariporo Airport",
    "city": "Paz De Ariporo"
  },
  {
    "iata": "MQU",
    "name": "Mariquita Airport",
    "city": "Mariquita"
  },
  {
    "iata": "MDE",
    "name": "Jose Maria Córdova International Airport",
    "city": "Medellín"
  },
  {
    "iata": "RCH",
    "name": "Almirante Padilla Airport",
    "city": "Riohacha"
  },
  {
    "iata": "SJE",
    "name": "Jorge E. Gonzalez Torres Airport",
    "city": "San José Del Guaviare"
  },
  {
    "iata": "SMR",
    "name": "Simón Bolívar International Airport",
    "city": "Santa Marta"
  },
  {
    "iata": "ADZ",
    "name": "Gustavo Rojas Pinilla International Airport",
    "city": "San Andrés"
  },
  {
    "iata": "SVI",
    "name": "Eduardo Falla Solano Airport",
    "city": "San Vicente Del Caguán"
  },
  {
    "iata": "TME",
    "name": "Gustavo Vargas Airport",
    "city": "Tame"
  },
  {
    "iata": "TQS",
    "name": "Captain Ernesto Esguerra Cubides Air Base",
    "city": "Tres Esquinas"
  },
  {
    "iata": "AUC",
    "name": "Santiago Perez Airport",
    "city": "Arauca"
  },
  {
    "iata": "UIB",
    "name": "El Caraño Airport",
    "city": "Quibdó"
  },
  {
    "iata": "ULQ",
    "name": "Heriberto Gíl Martínez Airport",
    "city": "Tuluá"
  },
  {
    "iata": "VUP",
    "name": "Alfonso López Pumarejo Airport",
    "city": "Valledupar"
  },
  {
    "iata": "VVC",
    "name": "Vanguardia Airport",
    "city": "Villavicencio"
  },
  {
    "iata": "EYP",
    "name": "El Alcaravan - Yopal Airport",
    "city": "Yopal"
  },
  {
    "iata": "BJO",
    "name": "Bermejo Airport",
    "city": "Bermejo"
  },
  {
    "iata": "CBB",
    "name": "Jorge Wilsterman International Airport",
    "city": "Cochabamba"
  },
  {
    "iata": "CIJ",
    "name": "Capitán Aníbal Arab Airport",
    "city": "Cobija"
  },
  {
    "iata": "SRZ",
    "name": "El Trompillo Airport",
    "city": "Santa Cruz"
  },
  {
    "iata": "LPB",
    "name": "El Alto International Airport",
    "city": "La Paz / El Alto"
  },
  {
    "iata": "ORU",
    "name": "Juan Mendoza Airport",
    "city": "Oruro"
  },
  {
    "iata": "POI",
    "name": "Capitan Nicolas Rojas Airport",
    "city": "Potosí"
  },
  {
    "iata": "PSZ",
    "name": "Capitán Av. Salvador Ogaya G. airport",
    "city": "Puerto Suárez"
  },
  {
    "iata": "RIB",
    "name": "Capitán Av. Selin Zeitun Lopez Airport",
    "city": "Riberalta"
  },
  {
    "iata": "SBL",
    "name": "Santa Ana Del Yacuma Airport",
    "city": "Santa Ana del Yacuma"
  },
  {
    "iata": "TJA",
    "name": "Capitan Oriel Lea Plaza Airport",
    "city": "Tarija"
  },
  {
    "iata": "TDD",
    "name": "Teniente Av. Jorge Henrich Arauz Airport",
    "city": "Trinidad"
  },
  {
    "iata": "VLM",
    "name": "Teniente Coronel Rafael Pabón Airport",
    "city": "Villamontes"
  },
  {
    "iata": "VVI",
    "name": "Viru Viru International Airport",
    "city": "Santa Cruz"
  },
  {
    "iata": "BYC",
    "name": "Yacuiba Airport",
    "city": "Yacuíba"
  },
  {
    "iata": "PBM",
    "name": "Johan Adolf Pengel International Airport",
    "city": "Zandery"
  },
  {
    "iata": "EEA",
    "name": "Planalto Serrano Regional Airport",
    "city": "Correia Pinto"
  },
  {
    "iata": "CAY",
    "name": "Cayenne – Félix Eboué Airport",
    "city": "Matoury"
  },
  {
    "iata": "OYP",
    "name": "Saint-Georges-de-l'Oyapock Airport",
    "city": "Saint-Georges-de-l'Oyapock"
  },
  {
    "iata": "AYX",
    "name": "Teniente General Gerardo Pérez Pinedo Airport",
    "city": "Atalaya"
  },
  {
    "iata": "IBP",
    "name": "Iberia Airport",
    "city": "Iberia"
  },
  {
    "iata": "PCL",
    "name": "Cap FAP David Abenzur Rengifo International Airport",
    "city": "Pucallpa"
  },
  {
    "iata": "CHM",
    "name": "FAP Lieutenant Jaime Andres de Montreuil Morales Airport",
    "city": "Chimbote"
  },
  {
    "iata": "CIX",
    "name": "Air Force Captain Jose A Quinones Gonzales International Airport",
    "city": "Chiclayo"
  },
  {
    "iata": "AYP",
    "name": "Air Force Colonel Alfredo Mendivil Duarte Airport",
    "city": "Ayacucho"
  },
  {
    "iata": "ATA",
    "name": "Comandante FAP German Arias Graziani Airport",
    "city": "Anta"
  },
  {
    "iata": "LIM",
    "name": "Jorge Chávez International Airport",
    "city": "Lima"
  },
  {
    "iata": "RIJ",
    "name": "Juan Simons Vela Airport",
    "city": "Rioja"
  },
  {
    "iata": "JAE",
    "name": "Shumba Airport",
    "city": "Jaén"
  },
  {
    "iata": "JJI",
    "name": "Juanjui Airport",
    "city": "Juanjuí"
  },
  {
    "iata": "JAU",
    "name": "Francisco Carle Airport",
    "city": "Jauja"
  },
  {
    "iata": "JUL",
    "name": "Inca Manco Capac International Airport",
    "city": "Juliaca"
  },
  {
    "iata": "CJA",
    "name": "Mayor General FAP Armando Revoredo Iglesias Airport",
    "city": "Cajamarca"
  },
  {
    "iata": "ILQ",
    "name": "General Jorge Fernandez Maldon Airport",
    "city": "Ilo"
  },
  {
    "iata": "TBP",
    "name": "Captain Pedro Canga Rodríguez International Airport",
    "city": "Tumbes"
  },
  {
    "iata": "YMS",
    "name": "Moises Benzaquen Rengifo Airport",
    "city": "Yurimaguas"
  },
  {
    "iata": "HUU",
    "name": "Alferez Fap David Figueroa Fernandini Airport",
    "city": "Huánuco"
  },
  {
    "iata": "CHH",
    "name": "Chachapoyas Airport",
    "city": "Chachapoyas"
  },
  {
    "iata": "IQT",
    "name": "Coronel FAP Francisco Secada Vignetta International Airport",
    "city": "Iquitos"
  },
  {
    "iata": "AQP",
    "name": "Rodríguez Ballón International Airport",
    "city": "Arequipa"
  },
  {
    "iata": "TRU",
    "name": "Capitan FAP Carlos Martinez De Pinillos International Airport",
    "city": "Trujillo"
  },
  {
    "iata": "PIO",
    "name": "Captain Renán Elías Olivera International Airport",
    "city": "Pisco"
  },
  {
    "iata": "TPP",
    "name": "Cadete FAP Guillermo Del Castillo Paredes Airport",
    "city": "Tarapoto"
  },
  {
    "iata": "TCQ",
    "name": "Coronel FAP Carlos Ciriani Santa Rosa International Airport",
    "city": "Tacna"
  },
  {
    "iata": "PEM",
    "name": "Padre Aldamiz International Airport",
    "city": "Puerto Maldonado"
  },
  {
    "iata": "PIU",
    "name": "Capitán FAP Guillermo Concha Iberico International Airport",
    "city": "Piura"
  },
  {
    "iata": "TYL",
    "name": "Captain Victor Montes Arias International Airport",
    "city": "Talara"
  },
  {
    "iata": "NZC",
    "name": "Maria Reiche Neuman Airport",
    "city": "Nazca"
  },
  {
    "iata": "CUZ",
    "name": "Alejandro Velasco Astete International Airport",
    "city": "Cusco"
  },
  {
    "iata": "DZO",
    "name": "Santa Bernardina International Airport",
    "city": "Durazno"
  },
  {
    "iata": "PDP",
    "name": "Capitan Corbeta CA Curbelo International Airport",
    "city": "Punta del Este"
  },
  {
    "iata": "MVD",
    "name": "Carrasco General Cesáreo L. Berisso International Airport",
    "city": "Ciudad de la Costa"
  },
  {
    "iata": "STY",
    "name": "Nueva Hesperides International Airport",
    "city": "Salto"
  },
  {
    "iata": "AGV",
    "name": "Oswaldo Guevara Mujica Airport",
    "city": "Acarigua"
  },
  {
    "iata": "AAO",
    "name": "Anaco Airport",
    "city": "Anaco"
  },
  {
    "iata": "BLA",
    "name": "General José Antonio Anzoategui International Airport",
    "city": "Barcelona"
  },
  {
    "iata": "BNS",
    "name": "Barinas Airport",
    "city": "Barinas"
  },
  {
    "iata": "BRM",
    "name": "Barquisimeto International Airport",
    "city": "Barquisimeto"
  },
  {
    "iata": "MYC",
    "name": "Escuela Mariscal Sucre Airport",
    "city": "Maracay"
  },
  {
    "iata": "CBL",
    "name": "General Tomas de Heres Airport",
    "city": "Ciudad Bolivar"
  },
  {
    "iata": "CLZ",
    "name": "Calabozo Airport",
    "city": "Guarico"
  },
  {
    "iata": "CAJ",
    "name": "Canaima Airport",
    "city": "Canaima"
  },
  {
    "iata": "CUP",
    "name": "General Francisco Bermúdez Airport",
    "city": "Carúpano"
  },
  {
    "iata": "CZE",
    "name": "José Leonardo Chirinos Airport",
    "city": "Coro"
  },
  {
    "iata": "EOR",
    "name": "El Dorado Airport",
    "city": "Bolivar"
  },
  {
    "iata": "GDO",
    "name": "Guasdualito Airport",
    "city": "Guasdualito"
  },
  {
    "iata": "GUQ",
    "name": "Guanare Airport",
    "city": "Guanare"
  },
  {
    "iata": "LSP",
    "name": "Josefa Camejo International Airport",
    "city": "Paraguaná"
  },
  {
    "iata": "MAR",
    "name": "La Chinita International Airport",
    "city": "Maracaibo"
  },
  {
    "iata": "MRD",
    "name": "Alberto Carnevalli Airport",
    "city": "Mérida"
  },
  {
    "iata": "PMV",
    "name": "Del Caribe Santiago Mariño International Airport",
    "city": "Isla Margarita"
  },
  {
    "iata": "CCS",
    "name": "Maiquetía Simón Bolívar International Airport",
    "city": "Maiquetía"
  },
  {
    "iata": "MUN",
    "name": "Maturín Airport",
    "city": "Maturín"
  },
  {
    "iata": "PYH",
    "name": "Cacique Aramare Airport",
    "city": "Puerto Ayacucho"
  },
  {
    "iata": "PZO",
    "name": "General Manuel Carlos Piar International Airport",
    "city": "Puerto Ordaz-Ciudad Guayana"
  },
  {
    "iata": "PTM",
    "name": "Palmarito Airport",
    "city": "Palmarito"
  },
  {
    "iata": "STD",
    "name": "Mayor Buenaventura Vivas International Airport",
    "city": "Santo Domingo"
  },
  {
    "iata": "SNF",
    "name": "Sub Teniente Nestor Arias Airport",
    "city": "San Felipe"
  },
  {
    "iata": "SFD",
    "name": "San Fernando de Apure Las Flecheras National Airport",
    "city": "San Fernando de Apure"
  },
  {
    "iata": "SOM",
    "name": "San Tomé Airport",
    "city": "El Tigre"
  },
  {
    "iata": "STB",
    "name": "Miguel Urdaneta Fernández Airport",
    "city": "San Carlos del Zulia"
  },
  {
    "iata": "TUV",
    "name": "Tucupita Airport",
    "city": "Tucupita"
  },
  {
    "iata": "VLN",
    "name": "Arturo Michelena International Airport",
    "city": "Valencia"
  },
  {
    "iata": "VIG",
    "name": "Juan Pablo Pérez Alfonso Airport",
    "city": "El Vigía"
  },
  {
    "iata": "VLV",
    "name": "Dr. Antonio Nicolás Briceño Airport",
    "city": "Valera"
  },
  {
    "iata": "AUX",
    "name": "Araguaína Airport",
    "city": "Araguaína"
  },
  {
    "iata": "GEO",
    "name": "Cheddi Jagan International Airport",
    "city": "Georgetown"
  },
  {
    "iata": "KAI",
    "name": "Kaieteur International Airport",
    "city": "Kaieteur Falls"
  },
  {
    "iata": "LTM",
    "name": "Lethem Airport",
    "city": "Lethem"
  },
  {
    "iata": "ANU",
    "name": "V C Bird International Airport",
    "city": "Osbourn"
  },
  {
    "iata": "BBQ",
    "name": "Codrington Airport",
    "city": "Codrington"
  },
  {
    "iata": "BGI",
    "name": "Grantley Adams International Airport",
    "city": "Bridgetown"
  },
  {
    "iata": "DCF",
    "name": "Canefield Airport",
    "city": "Canefield"
  },
  {
    "iata": "DOM",
    "name": "Douglas-Charles Airport",
    "city": "Marigot"
  },
  {
    "iata": "FDF",
    "name": "Martinique Aimé Césaire International Airport",
    "city": "Fort-de-France"
  },
  {
    "iata": "SFG",
    "name": "Grand Case-l'Espérance Airport",
    "city": "Grand Case"
  },
  {
    "iata": "SBH",
    "name": "Saint Barthélemy - Gustaf III Airport",
    "city": "Gustavia"
  },
  {
    "iata": "GBJ",
    "name": "Marie-Galante Airport",
    "city": "Grand-Bourg"
  },
  {
    "iata": "PTP",
    "name": "Guadeloupe - Maryse Condé International Airport",
    "city": "Pointe-à-Pitre"
  },
  {
    "iata": "GND",
    "name": "Maurice Bishop International Airport",
    "city": "Saint George's"
  },
  {
    "iata": "STT",
    "name": "Cyril E. King Airport",
    "city": "Charlotte Amalie"
  },
  {
    "iata": "STX",
    "name": "Henry E Rohlsen Airport",
    "city": "Christiansted"
  },
  {
    "iata": "ARE",
    "name": "Antonio Nery Juarbe Pol Airport",
    "city": "Arecibo"
  },
  {
    "iata": "BQN",
    "name": "Rafael Hernández International Airport",
    "city": "Aguadilla"
  },
  {
    "iata": "CPX",
    "name": "Benjamin Rivera Noriega Airport",
    "city": "Culebra"
  },
  {
    "iata": "SIG",
    "name": "Fernando Luis Ribas Dominicci Airport",
    "city": "San Juan"
  },
  {
    "iata": "MAZ",
    "name": "Eugenio Maria De Hostos Airport",
    "city": "Mayaguez"
  },
  {
    "iata": "PSE",
    "name": "Mercedita Airport",
    "city": "Ponce"
  },
  {
    "iata": "NRR",
    "name": "José Aponte de la Torre Airport",
    "city": "Ceiba"
  },
  {
    "iata": "SJU",
    "name": "Luis Munoz Marin International Airport",
    "city": "San Juan"
  },
  {
    "iata": "VQS",
    "name": "Antonio Rivera Rodriguez Airport",
    "city": "Vieques"
  },
  {
    "iata": "SKB",
    "name": "Robert L. Bradshaw International Airport",
    "city": "Basseterre"
  },
  {
    "iata": "NEV",
    "name": "Vance W. Amory International Airport",
    "city": "Charlestown"
  },
  {
    "iata": "SLU",
    "name": "George F. L. Charles Airport",
    "city": "Castries"
  },
  {
    "iata": "UVF",
    "name": "Hewanorra International Airport",
    "city": "Vieux Fort"
  },
  {
    "iata": "AUA",
    "name": "Queen Beatrix International Airport",
    "city": "Oranjestad"
  },
  {
    "iata": "BON",
    "name": "Flamingo International Airport",
    "city": "Kralendijk"
  },
  {
    "iata": "CUR",
    "name": "Hato International Airport",
    "city": "Willemstad"
  },
  {
    "iata": "EUX",
    "name": "F. D. Roosevelt Airport",
    "city": "Oranjestad"
  },
  {
    "iata": "SXM",
    "name": "Princess Juliana International Airport",
    "city": "Sint Maarten"
  },
  {
    "iata": "SAB",
    "name": "Juancho E. Yrausquin Airport",
    "city": "Zion's Hill"
  },
  {
    "iata": "AXA",
    "name": "Clayton J Lloyd International Airport",
    "city": "The Valley"
  },
  {
    "iata": "MNI",
    "name": "John A. Osborne Airport",
    "city": "Gerald's Park"
  },
  {
    "iata": "TAB",
    "name": "A.N.R. Robinson International Airport",
    "city": "Scarborough"
  },
  {
    "iata": "POS",
    "name": "Piarco International Airport",
    "city": "Port of Spain"
  },
  {
    "iata": "EIS",
    "name": "Terrance B. Lettsome International Airport",
    "city": "Beef Island"
  },
  {
    "iata": "SVD",
    "name": "Argyle International Airport",
    "city": "Kingstown"
  },
  {
    "iata": "BQU",
    "name": "J F Mitchell Airport",
    "city": "Bequia"
  },
  {
    "iata": "CIW",
    "name": "Canouan Airport",
    "city": "Canouan"
  },
  {
    "iata": "MQS",
    "name": "Mustique Airport",
    "city": "Lovell"
  },
  {
    "iata": "UNI",
    "name": "Union Island International Airport",
    "city": "Union Island"
  },
  {
    "iata": "BDA",
    "name": "L.F. Wade International Airport",
    "city": "Hamilton"
  },
  {
    "iata": "ALA",
    "name": "Almaty International Airport",
    "city": "Almaty"
  },
  {
    "iata": "BXH",
    "name": "Balkhash Airport",
    "city": "Balkhash"
  },
  {
    "iata": "NQZ",
    "name": "Nursultan Nazarbayev International Airport",
    "city": "Astana"
  },
  {
    "iata": "KOV",
    "name": "Kokshetau Airport",
    "city": "Kokshetau"
  },
  {
    "iata": "PPK",
    "name": "Petropavl Airport",
    "city": "Petropavl"
  },
  {
    "iata": "DMB",
    "name": "Taraz Airport",
    "city": "Taraz"
  },
  {
    "iata": "CIT",
    "name": "Shymkent Airport",
    "city": "Shymkent"
  },
  {
    "iata": "HSA",
    "name": "Hazrat Sultan International Airport",
    "city": "Turkıstan"
  },
  {
    "iata": "DZN",
    "name": "Zhezkazgan National Airport",
    "city": "Zhezkazgan"
  },
  {
    "iata": "KGF",
    "name": "Sary-Arka Airport",
    "city": "Karaganda"
  },
  {
    "iata": "BXY",
    "name": "Baikonur Krayniy Airport",
    "city": "Baikonur"
  },
  {
    "iata": "URA",
    "name": "Uralsk Airport",
    "city": "Uralsk"
  },
  {
    "iata": "EKB",
    "name": "Ekibastuz Airport",
    "city": "Ekibastuz"
  },
  {
    "iata": "UKK",
    "name": "Ust-Kamenogorsk Airport",
    "city": "Ust-Kamenogorsk (Oskemen)"
  },
  {
    "iata": "PWQ",
    "name": "Pavlodar Airport",
    "city": "Pavlodar"
  },
  {
    "iata": "PLX",
    "name": "Semey Airport",
    "city": "Semey"
  },
  {
    "iata": "SCO",
    "name": "Aktau Airport",
    "city": "Aktau"
  },
  {
    "iata": "GUW",
    "name": "Atyrau International Airport",
    "city": "Atyrau"
  },
  {
    "iata": "AKX",
    "name": "Aktobe Airport",
    "city": "Aktobe"
  },
  {
    "iata": "KSN",
    "name": "Kostanay West Airport",
    "city": "Kostanay"
  },
  {
    "iata": "GYD",
    "name": "Heydar Aliyev International Airport",
    "city": "Baku"
  },
  {
    "iata": "GNJ",
    "name": "Ganja International Airport",
    "city": "Ganja"
  },
  {
    "iata": "NAJ",
    "name": "Nakhchivan Airport",
    "city": "Nakhchivan"
  },
  {
    "iata": "GBB",
    "name": "Gabala International Airport",
    "city": "Gabala"
  },
  {
    "iata": "ZTU",
    "name": "Zaqatala International Airport",
    "city": "Zaqatala"
  },
  {
    "iata": "IKU",
    "name": "Issyk-Kul International Airport",
    "city": "Tamchy"
  },
  {
    "iata": "LWN",
    "name": "Shirak International Airport",
    "city": "Gyumri"
  },
  {
    "iata": "EVN",
    "name": "Zvartnots International Airport",
    "city": "Yerevan"
  },
  {
    "iata": "YKS",
    "name": "Yakutsk Airport",
    "city": "Yakutsk"
  },
  {
    "iata": "NER",
    "name": "Chulman Airport",
    "city": "Neryungri"
  },
  {
    "iata": "MQJ",
    "name": "Moma Airport",
    "city": "Khonuu"
  },
  {
    "iata": "GYG",
    "name": "Magan Airport",
    "city": "Magan"
  },
  {
    "iata": "OLZ",
    "name": "Olyokminsk Airport",
    "city": "Olyokminsk"
  },
  {
    "iata": "USR",
    "name": "Ust-Nera Airport",
    "city": "Ust-Nera"
  },
  {
    "iata": "VYI",
    "name": "Vilyuisk Airport",
    "city": "Vilyuisk"
  },
  {
    "iata": "ULK",
    "name": "Lensk Airport",
    "city": "Lensk"
  },
  {
    "iata": "PYJ",
    "name": "Polyarny Airport",
    "city": "Yakutia"
  },
  {
    "iata": "MJZ",
    "name": "Mirny Airport",
    "city": "Mirny"
  },
  {
    "iata": "BGN",
    "name": "Belaya Gora Airport",
    "city": "Belaya Gora"
  },
  {
    "iata": "SEK",
    "name": "Srednekolymsk Airport",
    "city": "Srednekolymsk"
  },
  {
    "iata": "CKH",
    "name": "Chokurdakh Airport",
    "city": "Chokurdah"
  },
  {
    "iata": "CYX",
    "name": "Cherskiy Airport",
    "city": "Cherskiy"
  },
  {
    "iata": "IKS",
    "name": "Tiksi Airport",
    "city": "Tiksi"
  },
  {
    "iata": "ZKP",
    "name": "Zyryanka Airport",
    "city": "Zyryanka"
  },
  {
    "iata": "ZIX",
    "name": "Zhigansk Airport",
    "city": "Zhigansk"
  },
  {
    "iata": "KUT",
    "name": "David the Builder Kutaisi International Airport",
    "city": "Kopitnari"
  },
  {
    "iata": "BUS",
    "name": "Batumi International Airport",
    "city": "Batumi"
  },
  {
    "iata": "SUI",
    "name": "Sukhumi Babushara /  Vladislav Ardzinba International Airport",
    "city": "Sukhumi"
  },
  {
    "iata": "TBS",
    "name": "Tbilisi International Airport",
    "city": "Tbilisi"
  },
  {
    "iata": "BQS",
    "name": "Ignatyevo Airport",
    "city": "Blagoveschensk"
  },
  {
    "iata": "KHV",
    "name": "Khabarovsk Novy Airport",
    "city": "Khabarovsk"
  },
  {
    "iata": "KXK",
    "name": "Komsomolsk-on-Amur Airport",
    "city": "Komsomolsk-on-Amur"
  },
  {
    "iata": "GVN",
    "name": "Sovetskaya Gavan (Maygatka) Airport",
    "city": "Sovetskaya Gavan"
  },
  {
    "iata": "DYR",
    "name": "Ugolny Yuri Ryktheu Airport",
    "city": "Anadyr"
  },
  {
    "iata": "PVS",
    "name": "Provideniya Bay Airport",
    "city": "Chukotka"
  },
  {
    "iata": "KPW",
    "name": "Keperveem Airport",
    "city": "Keperveem"
  },
  {
    "iata": "GDX",
    "name": "Sokol Airport",
    "city": "Magadan"
  },
  {
    "iata": "PWE",
    "name": "Pevek Airport",
    "city": "Apapelgino"
  },
  {
    "iata": "SWV",
    "name": "Severo-Evensk Airport",
    "city": "Evensk"
  },
  {
    "iata": "NLI",
    "name": "Nikolayevsk-na-Amure Airport",
    "city": "Nikolayevsk-na-Amure Airport"
  },
  {
    "iata": "OHO",
    "name": "Okhotsk Airport",
    "city": "Okhotsk"
  },
  {
    "iata": "PKC",
    "name": "Yelizovo Airport",
    "city": "Petropavlovsk-Kamchatsky"
  },
  {
    "iata": "UUS",
    "name": "Yuzhno-Sakhalinsk Airport",
    "city": "Yuzhno-Sakhalinsk"
  },
  {
    "iata": "VVO",
    "name": "Vladivostok International Airport",
    "city": "Artyom"
  },
  {
    "iata": "HTA",
    "name": "Chita-Kadala International Airport",
    "city": "Chita"
  },
  {
    "iata": "BTK",
    "name": "Bratsk Airport",
    "city": "Bratsk"
  },
  {
    "iata": "IKT",
    "name": "Irkutsk International Airport",
    "city": "Irkutsk"
  },
  {
    "iata": "UKX",
    "name": "Ust-Kut Airport",
    "city": "Ust-Kut"
  },
  {
    "iata": "UUD",
    "name": "Baikal International Airport",
    "city": "Ulan Ude"
  },
  {
    "iata": "KBP",
    "name": "Boryspil International Airport",
    "city": "Boryspil"
  },
  {
    "iata": "MPW",
    "name": "Mariupol International Airport",
    "city": "Mariupol"
  },
  {
    "iata": "ERD",
    "name": "Berdyansk Airport",
    "city": "Berdyansk"
  },
  {
    "iata": "DNK",
    "name": "Dnipro International Airport",
    "city": "Dnipro"
  },
  {
    "iata": "OZH",
    "name": "Zaporizhzhia International Airport",
    "city": "Zaporizhia"
  },
  {
    "iata": "KWG",
    "name": "Kryvyi Rih International Airport",
    "city": "Kryvyi Rih"
  },
  {
    "iata": "UKS",
    "name": "Sevastopol International Airport / Belbek Air Base",
    "city": "Sevastopol"
  },
  {
    "iata": "SIP",
    "name": "Simferopol International Airport",
    "city": "Simferopol"
  },
  {
    "iata": "HRK",
    "name": "Kharkiv International Airport",
    "city": "Kharkiv"
  },
  {
    "iata": "CKC",
    "name": "Cherkasy International Airport",
    "city": "Cherkasy"
  },
  {
    "iata": "IEV",
    "name": "Ihor Sikorsky Kyiv International Airport (Zhuliany)",
    "city": "Kyiv"
  },
  {
    "iata": "HMJ",
    "name": "Khmelnytskyi Airport",
    "city": "Khmelnytskyi"
  },
  {
    "iata": "IFO",
    "name": "Ivano-Frankivsk International Airport",
    "city": "Ivano-Frankivsk"
  },
  {
    "iata": "LWO",
    "name": "Lviv International Airport",
    "city": "Lviv"
  },
  {
    "iata": "CWC",
    "name": "Chernivtsi International Airport",
    "city": "Chernivtsi"
  },
  {
    "iata": "RWN",
    "name": "Rivne International Airport",
    "city": "Rivne"
  },
  {
    "iata": "UDJ",
    "name": "Uzhhorod International Airport",
    "city": "Uzhhorod"
  },
  {
    "iata": "KHE",
    "name": "Kherson International Airport",
    "city": "Kherson"
  },
  {
    "iata": "NLV",
    "name": "Mykolaiv International Airport",
    "city": "Nikolayev"
  },
  {
    "iata": "ODS",
    "name": "Odessa International Airport",
    "city": "Odessa"
  },
  {
    "iata": "VIN",
    "name": "Vinnytsia/Gavyryshivka International Airport",
    "city": "Vinnitsa"
  },
  {
    "iata": "ARH",
    "name": "Talagi Airport",
    "city": "Archangelsk"
  },
  {
    "iata": "NNM",
    "name": "Naryan Mar Airport",
    "city": "Naryan Mar"
  },
  {
    "iata": "AMV",
    "name": "Amderma Airport",
    "city": "Amderma"
  },
  {
    "iata": "KSZ",
    "name": "Kotlas Airport",
    "city": "Kotlas"
  },
  {
    "iata": "LED",
    "name": "Pulkovo Airport",
    "city": "St. Petersburg"
  },
  {
    "iata": "MMK",
    "name": "Murmansk Airport",
    "city": "Murmansk"
  },
  {
    "iata": "PKV",
    "name": "Pskov Airport",
    "city": "Pskov"
  },
  {
    "iata": "PES",
    "name": "Petrozavodsk Airport",
    "city": "Petrozavodsk"
  },
  {
    "iata": "CEE",
    "name": "Cherepovets Airport",
    "city": "Cherepovets"
  },
  {
    "iata": "VUS",
    "name": "Velikiy Ustyug Airport",
    "city": "Velikiy Ustyug"
  },
  {
    "iata": "VGD",
    "name": "Vologda Airport",
    "city": "Vologda"
  },
  {
    "iata": "BQT",
    "name": "Brest Airport",
    "city": "Brest"
  },
  {
    "iata": "GME",
    "name": "Gomel Airport",
    "city": "Gomel"
  },
  {
    "iata": "VTB",
    "name": "Vitebsk Vostochny Airport",
    "city": "Vitebsk"
  },
  {
    "iata": "KGD",
    "name": "Khrabrovo Airport",
    "city": "Kaliningrad"
  },
  {
    "iata": "GNA",
    "name": "Hrodna Airport",
    "city": "Hrodna"
  },
  {
    "iata": "MSQ",
    "name": "Minsk National Airport",
    "city": "Minsk"
  },
  {
    "iata": "MVQ",
    "name": "Mogilev Airport",
    "city": "Mogilev"
  },
  {
    "iata": "ABA",
    "name": "Abakan International Airport",
    "city": "Abakan"
  },
  {
    "iata": "BAX",
    "name": "Barnaul Airport",
    "city": "Barnaul"
  },
  {
    "iata": "RGK",
    "name": "Gorno-Altaysk Airport",
    "city": "Gorno-Altaysk"
  },
  {
    "iata": "KEJ",
    "name": "Kemerovo Airport",
    "city": "Kemerovo"
  },
  {
    "iata": "EIE",
    "name": "Yeniseysk Airport",
    "city": "Yeniseysk"
  },
  {
    "iata": "TGP",
    "name": "Podkamennaya Tunguska Airport",
    "city": "Bor"
  },
  {
    "iata": "KJA",
    "name": "Krasnoyarsk International Airport",
    "city": "Krasnoyarsk"
  },
  {
    "iata": "ACS",
    "name": "Achinsk Airport",
    "city": "Achinsk"
  },
  {
    "iata": "KYZ",
    "name": "Kyzyl Airport",
    "city": "Kyzyl"
  },
  {
    "iata": "OVB",
    "name": "Novosibirsk Tolmachevo Airport",
    "city": "Novosibirsk"
  },
  {
    "iata": "OMS",
    "name": "Omsk Central Airport",
    "city": "Omsk"
  },
  {
    "iata": "SWT",
    "name": "Strezhevoy Airport",
    "city": "Strezhevoy"
  },
  {
    "iata": "TOF",
    "name": "Bogashevo Airport",
    "city": "Tomsk"
  },
  {
    "iata": "NOZ",
    "name": "Spichenkovo Airport",
    "city": "Novokuznetsk"
  },
  {
    "iata": "DKS",
    "name": "Dikson Airport",
    "city": "Dikson"
  },
  {
    "iata": "HTG",
    "name": "Khatanga Airport",
    "city": "Khatanga"
  },
  {
    "iata": "IAA",
    "name": "Igarka Airport",
    "city": "Igarka"
  },
  {
    "iata": "NSK",
    "name": "Norilsk-Alykel Airport",
    "city": "Norilsk"
  },
  {
    "iata": "AAQ",
    "name": "Anapa Vityazevo Airport",
    "city": "Krasnyi Kurgan"
  },
  {
    "iata": "GDZ",
    "name": "Gelendzhik Airport",
    "city": "Gelendzhik"
  },
  {
    "iata": "KRR",
    "name": "Krasnodar Pashkovsky International Airport",
    "city": "Krasnodar"
  },
  {
    "iata": "GRV",
    "name": "Grozny Airport",
    "city": "Grozny"
  },
  {
    "iata": "MCX",
    "name": "Makhachkala Uytash International Airport",
    "city": "Makhachkala"
  },
  {
    "iata": "MRV",
    "name": "Mineralnyye Vody Airport",
    "city": "Mineralnyye Vody"
  },
  {
    "iata": "NAL",
    "name": "Nalchik Airport",
    "city": "Nalchik"
  },
  {
    "iata": "OGZ",
    "name": "Vladikavkaz Beslan International Airport",
    "city": "Beslan"
  },
  {
    "iata": "IGT",
    "name": "Magas Airport",
    "city": "Sunzha"
  },
  {
    "iata": "STW",
    "name": "Stavropol Shpakovskoye Airport",
    "city": "Stavropol"
  },
  {
    "iata": "ROV",
    "name": "Platov International Airport",
    "city": "Rostov-on-Don"
  },
  {
    "iata": "TGK",
    "name": "Taganrog Yuzhny Airport",
    "city": "Taganrog"
  },
  {
    "iata": "AER",
    "name": "Sochi International Airport",
    "city": "Sochi"
  },
  {
    "iata": "ASF",
    "name": "Astrakhan Narimanovo Boris M. Kustodiev International Airport",
    "city": "Astrakhan"
  },
  {
    "iata": "ESL",
    "name": "Elista Airport",
    "city": "Elista"
  },
  {
    "iata": "VOG",
    "name": "Volgograd International Airport",
    "city": "Volgograd"
  },
  {
    "iata": "CEK",
    "name": "Chelyabinsk Balandino Airport",
    "city": "Chelyabinsk"
  },
  {
    "iata": "MQF",
    "name": "Magnitogorsk International Airport",
    "city": "Magnitogorsk"
  },
  {
    "iata": "SBT",
    "name": "Sabetta International Airport",
    "city": "Sabetta"
  },
  {
    "iata": "BVJ",
    "name": "Bovanenkovo Airport",
    "city": "Bovanenkovo"
  },
  {
    "iata": "SLY",
    "name": "Salekhard Airport",
    "city": "Salekhard"
  },
  {
    "iata": "HMA",
    "name": "Khanty Mansiysk Airport",
    "city": "Khanty-Mansiysk"
  },
  {
    "iata": "NYA",
    "name": "Nyagan Airport",
    "city": "Nyagan"
  },
  {
    "iata": "OVS",
    "name": "Sovetskiy Airport",
    "city": "Sovetskiy"
  },
  {
    "iata": "URJ",
    "name": "Uray Airport",
    "city": "Uray"
  },
  {
    "iata": "IJK",
    "name": "Izhevsk Airport",
    "city": "Izhevsk"
  },
  {
    "iata": "KVX",
    "name": "Pobedilovo Airport",
    "city": "Kirov"
  },
  {
    "iata": "NYM",
    "name": "Nadym Airport",
    "city": "Nadym"
  },
  {
    "iata": "NUX",
    "name": "Novy Urengoy Airport",
    "city": "Novy Urengoy"
  },
  {
    "iata": "NJC",
    "name": "Nizhnevartovsk Airport",
    "city": "Nizhnevartovsk"
  },
  {
    "iata": "PEE",
    "name": "Perm International Airport",
    "city": "Perm"
  },
  {
    "iata": "KGP",
    "name": "Kogalym International Airport",
    "city": "Kogalym"
  },
  {
    "iata": "NFG",
    "name": "Nefteyugansk Airport",
    "city": "Nefteyugansk"
  },
  {
    "iata": "NOJ",
    "name": "Noyabrsk Airport",
    "city": "Noyabrsk"
  },
  {
    "iata": "SGC",
    "name": "Surgut Airport",
    "city": "Surgut"
  },
  {
    "iata": "SVX",
    "name": "Koltsovo Airport",
    "city": "Yekaterinburg"
  },
  {
    "iata": "TJM",
    "name": "Roshchino International Airport",
    "city": "Tyumen"
  },
  {
    "iata": "KRO",
    "name": "Kurgan Airport",
    "city": "Kurgan"
  },
  {
    "iata": "ASB",
    "name": "Ashgabat International Airport",
    "city": "Ashgabat"
  },
  {
    "iata": "KRW",
    "name": "Turkmenbashi International Airport",
    "city": "Turkmenbashi"
  },
  {
    "iata": "MYP",
    "name": "Mary International Airport",
    "city": "Mary"
  },
  {
    "iata": "TAZ",
    "name": "Daşoguz Airport",
    "city": "Daşoguz"
  },
  {
    "iata": "CRZ",
    "name": "Türkmenabat International Airport",
    "city": "Türkmenabat"
  },
  {
    "iata": "DYU",
    "name": "Dushanbe International Airport",
    "city": "Dushanbe"
  },
  {
    "iata": "TJU",
    "name": "Kulob Airport",
    "city": "Kulyab"
  },
  {
    "iata": "LBD",
    "name": "Khujand Airport",
    "city": "Khujand"
  },
  {
    "iata": "KQT",
    "name": "Qurghonteppa International Airport",
    "city": "Kurgan-Tyube"
  },
  {
    "iata": "NCU",
    "name": "Nukus Airport",
    "city": "Nukus"
  },
  {
    "iata": "UGC",
    "name": "Urgench Airport",
    "city": "Urgench"
  },
  {
    "iata": "NVI",
    "name": "Navoi Airport",
    "city": "Navoi"
  },
  {
    "iata": "BHK",
    "name": "Bukhara International Airport",
    "city": "Bukhara"
  },
  {
    "iata": "SKD",
    "name": "Samarkand Airport",
    "city": "Samarkand"
  },
  {
    "iata": "TMJ",
    "name": "Termez Airport",
    "city": "Termez"
  },
  {
    "iata": "TAS",
    "name": "Tashkent International Airport",
    "city": "Tashkent"
  },
  {
    "iata": "KMW",
    "name": "Kostroma Sokerkino Airport",
    "city": "Kostroma"
  },
  {
    "iata": "KLF",
    "name": "Grabtsevo Airport",
    "city": "Kaluga"
  },
  {
    "iata": "IWA",
    "name": "Ivanovo South Airport",
    "city": "Ivanovo"
  },
  {
    "iata": "RYB",
    "name": "Staroselye Airport",
    "city": "Rybinsk"
  },
  {
    "iata": "BZK",
    "name": "Bryansk Airport",
    "city": "Bryansk"
  },
  {
    "iata": "ZIA",
    "name": "Zhukovsky International Airport",
    "city": "Moscow"
  },
  {
    "iata": "DME",
    "name": "Domodedovo International Airport",
    "city": "Moscow"
  },
  {
    "iata": "SVO",
    "name": "Sheremetyevo International Airport",
    "city": "Moscow"
  },
  {
    "iata": "KLD",
    "name": "Migalovo Air Base",
    "city": "Tver"
  },
  {
    "iata": "OSF",
    "name": "Ostafyevo International Airport",
    "city": "Moscow"
  },
  {
    "iata": "CKL",
    "name": "Chkalovskiy Air Base",
    "city": "Moscow"
  },
  {
    "iata": "EGO",
    "name": "Belgorod International Airport",
    "city": "Belgorod"
  },
  {
    "iata": "URS",
    "name": "Kursk East Airport",
    "city": "Kursk"
  },
  {
    "iata": "LPK",
    "name": "Lipetsk Airport",
    "city": "Lipetsk"
  },
  {
    "iata": "VOZ",
    "name": "Voronezh International Airport",
    "city": "Voronezh"
  },
  {
    "iata": "TBW",
    "name": "Donskoye Airport",
    "city": "Tambov"
  },
  {
    "iata": "VKO",
    "name": "Vnukovo International Airport",
    "city": "Moscow"
  },
  {
    "iata": "UCT",
    "name": "Ukhta Airport",
    "city": "Ukhta"
  },
  {
    "iata": "INA",
    "name": "Inta Airport",
    "city": "Inta"
  },
  {
    "iata": "PEX",
    "name": "Pechora Airport",
    "city": "Pechora"
  },
  {
    "iata": "USK",
    "name": "Usinsk Airport",
    "city": "Usinsk"
  },
  {
    "iata": "VKT",
    "name": "Vorkuta Airport",
    "city": "Vorkuta"
  },
  {
    "iata": "UTS",
    "name": "Ust-Tsylma Airport",
    "city": "Ust-Tsylma"
  },
  {
    "iata": "SCW",
    "name": "Syktyvkar Airport",
    "city": "Syktyvkar"
  },
  {
    "iata": "GOJ",
    "name": "Nizhny Novgorod / Strigino International Airport",
    "city": "Nizhny Novgorod"
  },
  {
    "iata": "UUA",
    "name": "Bugulma Airport",
    "city": "Bugulma"
  },
  {
    "iata": "KZN",
    "name": "Kazan International Airport",
    "city": "Kazan"
  },
  {
    "iata": "NBC",
    "name": "Begishevo Airport",
    "city": "Nizhnekamsk"
  },
  {
    "iata": "JOK",
    "name": "Yoshkar-Ola Airport",
    "city": "Yoshkar-Ola"
  },
  {
    "iata": "CSY",
    "name": "Cheboksary Airport",
    "city": "Cheboksary"
  },
  {
    "iata": "ULV",
    "name": "Ulyanovsk Baratayevka Airport",
    "city": "Ulyanovsk"
  },
  {
    "iata": "ULY",
    "name": "Ulyanovsk East Airport",
    "city": "Cherdakly"
  },
  {
    "iata": "REN",
    "name": "Orenburg Central Airport",
    "city": "Orenburg"
  },
  {
    "iata": "OSW",
    "name": "Orsk Airport",
    "city": "Orsk"
  },
  {
    "iata": "PEZ",
    "name": "Penza Airport",
    "city": "Penza"
  },
  {
    "iata": "SKX",
    "name": "Saransk Airport",
    "city": "Saransk"
  },
  {
    "iata": "BWO",
    "name": "Balakovo Airport",
    "city": "Balakovo"
  },
  {
    "iata": "GSV",
    "name": "Gagarin International Airport",
    "city": "Saratov"
  },
  {
    "iata": "UFA",
    "name": "Ufa International Airport",
    "city": "Ufa"
  },
  {
    "iata": "KUF",
    "name": "Kurumoch International Airport",
    "city": "Samara"
  },
  {
    "iata": "AMD",
    "name": "Sardar Vallabh Bhai Patel International Airport",
    "city": "Ahmedabad"
  },
  {
    "iata": "AKD",
    "name": "Akola Airport",
    "city": "Akola"
  },
  {
    "iata": "IXU",
    "name": "Aurangabad Airport",
    "city": "Aurangabad"
  },
  {
    "iata": "BOM",
    "name": "Chhatrapati Shivaji International Airport",
    "city": "Mumbai"
  },
  {
    "iata": "BHJ",
    "name": "Bhuj Airport",
    "city": "Bhuj"
  },
  {
    "iata": "BDQ",
    "name": "Vadodara Airport",
    "city": "Vadodara"
  },
  {
    "iata": "BHO",
    "name": "Raja Bhoj International Airport",
    "city": "Bhopal"
  },
  {
    "iata": "BHU",
    "name": "Bhavnagar Airport",
    "city": "Bhavnagar"
  },
  {
    "iata": "NMB",
    "name": "Daman Airport",
    "city": "Daman"
  },
  {
    "iata": "HSR",
    "name": "Rajkot International Airport",
    "city": "Rajkot"
  },
  {
    "iata": "IDR",
    "name": "Devi Ahilyabai Holkar Airport",
    "city": "Indore"
  },
  {
    "iata": "JLR",
    "name": "Jabalpur Airport",
    "city": "Jabalpur"
  },
  {
    "iata": "JGA",
    "name": "Jamnagar Airport",
    "city": "Jamnagar"
  },
  {
    "iata": "IXY",
    "name": "Kandla Airport",
    "city": "Kandla"
  },
  {
    "iata": "KLH",
    "name": "Kolhapur Airport",
    "city": "Kolhapur"
  },
  {
    "iata": "IXK",
    "name": "Keshod Airport",
    "city": "Keshod"
  },
  {
    "iata": "LTU",
    "name": "Murod Kond Airport",
    "city": "Latur"
  },
  {
    "iata": "NAG",
    "name": "Dr. Babasaheb Ambedkar International Airport",
    "city": "Nagpur"
  },
  {
    "iata": "ISK",
    "name": "Nashik Airport",
    "city": "Nasik"
  },
  {
    "iata": "PNQ",
    "name": "Pune Airport / Lohagaon Air Force Station",
    "city": "Pune"
  },
  {
    "iata": "PBD",
    "name": "Porbandar Airport",
    "city": "Porbandar"
  },
  {
    "iata": "RAJ",
    "name": "Rajkot Airport",
    "city": "Rajkot"
  },
  {
    "iata": "SSE",
    "name": "Solapur Airport",
    "city": "Solapur"
  },
  {
    "iata": "STV",
    "name": "Surat Airport",
    "city": "Surat"
  },
  {
    "iata": "UDR",
    "name": "Maharana Pratap Airport",
    "city": "Udaipur"
  },
  {
    "iata": "CMB",
    "name": "Bandaranaike International Colombo Airport",
    "city": "Colombo"
  },
  {
    "iata": "ACJ",
    "name": "Anuradhapura Airport",
    "city": "Anuradhapura"
  },
  {
    "iata": "BTC",
    "name": "Batticaloa Airport",
    "city": "Batticaloa"
  },
  {
    "iata": "RML",
    "name": "Colombo Ratmalana Airport",
    "city": "Colombo"
  },
  {
    "iata": "ADP",
    "name": "Ampara Airport",
    "city": "Ampara"
  },
  {
    "iata": "HIM",
    "name": "Hingurakgoda Air Force Base",
    "city": "Polonnaruwa Town"
  },
  {
    "iata": "JAF",
    "name": "Jaffna International Airport",
    "city": "Jaffna"
  },
  {
    "iata": "KCT",
    "name": "Koggala Airport",
    "city": "Galle"
  },
  {
    "iata": "TRR",
    "name": "China Bay Airport",
    "city": "Trincomalee"
  },
  {
    "iata": "HRI",
    "name": "Mattala Rajapaksa International Airport",
    "city": "Mattala"
  },
  {
    "iata": "BBM",
    "name": "Battambang Airport",
    "city": "Battambang"
  },
  {
    "iata": "KZC",
    "name": "Kampong Chhnang Airport",
    "city": "Kampong Chhnang"
  },
  {
    "iata": "PNH",
    "name": "Phnom Penh International Airport",
    "city": "Phnom Penh (Pou Senchey)"
  },
  {
    "iata": "SAI",
    "name": "Siem Reap-Angkor International Airport",
    "city": "Siem Reap"
  },
  {
    "iata": "IXA",
    "name": "Agartala - Maharaja Bir Bikram Airport",
    "city": "Agartala"
  },
  {
    "iata": "IXB",
    "name": "Bagdogra Airport",
    "city": "Siliguri"
  },
  {
    "iata": "SHL",
    "name": "Shillong Airport",
    "city": "Shillong"
  },
  {
    "iata": "VNS",
    "name": "Lal Bahadur Shastri Airport",
    "city": "Varanasi"
  },
  {
    "iata": "BBI",
    "name": "Biju Patnaik Airport",
    "city": "Bhubaneswar"
  },
  {
    "iata": "PAB",
    "name": "Bilaspur Airport",
    "city": "Bilaspur"
  },
  {
    "iata": "CCU",
    "name": "Netaji Subhash Chandra Bose International Airport",
    "city": "Kolkata"
  },
  {
    "iata": "RDP",
    "name": "Kazi Nazrul Islam Airport",
    "city": "Durgapur"
  },
  {
    "iata": "DBR",
    "name": "Darbhanga Airport",
    "city": "Darbhanga"
  },
  {
    "iata": "GOP",
    "name": "Gorakhpur Airport",
    "city": "Gorakhpur"
  },
  {
    "iata": "GAU",
    "name": "Lokpriya Gopinath Bordoloi International Airport",
    "city": "Guwahati"
  },
  {
    "iata": "GAY",
    "name": "Gaya Airport",
    "city": "Gaya"
  },
  {
    "iata": "IMF",
    "name": "Imphal Airport",
    "city": "Imphal"
  },
  {
    "iata": "IXW",
    "name": "Sonari Airport",
    "city": "Jamshedpur"
  },
  {
    "iata": "JRH",
    "name": "Jorhat Airport",
    "city": "Jorhat"
  },
  {
    "iata": "IXH",
    "name": "Kailashahar Airport",
    "city": "Kailashahar"
  },
  {
    "iata": "IXS",
    "name": "Silchar Airport",
    "city": "Silchar"
  },
  {
    "iata": "AJL",
    "name": "Lengpui Airport",
    "city": "Aizawl (Lengpui)"
  },
  {
    "iata": "IXI",
    "name": "Lilabari North Lakhimpur Airport",
    "city": "Lilabari"
  },
  {
    "iata": "DIB",
    "name": "Dibrugarh Airport",
    "city": "Dibrugarh"
  },
  {
    "iata": "DMU",
    "name": "Dimapur Airport",
    "city": "Dimapur"
  },
  {
    "iata": "MZU",
    "name": "Muzaffarpur Airport",
    "city": "Muzaffarpur"
  },
  {
    "iata": "PAT",
    "name": "Jay Prakash Narayan Airport",
    "city": "Patna"
  },
  {
    "iata": "IXR",
    "name": "Birsa Munda Airport",
    "city": "Ranchi"
  },
  {
    "iata": "RRK",
    "name": "Rourkela Airport",
    "city": "Rourkela"
  },
  {
    "iata": "ZER",
    "name": "Ziro Airport",
    "city": "Ziro"
  },
  {
    "iata": "BZL",
    "name": "Barisal Airport",
    "city": "Barisal"
  },
  {
    "iata": "CXB",
    "name": "Cox's Bazar Airport",
    "city": "Cox's Bazar"
  },
  {
    "iata": "CGP",
    "name": "Shah Amanat International Airport",
    "city": "Chattogram (Chittagong)"
  },
  {
    "iata": "DAC",
    "name": "Hazrat Shahjalal International Airport",
    "city": "Dhaka"
  },
  {
    "iata": "IRD",
    "name": "Ishurdi Airport",
    "city": "Ishurdi"
  },
  {
    "iata": "JSR",
    "name": "Jessore Airport",
    "city": "Jashore (Jessore)"
  },
  {
    "iata": "RJH",
    "name": "Shah Mokhdum Airport",
    "city": "Rajshahi"
  },
  {
    "iata": "SPD",
    "name": "Saidpur Airport",
    "city": "Saidpur"
  },
  {
    "iata": "ZYL",
    "name": "Osmany International Airport",
    "city": "Sylhet"
  },
  {
    "iata": "HKG",
    "name": "Hong Kong International Airport",
    "city": "Hong Kong"
  },
  {
    "iata": "AGR",
    "name": "Agra Airport / Agra Air Force Station",
    "city": "Agra"
  },
  {
    "iata": "ATQ",
    "name": "Sri Guru Ram Dass Jee International Airport",
    "city": "Amritsar"
  },
  {
    "iata": "BKB",
    "name": "Nal Airport",
    "city": "Bikaner"
  },
  {
    "iata": "KUU",
    "name": "Kullu Manali Airport",
    "city": "Bhuntar"
  },
  {
    "iata": "BEK",
    "name": "Bareilly Air Force Station",
    "city": "Bareilly"
  },
  {
    "iata": "IXC",
    "name": "Chandigarh International Airport",
    "city": "Chandigarh"
  },
  {
    "iata": "DED",
    "name": "Dehradun Jolly Grant Airport",
    "city": "Dehradun (Jauligrant)"
  },
  {
    "iata": "DEL",
    "name": "Indira Gandhi International Airport",
    "city": "New Delhi"
  },
  {
    "iata": "DHM",
    "name": "Kangra Airport",
    "city": "Kangra"
  },
  {
    "iata": "GWL",
    "name": "Gwalior Airport",
    "city": "Gwalior"
  },
  {
    "iata": "HSS",
    "name": "Hisar Airport",
    "city": "Hisar"
  },
  {
    "iata": "JDH",
    "name": "Jodhpur Airport",
    "city": "Jodhpur"
  },
  {
    "iata": "JAI",
    "name": "Jaipur International Airport",
    "city": "Jaipur"
  },
  {
    "iata": "IXJ",
    "name": "Jammu Airport",
    "city": "Jammu"
  },
  {
    "iata": "KTU",
    "name": "Kota Airport",
    "city": "Kota"
  },
  {
    "iata": "IXL",
    "name": "Leh Kushok Bakula Rimpochee Airport",
    "city": "Leh"
  },
  {
    "iata": "LKO",
    "name": "Chaudhary Charan Singh International Airport",
    "city": "Lucknow"
  },
  {
    "iata": "IXP",
    "name": "Pathankot Airport",
    "city": "Pathankot"
  },
  {
    "iata": "PGH",
    "name": "Pantnagar Airport",
    "city": "Pantnagar"
  },
  {
    "iata": "SXR",
    "name": "Sheikh ul Alam International Airport",
    "city": "Srinagar"
  },
  {
    "iata": "LPQ",
    "name": "Luang Phabang International Airport",
    "city": "Luang Phabang"
  },
  {
    "iata": "PKZ",
    "name": "Pakse International Airport",
    "city": "Pakse"
  },
  {
    "iata": "VTE",
    "name": "Wattay International Airport",
    "city": "Vientiane"
  },
  {
    "iata": "MFM",
    "name": "Macau International Airport",
    "city": "Nossa Senhora do Carmo"
  },
  {
    "iata": "BWA",
    "name": "Gautam Buddha International Airport",
    "city": "Siddharthanagar (Bhairahawa)"
  },
  {
    "iata": "JKR",
    "name": "Janakpur Airport",
    "city": "Janakpur"
  },
  {
    "iata": "KTM",
    "name": "Tribhuvan International Airport",
    "city": "Kathmandu"
  },
  {
    "iata": "KEP",
    "name": "Nepalgunj Airport",
    "city": "Nepalgunj"
  },
  {
    "iata": "TPJ",
    "name": "Taplejung Airport",
    "city": "Taplejung"
  },
  {
    "iata": "BIR",
    "name": "Biratnagar Airport",
    "city": "Biratnagar"
  },
  {
    "iata": "AGX",
    "name": "Agatti Airport",
    "city": "Agatti"
  },
  {
    "iata": "BEP",
    "name": "Bellary Airport",
    "city": "Bellary"
  },
  {
    "iata": "BLR",
    "name": "Kempegowda International Airport",
    "city": "Bangalore"
  },
  {
    "iata": "VGA",
    "name": "Vijayawada Airport",
    "city": "Gannavaram"
  },
  {
    "iata": "CJB",
    "name": "Coimbatore International Airport",
    "city": "Coimbatore"
  },
  {
    "iata": "COK",
    "name": "Cochin International Airport",
    "city": "Kochi"
  },
  {
    "iata": "CCJ",
    "name": "Calicut International Airport",
    "city": "Calicut"
  },
  {
    "iata": "CDP",
    "name": "Kadapa Airport",
    "city": "Kadapa"
  },
  {
    "iata": "CBD",
    "name": "Car Nicobar Air Force Base",
    "city": "IAF Camp"
  },
  {
    "iata": "GOX",
    "name": "Manohar International Airport",
    "city": "Mopa"
  },
  {
    "iata": "GOI",
    "name": "Dabolim Airport",
    "city": "Vasco da Gama"
  },
  {
    "iata": "HYD",
    "name": "Rajiv Gandhi International Airport",
    "city": "Hyderabad"
  },
  {
    "iata": "BPM",
    "name": "Begumpet Airport",
    "city": "Hyderabad"
  },
  {
    "iata": "CNN",
    "name": "Kannur International Airport",
    "city": "Kannur"
  },
  {
    "iata": "KJB",
    "name": "Kurnool Airport",
    "city": "Orvakal"
  },
  {
    "iata": "IXM",
    "name": "Madurai Airport",
    "city": "Madurai"
  },
  {
    "iata": "IXE",
    "name": "Mangalore International Airport",
    "city": "Mangalore"
  },
  {
    "iata": "MAA",
    "name": "Chennai International Airport",
    "city": "Chennai"
  },
  {
    "iata": "IXZ",
    "name": "Veer Savarkar International Airport / INS Utkrosh",
    "city": "Port Blair"
  },
  {
    "iata": "PNY",
    "name": "Pondicherry Airport",
    "city": "Puducherry (Pondicherry)"
  },
  {
    "iata": "PUT",
    "name": "Sri Sathya Sai Airport",
    "city": "Puttaparthi"
  },
  {
    "iata": "RJA",
    "name": "Rajahmundry Airport",
    "city": "Madhurapudi"
  },
  {
    "iata": "SXV",
    "name": "Salem Airport",
    "city": "Salem"
  },
  {
    "iata": "TRZ",
    "name": "Tiruchirappalli International Airport",
    "city": "Tiruchirappalli"
  },
  {
    "iata": "TRV",
    "name": "Thiruvananthapuram International Airport",
    "city": "Thiruvananthapuram"
  },
  {
    "iata": "GLU",
    "name": "Gelephu Airport",
    "city": "Gelephu"
  },
  {
    "iata": "PBH",
    "name": "Paro International Airport",
    "city": "Paro"
  },
  {
    "iata": "GAN",
    "name": "Gan International Airport",
    "city": "Gan"
  },
  {
    "iata": "HAQ",
    "name": "Hanimaadhoo Airport",
    "city": "Haa Dhaalu Atoll"
  },
  {
    "iata": "KDO",
    "name": "Kadhdhoo Airport",
    "city": "Kadhdhoo"
  },
  {
    "iata": "MLE",
    "name": "Malé International Airport",
    "city": "Malé"
  },
  {
    "iata": "KDM",
    "name": "Kaadedhdhoo Airport",
    "city": "Huvadhu Atoll"
  },
  {
    "iata": "VAM",
    "name": "Villa International Airport Maamigili",
    "city": "Maamigili"
  },
  {
    "iata": "DMK",
    "name": "Don Mueang International Airport",
    "city": "Bangkok"
  },
  {
    "iata": "KDT",
    "name": "Kamphaeng Saen Airport",
    "city": "Nakhon Pathom"
  },
  {
    "iata": "TDX",
    "name": "Trat Airport",
    "city": "Laem Ngop"
  },
  {
    "iata": "BKK",
    "name": "Suvarnabhumi Airport",
    "city": "Bangkok"
  },
  {
    "iata": "UTP",
    "name": "U-Tapao International Airport",
    "city": "Rayong"
  },
  {
    "iata": "CNX",
    "name": "Chiang Mai International Airport",
    "city": "Chiang Mai"
  },
  {
    "iata": "HGN",
    "name": "Mae Hong Son Airport",
    "city": "Mae Hong Son"
  },
  {
    "iata": "CEI",
    "name": "Mae Fah Luang - Chiang Rai International Airport",
    "city": "Chiang Rai"
  },
  {
    "iata": "HHQ",
    "name": "Hua Hin Airport",
    "city": "Hua Hin"
  },
  {
    "iata": "PHS",
    "name": "Phitsanulok Airport",
    "city": "Phitsanulok"
  },
  {
    "iata": "URT",
    "name": "Surat Thani Airport",
    "city": "Surat Thani"
  },
  {
    "iata": "CJM",
    "name": "Chumphon Airport",
    "city": "Chumphon"
  },
  {
    "iata": "NST",
    "name": "Nakhon Si Thammarat Airport",
    "city": "Nakhon Si Thammarat"
  },
  {
    "iata": "KBV",
    "name": "Krabi Airport",
    "city": "Krabi"
  },
  {
    "iata": "USM",
    "name": "Samui Airport",
    "city": "Na Thon (Ko Samui Island)"
  },
  {
    "iata": "HKT",
    "name": "Phuket International Airport",
    "city": "Phuket"
  },
  {
    "iata": "UNN",
    "name": "Ranong Airport",
    "city": "Ranong"
  },
  {
    "iata": "HDY",
    "name": "Hat Yai International Airport",
    "city": "Hat Yai"
  },
  {
    "iata": "TST",
    "name": "Trang Airport",
    "city": "Trang"
  },
  {
    "iata": "UTH",
    "name": "Udon Thani Airport",
    "city": "Udon Thani"
  },
  {
    "iata": "PXR",
    "name": "Surin Airport",
    "city": "Surin"
  },
  {
    "iata": "KKC",
    "name": "Khon Kaen Airport",
    "city": "Khon Kaen"
  },
  {
    "iata": "BFV",
    "name": "Buri Ram Airport",
    "city": "Buriram"
  },
  {
    "iata": "NAK",
    "name": "Nakhon Ratchasima Airport",
    "city": "Chaloem Phra Kiat"
  },
  {
    "iata": "UBP",
    "name": "Ubon Ratchathani Airport",
    "city": "Ubon Ratchathani"
  },
  {
    "iata": "ROI",
    "name": "Roi Et Airport",
    "city": "Roi Et"
  },
  {
    "iata": "KOP",
    "name": "Nakhon Phanom Airport",
    "city": "Nakhon Phanom"
  },
  {
    "iata": "BMV",
    "name": "Buon Ma Thuot Airport",
    "city": "Buon Ma Thuot"
  },
  {
    "iata": "HPH",
    "name": "Cat Bi International Airport",
    "city": "Haiphong (Hai An)"
  },
  {
    "iata": "CAH",
    "name": "Cà Mau Airport",
    "city": "Ca Mau City"
  },
  {
    "iata": "CXR",
    "name": "Cam Ranh International Airport / Cam Ranh Air Base",
    "city": "Cam Ranh"
  },
  {
    "iata": "VCS",
    "name": "Con Dao Airport",
    "city": "Con Dao"
  },
  {
    "iata": "VCA",
    "name": "Can Tho International Airport",
    "city": "Can Tho"
  },
  {
    "iata": "DIN",
    "name": "Dien Bien Phu Airport",
    "city": "Dien Bien Phu"
  },
  {
    "iata": "VDH",
    "name": "Dong Hoi Airport",
    "city": "Dong Hoi"
  },
  {
    "iata": "DLI",
    "name": "Lien Khuong Airport",
    "city": "Da Lat"
  },
  {
    "iata": "DAD",
    "name": "Da Nang International Airport",
    "city": "Da Nang"
  },
  {
    "iata": "HAN",
    "name": "Noi Bai International Airport",
    "city": "Hanoi (Soc Son)"
  },
  {
    "iata": "HUI",
    "name": "Phu Bai International Airport",
    "city": "Huế"
  },
  {
    "iata": "UIH",
    "name": "Phu Cat Airport",
    "city": "Quy Nohn"
  },
  {
    "iata": "PXU",
    "name": "Pleiku Airport",
    "city": "Pleiku"
  },
  {
    "iata": "PQC",
    "name": "Phu Quoc International Airport",
    "city": "Phu Quoc Island"
  },
  {
    "iata": "VKG",
    "name": "Rach Gia Airport",
    "city": "Rach Gia"
  },
  {
    "iata": "TBB",
    "name": "Dong Tac Airport",
    "city": "Tuy Hoa"
  },
  {
    "iata": "SGN",
    "name": "Tan Son Nhat International Airport",
    "city": "Ho Chi Minh City"
  },
  {
    "iata": "VDO",
    "name": "Van Don International Airport",
    "city": "Van Don"
  },
  {
    "iata": "VII",
    "name": "Vinh Airport",
    "city": "Vinh"
  },
  {
    "iata": "TVY",
    "name": "Dawei Airport",
    "city": "Dawei"
  },
  {
    "iata": "KET",
    "name": "Kengtung Airport",
    "city": "Kengtung"
  },
  {
    "iata": "KYP",
    "name": "Kyaukpyu Airport",
    "city": "Kyaukpyu"
  },
  {
    "iata": "KAW",
    "name": "Kawthoung Airport",
    "city": "Kawthoung"
  },
  {
    "iata": "LIW",
    "name": "Loikaw Airport",
    "city": "Loikaw"
  },
  {
    "iata": "LSH",
    "name": "Lashio Airport",
    "city": "Lashio"
  },
  {
    "iata": "MDL",
    "name": "Mandalay International Airport",
    "city": "Mandalay"
  },
  {
    "iata": "MGZ",
    "name": "Myeik Airport",
    "city": "Mkeik"
  },
  {
    "iata": "MYT",
    "name": "Myitkyina Airport",
    "city": "Myitkyina"
  },
  {
    "iata": "MOG",
    "name": "Mong Hsat Airport",
    "city": "Mong Hsat"
  },
  {
    "iata": "NMS",
    "name": "Namsang Airport",
    "city": "Namsang"
  },
  {
    "iata": "NYT",
    "name": "Nay Pyi Taw International Airport",
    "city": "Pyinmana"
  },
  {
    "iata": "PBU",
    "name": "Putao Airport",
    "city": "Putao"
  },
  {
    "iata": "AKY",
    "name": "Sittwe Airport",
    "city": "Sittwe"
  },
  {
    "iata": "SNW",
    "name": "Thandwe Airport",
    "city": "Thandwe"
  },
  {
    "iata": "THL",
    "name": "Tachileik Airport",
    "city": "Tachileik"
  },
  {
    "iata": "RGN",
    "name": "Yangon International Airport",
    "city": "Yangon"
  },
  {
    "iata": "UPG",
    "name": "Hasanuddin International Airport",
    "city": "Ujung Pandang"
  },
  {
    "iata": "BIK",
    "name": "Frans Kaisiepo Airport",
    "city": "Biak"
  },
  {
    "iata": "NBX",
    "name": "Douw Aturure Airport",
    "city": "Nabire"
  },
  {
    "iata": "ZRI",
    "name": "Stevanus Rumbewas Airport",
    "city": "Serui"
  },
  {
    "iata": "DPS",
    "name": "Denpasar I Gusti Ngurah Rai International Airport",
    "city": "Kuta, Badung"
  },
  {
    "iata": "LOP",
    "name": "Lombok International Airport",
    "city": "Mataram (Pujut, Lombok Tengah)"
  },
  {
    "iata": "TTE",
    "name": "Sultan Babullah Airport",
    "city": "Sango"
  },
  {
    "iata": "PLW",
    "name": "Mutiara - SIS Al-Jufrie Airport",
    "city": "Palu"
  },
  {
    "iata": "PKY",
    "name": "Tjilik Riwut Airport",
    "city": "Palangkaraya"
  },
  {
    "iata": "YIA",
    "name": "Yogyakarta International Airport",
    "city": "Yogyakarta"
  },
  {
    "iata": "CXP",
    "name": "Tunggul Wulung Airport",
    "city": "Cilacap"
  },
  {
    "iata": "DJJ",
    "name": "Dortheys Hiyo Eluay International Airport",
    "city": "Sentani"
  },
  {
    "iata": "OKL",
    "name": "Oksibil Airport",
    "city": "Oksibil"
  },
  {
    "iata": "MKQ",
    "name": "Mopah International Airport",
    "city": "Merauke"
  },
  {
    "iata": "TMH",
    "name": "Tanah Merah Airport",
    "city": "Tanah Merah"
  },
  {
    "iata": "BPN",
    "name": "Sultan Aji Muhammad Sulaiman Sepinggan International Airport",
    "city": "Balikpapan"
  },
  {
    "iata": "AAP",
    "name": "Aji Pangeran Tumenggung Pranoto International Airport",
    "city": "Samarinda"
  },
  {
    "iata": "NAH",
    "name": "Naha Airport",
    "city": "Tabukan Utara, Sangihe Islands"
  },
  {
    "iata": "MDC",
    "name": "Sam Ratulangi Airport",
    "city": "Manado"
  },
  {
    "iata": "TJG",
    "name": "Warukin Airport",
    "city": "Tanta-Tabalong"
  },
  {
    "iata": "BDJ",
    "name": "Syamsudin Noor International Airport",
    "city": "Landasan Ulin"
  },
  {
    "iata": "LUV",
    "name": "Karel Sadsuitubun Airport",
    "city": "Langgur"
  },
  {
    "iata": "NAM",
    "name": "Namniwel Airport",
    "city": "Namniwel"
  },
  {
    "iata": "AMQ",
    "name": "Pattimura International Airport",
    "city": "Ambon"
  },
  {
    "iata": "MLG",
    "name": "Abdul Rachman Saleh Airport",
    "city": "Malang"
  },
  {
    "iata": "SUB",
    "name": "Juanda International Airport",
    "city": "Surabaya"
  },
  {
    "iata": "FKQ",
    "name": "Fakfak Airport",
    "city": "Fakfak"
  },
  {
    "iata": "KNG",
    "name": "Kaimana Airport",
    "city": "Kaimana"
  },
  {
    "iata": "BXB",
    "name": "Babo Airport",
    "city": "Babo"
  },
  {
    "iata": "SOQ",
    "name": "Domine Eduard Osok Airport",
    "city": "Sorong"
  },
  {
    "iata": "WMX",
    "name": "Wamena Airport",
    "city": "Wamena"
  },
  {
    "iata": "KXB",
    "name": "Sangia Nibandera Airport",
    "city": "Kolaka"
  },
  {
    "iata": "BTU",
    "name": "Bintulu Airport",
    "city": "Bintulu"
  },
  {
    "iata": "KCH",
    "name": "Kuching International Airport",
    "city": "Kuching"
  },
  {
    "iata": "LMN",
    "name": "Limbang Airport",
    "city": "Limbang"
  },
  {
    "iata": "MKM",
    "name": "Mukah Airport",
    "city": "Mukah"
  },
  {
    "iata": "MUR",
    "name": "Marudi Airport",
    "city": "Marudi"
  },
  {
    "iata": "MYY",
    "name": "Miri Airport",
    "city": "Miri"
  },
  {
    "iata": "SBW",
    "name": "Sibu Airport",
    "city": "Sibu"
  },
  {
    "iata": "BBN",
    "name": "Bario Airport",
    "city": "Bario"
  },
  {
    "iata": "LDU",
    "name": "Lahad Datu Airport",
    "city": "Lahad Datu"
  },
  {
    "iata": "BKI",
    "name": "Kota Kinabalu International Airport",
    "city": "Kota Kinabalu"
  },
  {
    "iata": "LBU",
    "name": "Labuan Airport",
    "city": "Labuan"
  },
  {
    "iata": "SDK",
    "name": "Sandakan Airport",
    "city": "Sandakan"
  },
  {
    "iata": "TWU",
    "name": "Tawau Airport",
    "city": "Tawau"
  },
  {
    "iata": "MZV",
    "name": "Mulu Airport",
    "city": "Mulu"
  },
  {
    "iata": "BWN",
    "name": "Brunei International Airport",
    "city": "Bandar Seri Begawan"
  },
  {
    "iata": "PKU",
    "name": "Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB",
    "city": "Pekanbaru"
  },
  {
    "iata": "DUM",
    "name": "Pinang Kampai Airport",
    "city": "Dumai"
  },
  {
    "iata": "RGT",
    "name": "Japura Airport",
    "city": "Rengat-Sumatra Island"
  },
  {
    "iata": "KJT",
    "name": "Kertajati International Airport",
    "city": "Kertajati"
  },
  {
    "iata": "BDO",
    "name": "Husein Sastranegara International Airport",
    "city": "Bandung"
  },
  {
    "iata": "BTH",
    "name": "Hang Nadim International Airport",
    "city": "Batam"
  },
  {
    "iata": "HLP",
    "name": "Halim Perdanakusuma International Airport",
    "city": "Jakarta"
  },
  {
    "iata": "CGK",
    "name": "Soekarno-Hatta International Airport",
    "city": "Jakarta"
  },
  {
    "iata": "TKG",
    "name": "Radin Inten II International Airport",
    "city": "Bandar Lampung"
  },
  {
    "iata": "GNS",
    "name": "Binaka Airport",
    "city": "Gunungsitoli"
  },
  {
    "iata": "AEG",
    "name": "Aek Godang Airport",
    "city": "Padang Sidempuan"
  },
  {
    "iata": "MES",
    "name": "Soewondo Air Force Base",
    "city": "Medan"
  },
  {
    "iata": "KNO",
    "name": "Kualanamu International Airport",
    "city": "Beringin"
  },
  {
    "iata": "FLZ",
    "name": "Dr. Ferdinand Lumban Tobing Airport",
    "city": "Sibolga (Pinangsori)"
  },
  {
    "iata": "NPO",
    "name": "Nanga Pinoh Airport",
    "city": "Nanga Pinoh-Borneo Island"
  },
  {
    "iata": "KTG",
    "name": "Rahadi Osman Airport",
    "city": "Ketapang"
  },
  {
    "iata": "PNK",
    "name": "Supadio Airport",
    "city": "Pontianak"
  },
  {
    "iata": "PSU",
    "name": "Pangsuma Airport",
    "city": "Putussibau-Borneo Island"
  },
  {
    "iata": "SQG",
    "name": "Tebelian Airport",
    "city": "Sintang"
  },
  {
    "iata": "PLM",
    "name": "Sultan Mahmud Badaruddin II Airport",
    "city": "Palembang"
  },
  {
    "iata": "PDO",
    "name": "Pendopo Airport",
    "city": "Talang Gudang-Sumatra Island"
  },
  {
    "iata": "MEQ",
    "name": "Cut Nyak Dhien Airport",
    "city": "Kuala Pesisir"
  },
  {
    "iata": "LSX",
    "name": "Lhok Sukon Airport",
    "city": "Lhok Sukon-Sumatra Island"
  },
  {
    "iata": "BTJ",
    "name": "Sultan Iskandar Muda International Airport",
    "city": "Banda Aceh"
  },
  {
    "iata": "TOD",
    "name": "Tioman Airport",
    "city": "Tioman Island"
  },
  {
    "iata": "AOR",
    "name": "Sultan Abdul Halim Airport",
    "city": "Alor Satar"
  },
  {
    "iata": "BWH",
    "name": "RMAF Butterworth Air Base",
    "city": "Butterworth"
  },
  {
    "iata": "KBR",
    "name": "Sultan Ismail Petra Airport",
    "city": "Kota Baharu"
  },
  {
    "iata": "KUA",
    "name": "Kuantan Airport",
    "city": "Kuantan"
  },
  {
    "iata": "KTE",
    "name": "Kerteh Airport",
    "city": "Kerteh"
  },
  {
    "iata": "IPH",
    "name": "Sultan Azlan Shah Airport",
    "city": "Ipoh"
  },
  {
    "iata": "JHB",
    "name": "Senai International Airport",
    "city": "Johor Bahru"
  },
  {
    "iata": "KUL",
    "name": "Kuala Lumpur International Airport",
    "city": "Sepang"
  },
  {
    "iata": "LGK",
    "name": "Langkawi International Airport",
    "city": "Langkawi"
  },
  {
    "iata": "MKZ",
    "name": "Malacca International Airport",
    "city": "Malacca"
  },
  {
    "iata": "TGG",
    "name": "Sultan Mahmud Airport",
    "city": "Kuala Terengganu"
  },
  {
    "iata": "PEN",
    "name": "Penang International Airport",
    "city": "Penang"
  },
  {
    "iata": "SZB",
    "name": "Sultan Abdul Aziz Shah International Airport",
    "city": "Subang"
  },
  {
    "iata": "UAI",
    "name": "Suai Airport",
    "city": "Suai"
  },
  {
    "iata": "DIL",
    "name": "Presidente Nicolau Lobato International Airport",
    "city": "Dili"
  },
  {
    "iata": "BCH",
    "name": "Cakung Airport",
    "city": "Baucau"
  },
  {
    "iata": "QPG",
    "name": "Paya Lebar Air Base",
    "city": "Paya Lebar"
  },
  {
    "iata": "TGA",
    "name": "Tengah Air Base",
    "city": "Western Water Catchment"
  },
  {
    "iata": "XSP",
    "name": "Seletar Airport",
    "city": "Seletar"
  },
  {
    "iata": "SIN",
    "name": "Singapore Changi Airport",
    "city": "Singapore"
  },
  {
    "iata": "ALH",
    "name": "Albany Airport",
    "city": "Albany"
  },
  {
    "iata": "ARY",
    "name": "Ararat Airport",
    "city": "Ararat"
  },
  {
    "iata": "ARM",
    "name": "Armidale Airport",
    "city": "Armidale"
  },
  {
    "iata": "AYQ",
    "name": "Ayers Rock Connellan Airport",
    "city": "Yulara"
  },
  {
    "iata": "BCI",
    "name": "Barcaldine Airport",
    "city": "Barcaldine"
  },
  {
    "iata": "ASP",
    "name": "Alice Springs Airport",
    "city": "Alice Springs"
  },
  {
    "iata": "BNE",
    "name": "Brisbane International Airport",
    "city": "Brisbane"
  },
  {
    "iata": "OOL",
    "name": "Gold Coast Airport",
    "city": "Gold Coast"
  },
  {
    "iata": "BKQ",
    "name": "Blackall Airport",
    "city": "Blackall"
  },
  {
    "iata": "CNS",
    "name": "Cairns International Airport",
    "city": "Cairns"
  },
  {
    "iata": "CTL",
    "name": "Charleville Airport",
    "city": "Charleville"
  },
  {
    "iata": "BHQ",
    "name": "Broken Hill Airport",
    "city": "Broken Hill"
  },
  {
    "iata": "HTI",
    "name": "Hamilton Island Airport",
    "city": "Hamilton Island"
  },
  {
    "iata": "BEU",
    "name": "Bedourie Airport",
    "city": "Bedourie"
  },
  {
    "iata": "BLN",
    "name": "Benalla Airport",
    "city": "Benalla"
  },
  {
    "iata": "ISA",
    "name": "Mount Isa Airport",
    "city": "Mount Isa"
  },
  {
    "iata": "MKY",
    "name": "Mackay Airport",
    "city": "Mackay"
  },
  {
    "iata": "BNK",
    "name": "Ballina Byron Gateway Airport",
    "city": "Ballina"
  },
  {
    "iata": "BSJ",
    "name": "Bairnsdale Airport",
    "city": "Bairnsdale"
  },
  {
    "iata": "PPP",
    "name": "Proserpine Whitsunday Coast Airport",
    "city": "Proserpine"
  },
  {
    "iata": "ROK",
    "name": "Rockhampton Airport",
    "city": "Rockhampton"
  },
  {
    "iata": "BME",
    "name": "Broome International Airport",
    "city": "Broome"
  },
  {
    "iata": "MCY",
    "name": "Sunshine Coast Airport",
    "city": "Maroochydore"
  },
  {
    "iata": "BHS",
    "name": "Bathurst Airport",
    "city": "Bathurst"
  },
  {
    "iata": "BRT",
    "name": "Bathurst Island Airport",
    "city": "Wurrumiyanga"
  },
  {
    "iata": "TSV",
    "name": "Townsville Airport / RAAF Base Townsville",
    "city": "Townsville"
  },
  {
    "iata": "BDB",
    "name": "Bundaberg Airport",
    "city": "Bundaberg"
  },
  {
    "iata": "WEI",
    "name": "Weipa Airport",
    "city": "Weipa"
  },
  {
    "iata": "WTB",
    "name": "Toowoomba Wellcamp Airport",
    "city": "Toowoomba"
  },
  {
    "iata": "CVQ",
    "name": "Carnarvon Airport",
    "city": "Carnarvon"
  },
  {
    "iata": "CPD",
    "name": "Coober Pedy Airport",
    "city": "Coober Pedy"
  },
  {
    "iata": "CCL",
    "name": "Chinchilla Airport",
    "city": "Chinchilla"
  },
  {
    "iata": "CNJ",
    "name": "Cloncurry Airport",
    "city": "Cloncurry"
  },
  {
    "iata": "CFS",
    "name": "Coffs Harbour Airport",
    "city": "Coffs Harbour"
  },
  {
    "iata": "DCN",
    "name": "RAAF Base Curtin",
    "city": "Derby"
  },
  {
    "iata": "CUQ",
    "name": "Coen Airport",
    "city": "Coen"
  },
  {
    "iata": "OOM",
    "name": "Cooma Snowy Mountains Airport",
    "city": "Cooma"
  },
  {
    "iata": "DRB",
    "name": "Derby Airport",
    "city": "Derby"
  },
  {
    "iata": "DNQ",
    "name": "Deniliquin Airport",
    "city": "Deniliquin"
  },
  {
    "iata": "DPO",
    "name": "Devonport Airport",
    "city": "Devonport"
  },
  {
    "iata": "ELC",
    "name": "Elcho Island Airport",
    "city": "Elcho Island"
  },
  {
    "iata": "EMD",
    "name": "Emerald Airport",
    "city": "Emerald"
  },
  {
    "iata": "EPR",
    "name": "Esperance Airport",
    "city": "Esperance"
  },
  {
    "iata": "FRB",
    "name": "Forbes Airport",
    "city": "Forbes"
  },
  {
    "iata": "GET",
    "name": "Geraldton Airport",
    "city": "Moonyoonooka"
  },
  {
    "iata": "GFN",
    "name": "Clarence Valley Regional Airport",
    "city": "Grafton"
  },
  {
    "iata": "GLT",
    "name": "Gladstone Airport",
    "city": "Gladstone"
  },
  {
    "iata": "GLI",
    "name": "Glen Innes Airport",
    "city": "Glen Innes"
  },
  {
    "iata": "GPN",
    "name": "Garden Point Airport",
    "city": "Pirlangimpi"
  },
  {
    "iata": "GTE",
    "name": "Groote Eylandt Airport",
    "city": "Groote Eylandt"
  },
  {
    "iata": "GFF",
    "name": "Griffith Airport",
    "city": "Griffith"
  },
  {
    "iata": "HVB",
    "name": "Hervey Bay Airport",
    "city": "Hervey Bay"
  },
  {
    "iata": "HID",
    "name": "Horn Island Airport",
    "city": "Horn"
  },
  {
    "iata": "MHU",
    "name": "Mount Hotham Airport",
    "city": "Mount Hotham"
  },
  {
    "iata": "IVR",
    "name": "Inverell Airport",
    "city": "Inverell"
  },
  {
    "iata": "KWM",
    "name": "Kowanyama Airport",
    "city": "Kowanyama"
  },
  {
    "iata": "LNO",
    "name": "Leonora Airport",
    "city": "Leonora"
  },
  {
    "iata": "IRG",
    "name": "Lockhart River Airport",
    "city": "Lockhart River"
  },
  {
    "iata": "LSY",
    "name": "Lismore Airport",
    "city": "Lismore"
  },
  {
    "iata": "LRE",
    "name": "Longreach Airport",
    "city": "Longreach"
  },
  {
    "iata": "TGN",
    "name": "Latrobe Valley Airport",
    "city": "Morwell"
  },
  {
    "iata": "AVV",
    "name": "Avalon Airport",
    "city": "Lara"
  },
  {
    "iata": "ABX",
    "name": "Albury Airport",
    "city": "East Albury"
  },
  {
    "iata": "MRG",
    "name": "Mareeba Airport",
    "city": "Mareeba"
  },
  {
    "iata": "DGE",
    "name": "Mudgee Airport",
    "city": "Mudgee"
  },
  {
    "iata": "MEB",
    "name": "Melbourne Essendon Airport",
    "city": "Essendon Fields"
  },
  {
    "iata": "MIM",
    "name": "Merimbula Airport",
    "city": "Merimbula"
  },
  {
    "iata": "MNG",
    "name": "Maningrida Airport",
    "city": "Maningrida"
  },
  {
    "iata": "HBA",
    "name": "Hobart International Airport",
    "city": "Hobart (Cambridge)"
  },
  {
    "iata": "MQL",
    "name": "Mildura Airport",
    "city": "Mildura"
  },
  {
    "iata": "LST",
    "name": "Launceston Airport",
    "city": "Launceston (Western Junction)"
  },
  {
    "iata": "MBW",
    "name": "Melbourne Moorabbin Airport",
    "city": "Melbourne"
  },
  {
    "iata": "MEL",
    "name": "Melbourne Airport",
    "city": "Melbourne"
  },
  {
    "iata": "MRZ",
    "name": "Moree Airport",
    "city": "Moree"
  },
  {
    "iata": "MOV",
    "name": "Moranbah Airport",
    "city": "Moranbah"
  },
  {
    "iata": "MYA",
    "name": "Moruya Airport",
    "city": "Moruya"
  },
  {
    "iata": "NRA",
    "name": "Narrandera Airport",
    "city": "Narrandera"
  },
  {
    "iata": "NAA",
    "name": "Narrabri Airport",
    "city": "Narrabri"
  },
  {
    "iata": "NTN",
    "name": "Normanton Airport",
    "city": "Normanton"
  },
  {
    "iata": "ZNE",
    "name": "Newman Airport",
    "city": "Newman"
  },
  {
    "iata": "OAG",
    "name": "Orange Airport",
    "city": "Orange"
  },
  {
    "iata": "ADL",
    "name": "Adelaide International Airport",
    "city": "Adelaide"
  },
  {
    "iata": "PBO",
    "name": "Paraburdoo Airport",
    "city": "Paraburdoo"
  },
  {
    "iata": "CCK",
    "name": "Cocos (Keeling) Islands Airport",
    "city": "West Island"
  },
  {
    "iata": "DRW",
    "name": "Darwin International Airport / RAAF Darwin",
    "city": "Darwin"
  },
  {
    "iata": "GOV",
    "name": "Gove Airport",
    "city": "Nhulunbuy"
  },
  {
    "iata": "JAD",
    "name": "Perth Jandakot Airport",
    "city": "Perth"
  },
  {
    "iata": "KTA",
    "name": "Karratha Airport",
    "city": "Karratha"
  },
  {
    "iata": "KGI",
    "name": "Kalgoorlie Boulder Airport",
    "city": "Broadwood"
  },
  {
    "iata": "PKE",
    "name": "Parkes Airport",
    "city": "Parkes"
  },
  {
    "iata": "KNX",
    "name": "East Kimberley Regional (Kununurra) Airport",
    "city": "Kununurra"
  },
  {
    "iata": "PLO",
    "name": "Port Lincoln Airport",
    "city": "Port Lincoln"
  },
  {
    "iata": "LEA",
    "name": "Learmonth Airport",
    "city": "Exmouth"
  },
  {
    "iata": "PQQ",
    "name": "Port Macquarie Airport",
    "city": "Port Macquarie"
  },
  {
    "iata": "PHE",
    "name": "Port Hedland International Airport",
    "city": "Port Hedland"
  },
  {
    "iata": "PER",
    "name": "Perth International Airport",
    "city": "Perth"
  },
  {
    "iata": "XCH",
    "name": "Christmas Island Airport",
    "city": "Flying Fish Cove"
  },
  {
    "iata": "RMA",
    "name": "Roma Airport",
    "city": "Roma"
  },
  {
    "iata": "BWU",
    "name": "Sydney Bankstown Airport",
    "city": "Sydney"
  },
  {
    "iata": "CBR",
    "name": "Canberra Airport",
    "city": "Canberra"
  },
  {
    "iata": "CDU",
    "name": "Camden Airport",
    "city": "Cobbitty"
  },
  {
    "iata": "DBO",
    "name": "Dubbo City Regional Airport",
    "city": "Dubbo"
  },
  {
    "iata": "MJK",
    "name": "Shark Bay Airport",
    "city": "Denham"
  },
  {
    "iata": "NLK",
    "name": "Norfolk Island International Airport",
    "city": "Burnt Pine"
  },
  {
    "iata": "NOA",
    "name": "Naval Air Station Nowra - HMAS Albatross",
    "city": "Nowra Hill"
  },
  {
    "iata": "XRH",
    "name": "RAAF Base Richmond",
    "city": "Richmond"
  },
  {
    "iata": "SYD",
    "name": "Sydney Kingsford Smith International Airport",
    "city": "Sydney (Mascot)"
  },
  {
    "iata": "TMW",
    "name": "Tamworth Airport",
    "city": "Tamworth"
  },
  {
    "iata": "WGA",
    "name": "Wagga Wagga Airport",
    "city": "Forest Hill"
  },
  {
    "iata": "TEM",
    "name": "Temora Airport",
    "city": "Temora"
  },
  {
    "iata": "XTG",
    "name": "Thargomindah Airport",
    "city": "Thargomindah"
  },
  {
    "iata": "TUM",
    "name": "Tumut Aerodrome",
    "city": "Tumut"
  },
  {
    "iata": "THG",
    "name": "Thangool Airport",
    "city": "Biloela"
  },
  {
    "iata": "TCA",
    "name": "Tennant Creek Airport",
    "city": "Tennant Creek"
  },
  {
    "iata": "TRO",
    "name": "Taree Airport",
    "city": "Taree"
  },
  {
    "iata": "WNR",
    "name": "Windorah Airport",
    "city": "Windorah"
  },
  {
    "iata": "WGT",
    "name": "Wangaratta Airport",
    "city": "Laceby"
  },
  {
    "iata": "WYA",
    "name": "Whyalla Airport",
    "city": "Whyalla"
  },
  {
    "iata": "NTL",
    "name": "Newcastle Airport",
    "city": "Williamtown"
  },
  {
    "iata": "SXE",
    "name": "West Sale Airport",
    "city": "Sale"
  },
  {
    "iata": "WWY",
    "name": "West Wyalong Airport",
    "city": "West Wyalong"
  },
  {
    "iata": "BWT",
    "name": "Wynyard Airport",
    "city": "Burnie"
  },
  {
    "iata": "PEK",
    "name": "Beijing Capital International Airport",
    "city": "Beijing"
  },
  {
    "iata": "PKX",
    "name": "Beijing Daxing International Airport",
    "city": "Beijing"
  },
  {
    "iata": "CIF",
    "name": "Chifeng Yulong Airport",
    "city": "Chifeng"
  },
  {
    "iata": "BPE",
    "name": "Qinhuangdao Beidaihe Airport",
    "city": "Qinhuangdao (Changli)"
  },
  {
    "iata": "DSN",
    "name": "Ordos Ejin Horo Airport",
    "city": "Ordos"
  },
  {
    "iata": "ERL",
    "name": "Erenhot Saiwusu International Airport",
    "city": "Erenhot"
  },
  {
    "iata": "YIE",
    "name": "Arxan Yi'ershi Airport",
    "city": "Arxan"
  },
  {
    "iata": "HDG",
    "name": "Handan Airport",
    "city": "Handan"
  },
  {
    "iata": "HET",
    "name": "Hohhot Baita International Airport",
    "city": "Hohhot"
  },
  {
    "iata": "HLD",
    "name": "Hulunbuir Hailar Airport",
    "city": "Hailar"
  },
  {
    "iata": "LFQ",
    "name": "Linfen Yaodu Airport",
    "city": "Linfen (Yaodu)"
  },
  {
    "iata": "NZH",
    "name": "Manzhouli Xijiao Airport",
    "city": "Manzhouli"
  },
  {
    "iata": "BAV",
    "name": "Baotou Donghe Airport",
    "city": "Baotou"
  },
  {
    "iata": "SJW",
    "name": "Shijiazhuang Zhengding International Airport",
    "city": "Shijiazhuang"
  },
  {
    "iata": "TSN",
    "name": "Tianjin Binhai International Airport",
    "city": "Tianjin"
  },
  {
    "iata": "TGO",
    "name": "Tongliao Airport",
    "city": "Tongliao"
  },
  {
    "iata": "YCU",
    "name": "Yuncheng Zhangxiao Airport",
    "city": "Yuncheng (Yanhu)"
  },
  {
    "iata": "TYN",
    "name": "Taiyuan Wusu International Airport",
    "city": "Taiyuan"
  },
  {
    "iata": "RLK",
    "name": "Bayannur Tianjitai Airport",
    "city": "Bavannur"
  },
  {
    "iata": "ZQZ",
    "name": "Zhangjiakou Ningyuan Airport",
    "city": "Zhangjiakou"
  },
  {
    "iata": "BHY",
    "name": "Beihai Fucheng Airport",
    "city": "Beihai (Yinhai)"
  },
  {
    "iata": "AEB",
    "name": "Baise (Bose) Bama Airport",
    "city": "Baise (Tianyang)"
  },
  {
    "iata": "CGD",
    "name": "Changde Taohuayuan Airport",
    "city": "Changde (Dingcheng)"
  },
  {
    "iata": "HJJ",
    "name": "Huaihua Zhijiang Airport",
    "city": "Huaihua"
  },
  {
    "iata": "HCZ",
    "name": "Chenzhou Beihu Airport",
    "city": "Chenzhou"
  },
  {
    "iata": "FUO",
    "name": "Foshan Shadi Airport",
    "city": "Foshan (Nanhai)"
  },
  {
    "iata": "CAN",
    "name": "Guangzhou Baiyun International Airport",
    "city": "Guangzhou (Huadu)"
  },
  {
    "iata": "CSX",
    "name": "Changsha Huanghua International Airport",
    "city": "Changsha (Changsha)"
  },
  {
    "iata": "HCJ",
    "name": "Hechi Jinchengjiang Airport",
    "city": "Hechi (Jinchengjiang)"
  },
  {
    "iata": "HUZ",
    "name": "Huizhou Pingtan Airport",
    "city": "Huizhou (Pingtan)"
  },
  {
    "iata": "KWL",
    "name": "Guilin Liangjiang International Airport",
    "city": "Guilin (Lingui)"
  },
  {
    "iata": "LLF",
    "name": "Yongzhou Lingling Airport",
    "city": "Yongzhou"
  },
  {
    "iata": "NNG",
    "name": "Nanning Wuxu Airport",
    "city": "Nanning (Jiangnan)"
  },
  {
    "iata": "ZUH",
    "name": "Zhuhai Jinwan Airport",
    "city": "Zhuhai (Jinwan)"
  },
  {
    "iata": "WGN",
    "name": "Shaoyang Wugang Airport",
    "city": "Shaoyang (Wugang)"
  },
  {
    "iata": "SZX",
    "name": "Shenzhen Bao'an International Airport",
    "city": "Shenzhen (Bao'an)"
  },
  {
    "iata": "WUZ",
    "name": "Wuzhou Xijiang Airport",
    "city": "Tangbu"
  },
  {
    "iata": "YYA",
    "name": "Yueyang Sanhe Airport",
    "city": "Yueyang (Yueyanglou)"
  },
  {
    "iata": "LZH",
    "name": "Liuzhou Bailian Airport / Bailian Air Base",
    "city": "Liuzhou (Liujiang)"
  },
  {
    "iata": "CGO",
    "name": "Zhengzhou Xinzheng International Airport",
    "city": "Zhengzhou"
  },
  {
    "iata": "EHU",
    "name": "Ezhou Huahu Airport",
    "city": "Ezhou"
  },
  {
    "iata": "ENH",
    "name": "Enshi Xujiaping Airport",
    "city": "Enshi (Enshi)"
  },
  {
    "iata": "WUH",
    "name": "Wuhan Tianhe International Airport",
    "city": "Wuhan (Huangpi)"
  },
  {
    "iata": "LYA",
    "name": "Luoyang Beijiao Airport",
    "city": "Luoyang (Laocheng)"
  },
  {
    "iata": "HPG",
    "name": "Shennongjia Hongping Airport",
    "city": "Shennongjia (Hongping)"
  },
  {
    "iata": "XFN",
    "name": "Xiangyang Liuji Airport",
    "city": "Xiangyang (Xiangzhou)"
  },
  {
    "iata": "XAI",
    "name": "Xinyang Minggang Airport",
    "city": "Xinyang"
  },
  {
    "iata": "YIH",
    "name": "Yichang Sanxia Airport",
    "city": "Yichang (Xiaoting)"
  },
  {
    "iata": "HAK",
    "name": "Haikou Meilan International Airport",
    "city": "Haikou (Meilan)"
  },
  {
    "iata": "SYX",
    "name": "Sanya Phoenix International Airport",
    "city": "Sanya (Tianya)"
  },
  {
    "iata": "RGO",
    "name": "Orang (Chongjin) Airport",
    "city": "Hoemun-ri"
  },
  {
    "iata": "FNJ",
    "name": "Pyongyang Sunan International Airport",
    "city": "Pyongyang"
  },
  {
    "iata": "DSO",
    "name": "Sondok Airport",
    "city": "Sŏndŏng-ni"
  },
  {
    "iata": "WOS",
    "name": "Wonsan Kalma International Airport",
    "city": "Wonsan"
  },
  {
    "iata": "GMQ",
    "name": "Golog Maqên Airport",
    "city": "Golog (Maqên)"
  },
  {
    "iata": "GOQ",
    "name": "Golmud Airport",
    "city": "Golmud"
  },
  {
    "iata": "GYU",
    "name": "Guyuan Liupanshan Airport",
    "city": "Guyuan (Yuanzhou)"
  },
  {
    "iata": "INC",
    "name": "Yinchuan Hedong International Airport",
    "city": "Yinchuan"
  },
  {
    "iata": "LHW",
    "name": "Lanzhou Zhongchuan International Airport",
    "city": "Lanzhou (Yongdeng)"
  },
  {
    "iata": "LNL",
    "name": "Longnan Chengzhou Airport",
    "city": "Longnan (Cheng)"
  },
  {
    "iata": "THQ",
    "name": "Tianshui Maijishan Airport",
    "city": "Tianshui (Maiji)"
  },
  {
    "iata": "GXH",
    "name": "Gannan Xiahe Airport",
    "city": "Gannan (Xiahe)"
  },
  {
    "iata": "XNN",
    "name": "Xining Caojiabao International Airport",
    "city": "Haidong (Huzhu Tu Autonomous County)"
  },
  {
    "iata": "XIY",
    "name": "Xi'an Xianyang International Airport",
    "city": "Xianyang (Weicheng)"
  },
  {
    "iata": "YUS",
    "name": "Yushu Batang Airport",
    "city": "Yushu (Batang)"
  },
  {
    "iata": "ZHY",
    "name": "Zhongwei Shapotou Airport",
    "city": "Zhongwei (Shapotou)"
  },
  {
    "iata": "AVK",
    "name": "Arvaikheer Airport",
    "city": "Arvaikheer"
  },
  {
    "iata": "LTI",
    "name": "Altai Airport",
    "city": "Altai"
  },
  {
    "iata": "BYN",
    "name": "Bayankhongor Airport",
    "city": "Bayankhongor"
  },
  {
    "iata": "UGA",
    "name": "Bulgan Airport",
    "city": "Bulgan"
  },
  {
    "iata": "UBN",
    "name": "Ulaanbaatar Chinggis Khaan International Airport",
    "city": "Ulaanbaatar (Sergelen)"
  },
  {
    "iata": "DLZ",
    "name": "Dalanzadgad Airport",
    "city": "Dalanzadgad"
  },
  {
    "iata": "HVD",
    "name": "Khovd Airport",
    "city": "Khovd"
  },
  {
    "iata": "MXV",
    "name": "Mörön Airport",
    "city": "Mörön"
  },
  {
    "iata": "ULN",
    "name": "Buyant-Ukhaa International Airport",
    "city": "Ulaanbaatar"
  },
  {
    "iata": "BSD",
    "name": "Baoshan Yunrui Airport",
    "city": "Baoshan (Longyang)"
  },
  {
    "iata": "DLU",
    "name": "Dali Fengyi Airport",
    "city": "Dali (Xiaguan)"
  },
  {
    "iata": "DIG",
    "name": "Diqing Shangri-La Airport",
    "city": "Diqing (Shangri-La)"
  },
  {
    "iata": "JHG",
    "name": "Xishuangbanna Gasa International Airport",
    "city": "Jinghong (Gasa)"
  },
  {
    "iata": "LNJ",
    "name": "Lincang Boshang Airport",
    "city": "Lincang"
  },
  {
    "iata": "LJG",
    "name": "Lijiang Sanyi International Airport",
    "city": "Lijiang (Gucheng)"
  },
  {
    "iata": "LUM",
    "name": "Dehong Mangshi Airport",
    "city": "Dehong (Mangshi)"
  },
  {
    "iata": "KMG",
    "name": "Kunming Changshui International Airport",
    "city": "Kunming"
  },
  {
    "iata": "YUA",
    "name": "Yuanmou Air Base",
    "city": "Chuxiong (Yuanmou)"
  },
  {
    "iata": "XMN",
    "name": "Xiamen Gaoqi International Airport",
    "city": "Xiamen"
  },
  {
    "iata": "BFU",
    "name": "Bengbu Tenghu Airport",
    "city": "Bengbu"
  },
  {
    "iata": "CZX",
    "name": "Changzhou Benniu International Airport",
    "city": "Changzhou"
  },
  {
    "iata": "KHN",
    "name": "Nanchang Changbei International Airport",
    "city": "Nanchang"
  },
  {
    "iata": "DOY",
    "name": "Dongying Shengli Airport",
    "city": "Dongying (Kenli)"
  },
  {
    "iata": "FUG",
    "name": "Fuyang Xiguan Airport",
    "city": "Yingzhou, Fuyang"
  },
  {
    "iata": "FOC",
    "name": "Fuzhou Changle International Airport",
    "city": "Fuzhou (Changle)"
  },
  {
    "iata": "HGH",
    "name": "Hangzhou Xiaoshan International Airport",
    "city": "Hangzhou"
  },
  {
    "iata": "JDZ",
    "name": "Jingdezhen Luojia Airport",
    "city": "Jingdezhen"
  },
  {
    "iata": "TNA",
    "name": "Jinan Yaoqiang International Airport",
    "city": "Jinan (Licheng)"
  },
  {
    "iata": "JUZ",
    "name": "Quzhou Airport",
    "city": "Quzhou (Kezheng)"
  },
  {
    "iata": "LCX",
    "name": "Liancheng Guanzhishan Airport",
    "city": "Longyan (Liancheng)"
  },
  {
    "iata": "LYI",
    "name": "Linyi Qiyang Airport",
    "city": "Linyi (Hedong)"
  },
  {
    "iata": "NGB",
    "name": "Ningbo Lishe International Airport",
    "city": "Ningbo"
  },
  {
    "iata": "NKG",
    "name": "Nanjing Lukou International Airport",
    "city": "Nanjing"
  },
  {
    "iata": "NTG",
    "name": "Nantong Xingdong International Airport",
    "city": "Nantong (Tongzhou)"
  },
  {
    "iata": "HFE",
    "name": "Hefei Xinqiao International Airport",
    "city": "Hefei"
  },
  {
    "iata": "PVG",
    "name": "Shanghai Pudong International Airport",
    "city": "Shanghai (Pudong)"
  },
  {
    "iata": "TAO",
    "name": "Qingdao Jiaodong International Airport",
    "city": "Qingdao (Jiaozhou)"
  },
  {
    "iata": "JJN",
    "name": "Quanzhou Jinjiang International Airport",
    "city": "Quanzhou"
  },
  {
    "iata": "HIA",
    "name": "Huai'an Lianshui International Airport",
    "city": "Huai'an"
  },
  {
    "iata": "SQJ",
    "name": "Sanming Shaxian Airport",
    "city": "Sanming (Sha)"
  },
  {
    "iata": "SQD",
    "name": "Shangrao Sanqingshan Airport",
    "city": "Shangrao (Hengfeng)"
  },
  {
    "iata": "SHA",
    "name": "Shanghai Hongqiao International Airport",
    "city": "Shanghai (Minhang)"
  },
  {
    "iata": "WHA",
    "name": "Wuhu Xuanzhou Airport",
    "city": "Wuhu"
  },
  {
    "iata": "WEH",
    "name": "Weihai Dashuibo Airport",
    "city": "Weihai"
  },
  {
    "iata": "WUX",
    "name": "Sunan Shuofang International Airport",
    "city": "Wuxi"
  },
  {
    "iata": "WUS",
    "name": "Nanping Wuyishan Airport",
    "city": "Wuyishan"
  },
  {
    "iata": "WNZ",
    "name": "Wenzhou Longwan International Airport",
    "city": "Wenzhou (Longwan)"
  },
  {
    "iata": "XUZ",
    "name": "Xuzhou Guanyin International Airport",
    "city": "Xuzhou"
  },
  {
    "iata": "YTY",
    "name": "Yangzhou Taizhou Airport",
    "city": "Yangzhou"
  },
  {
    "iata": "YIC",
    "name": "Yichun Mingyueshan Airport",
    "city": "Yichun"
  },
  {
    "iata": "YNZ",
    "name": "Yancheng Nanyang International Airport",
    "city": "Yancheng (Tinghu)"
  },
  {
    "iata": "YNT",
    "name": "Yantai Penglai International Airport",
    "city": "Yantai"
  },
  {
    "iata": "YIW",
    "name": "Yiwu Airport",
    "city": "Jinhua (Yiwu)"
  },
  {
    "iata": "HSN",
    "name": "Zhoushan Putuoshan Airport",
    "city": "Zhoushan"
  },
  {
    "iata": "NGQ",
    "name": "Ngari Gunsa Airport",
    "city": "Shiquanhe"
  },
  {
    "iata": "AVA",
    "name": "Anshun Huangguoshu Airport",
    "city": "Anshun (Xixiu)"
  },
  {
    "iata": "BPX",
    "name": "Qamdo Bangda Airport",
    "city": "Bangda"
  },
  {
    "iata": "BFJ",
    "name": "Bijie Feixiong Airport",
    "city": "Bijie"
  },
  {
    "iata": "CKG",
    "name": "Chongqing Jiangbei International Airport",
    "city": "Chongqing"
  },
  {
    "iata": "DZH",
    "name": "Dazhou Jinya Airport",
    "city": "Dazhou (Dachuan)"
  },
  {
    "iata": "DCY",
    "name": "Daocheng Yading Airport",
    "city": "Garzê (Daocheng)"
  },
  {
    "iata": "KWE",
    "name": "Guiyang Longdongbao International Airport",
    "city": "Guiyang (Nanming)"
  },
  {
    "iata": "AHJ",
    "name": "Hongyuan Airport",
    "city": "Ngawa (Hongyuan)"
  },
  {
    "iata": "JZH",
    "name": "Jiuzhai Huanglong Airport",
    "city": "Ngawa (Songpan)"
  },
  {
    "iata": "KGT",
    "name": "Kangding Airport",
    "city": "Garzê (Kangding)"
  },
  {
    "iata": "LXA",
    "name": "Lhasa Gonggar Airport",
    "city": "Shannan (Gonggar)"
  },
  {
    "iata": "WMT",
    "name": "Zunyi Maotai Airport",
    "city": "Zunyi"
  },
  {
    "iata": "MIG",
    "name": "Mianyang Nanjiao Airport",
    "city": "Mianyang (Fucheng)"
  },
  {
    "iata": "HZH",
    "name": "Liping Airport",
    "city": "Liping"
  },
  {
    "iata": "LZY",
    "name": "Nyingchi Mainling Airport",
    "city": "Nyingchi (Mainling)"
  },
  {
    "iata": "JIQ",
    "name": "Qianjiang Wulingshan Airport",
    "city": "Qianjiang"
  },
  {
    "iata": "RKZ",
    "name": "Xigaze Peace Airport / Shigatse Air Base",
    "city": "Xigazê (Samzhubzê)"
  },
  {
    "iata": "TFU",
    "name": "Chengdu Tianfu International Airport",
    "city": "Chengdu (Jianyang)"
  },
  {
    "iata": "CTU",
    "name": "Chengdu Shuangliu International Airport",
    "city": "Chengdu (Shuangliu)"
  },
  {
    "iata": "CQW",
    "name": "Chongqing Xiannüshan Airport",
    "city": "Wulong"
  },
  {
    "iata": "XIC",
    "name": "Xichang Qingshan Airport",
    "city": "Liangshan (Xichang)"
  },
  {
    "iata": "YBP",
    "name": "Yibin Wuliangye Airport",
    "city": "Yibin (Cuiping)"
  },
  {
    "iata": "ACX",
    "name": "Xingyi Wanfenglin Airport",
    "city": "Xingyi"
  },
  {
    "iata": "PZI",
    "name": "Panzhihua Bao'anying Airport",
    "city": "Panzhihua (Renhe)"
  },
  {
    "iata": "ZYI",
    "name": "Zunyi Xinzhou Airport",
    "city": "Zunyi"
  },
  {
    "iata": "AKU",
    "name": "Aksu Hongqipo Airport",
    "city": "Aksu (Onsu)"
  },
  {
    "iata": "AAT",
    "name": "Altay Xuedu Airport",
    "city": "Altay"
  },
  {
    "iata": "BPL",
    "name": "Bole Alashankou Airport",
    "city": "Bole"
  },
  {
    "iata": "FYN",
    "name": "Fuyun Koktokay Airport",
    "city": "Fuyun"
  },
  {
    "iata": "HMI",
    "name": "Hami Airport",
    "city": "Hami"
  },
  {
    "iata": "KRL",
    "name": "Korla Licheng Airport",
    "city": "Korla"
  },
  {
    "iata": "KJI",
    "name": "Burqin Kanas Airport",
    "city": "Burqin"
  },
  {
    "iata": "NLT",
    "name": "Xinyuan Nalati Airport",
    "city": "Xinyuan"
  },
  {
    "iata": "RQA",
    "name": "Ruoqiang Loulan Airport",
    "city": "Ruoqiang Town"
  },
  {
    "iata": "KHG",
    "name": "Kashgar Laining International Airport",
    "city": "Kashgar"
  },
  {
    "iata": "TLQ",
    "name": "Turpan Jiaohe Airport",
    "city": "Turpan"
  },
  {
    "iata": "HTN",
    "name": "Hotan Airport",
    "city": "Hotan"
  },
  {
    "iata": "URC",
    "name": "Ürümqi Diwopu International Airport",
    "city": "Ürümqi"
  },
  {
    "iata": "DBC",
    "name": "Baicheng Chang'an Airport",
    "city": "Baicheng"
  },
  {
    "iata": "NBS",
    "name": "Changbaishan Airport",
    "city": "Baishan"
  },
  {
    "iata": "CGQ",
    "name": "Changchun Longjia International Airport",
    "city": "Changchun"
  },
  {
    "iata": "CNI",
    "name": "Changhai Airport",
    "city": "Dalian (Changhai)"
  },
  {
    "iata": "CHG",
    "name": "Chaoyang Airport",
    "city": "Shuangta, Chaoyang"
  },
  {
    "iata": "DDG",
    "name": "Dandong Langtou Airport",
    "city": "Dandong (Zhenxing)"
  },
  {
    "iata": "HRB",
    "name": "Harbin Taiping International Airport",
    "city": "Harbin"
  },
  {
    "iata": "HEK",
    "name": "Heihe Aihui Airport",
    "city": "Heihe"
  },
  {
    "iata": "JGD",
    "name": "Daxing'anling Elunchun Airport",
    "city": "Jiagedaqi"
  },
  {
    "iata": "JMU",
    "name": "Jiamusi Dongjiao Airport",
    "city": "Jiamusi"
  },
  {
    "iata": "JXA",
    "name": "Jixi Xingkaihu Airport",
    "city": "Jixi"
  },
  {
    "iata": "LDS",
    "name": "Yichun Lindu Airport",
    "city": "Yichun"
  },
  {
    "iata": "MDG",
    "name": "Mudanjiang Hailang International Airport",
    "city": "Mudanjiang"
  },
  {
    "iata": "OHE",
    "name": "Mohe Gulian Airport",
    "city": "Mohe"
  },
  {
    "iata": "NDG",
    "name": "Qiqihar Sanjiazi Airport",
    "city": "Qiqihar"
  },
  {
    "iata": "YSQ",
    "name": "Songyuan Chaganhu Airport",
    "city": "Qian Gorlos Mongol Autonomous County"
  },
  {
    "iata": "DLC",
    "name": "Dalian Zhoushuizi International Airport",
    "city": "Dalian (Ganjingzi)"
  },
  {
    "iata": "TNH",
    "name": "Tonghua Sanyuanpu Airport",
    "city": "Tonghua"
  },
  {
    "iata": "SHE",
    "name": "Shenyang Taoxian International Airport",
    "city": "Hunnan, Shenyang"
  },
  {
    "iata": "XEN",
    "name": "Xingcheng Air Base",
    "city": "Huludao (Xingcheng)"
  },
  {
    "iata": "YNJ",
    "name": "Yanji Chaoyangchuan Airport",
    "city": "Yanji"
  },
    {
    "iata": "NAT",
    "name": "Aeroporto Internacional de Natal",
    "city": "Natal"
  },
    {
    "iata": "PIN",
    "name": "Aeroporto Regional Júlio Belém",
    "city": "Parintins"
  }
];
